import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import * as React from 'react';
import React__default, { memo, useState, useEffect, useCallback, createContext, useContext, useMemo, Fragment as Fragment$1, useImperativeHandle, createElement, cloneElement, useRef, forwardRef, Suspense } from 'react';
import { useTranslate } from 'react-polyglot';
import { Typography, SearchField, Checkbox, NumberField, RadioGroup, Select, Option, TextArea, TextField as TextField$2, Link as Link$1, Skeleton, Chip, IconButton, Tooltip, Button, EmptyState, RadioButton, Popover, Menu, MenuItem, MenuSeparator, Alert, TextBadge, Switch, Avatar, Tabs as Tabs$3, Tab as Tab$1, TabPanel as TabPanel$1, IconBadge, RoundButton } from '@getgo/chameleon-web-react-wrapper';
import { TextField, InputAdornment, Checkbox as Checkbox$1, Dialog as Dialog$1, Container, DialogTitle as DialogTitle$1, DialogContent as DialogContent$1, DialogActions as DialogActions$1, Divider as Divider$2, Drawer as Drawer$2, FormControlLabel, TableRow, TableCell, Table, TableHead, Button as Button$1, TableBody, Collapse, TableFooter, TableContainer, CircularProgress, LinearProgress as LinearProgress$1, Breadcrumbs, Tabs as Tabs$2, withTheme, Tab, Popover as Popover$1, CssBaseline, alpha, createGenerateClassName, createTheme, StylesProvider, ThemeProvider } from '@material-ui/core';
import clsx from 'clsx';
import { useField, Field, useFormikContext, Formik, Form, FieldArray } from 'formik';
import { TextField as TextField$1 } from 'formik-material-ui';
import omit from 'lodash/omit';
import { useDebounce, useFirstMountState, useTitle, useMeasure, useEffectOnce } from 'react-use';
import { CheckboxCheckIcon, CheckboxLineIcon, ChevronDownOutlinedIcon, CloseOutlinedIcon, SearchOutlinedIcon, ChevronLeftOutlinedIcon, ChevronRightOutlinedIcon, DragFreeIcon, LockedOutlinedIcon, RefreshOutlinedIcon, ArrowDownOutlinedIcon, ArrowUpOutlinedIcon, AddOutlinedIcon, MoreMenuVerticalOutlinedIcon, TrashOutlinedIcon, DownloadOutlinedIcon, FilterFilledIcon, FilterOutlinedIcon, FineAdjustmentFilledIcon, FineAdjustmentOutlinedIcon, ChevronUpOutlinedIcon, EditFilledIcon, VisibilityOnFilledIcon, SwapFilledIcon, HistoryOutlinedIcon, CreateGroupOutlinedIcon, CopyOutlinedIcon, PlayCircleOutlinedIcon, PresenceBusyInactiveIcon, SettingsOutlinedIcon, CloudUploadFilledIcon, AttachmentOutlinedIcon, CloseCircleFilledIcon, CalendarOutlinedIcon, PauseOutlinedIcon, SpeakerOnOutlinedIcon, SpeakerOffOutlinedIcon, UploadOutlinedIcon, BlockOutlinedIcon, OpenVoiceIcon, GotoMarkIcon, GotoIcon, PhoneUpFilledIcon, WebcamOnFilledIcon, EducationFilledIcon, LoudspeakerFilledIcon, ScreenMirroringOutlinedIcon, SmartphoneOutlinedIcon, RemoteSupportOutlinedIcon, TicketOutlinedIcon, MobileSupportOutlinedIcon, CameraShareOutlinedIcon, VoipOutlinedIcon, BroadcastOutlinedIcon, PhoneLogFilledIcon, MobileDeviceManagementOutlinedIcon, ResolveEndpointProtectionOutlinedIcon, CalendarFilledIcon } from '@getgo/chameleon-icons/react';
import orderBy from 'lodash/orderBy';
import moment from 'moment';
import { v4 } from 'uuid';
import { Autocomplete } from '@material-ui/lab';
import { Link, useRouteMatch, useLocation, useHistory, Switch as Switch$1, Route, Redirect } from 'react-router-dom';
import * as Yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { useQueryParam, NumberParam, ObjectParam, StringParam } from 'use-query-params';
import useLocalStorage from '@rehooks/local-storage';
import { useTable, useSortBy, useExpanded, usePagination, useRowSelect, useAbsoluteLayout, useColumnOrder } from 'react-table';
import keyBy from 'lodash/keyBy';
import { Draggable, DragDropContext, Droppable } from 'react-beautiful-dnd';
import AnimatedNumber from 'animated-number-react';
import { useDropzone } from 'react-dropzone';
import isArray from 'lodash/isArray';
import { DatePicker } from '@material-ui/pickers';
import { parsePhoneNumber, AsYouType, parsePhoneNumberFromString } from 'libphonenumber-js';
import debounce from 'lodash/debounce';
import AudioPlayer from 'react-h5-audio-player';
import drop from 'lodash/drop';
import capitalize from 'lodash/capitalize';
import isEqual from 'lodash/isEqual';
import isString from 'lodash/isString';
import range from 'lodash/range';
import { ViewState, EditingState, IntegratedEditing } from '@devexpress/dx-react-scheduler';
import { Scheduler as Scheduler$1, WeekView, Appointments, AllDayPanel, DragDropProvider } from '@devexpress/dx-react-scheduler-material-ui';
import throttle from 'lodash/throttle';
import { useDeepCompareMemo } from 'use-deep-compare';
import join from 'lodash/join';
import split from 'lodash/split';
import toLower from 'lodash/toLower';
import upperFirst from 'lodash/upperFirst';
import { encode } from 'html-entities';
import seedrandom from 'seedrandom';

var styles$v = {"addressBox":"ua-common_10-0-0_AddressBox__addressBox__af1f6","column":"ua-common_10-0-0_AddressBox__column__af1f6","addressDetails":"ua-common_10-0-0_AddressBox__addressDetails__af1f6","callbackDetails":"ua-common_10-0-0_AddressBox__callbackDetails__af1f6"};

var AddressBox = function AddressBox(_ref) {
  var locationName = _ref.locationName,
    callbackNumber = _ref.callbackNumber,
    addressLine1 = _ref.addressLine1,
    addressLine2 = _ref.addressLine2,
    addressLine3 = _ref.addressLine3,
    addressLine4 = _ref.addressLine4,
    city = _ref.city,
    state = _ref.state,
    postalCode = _ref.postalCode,
    country = _ref.country;
  var t = useTranslate();
  return jsx("div", {
    className: styles$v.addressBox,
    children: jsxs("div", {
      className: styles$v.column,
      children: [jsx(Typography, {
        children: t('Preview of the address that will be sent to first responders:')
      }), jsxs("div", {
        className: styles$v.addressDetails,
        children: [jsx(Typography, {
          children: locationName
        }), jsx(Typography, {
          children: addressLine1
        }), jsx(Typography, {
          children: "".concat(addressLine2 ? "".concat(addressLine2, ", ") : '').concat(addressLine3 ? "".concat(addressLine3, ", ") : '').concat(addressLine4 ? "".concat(addressLine4, ", ") : '')
        }), jsx(Typography, {
          children: "".concat(city, ", ").concat(state, ", ").concat(postalCode)
        }), jsx(Typography, {
          children: country
        })]
      }), jsxs("div", {
        className: styles$v.callbackDetails,
        children: [jsx(Typography, {
          variant: "caption-medium-strong",
          color: "type-color-secondary",
          children: t('Emergency callback number')
        }), jsx(Typography, {
          children: callbackNumber
        })]
      })]
    })
  });
};
var AddressBox$1 = memo(AddressBox);

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends$4() {
  _extends$4 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$4.apply(this, arguments);
}
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

const gotoAdminLight = {
  backgroundColorDefault: "rgba(255, 255, 255, 1)",
  backgroundColorSecondary: "rgba(247, 247, 247, 1)",
  surfaceColorDefault: "rgba(255, 255, 255, 1)",
  surfaceColorDefaultSemitransparent: "rgba(255, 255, 255, 0.7)",
  surfaceColorSecondary: "rgba(247, 247, 247, 1)",
  surfaceColorSecondaryInverted: "rgba(42, 50, 56, 1)",
  surfaceColorTertiary: "rgba(88, 121, 143, 0.9)",
  surfaceColorInverted: "rgba(0, 0, 0, 1)",
  surfaceColorPersistent: "rgba(0, 0, 0, 1)",
  surfaceColorBrandDefault: "rgba(44, 114, 222, 1)",
  surfaceColorBrandSecondary: "rgba(44, 114, 222, 0.1)",
  surfaceColorSuccessDefault: "rgba(27, 135, 86, 1)",
  surfaceColorSuccessSecondary: "rgba(27, 135, 86, 0.1)",
  surfaceColorDangerDefault: "rgba(211, 58, 97, 1)",
  surfaceColorDangerSecondary: "rgba(211, 58, 97, 0.1)",
  surfaceColorWarningDefault: "rgba(242, 221, 6, 1)",
  surfaceColorWarningSecondary: "rgba(242, 221, 6, 0.1)",
  surfaceColorUtilityPurple: "rgba(194, 164, 255, 0.1)",
  surfaceColorUtilityOrange: "rgba(246, 141, 46, 0.1)",
  surfaceColorUtilityBlue: "rgba(44, 114, 222, 0.1)",
  typeColorDefault: "rgba(0, 0, 0, 1)",
  typeColorSecondary: "rgba(42, 50, 56, 0.7)",
  typeColorInverted: "rgba(255, 255, 255, 1)",
  typeColorSecondaryInverted: "rgba(217, 227, 233, 0.7)",
  typeColorPersistent: "rgba(255, 255, 255, 1)",
  typeColorBrandDefault: "rgba(44, 114, 222, 1)",
  typeColorBrandPersistent: "rgba(44, 114, 222, 1)",
  typeColorSuccess: "rgba(27, 135, 86, 1)",
  typeColorDanger: "rgba(211, 58, 97, 1)",
  typeColorWarning: "rgba(165, 148, 30, 1)",
  typeColorDisabled: "rgba(0, 0, 0, 0.3)",
  typeColorPersistentDisabled: "rgba(255, 255, 255, 0.3)",
  iconColorDefault: "rgba(0, 0, 0, 1)",
  iconColorSecondary: "rgba(42, 50, 56, 0.7)",
  iconColorInverted: "rgba(255, 255, 255, 1)",
  iconColorPersistent: "rgba(255, 255, 255, 1)",
  iconColorBrandDefault: "rgba(44, 114, 222, 1)",
  iconColorBrandPersistent: "rgba(44, 114, 222, 1)",
  iconColorSuccess: "rgba(27, 135, 86, 1)",
  iconColorDanger: "rgba(211, 58, 97, 1)",
  iconColorWarning: "rgba(165, 148, 30, 1)",
  iconColorDisabled: "rgba(0, 0, 0, 0.3)",
  iconColorPersistentDisabled: "rgba(255, 255, 255, 0.3)",
  interactiveColorNeutralDefault: "rgba(247, 247, 247, 1)",
  interactiveColorNeutralHover: "rgba(217, 227, 233, 1)",
  interactiveColorNeutralPressed: "rgba(195, 212, 222, 1)",
  interactiveColorPrimaryDefault: "rgba(0, 0, 0, 1)",
  interactiveColorPrimaryHover: "rgba(42, 50, 56, 1)",
  interactiveColorPrimaryPressed: "rgba(49, 62, 73, 1)",
  interactiveColorSecondaryDefault: "rgba(88, 121, 143, 0)",
  interactiveColorSecondaryHover: "rgba(88, 121, 143, 0.1)",
  interactiveColorSecondaryPressed: "rgba(88, 121, 143, 0.3)",
  interactiveColorSuccessDefault: "rgba(27, 135, 86, 1)",
  interactiveColorSuccessHover: "rgba(20, 100, 89, 1)",
  interactiveColorSuccessPressed: "rgba(0, 79, 73, 1)",
  interactiveColorDangerDefault: "rgba(211, 58, 97, 1)",
  interactiveColorDangerHover: "rgba(165, 34, 81, 1)",
  interactiveColorDangerPressed: "rgba(128, 18, 72, 1)",
  interactiveColorBrandDefault: "rgba(44, 114, 222, 1)",
  interactiveColorBrandHover: "rgba(29, 82, 186, 1)",
  interactiveColorBrandPressed: "rgba(15, 53, 153, 1)",
  interactiveColorPersistentDefault: "rgba(0, 0, 0, 1)",
  interactiveColorPersistentHover: "rgba(42, 50, 56, 1)",
  interactiveColorPersistentPressed: "rgba(49, 62, 73, 1)",
  interactiveColorPersistentActive: "rgba(255, 255, 255, 1)",
  interactiveColorDisabled: "rgba(0, 0, 0, 0.1)",
  borderColorDefault: "rgba(88, 121, 143, 0.5)",
  borderColorSecondary: "rgba(247, 247, 247, 1)",
  borderColorInverted: "rgba(152, 182, 201, 0.5)",
  borderColorPersistent: "rgba(88, 121, 143, 0.5)",
  borderColorBrand: "rgba(44, 114, 222, 1)",
  borderColorSuccess: "rgba(27, 135, 86, 1)",
  borderColorWarning: "rgba(165, 148, 30, 1)",
  borderColorDanger: "rgba(211, 58, 97, 1)",
  focusBorderColorDefault: "rgba(255, 255, 255, 1)",
  focusBorderColorSuccess: "rgba(255, 255, 255, 1)",
  focusBorderColorDanger: "rgba(255, 255, 255, 1)",
  focusBorderColorPersistent: "rgba(0, 0, 0, 1)",
  focusColorHighlightDefault: "rgba(0, 0, 0, 1)",
  focusColorHighlightSuccess: "rgba(20, 100, 89, 1)",
  focusColorHighlightDanger: "rgba(165, 34, 81, 1)",
  focusColorHighlightPersistent: "rgba(255, 255, 255, 1)",
  scrimColor: "rgba(42, 50, 56, 0.7)",
  gradientColorSkeleton: "rgba(37, 40, 45, 0), rgba(37, 40, 45, 0.1), rgba(37, 40, 45, 0)",
  overflowTopGradientDefault: "rgba(255, 255, 255, 1), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)",
  overflowRightGradientDefault: "rgba(255, 255, 255, 1), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)",
  overflowBottomGradientDefault: "rgba(255, 255, 255, 0), rgba(255, 255, 255, 0), rgba(255, 255, 255, 1)",
  overflowLeftGradientDefault: "rgba(255, 255, 255, 1), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)",
  overflowTopGradientSecondary: "rgba(247, 247, 247, 1), rgba(247, 247, 247, 0), rgba(247, 247, 247, 0)",
  overflowRightGradientSecondary: "rgba(247, 247, 247, 1), rgba(247, 247, 247, 0), rgba(247, 247, 247, 0)",
  overflowBottomGradientSecondary: "rgba(247, 247, 247, 0), rgba(247, 247, 247, 0), rgba(247, 247, 247, 1)",
  overflowLeftGradientSecondary: "rgba(247, 247, 247, 1), rgba(247, 247, 247, 0), rgba(247, 247, 247, 0)",
  highlightBackgroundColor: "rgba(242, 221, 6, 0.7)",
  highlightTypeColor: "rgba(0, 0, 0, 1)",
  badgeColorZomp: "rgba(41, 150, 157, 1)",
  badgeColorRed: "rgba(253, 76, 111, 1)",
  badgeColorViolet: "rgba(125, 51, 255, 1)",
  badgeColorOrange: "rgba(246, 141, 46, 1)",
  badgeColorAzure: "rgba(64, 144, 255, 1)",
  badgeColorDeeppurple: "rgba(153, 41, 119, 1)",
  badgeColorGreen: "rgba(0, 170, 110, 1)",
  badgeColorBlue: "rgba(0, 192, 243, 1)",
  badgeColorCitron: "rgba(165, 148, 30, 1)",
  badgeColorBlack: "rgba(0, 0, 0, 1)",
  badgeColorGrey: "rgba(70, 91, 107, 0.7)",
  badgeColorQueenblue: "rgba(53, 103, 153, 1)",
  badgeColorBrand: "rgba(44, 114, 222, 1)",
  badgeColorDisabled: "rgba(0, 0, 0, 0.3)",
  badgeColorAssist: "rgba(41, 150, 157, 1)",
  badgeColorCustomer: "rgba(253, 76, 111, 1)",
  badgeColorGotoresolve: "rgba(125, 51, 255, 1)",
  badgeColorMeeting: "rgba(246, 141, 46, 1)",
  badgeColorMessage: "rgba(64, 144, 255, 1)",
  badgeColorTraining: "rgba(153, 41, 119, 1)",
  badgeColorVoice: "rgba(0, 170, 110, 1)",
  badgeColorWebinar: "rgba(0, 192, 243, 1)",
  badgeColorAudio: "rgba(165, 148, 30, 1)",
  badgeColorCustom: "rgba(0, 0, 0, 1)",
  badgeColorFiles: "rgba(70, 91, 107, 0.7)",
  badgeColorDigitalEngagement: "rgba(53, 103, 153, 1)",
  avatarColor00: "rgba(20, 126, 129, 1)",
  avatarColor01: "rgba(0, 127, 163, 1)",
  avatarColor02: "rgba(15, 89, 128, 1)",
  avatarColor10: "rgba(51, 112, 77, 1)",
  avatarColor11: "rgba(29, 83, 62, 1)",
  avatarColor12: "rgba(24, 99, 73, 1)",
  avatarColor20: "rgba(126, 117, 10, 1)",
  avatarColor21: "rgba(99, 92, 10, 1)",
  avatarColor22: "rgba(69, 112, 31, 1)",
  avatarColor30: "rgba(191, 46, 48, 1)",
  avatarColor31: "rgba(175, 76, 8, 1)",
  avatarColor32: "rgba(153, 77, 3, 1)",
  avatarColor40: "rgba(184, 60, 21, 1)",
  avatarColor41: "rgba(163, 88, 109, 1)",
  avatarColor42: "rgba(150, 42, 67, 1)",
  avatarColor50: "rgba(178, 57, 159, 1)",
  avatarColor51: "rgba(129, 104, 168, 1)",
  avatarColor52: "rgba(108, 54, 153, 1)",
  avatarColorPrimary: "rgba(148, 152, 155, 1)",
  avatarColorSecondary: "rgba(217, 227, 233, 1)",
  avatarInteractiveColorOverlayHover: "rgba(0, 0, 0, 0.2)",
  avatarInteractiveColorOverlayPressed: "rgba(0, 0, 0, 0.3)",
  datavizColorBlueDefault: "rgba(44, 114, 222, 0.7)",
  datavizColorBlueHover: "rgba(100, 187, 250, 0.7)",
  datavizColorBluePressed: "rgba(15, 53, 153, 0.7)",
  datavizColorGreenDefault: "rgba(27, 135, 86, 0.7)",
  datavizColorGreenHover: "rgba(83, 206, 115, 0.7)",
  datavizColorGreenPressed: "rgba(0, 79, 73, 0.7)",
  datavizColorRedDefault: "rgba(211, 58, 97, 0.7)",
  datavizColorRedHover: "rgba(230, 162, 162, 0.7)",
  datavizColorRedPressed: "rgba(128, 18, 72, 0.7)",
  datavizColorYellowDefault: "rgba(165, 148, 30, 0.7)",
  datavizColorYellowHover: "rgba(242, 221, 6, 0.7)",
  datavizColorYellowPressed: "rgba(104, 87, 20, 0.7)",
  datavizColorPurpleDefault: "rgba(133, 82, 246, 0.7)",
  datavizColorPurpleHover: "rgba(194, 164, 255, 0.7)",
  datavizColorPurplePressed: "rgba(50, 28, 156, 0.7)",
  blue500: "rgba(44, 114, 222, 1)",
  blue200: "rgba(152, 215, 252, 1)",
  blue100: "rgba(203, 243, 254, 1)",
  blue600: "rgba(29, 82, 186, 1)",
  blue300: "rgba(100, 187, 250, 1)",
  blue700: "rgba(15, 53, 153, 1)",
  blue400: "rgba(71, 145, 255, 1)",
  green500: "rgba(27, 135, 86, 1)",
  green200: "rgba(161, 232, 165, 1)",
  green100: "rgba(209, 246, 207, 1)",
  green600: "rgba(20, 100, 89, 1)",
  green300: "rgba(83, 206, 115, 1)",
  green700: "rgba(0, 79, 73, 1)",
  green400: "rgba(43, 169, 92, 1)",
  red500: "rgba(211, 58, 97, 1)",
  red200: "rgba(244, 195, 191, 1)",
  red100: "rgba(254, 231, 226, 1)",
  red600: "rgba(165, 34, 81, 1)",
  red300: "rgba(230, 162, 162, 1)",
  red700: "rgba(128, 18, 72, 1)",
  red400: "rgba(217, 111, 126, 1)",
  yellow500: "rgba(165, 148, 30, 1)",
  yellow200: "rgba(255, 251, 123, 1)",
  yellow100: "rgba(255, 253, 169, 1)",
  yellow600: "rgba(134, 117, 28, 1)",
  yellow300: "rgba(242, 221, 6, 1)",
  yellow700: "rgba(104, 87, 20, 1)",
  yellow400: "rgba(214, 194, 18, 1)",
  purple500: "rgba(133, 82, 246, 1)",
  purple200: "rgba(218, 196, 255, 1)",
  purple100: "rgba(235, 222, 255, 1)",
  purple600: "rgba(95, 54, 211, 1)",
  purple300: "rgba(194, 164, 255, 1)",
  purple700: "rgba(50, 28, 156, 1)",
  purple400: "rgba(163, 123, 251, 1)",
  orange500: "rgba(179, 95, 17, 1)",
  orange200: "rgba(255, 196, 140, 1)",
  orange100: "rgba(254, 237, 222, 1)",
  orange600: "rgba(140, 68, 0, 1)",
  orange300: "rgba(246, 141, 46, 1)",
  orange700: "rgba(112, 60, 10, 1)",
  orange400: "rgba(219, 120, 28, 1)",
  neutral900: "rgba(0, 0, 0, 1)",
  neutral850: "rgba(23, 27, 31, 1)",
  neutral800: "rgba(34, 41, 46, 1)",
  neutral700: "rgba(49, 62, 73, 1)",
  neutral600: "rgba(70, 91, 107, 1)",
  neutral500: "rgba(88, 121, 143, 1)",
  neutral400: "rgba(115, 153, 175, 1)",
  neutral300: "rgba(152, 182, 201, 1)",
  neutral200: "rgba(195, 212, 222, 1)",
  neutral100: "rgba(217, 227, 233, 1)",
  neutral050: "rgba(247, 247, 247, 1)",
  neutral000: "rgba(255, 255, 255, 1)",
  brandColorPrimaryYellow: "rgba(255, 233, 0, 1)",
  brandColorBlack: "rgba(0, 0, 0, 1)",
  brandColorWhite: "rgba(255, 255, 255, 1)",
  brandColorAdminBlue: "rgba(2, 166, 255, 1)",
  brandColorResolvePurple: "rgba(146, 84, 255, 1)",
  brandColorGotoAppGreen: "rgba(7, 203, 115, 1)",
  brandColorSecureRed: "rgba(233, 42, 96, 1)",
  brandColorGray100: "rgba(217, 230, 236, 1)",
  brandColorGray200: "rgba(178, 205, 219, 1)",
  brandColorGray300: "rgba(140, 180, 200, 1)",
  brandColorGray400: "rgba(99, 155, 182, 1)",
  elevationNone: "none",
  elevationSmall: "0px 1px 3px rgba(0, 0, 0, 0.2), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 1px rgba(0, 0, 0, 0.14)",
  elevationMedium: "0px 2px 4px rgba(0, 0, 0, 0.2), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 4px 5px rgba(0, 0, 0, 0.14)",
  elevationLarge: "0px 5px 6px rgba(0, 0, 0, 0.2), 0px 3px 16px rgba(0, 0, 0, 0.12), 0px 9px 12px rgba(0, 0, 0, 0.14)",
  elevationXlarge: "0px 11px 15px rgba(0, 0, 0, 0.2), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 24px 38px rgba(0, 0, 0, 0.14)",
  blurMedium: "30px",
  blurSmall: "10px",
  blurLarge: "50px",
  blurXlarge: "70px",
  radiusNone: "0px",
  radiusSmall: "4px",
  radiusMedium: "8px",
  radiusLarge: "12px",
  radiusXlarge: "16px",
  radiusCircle: "1000px",
  spacing00: "0rem",
  spacing01: "0.25rem",
  spacing02: "0.5rem",
  spacing03: "0.75rem",
  spacing04: "1rem",
  spacing05: "1.25rem",
  spacing06: "1.5rem",
  spacing07: "2rem",
  spacing08: "2.5rem",
  spacing09: "3rem",
  spacing10: "3.5rem",
  spacing11: "4rem",
  layout00: "0rem",
  layout01: "1rem",
  layout02: "1.5rem",
  layout03: "2rem",
  layout04: "3rem",
  layout05: "4rem",
  layout06: "6rem",
  layout07: "10rem",
  zIndexDeep: "-999999",
  zIndexDefault: "1",
  zIndexMasked: "100",
  zIndexMask: "200",
  zIndexSticky: "300",
  zIndexHeader: "400",
  zIndexToast: "500",
  zIndexDropdown: "600",
  zIndexOverlay: "700",
  zIndexLoading: "800",
  zIndexModal: "900",
  durationSnappy01: "70ms",
  durationSnappy02: "110ms",
  durationModest01: "150ms",
  durationModest02: "240ms",
  durationLethargic01: "400ms",
  durationLethargic02: "700ms",
  durationSluggish: "1300ms",
  standardEasing: "cubic-bezier(0.4, 0.14, 0.3, 1)",
  entranceEasing: "cubic-bezier(0, 0, 0.3, 1)",
  exitEasing: "cubic-bezier(0.4, 0.14, 1, 1)",
  mqSmall: "30rem",
  mqMedium: "48rem",
  mqLarge: "62rem",
  mqXlarge: "80rem"
};
const gotoAdminDark = {
  backgroundColorDefault: "rgba(34, 41, 46, 1)",
  backgroundColorSecondary: "rgba(23, 27, 31, 1)",
  surfaceColorDefault: "rgba(34, 41, 46, 1)",
  surfaceColorDefaultSemitransparent: "rgba(34, 41, 46, 0.7)",
  surfaceColorSecondary: "rgba(23, 27, 31, 1)",
  surfaceColorSecondaryInverted: "rgba(217, 227, 233, 1)",
  surfaceColorTertiary: "rgba(152, 182, 201, 0.5)",
  surfaceColorInverted: "rgba(255, 255, 255, 1)",
  surfaceColorPersistent: "rgba(0, 0, 0, 1)",
  surfaceColorBrandDefault: "rgba(71, 145, 255, 1)",
  surfaceColorBrandSecondary: "rgba(71, 145, 255, 0.3)",
  surfaceColorSuccessDefault: "rgba(43, 169, 92, 1)",
  surfaceColorSuccessSecondary: "rgba(43, 169, 92, 0.3)",
  surfaceColorDangerDefault: "rgba(211, 58, 97, 1)",
  surfaceColorDangerSecondary: "rgba(211, 58, 97, 0.3)",
  surfaceColorWarningDefault: "rgba(242, 221, 6, 1)",
  surfaceColorWarningSecondary: "rgba(242, 221, 6, 0.3)",
  surfaceColorUtilityPurple: "rgba(163, 123, 251, 0.3)",
  surfaceColorUtilityOrange: "rgba(246, 141, 46, 0.3)",
  surfaceColorUtilityBlue: "rgba(71, 145, 255, 0.3)",
  typeColorDefault: "rgba(255, 255, 255, 1)",
  typeColorSecondary: "rgba(217, 227, 233, 0.7)",
  typeColorInverted: "rgba(0, 0, 0, 1)",
  typeColorSecondaryInverted: "rgba(70, 91, 107, 0.7)",
  typeColorPersistent: "rgba(255, 255, 255, 1)",
  typeColorBrandDefault: "rgba(71, 145, 255, 1)",
  typeColorBrandPersistent: "rgba(44, 114, 222, 1)",
  typeColorSuccess: "rgba(43, 169, 92, 1)",
  typeColorDanger: "rgba(230, 162, 162, 1)",
  typeColorWarning: "rgba(242, 221, 6, 1)",
  typeColorDisabled: "rgba(255, 255, 255, 0.3)",
  typeColorPersistentDisabled: "rgba(255, 255, 255, 0.3)",
  iconColorDefault: "rgba(255, 255, 255, 1)",
  iconColorSecondary: "rgba(217, 227, 233, 0.7)",
  iconColorInverted: "rgba(0, 0, 0, 1)",
  iconColorPersistent: "rgba(255, 255, 255, 1)",
  iconColorBrandDefault: "rgba(71, 145, 255, 1)",
  iconColorBrandPersistent: "rgba(44, 114, 222, 1)",
  iconColorSuccess: "rgba(43, 169, 92, 1)",
  iconColorDanger: "rgba(211, 58, 97, 1)",
  iconColorWarning: "rgba(242, 221, 6, 1)",
  iconColorDisabled: "rgba(255, 255, 255, 0.3)",
  iconColorPersistentDisabled: "rgba(255, 255, 255, 0.3)",
  interactiveColorNeutralDefault: "rgba(61, 72, 82, 1)",
  interactiveColorNeutralHover: "rgba(70, 91, 107, 1)",
  interactiveColorNeutralPressed: "rgba(88, 121, 143, 1)",
  interactiveColorPrimaryDefault: "rgba(217, 227, 233, 1)",
  interactiveColorPrimaryHover: "rgba(195, 212, 222, 1)",
  interactiveColorPrimaryPressed: "rgba(152, 182, 201, 1)",
  interactiveColorSecondaryDefault: "rgba(152, 182, 201, 0)",
  interactiveColorSecondaryHover: "rgba(152, 182, 201, 0.1)",
  interactiveColorSecondaryPressed: "rgba(152, 182, 201, 0.3)",
  interactiveColorSuccessDefault: "rgba(43, 169, 92, 1)",
  interactiveColorSuccessHover: "rgba(83, 206, 115, 1)",
  interactiveColorSuccessPressed: "rgba(161, 232, 165, 1)",
  interactiveColorDangerDefault: "rgba(211, 58, 97, 1)",
  interactiveColorDangerHover: "rgba(217, 111, 126, 1)",
  interactiveColorDangerPressed: "rgba(230, 162, 162, 1)",
  interactiveColorBrandDefault: "rgba(71, 145, 255, 1)",
  interactiveColorBrandHover: "rgba(100, 187, 250, 1)",
  interactiveColorBrandPressed: "rgba(152, 215, 252, 1)",
  interactiveColorPersistentDefault: "rgba(0, 0, 0, 1)",
  interactiveColorPersistentHover: "rgba(42, 50, 56, 1)",
  interactiveColorPersistentPressed: "rgba(61, 72, 82, 1)",
  interactiveColorPersistentActive: "rgba(255, 255, 255, 1)",
  interactiveColorDisabled: "rgba(255, 255, 255, 0.1)",
  borderColorDefault: "rgba(88, 121, 143, 0.5)",
  borderColorSecondary: "rgba(23, 27, 31, 1)",
  borderColorInverted: "rgba(88, 121, 143, 0.5)",
  borderColorPersistent: "rgba(88, 121, 143, 0.5)",
  borderColorBrand: "rgba(71, 145, 255, 1)",
  borderColorSuccess: "rgba(43, 169, 92, 1)",
  borderColorWarning: "rgba(242, 221, 6, 1)",
  borderColorDanger: "rgba(211, 58, 97, 1)",
  focusBorderColorDefault: "rgba(0, 0, 0, 1)",
  focusBorderColorSuccess: "rgba(0, 0, 0, 1)",
  focusBorderColorDanger: "rgba(0, 0, 0, 1)",
  focusBorderColorPersistent: "rgba(0, 0, 0, 1)",
  focusColorHighlightDefault: "rgba(255, 255, 255, 1)",
  focusColorHighlightSuccess: "rgba(161, 232, 165, 1)",
  focusColorHighlightDanger: "rgba(244, 195, 191, 1)",
  focusColorHighlightPersistent: "rgba(255, 255, 255, 1)",
  scrimColor: "rgba(42, 50, 56, 0.7)",
  gradientColorSkeleton: "rgba(152, 182, 201, 0), rgba(152, 182, 201, 0.1), rgba(152, 182, 201, 0)",
  overflowTopGradientDefault: "rgba(34, 41, 46, 1), rgba(34, 41, 46, 0), rgba(34, 41, 46, 0)",
  overflowRightGradientDefault: "rgba(34, 41, 46, 1), rgba(34, 41, 46, 0), rgba(34, 41, 46, 0)",
  overflowBottomGradientDefault: "rgba(34, 41, 46, 0), rgba(34, 41, 46, 0), rgba(34, 41, 46, 1)",
  overflowLeftGradientDefault: "rgba(34, 41, 46, 1), rgba(34, 41, 46, 0), rgba(34, 41, 46, 0)",
  overflowTopGradientSecondary: "rgba(23, 27, 31, 1), rgba(23, 27, 31, 0), rgba(23, 27, 31, 0)",
  overflowRightGradientSecondary: "rgba(23, 27, 31, 1), rgba(23, 27, 31, 0), rgba(23, 27, 31, 0)",
  overflowBottomGradientSecondary: "rgba(34, 41, 46, 0), rgba(34, 41, 46, 0), rgba(34, 41, 46, 1)",
  overflowLeftGradientSecondary: "rgba(34, 41, 46, 1), rgba(34, 41, 46, 0), rgba(34, 41, 46, 0)",
  highlightBackgroundColor: "rgba(165, 148, 30, 0.7)",
  highlightTypeColor: "rgba(255, 255, 255, 1)",
  badgeColorZomp: "rgba(41, 150, 157, 1)",
  badgeColorRed: "rgba(253, 76, 111, 1)",
  badgeColorViolet: "rgba(125, 51, 255, 1)",
  badgeColorOrange: "rgba(246, 141, 46, 1)",
  badgeColorAzure: "rgba(64, 144, 255, 1)",
  badgeColorDeeppurple: "rgba(153, 41, 119, 1)",
  badgeColorGreen: "rgba(0, 170, 110, 1)",
  badgeColorBlue: "rgba(0, 192, 243, 1)",
  badgeColorCitron: "rgba(242, 221, 6, 1)",
  badgeColorBlack: "rgba(255, 255, 255, 1)",
  badgeColorGrey: "rgba(152, 182, 201, 0.7)",
  badgeColorQueenblue: "rgba(53, 103, 153, 1)",
  badgeColorBrand: "rgba(71, 145, 255, 1)",
  badgeColorDisabled: "rgba(255, 255, 255, 0.3)",
  badgeColorAssist: "rgba(41, 150, 157, 1)",
  badgeColorCustomer: "rgba(253, 76, 111, 1)",
  badgeColorGotoresolve: "rgba(125, 51, 255, 1)",
  badgeColorMeeting: "rgba(246, 141, 46, 1)",
  badgeColorMessage: "rgba(64, 144, 255, 1)",
  badgeColorTraining: "rgba(153, 41, 119, 1)",
  badgeColorVoice: "rgba(0, 170, 110, 1)",
  badgeColorWebinar: "rgba(0, 192, 243, 1)",
  badgeColorAudio: "rgba(242, 221, 6, 1)",
  badgeColorCustom: "rgba(255, 255, 255, 1)",
  badgeColorFiles: "rgba(152, 182, 201, 0.7)",
  badgeColorDigitalEngagement: "rgba(53, 103, 153, 1)",
  avatarColor00: "rgba(190, 217, 254, 1)",
  avatarColor01: "rgba(63, 192, 193, 1)",
  avatarColor02: "rgba(31, 156, 182, 1)",
  avatarColor10: "rgba(127, 254, 209, 1)",
  avatarColor11: "rgba(112, 206, 95, 1)",
  avatarColor12: "rgba(0, 169, 110, 1)",
  avatarColor20: "rgba(254, 231, 139, 1)",
  avatarColor21: "rgba(203, 184, 93, 1)",
  avatarColor22: "rgba(216, 172, 0, 1)",
  avatarColor30: "rgba(254, 189, 127, 1)",
  avatarColor31: "rgba(239, 137, 83, 1)",
  avatarColor32: "rgba(218, 120, 28, 1)",
  avatarColor40: "rgba(249, 179, 193, 1)",
  avatarColor41: "rgba(240, 134, 186, 1)",
  avatarColor42: "rgba(252, 76, 111, 1)",
  avatarColor50: "rgba(212, 190, 254, 1)",
  avatarColor51: "rgba(191, 158, 255, 1)",
  avatarColor52: "rgba(154, 102, 254, 1)",
  avatarColorPrimary: "rgba(126, 134, 139, 1)",
  avatarColorSecondary: "rgba(61, 72, 82, 1)",
  avatarInteractiveColorOverlayHover: "rgba(0, 0, 0, 0.2)",
  avatarInteractiveColorOverlayPressed: "rgba(0, 0, 0, 0.3)",
  datavizColorBlueDefault: "rgba(100, 187, 250, 0.9)",
  datavizColorBlueHover: "rgba(203, 243, 254, 0.9)",
  datavizColorBluePressed: "rgba(44, 114, 222, 0.9)",
  datavizColorGreenDefault: "rgba(83, 206, 115, 0.9)",
  datavizColorGreenHover: "rgba(209, 246, 207, 0.9)",
  datavizColorGreenPressed: "rgba(27, 135, 86, 0.9)",
  datavizColorRedDefault: "rgba(230, 162, 162, 0.9)",
  datavizColorRedHover: "rgba(254, 231, 226, 0.9)",
  datavizColorRedPressed: "rgba(211, 58, 97, 0.9)",
  datavizColorYellowDefault: "rgba(242, 221, 6, 0.9)",
  datavizColorYellowHover: "rgba(255, 253, 169, 0.9)",
  datavizColorYellowPressed: "rgba(165, 148, 30, 0.9)",
  datavizColorPurpleDefault: "rgba(194, 164, 255, 0.9)",
  datavizColorPurpleHover: "rgba(235, 222, 255, 0.9)",
  datavizColorPurplePressed: "rgba(133, 82, 246, 0.9)",
  brandColorPrimaryYellow: "rgba(255, 233, 0, 1)",
  brandColorBlack: "rgba(255, 255, 255, 1)",
  brandColorWhite: "rgba(0, 0, 0, 1)",
  brandColorAdminBlue: "rgba(2, 166, 255, 1)",
  brandColorResolvePurple: "rgba(146, 84, 255, 1)",
  brandColorGotoAppGreen: "rgba(7, 203, 115, 1)",
  brandColorSecureRed: "rgba(233, 42, 96, 1)",
  brandColorGray100: "rgba(217, 230, 236, 1)",
  brandColorGray200: "rgba(178, 205, 219, 1)",
  brandColorGray300: "rgba(140, 180, 200, 1)",
  brandColorGray400: "rgba(99, 155, 182, 1)",
  blue500: "rgba(44, 114, 222, 1)",
  blue200: "rgba(152, 215, 252, 1)",
  blue100: "rgba(203, 243, 254, 1)",
  blue600: "rgba(29, 82, 186, 1)",
  blue300: "rgba(100, 187, 250, 1)",
  blue700: "rgba(15, 53, 153, 1)",
  blue400: "rgba(71, 145, 255, 1)",
  green500: "rgba(27, 135, 86, 1)",
  green200: "rgba(161, 232, 165, 1)",
  green100: "rgba(209, 246, 207, 1)",
  green600: "rgba(20, 100, 89, 1)",
  green300: "rgba(83, 206, 115, 1)",
  green700: "rgba(0, 79, 73, 1)",
  green400: "rgba(43, 169, 92, 1)",
  red500: "rgba(211, 58, 97, 1)",
  red200: "rgba(244, 195, 191, 1)",
  red100: "rgba(254, 231, 226, 1)",
  red600: "rgba(165, 34, 81, 1)",
  red300: "rgba(230, 162, 162, 1)",
  red700: "rgba(128, 18, 72, 1)",
  red400: "rgba(217, 111, 126, 1)",
  yellow500: "rgba(165, 148, 30, 1)",
  yellow200: "rgba(255, 251, 123, 1)",
  yellow100: "rgba(255, 253, 169, 1)",
  yellow600: "rgba(134, 117, 28, 1)",
  yellow300: "rgba(242, 221, 6, 1)",
  yellow700: "rgba(104, 87, 20, 1)",
  yellow400: "rgba(214, 194, 18, 1)",
  purple500: "rgba(133, 82, 246, 1)",
  purple200: "rgba(218, 196, 255, 1)",
  purple100: "rgba(235, 222, 255, 1)",
  purple600: "rgba(95, 54, 211, 1)",
  purple300: "rgba(194, 164, 255, 1)",
  purple700: "rgba(50, 28, 156, 1)",
  purple400: "rgba(163, 123, 251, 1)",
  orange500: "rgba(179, 95, 17, 1)",
  orange200: "rgba(255, 196, 140, 1)",
  orange100: "rgba(254, 237, 222, 1)",
  orange600: "rgba(140, 68, 0, 1)",
  orange300: "rgba(246, 141, 46, 1)",
  orange700: "rgba(112, 60, 10, 1)",
  orange400: "rgba(219, 120, 28, 1)",
  neutral900: "rgba(0, 0, 0, 1)",
  neutral850: "rgba(23, 27, 31, 1)",
  neutral800: "rgba(34, 41, 46, 1)",
  neutral700: "rgba(61, 72, 82, 1)",
  neutral600: "rgba(70, 91, 107, 1)",
  neutral500: "rgba(88, 121, 143, 1)",
  neutral400: "rgba(115, 153, 175, 1)",
  neutral300: "rgba(152, 182, 201, 1)",
  neutral200: "rgba(195, 212, 222, 1)",
  neutral100: "rgba(217, 227, 233, 1)",
  neutral050: "rgba(242, 246, 247, 1)",
  neutral000: "rgba(255, 255, 255, 1)",
  elevationNone: "none",
  elevationSmall: "0px 1px 3px rgba(0, 0, 0, 0.2), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 1px rgba(0, 0, 0, 0.14)",
  elevationMedium: "0px 2px 4px rgba(0, 0, 0, 0.2), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 4px 5px rgba(0, 0, 0, 0.14)",
  elevationLarge: "0px 5px 6px rgba(0, 0, 0, 0.2), 0px 3px 16px rgba(0, 0, 0, 0.12), 0px 9px 12px rgba(0, 0, 0, 0.14)",
  elevationXlarge: "0px 11px 15px rgba(0, 0, 0, 0.2), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 24px 38px rgba(0, 0, 0, 0.14)",
  blurMedium: "30px",
  blurSmall: "10px",
  blurLarge: "50px",
  blurXlarge: "70px",
  radiusNone: "0px",
  radiusSmall: "4px",
  radiusMedium: "8px",
  radiusLarge: "12px",
  radiusXlarge: "16px",
  radiusCircle: "1000px",
  spacing00: "0rem",
  spacing01: "0.25rem",
  spacing02: "0.5rem",
  spacing03: "0.75rem",
  spacing04: "1rem",
  spacing05: "1.25rem",
  spacing06: "1.5rem",
  spacing07: "2rem",
  spacing08: "2.5rem",
  spacing09: "3rem",
  spacing10: "3.5rem",
  spacing11: "4rem",
  layout00: "0rem",
  layout01: "1rem",
  layout02: "1.5rem",
  layout03: "2rem",
  layout04: "3rem",
  layout05: "4rem",
  layout06: "6rem",
  layout07: "10rem",
  zIndexDeep: "-999999",
  zIndexDefault: "1",
  zIndexMasked: "100",
  zIndexMask: "200",
  zIndexSticky: "300",
  zIndexHeader: "400",
  zIndexToast: "500",
  zIndexDropdown: "600",
  zIndexOverlay: "700",
  zIndexLoading: "800",
  zIndexModal: "900",
  durationSnappy01: "70ms",
  durationSnappy02: "110ms",
  durationModest01: "150ms",
  durationModest02: "240ms",
  durationLethargic01: "400ms",
  durationLethargic02: "700ms",
  durationSluggish: "1300ms",
  standardEasing: "cubic-bezier(0.4, 0.14, 0.3, 1)",
  entranceEasing: "cubic-bezier(0, 0, 0.3, 1)",
  exitEasing: "cubic-bezier(0.4, 0.14, 1, 1)",
  mqSmall: "30rem",
  mqMedium: "48rem",
  mqLarge: "62rem",
  mqXlarge: "80rem"
};
const gotoAdminTypography = {
  headingXlarge: "700 3rem/3.25rem var(--goto-font-family)",
  headingLarge: "700 2.25rem/2.5rem var(--goto-font-family)",
  headingMedium: "600 1.75rem/2rem var(--goto-font-family)",
  headingSmall: "600 1.25rem/1.5rem var(--goto-font-family)",
  bodyLarge: "400 1.125rem/1.5rem var(--goto-font-family)",
  bodyLargeStrong: "600 1.125rem/1.5rem var(--goto-font-family)",
  bodyMedium: "400 1rem/1.5rem var(--goto-font-family)",
  bodyMediumStrong: "600 1rem/1.5rem var(--goto-font-family)",
  bodySmall: "400 0.875rem/1.5rem var(--goto-font-family)",
  bodySmallStrong: "600 0.875rem/1.5rem var(--goto-font-family)",
  captionMedium: "400 0.75rem/1.25rem var(--goto-font-family)",
  captionMediumStrong: "600 0.75rem/1.25rem var(--goto-font-family)",
  captionSmall: "400 0.625rem/1rem var(--goto-font-family)",
  captionSmallStrong: "600 0.625rem/1rem var(--goto-font-family)",
  codeMedium: "400 0.875rem/1.5rem var(--goto-font-family-mono)",
  codeSmall: "400 0.75rem/1.25rem var(--goto-font-family-mono)",
  buttonXlarge: "600 1.125rem/1.5rem var(--goto-font-family)",
  buttonLarge: "600 1rem/1.5rem var(--goto-font-family)",
  buttonMedium: "600 0.875rem/1.5rem var(--goto-font-family)",
  buttonSmall: "600 0.75rem/1.25rem var(--goto-font-family)",
  avatarXxxlarge: "700 5rem/6.25rem var(--goto-font-family)",
  avatarXxlarge: "700 2.25rem/3rem var(--goto-font-family)",
  avatarXlarge: "700 1.625rem/2rem var(--goto-font-family)",
  avatarLarge: "700 1.25rem/1.5rem var(--goto-font-family)",
  avatarMedium: "700 0.875rem/1.25rem var(--goto-font-family)",
  avatarSmall: "700 0.75rem/1rem var(--goto-font-family)",
  avatarXsmall: "700 0.625rem/1rem var(--goto-font-family)",
  fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif",
  fontFamilyMono: "Menlo, Consolas, Monaco, 'Liberation Mono', 'Lucida Console', monospace"
};

const tokens = {
  backgroundColorDefault: "var(--goto-background-color-default)",
  backgroundColorSecondary: "var(--goto-background-color-secondary)",
  surfaceColorDefault: "var(--goto-surface-color-default)",
  surfaceColorDefaultSemitransparent: "var(--goto-surface-color-default-semitransparent)",
  surfaceColorSecondary: "var(--goto-surface-color-secondary)",
  surfaceColorSecondaryInverted: "var(--goto-surface-color-secondary-inverted)",
  surfaceColorTertiary: "var(--goto-surface-color-tertiary)",
  surfaceColorInverted: "var(--goto-surface-color-inverted)",
  surfaceColorPersistent: "var(--goto-surface-color-persistent)",
  surfaceColorBrandDefault: "var(--goto-surface-color-brand-default)",
  surfaceColorBrandSecondary: "var(--goto-surface-color-brand-secondary)",
  surfaceColorSuccessDefault: "var(--goto-surface-color-success-default)",
  surfaceColorSuccessSecondary: "var(--goto-surface-color-success-secondary)",
  surfaceColorDangerDefault: "var(--goto-surface-color-danger-default)",
  surfaceColorDangerSecondary: "var(--goto-surface-color-danger-secondary)",
  surfaceColorWarningDefault: "var(--goto-surface-color-warning-default)",
  surfaceColorWarningSecondary: "var(--goto-surface-color-warning-secondary)",
  surfaceColorUtilityPurple: "var(--goto-surface-color-utility-purple)",
  surfaceColorUtilityOrange: "var(--goto-surface-color-utility-orange)",
  surfaceColorUtilityBlue: "var(--goto-surface-color-utility-blue)",
  typeColorDefault: "var(--goto-type-color-default)",
  typeColorSecondary: "var(--goto-type-color-secondary)",
  typeColorInverted: "var(--goto-type-color-inverted)",
  typeColorSecondaryInverted: "var(--goto-type-color-secondary-inverted)",
  typeColorPersistent: "var(--goto-type-color-persistent)",
  typeColorBrandDefault: "var(--goto-type-color-brand-default)",
  typeColorBrandPersistent: "var(--goto-type-color-brand-persistent)",
  typeColorSuccess: "var(--goto-type-color-success)",
  typeColorDanger: "var(--goto-type-color-danger)",
  typeColorWarning: "var(--goto-type-color-warning)",
  typeColorDisabled: "var(--goto-type-color-disabled)",
  typeColorPersistentDisabled: "var(--goto-type-color-persistent-disabled)",
  iconColorDefault: "var(--goto-icon-color-default)",
  iconColorSecondary: "var(--goto-icon-color-secondary)",
  iconColorInverted: "var(--goto-icon-color-inverted)",
  iconColorPersistent: "var(--goto-icon-color-persistent)",
  iconColorBrandDefault: "var(--goto-icon-color-brand-default)",
  iconColorBrandPersistent: "var(--goto-icon-color-brand-persistent)",
  iconColorSuccess: "var(--goto-icon-color-success)",
  iconColorDanger: "var(--goto-icon-color-danger)",
  iconColorWarning: "var(--goto-icon-color-warning)",
  iconColorDisabled: "var(--goto-icon-color-disabled)",
  iconColorPersistentDisabled: "var(--goto-icon-color-persistent-disabled)",
  interactiveColorNeutralDefault: "var(--goto-interactive-color-neutral-default)",
  interactiveColorNeutralHover: "var(--goto-interactive-color-neutral-hover)",
  interactiveColorNeutralPressed: "var(--goto-interactive-color-neutral-pressed)",
  interactiveColorPrimaryDefault: "var(--goto-interactive-color-primary-default)",
  interactiveColorPrimaryHover: "var(--goto-interactive-color-primary-hover)",
  interactiveColorPrimaryPressed: "var(--goto-interactive-color-primary-pressed)",
  interactiveColorSecondaryDefault: "var(--goto-interactive-color-secondary-default)",
  interactiveColorSecondaryHover: "var(--goto-interactive-color-secondary-hover)",
  interactiveColorSecondaryPressed: "var(--goto-interactive-color-secondary-pressed)",
  interactiveColorSuccessDefault: "var(--goto-interactive-color-success-default)",
  interactiveColorSuccessHover: "var(--goto-interactive-color-success-hover)",
  interactiveColorSuccessPressed: "var(--goto-interactive-color-success-pressed)",
  interactiveColorDangerDefault: "var(--goto-interactive-color-danger-default)",
  interactiveColorDangerHover: "var(--goto-interactive-color-danger-hover)",
  interactiveColorDangerPressed: "var(--goto-interactive-color-danger-pressed)",
  interactiveColorBrandDefault: "var(--goto-interactive-color-brand-default)",
  interactiveColorBrandHover: "var(--goto-interactive-color-brand-hover)",
  interactiveColorBrandPressed: "var(--goto-interactive-color-brand-pressed)",
  interactiveColorPersistentDefault: "var(--goto-interactive-color-persistent-default)",
  interactiveColorPersistentHover: "var(--goto-interactive-color-persistent-hover)",
  interactiveColorPersistentPressed: "var(--goto-interactive-color-persistent-pressed)",
  interactiveColorPersistentActive: "var(--goto-interactive-color-persistent-active)",
  interactiveColorDisabled: "var(--goto-interactive-color-disabled)",
  borderColorDefault: "var(--goto-border-color-default)",
  borderColorSecondary: "var(--goto-border-color-secondary)",
  borderColorInverted: "var(--goto-border-color-inverted)",
  borderColorPersistent: "var(--goto-border-color-persistent)",
  borderColorBrand: "var(--goto-border-color-brand)",
  borderColorSuccess: "var(--goto-border-color-success)",
  borderColorWarning: "var(--goto-border-color-warning)",
  borderColorDanger: "var(--goto-border-color-danger)",
  focusBorderColorDefault: "var(--goto-focus-border-color-default)",
  focusBorderColorSuccess: "var(--goto-focus-border-color-success)",
  focusBorderColorDanger: "var(--goto-focus-border-color-danger)",
  focusBorderColorPersistent: "var(--goto-focus-border-color-persistent)",
  focusColorHighlightDefault: "var(--goto-focus-color-highlight-default)",
  focusColorHighlightSuccess: "var(--goto-focus-color-highlight-success)",
  focusColorHighlightDanger: "var(--goto-focus-color-highlight-danger)",
  focusColorHighlightPersistent: "var(--goto-focus-color-highlight-persistent)",
  scrimColor: "var(--goto-scrim-color)",
  gradientColorSkeleton: "var(--goto-gradient-color-skeleton)",
  overflowTopGradientDefault: "var(--goto-overflow-top-gradient-default)",
  overflowRightGradientDefault: "var(--goto-overflow-right-gradient-default)",
  overflowBottomGradientDefault: "var(--goto-overflow-bottom-gradient-default)",
  overflowLeftGradientDefault: "var(--goto-overflow-left-gradient-default)",
  overflowTopGradientSecondary: "var(--goto-overflow-top-gradient-secondary)",
  overflowRightGradientSecondary: "var(--goto-overflow-right-gradient-secondary)",
  overflowBottomGradientSecondary: "var(--goto-overflow-bottom-gradient-secondary)",
  overflowLeftGradientSecondary: "var(--goto-overflow-left-gradient-secondary)",
  highlightBackgroundColor: "var(--goto-highlight-background-color)",
  highlightTypeColor: "var(--goto-highlight-type-color)",
  badgeColorZomp: "var(--goto-badge-color-zomp)",
  badgeColorRed: "var(--goto-badge-color-red)",
  badgeColorViolet: "var(--goto-badge-color-violet)",
  badgeColorOrange: "var(--goto-badge-color-orange)",
  badgeColorAzure: "var(--goto-badge-color-azure)",
  badgeColorDeeppurple: "var(--goto-badge-color-deeppurple)",
  badgeColorGreen: "var(--goto-badge-color-green)",
  badgeColorBlue: "var(--goto-badge-color-blue)",
  badgeColorCitron: "var(--goto-badge-color-citron)",
  badgeColorBlack: "var(--goto-badge-color-black)",
  badgeColorGrey: "var(--goto-badge-color-grey)",
  badgeColorQueenblue: "var(--goto-badge-color-queenblue)",
  badgeColorBrand: "var(--goto-badge-color-brand)",
  badgeColorDisabled: "var(--goto-badge-color-disabled)",
  badgeColorAssist: "var(--goto-badge-color-assist)",
  badgeColorCustomer: "var(--goto-badge-color-customer)",
  badgeColorGotoresolve: "var(--goto-badge-color-gotoresolve)",
  badgeColorMeeting: "var(--goto-badge-color-meeting)",
  badgeColorMessage: "var(--goto-badge-color-message)",
  badgeColorTraining: "var(--goto-badge-color-training)",
  badgeColorVoice: "var(--goto-badge-color-voice)",
  badgeColorWebinar: "var(--goto-badge-color-webinar)",
  badgeColorAudio: "var(--goto-badge-color-audio)",
  badgeColorCustom: "var(--goto-badge-color-custom)",
  badgeColorFiles: "var(--goto-badge-color-files)",
  badgeColorDigitalEngagement: "var(--goto-badge-color-digital-engagement)",
  avatarColor00: "var(--goto-avatar-color-00)",
  avatarColor01: "var(--goto-avatar-color-01)",
  avatarColor02: "var(--goto-avatar-color-02)",
  avatarColor10: "var(--goto-avatar-color-10)",
  avatarColor11: "var(--goto-avatar-color-11)",
  avatarColor12: "var(--goto-avatar-color-12)",
  avatarColor20: "var(--goto-avatar-color-20)",
  avatarColor21: "var(--goto-avatar-color-21)",
  avatarColor22: "var(--goto-avatar-color-22)",
  avatarColor30: "var(--goto-avatar-color-30)",
  avatarColor31: "var(--goto-avatar-color-31)",
  avatarColor32: "var(--goto-avatar-color-32)",
  avatarColor40: "var(--goto-avatar-color-40)",
  avatarColor41: "var(--goto-avatar-color-41)",
  avatarColor42: "var(--goto-avatar-color-42)",
  avatarColor50: "var(--goto-avatar-color-50)",
  avatarColor51: "var(--goto-avatar-color-51)",
  avatarColor52: "var(--goto-avatar-color-52)",
  avatarColorPrimary: "var(--goto-avatar-color-primary)",
  avatarColorSecondary: "var(--goto-avatar-color-secondary)",
  avatarInteractiveColorOverlayHover: "var(--goto-avatar-interactive-color-overlay-hover)",
  avatarInteractiveColorOverlayPressed: "var(--goto-avatar-interactive-color-overlay-pressed)",
  datavizColorBlueDefault: "var(--goto-dataviz-color-blue-default)",
  datavizColorBlueHover: "var(--goto-dataviz-color-blue-hover)",
  datavizColorBluePressed: "var(--goto-dataviz-color-blue-pressed)",
  datavizColorGreenDefault: "var(--goto-dataviz-color-green-default)",
  datavizColorGreenHover: "var(--goto-dataviz-color-green-hover)",
  datavizColorGreenPressed: "var(--goto-dataviz-color-green-pressed)",
  datavizColorRedDefault: "var(--goto-dataviz-color-red-default)",
  datavizColorRedHover: "var(--goto-dataviz-color-red-hover)",
  datavizColorRedPressed: "var(--goto-dataviz-color-red-pressed)",
  datavizColorYellowDefault: "var(--goto-dataviz-color-yellow-default)",
  datavizColorYellowHover: "var(--goto-dataviz-color-yellow-hover)",
  datavizColorYellowPressed: "var(--goto-dataviz-color-yellow-pressed)",
  datavizColorPurpleDefault: "var(--goto-dataviz-color-purple-default)",
  datavizColorPurpleHover: "var(--goto-dataviz-color-purple-hover)",
  datavizColorPurplePressed: "var(--goto-dataviz-color-purple-pressed)",
  blue500: "var(--goto-blue-500)",
  blue200: "var(--goto-blue-200)",
  blue100: "var(--goto-blue-100)",
  blue600: "var(--goto-blue-600)",
  blue300: "var(--goto-blue-300)",
  blue700: "var(--goto-blue-700)",
  blue400: "var(--goto-blue-400)",
  green500: "var(--goto-green-500)",
  green200: "var(--goto-green-200)",
  green100: "var(--goto-green-100)",
  green600: "var(--goto-green-600)",
  green300: "var(--goto-green-300)",
  green700: "var(--goto-green-700)",
  green400: "var(--goto-green-400)",
  red500: "var(--goto-red-500)",
  red200: "var(--goto-red-200)",
  red100: "var(--goto-red-100)",
  red600: "var(--goto-red-600)",
  red300: "var(--goto-red-300)",
  red700: "var(--goto-red-700)",
  red400: "var(--goto-red-400)",
  yellow500: "var(--goto-yellow-500)",
  yellow200: "var(--goto-yellow-200)",
  yellow100: "var(--goto-yellow-100)",
  yellow600: "var(--goto-yellow-600)",
  yellow300: "var(--goto-yellow-300)",
  yellow700: "var(--goto-yellow-700)",
  yellow400: "var(--goto-yellow-400)",
  purple500: "var(--goto-purple-500)",
  purple200: "var(--goto-purple-200)",
  purple100: "var(--goto-purple-100)",
  purple600: "var(--goto-purple-600)",
  purple300: "var(--goto-purple-300)",
  purple700: "var(--goto-purple-700)",
  purple400: "var(--goto-purple-400)",
  orange500: "var(--goto-orange-500)",
  orange200: "var(--goto-orange-200)",
  orange100: "var(--goto-orange-100)",
  orange600: "var(--goto-orange-600)",
  orange300: "var(--goto-orange-300)",
  orange700: "var(--goto-orange-700)",
  orange400: "var(--goto-orange-400)",
  neutral900: "var(--goto-neutral-900)",
  neutral850: "var(--goto-neutral-850)",
  neutral800: "var(--goto-neutral-800)",
  neutral700: "var(--goto-neutral-700)",
  neutral600: "var(--goto-neutral-600)",
  neutral500: "var(--goto-neutral-500)",
  neutral400: "var(--goto-neutral-400)",
  neutral300: "var(--goto-neutral-300)",
  neutral200: "var(--goto-neutral-200)",
  neutral100: "var(--goto-neutral-100)",
  neutral050: "var(--goto-neutral-050)",
  neutral000: "var(--goto-neutral-000)",
  brandColorPrimaryYellow: "var(--goto-brand-color-primary-yellow)",
  brandColorBlack: "var(--goto-brand-color-black)",
  brandColorWhite: "var(--goto-brand-color-white)",
  brandColorAdminBlue: "var(--goto-brand-color-admin-blue)",
  brandColorResolvePurple: "var(--goto-brand-color-resolve-purple)",
  brandColorGotoAppGreen: "var(--goto-brand-color-goto-app-green)",
  brandColorSecureRed: "var(--goto-brand-color-secure-red)",
  brandColorGray100: "var(--goto-brand-color-gray-100)",
  brandColorGray200: "var(--goto-brand-color-gray-200)",
  brandColorGray300: "var(--goto-brand-color-gray-300)",
  brandColorGray400: "var(--goto-brand-color-gray-400)",
  elevationNone: "var(--goto-elevation-none)",
  elevationSmall: "var(--goto-elevation-small)",
  elevationMedium: "var(--goto-elevation-medium)",
  elevationLarge: "var(--goto-elevation-large)",
  elevationXlarge: "var(--goto-elevation-xlarge)",
  blurMedium: "var(--goto-blur-medium)",
  blurSmall: "var(--goto-blur-small)",
  blurLarge: "var(--goto-blur-large)",
  blurXlarge: "var(--goto-blur-xlarge)",
  radiusNone: "var(--goto-radius-none)",
  radiusSmall: "var(--goto-radius-small)",
  radiusMedium: "var(--goto-radius-medium)",
  radiusLarge: "var(--goto-radius-large)",
  radiusXlarge: "var(--goto-radius-xlarge)",
  radiusCircle: "var(--goto-radius-circle)",
  spacing00: "var(--goto-spacing-00)",
  spacing01: "var(--goto-spacing-01)",
  spacing02: "var(--goto-spacing-02)",
  spacing03: "var(--goto-spacing-03)",
  spacing04: "var(--goto-spacing-04)",
  spacing05: "var(--goto-spacing-05)",
  spacing06: "var(--goto-spacing-06)",
  spacing07: "var(--goto-spacing-07)",
  spacing08: "var(--goto-spacing-08)",
  spacing09: "var(--goto-spacing-09)",
  spacing10: "var(--goto-spacing-10)",
  spacing11: "var(--goto-spacing-11)",
  layout00: "var(--goto-layout-00)",
  layout01: "var(--goto-layout-01)",
  layout02: "var(--goto-layout-02)",
  layout03: "var(--goto-layout-03)",
  layout04: "var(--goto-layout-04)",
  layout05: "var(--goto-layout-05)",
  layout06: "var(--goto-layout-06)",
  layout07: "var(--goto-layout-07)",
  zIndexDeep: "var(--goto-z-index-deep)",
  zIndexDefault: "var(--goto-z-index-default)",
  zIndexMasked: "var(--goto-z-index-masked)",
  zIndexMask: "var(--goto-z-index-mask)",
  zIndexSticky: "var(--goto-z-index-sticky)",
  zIndexHeader: "var(--goto-z-index-header)",
  zIndexToast: "var(--goto-z-index-toast)",
  zIndexDropdown: "var(--goto-z-index-dropdown)",
  zIndexOverlay: "var(--goto-z-index-overlay)",
  zIndexLoading: "var(--goto-z-index-loading)",
  zIndexModal: "var(--goto-z-index-modal)",
  durationSnappy01: "var(--goto-duration-snappy-01)",
  durationSnappy02: "var(--goto-duration-snappy-02)",
  durationModest01: "var(--goto-duration-modest-01)",
  durationModest02: "var(--goto-duration-modest-02)",
  durationLethargic01: "var(--goto-duration-lethargic-01)",
  durationLethargic02: "var(--goto-duration-lethargic-02)",
  durationSluggish: "var(--goto-duration-sluggish)",
  standardEasing: "var(--goto-standard-easing)",
  entranceEasing: "var(--goto-entrance-easing)",
  exitEasing: "var(--goto-exit-easing)",
  mqSmall: "var(--goto-mq-small)",
  mqMedium: "var(--goto-mq-medium)",
  mqLarge: "var(--goto-mq-large)",
  mqXlarge: "var(--goto-mq-xlarge)",
  headingXlarge: "var(--goto-heading-xlarge)",
  headingLarge: "var(--goto-heading-large)",
  headingMedium: "var(--goto-heading-medium)",
  headingSmall: "var(--goto-heading-small)",
  bodyLarge: "var(--goto-body-large)",
  bodyLargeStrong: "var(--goto-body-large-strong)",
  bodyMedium: "var(--goto-body-medium)",
  bodyMediumStrong: "var(--goto-body-medium-strong)",
  bodySmall: "var(--goto-body-small)",
  bodySmallStrong: "var(--goto-body-small-strong)",
  captionMedium: "var(--goto-caption-medium)",
  captionMediumStrong: "var(--goto-caption-medium-strong)",
  captionSmall: "var(--goto-caption-small)",
  captionSmallStrong: "var(--goto-caption-small-strong)",
  codeMedium: "var(--goto-code-medium)",
  codeSmall: "var(--goto-code-small)",
  buttonXlarge: "var(--goto-button-xlarge)",
  buttonLarge: "var(--goto-button-large)",
  buttonMedium: "var(--goto-button-medium)",
  buttonSmall: "var(--goto-button-small)",
  avatarXxxlarge: "var(--goto-avatar-xxxlarge)",
  avatarXxlarge: "var(--goto-avatar-xxlarge)",
  avatarXlarge: "var(--goto-avatar-xlarge)",
  avatarLarge: "var(--goto-avatar-large)",
  avatarMedium: "var(--goto-avatar-medium)",
  avatarSmall: "var(--goto-avatar-small)",
  avatarXsmall: "var(--goto-avatar-xsmall)",
  fontFamily: "var(--goto-font-family)",
  fontFamilyMono: "var(--goto-font-family-mono)"
};

const colorLight = {
  backgroundColorDefault: "rgba(255, 255, 255, 1)",
  backgroundColorSecondary: "rgba(247, 247, 247, 1)",
  surfaceColorDefault: "rgba(255, 255, 255, 1)",
  surfaceColorDefaultSemitransparent: "rgba(255, 255, 255, 0.7)",
  surfaceColorSecondary: "rgba(247, 247, 247, 1)",
  surfaceColorSecondaryInverted: "rgba(42, 50, 56, 1)",
  surfaceColorTertiary: "rgba(88, 121, 143, 0.9)",
  surfaceColorInverted: "rgba(0, 0, 0, 1)",
  surfaceColorPersistent: "rgba(0, 0, 0, 1)",
  surfaceColorBrandDefault: "rgba(44, 114, 222, 1)",
  surfaceColorBrandSecondary: "rgba(44, 114, 222, 0.1)",
  surfaceColorSuccessDefault: "rgba(27, 135, 86, 1)",
  surfaceColorSuccessSecondary: "rgba(27, 135, 86, 0.1)",
  surfaceColorDangerDefault: "rgba(211, 58, 97, 1)",
  surfaceColorDangerSecondary: "rgba(211, 58, 97, 0.1)",
  surfaceColorWarningDefault: "rgba(242, 221, 6, 1)",
  surfaceColorWarningSecondary: "rgba(242, 221, 6, 0.1)",
  surfaceColorUtilityPurple: "rgba(194, 164, 255, 0.1)",
  surfaceColorUtilityOrange: "rgba(246, 141, 46, 0.1)",
  surfaceColorUtilityBlue: "rgba(44, 114, 222, 0.1)",
  typeColorDefault: "rgba(0, 0, 0, 1)",
  typeColorSecondary: "rgba(42, 50, 56, 0.7)",
  typeColorInverted: "rgba(255, 255, 255, 1)",
  typeColorSecondaryInverted: "rgba(217, 227, 233, 0.7)",
  typeColorPersistent: "rgba(255, 255, 255, 1)",
  typeColorBrandDefault: "rgba(44, 114, 222, 1)",
  typeColorBrandPersistent: "rgba(44, 114, 222, 1)",
  typeColorSuccess: "rgba(27, 135, 86, 1)",
  typeColorDanger: "rgba(211, 58, 97, 1)",
  typeColorWarning: "rgba(165, 148, 30, 1)",
  typeColorDisabled: "rgba(0, 0, 0, 0.3)",
  typeColorPersistentDisabled: "rgba(255, 255, 255, 0.3)",
  iconColorDefault: "rgba(0, 0, 0, 1)",
  iconColorSecondary: "rgba(42, 50, 56, 0.7)",
  iconColorInverted: "rgba(255, 255, 255, 1)",
  iconColorPersistent: "rgba(255, 255, 255, 1)",
  iconColorBrandDefault: "rgba(44, 114, 222, 1)",
  iconColorBrandPersistent: "rgba(44, 114, 222, 1)",
  iconColorSuccess: "rgba(27, 135, 86, 1)",
  iconColorDanger: "rgba(211, 58, 97, 1)",
  iconColorWarning: "rgba(165, 148, 30, 1)",
  iconColorDisabled: "rgba(0, 0, 0, 0.3)",
  iconColorPersistentDisabled: "rgba(255, 255, 255, 0.3)",
  interactiveColorNeutralDefault: "rgba(247, 247, 247, 1)",
  interactiveColorNeutralHover: "rgba(217, 227, 233, 1)",
  interactiveColorNeutralPressed: "rgba(195, 212, 222, 1)",
  interactiveColorPrimaryDefault: "rgba(0, 0, 0, 1)",
  interactiveColorPrimaryHover: "rgba(42, 50, 56, 1)",
  interactiveColorPrimaryPressed: "rgba(49, 62, 73, 1)",
  interactiveColorSecondaryDefault: "rgba(88, 121, 143, 0)",
  interactiveColorSecondaryHover: "rgba(88, 121, 143, 0.1)",
  interactiveColorSecondaryPressed: "rgba(88, 121, 143, 0.3)",
  interactiveColorSuccessDefault: "rgba(27, 135, 86, 1)",
  interactiveColorSuccessHover: "rgba(20, 100, 89, 1)",
  interactiveColorSuccessPressed: "rgba(0, 79, 73, 1)",
  interactiveColorDangerDefault: "rgba(211, 58, 97, 1)",
  interactiveColorDangerHover: "rgba(165, 34, 81, 1)",
  interactiveColorDangerPressed: "rgba(128, 18, 72, 1)",
  interactiveColorBrandDefault: "rgba(44, 114, 222, 1)",
  interactiveColorBrandHover: "rgba(29, 82, 186, 1)",
  interactiveColorBrandPressed: "rgba(15, 53, 153, 1)",
  interactiveColorPersistentDefault: "rgba(0, 0, 0, 1)",
  interactiveColorPersistentHover: "rgba(42, 50, 56, 1)",
  interactiveColorPersistentPressed: "rgba(49, 62, 73, 1)",
  interactiveColorPersistentActive: "rgba(255, 255, 255, 1)",
  interactiveColorDisabled: "rgba(0, 0, 0, 0.1)",
  borderColorDefault: "rgba(88, 121, 143, 0.5)",
  borderColorSecondary: "rgba(247, 247, 247, 1)",
  borderColorInverted: "rgba(152, 182, 201, 0.5)",
  borderColorPersistent: "rgba(88, 121, 143, 0.5)",
  borderColorBrand: "rgba(44, 114, 222, 1)",
  borderColorSuccess: "rgba(27, 135, 86, 1)",
  borderColorWarning: "rgba(165, 148, 30, 1)",
  borderColorDanger: "rgba(211, 58, 97, 1)",
  focusBorderColorDefault: "rgba(255, 255, 255, 1)",
  focusBorderColorSuccess: "rgba(255, 255, 255, 1)",
  focusBorderColorDanger: "rgba(255, 255, 255, 1)",
  focusBorderColorPersistent: "rgba(0, 0, 0, 1)",
  focusColorHighlightDefault: "rgba(0, 0, 0, 1)",
  focusColorHighlightSuccess: "rgba(20, 100, 89, 1)",
  focusColorHighlightDanger: "rgba(165, 34, 81, 1)",
  focusColorHighlightPersistent: "rgba(255, 255, 255, 1)",
  scrimColor: "rgba(42, 50, 56, 0.7)",
  highlightBackgroundColor: "rgba(242, 221, 6, 0.7)",
  highlightTypeColor: "rgba(0, 0, 0, 1)",
  badgeColorZomp: "rgba(41, 150, 157, 1)",
  badgeColorRed: "rgba(253, 76, 111, 1)",
  badgeColorViolet: "rgba(125, 51, 255, 1)",
  badgeColorOrange: "rgba(246, 141, 46, 1)",
  badgeColorAzure: "rgba(64, 144, 255, 1)",
  badgeColorDeeppurple: "rgba(153, 41, 119, 1)",
  badgeColorGreen: "rgba(0, 170, 110, 1)",
  badgeColorBlue: "rgba(0, 192, 243, 1)",
  badgeColorCitron: "rgba(165, 148, 30, 1)",
  badgeColorBlack: "rgba(0, 0, 0, 1)",
  badgeColorGrey: "rgba(70, 91, 107, 0.7)",
  badgeColorQueenblue: "rgba(53, 103, 153, 1)",
  badgeColorBrand: "rgba(44, 114, 222, 1)",
  badgeColorDisabled: "rgba(0, 0, 0, 0.3)",
  badgeColorAssist: "rgba(41, 150, 157, 1)",
  badgeColorCustomer: "rgba(253, 76, 111, 1)",
  badgeColorGotoresolve: "rgba(125, 51, 255, 1)",
  badgeColorMeeting: "rgba(246, 141, 46, 1)",
  badgeColorMessage: "rgba(64, 144, 255, 1)",
  badgeColorTraining: "rgba(153, 41, 119, 1)",
  badgeColorVoice: "rgba(0, 170, 110, 1)",
  badgeColorWebinar: "rgba(0, 192, 243, 1)",
  badgeColorAudio: "rgba(165, 148, 30, 1)",
  badgeColorCustom: "rgba(0, 0, 0, 1)",
  badgeColorFiles: "rgba(70, 91, 107, 0.7)",
  badgeColorDigitalEngagement: "rgba(53, 103, 153, 1)",
  avatarColor00: "rgba(20, 126, 129, 1)",
  avatarColor01: "rgba(0, 127, 163, 1)",
  avatarColor02: "rgba(15, 89, 128, 1)",
  avatarColor10: "rgba(51, 112, 77, 1)",
  avatarColor11: "rgba(29, 83, 62, 1)",
  avatarColor12: "rgba(24, 99, 73, 1)",
  avatarColor20: "rgba(126, 117, 10, 1)",
  avatarColor21: "rgba(99, 92, 10, 1)",
  avatarColor22: "rgba(69, 112, 31, 1)",
  avatarColor30: "rgba(191, 46, 48, 1)",
  avatarColor31: "rgba(175, 76, 8, 1)",
  avatarColor32: "rgba(153, 77, 3, 1)",
  avatarColor40: "rgba(184, 60, 21, 1)",
  avatarColor41: "rgba(163, 88, 109, 1)",
  avatarColor42: "rgba(150, 42, 67, 1)",
  avatarColor50: "rgba(178, 57, 159, 1)",
  avatarColor51: "rgba(129, 104, 168, 1)",
  avatarColor52: "rgba(108, 54, 153, 1)",
  avatarColorPrimary: "rgba(148, 152, 155, 1)",
  avatarColorSecondary: "rgba(217, 227, 233, 1)",
  avatarInteractiveColorOverlayHover: "rgba(0, 0, 0, 0.2)",
  avatarInteractiveColorOverlayPressed: "rgba(0, 0, 0, 0.3)",
  datavizColorBlueDefault: "rgba(44, 114, 222, 0.7)",
  datavizColorBlueHover: "rgba(100, 187, 250, 0.7)",
  datavizColorBluePressed: "rgba(15, 53, 153, 0.7)",
  datavizColorGreenDefault: "rgba(27, 135, 86, 0.7)",
  datavizColorGreenHover: "rgba(83, 206, 115, 0.7)",
  datavizColorGreenPressed: "rgba(0, 79, 73, 0.7)",
  datavizColorRedDefault: "rgba(211, 58, 97, 0.7)",
  datavizColorRedHover: "rgba(230, 162, 162, 0.7)",
  datavizColorRedPressed: "rgba(128, 18, 72, 0.7)",
  datavizColorYellowDefault: "rgba(165, 148, 30, 0.7)",
  datavizColorYellowHover: "rgba(242, 221, 6, 0.7)",
  datavizColorYellowPressed: "rgba(104, 87, 20, 0.7)",
  datavizColorPurpleDefault: "rgba(133, 82, 246, 0.7)",
  datavizColorPurpleHover: "rgba(194, 164, 255, 0.7)",
  datavizColorPurplePressed: "rgba(50, 28, 156, 0.7)",
  blue500: "rgba(44, 114, 222, 1)",
  blue200: "rgba(152, 215, 252, 1)",
  blue100: "rgba(203, 243, 254, 1)",
  blue600: "rgba(29, 82, 186, 1)",
  blue300: "rgba(100, 187, 250, 1)",
  blue700: "rgba(15, 53, 153, 1)",
  blue400: "rgba(71, 145, 255, 1)",
  green500: "rgba(27, 135, 86, 1)",
  green200: "rgba(161, 232, 165, 1)",
  green100: "rgba(209, 246, 207, 1)",
  green600: "rgba(20, 100, 89, 1)",
  green300: "rgba(83, 206, 115, 1)",
  green700: "rgba(0, 79, 73, 1)",
  green400: "rgba(43, 169, 92, 1)",
  red500: "rgba(211, 58, 97, 1)",
  red200: "rgba(244, 195, 191, 1)",
  red100: "rgba(254, 231, 226, 1)",
  red600: "rgba(165, 34, 81, 1)",
  red300: "rgba(230, 162, 162, 1)",
  red700: "rgba(128, 18, 72, 1)",
  red400: "rgba(217, 111, 126, 1)",
  yellow500: "rgba(165, 148, 30, 1)",
  yellow200: "rgba(255, 251, 123, 1)",
  yellow100: "rgba(255, 253, 169, 1)",
  yellow600: "rgba(134, 117, 28, 1)",
  yellow300: "rgba(242, 221, 6, 1)",
  yellow700: "rgba(104, 87, 20, 1)",
  yellow400: "rgba(214, 194, 18, 1)",
  purple500: "rgba(133, 82, 246, 1)",
  purple200: "rgba(218, 196, 255, 1)",
  purple100: "rgba(235, 222, 255, 1)",
  purple600: "rgba(95, 54, 211, 1)",
  purple300: "rgba(194, 164, 255, 1)",
  purple700: "rgba(50, 28, 156, 1)",
  purple400: "rgba(163, 123, 251, 1)",
  orange500: "rgba(179, 95, 17, 1)",
  orange200: "rgba(255, 196, 140, 1)",
  orange100: "rgba(254, 237, 222, 1)",
  orange600: "rgba(140, 68, 0, 1)",
  orange300: "rgba(246, 141, 46, 1)",
  orange700: "rgba(112, 60, 10, 1)",
  orange400: "rgba(219, 120, 28, 1)",
  neutral900: "rgba(0, 0, 0, 1)",
  neutral850: "rgba(23, 27, 31, 1)",
  neutral800: "rgba(34, 41, 46, 1)",
  neutral700: "rgba(49, 62, 73, 1)",
  neutral600: "rgba(70, 91, 107, 1)",
  neutral500: "rgba(88, 121, 143, 1)",
  neutral400: "rgba(115, 153, 175, 1)",
  neutral300: "rgba(152, 182, 201, 1)",
  neutral200: "rgba(195, 212, 222, 1)",
  neutral100: "rgba(217, 227, 233, 1)",
  neutral050: "rgba(247, 247, 247, 1)",
  neutral000: "rgba(255, 255, 255, 1)",
  brandColorPrimaryYellow: "rgba(255, 233, 0, 1)",
  brandColorBlack: "rgba(0, 0, 0, 1)",
  brandColorWhite: "rgba(255, 255, 255, 1)",
  brandColorAdminBlue: "rgba(2, 166, 255, 1)",
  brandColorResolvePurple: "rgba(146, 84, 255, 1)",
  brandColorGotoAppGreen: "rgba(7, 203, 115, 1)",
  brandColorSecureRed: "rgba(233, 42, 96, 1)",
  brandColorGray100: "rgba(217, 230, 236, 1)",
  brandColorGray200: "rgba(178, 205, 219, 1)",
  brandColorGray300: "rgba(140, 180, 200, 1)",
  brandColorGray400: "rgba(99, 155, 182, 1)"
};
const colorDark = {
  backgroundColorDefault: "rgba(34, 41, 46, 1)",
  backgroundColorSecondary: "rgba(23, 27, 31, 1)",
  surfaceColorDefault: "rgba(34, 41, 46, 1)",
  surfaceColorDefaultSemitransparent: "rgba(34, 41, 46, 0.7)",
  surfaceColorSecondary: "rgba(23, 27, 31, 1)",
  surfaceColorSecondaryInverted: "rgba(217, 227, 233, 1)",
  surfaceColorTertiary: "rgba(152, 182, 201, 0.5)",
  surfaceColorInverted: "rgba(255, 255, 255, 1)",
  surfaceColorPersistent: "rgba(0, 0, 0, 1)",
  surfaceColorBrandDefault: "rgba(71, 145, 255, 1)",
  surfaceColorBrandSecondary: "rgba(71, 145, 255, 0.3)",
  surfaceColorSuccessDefault: "rgba(43, 169, 92, 1)",
  surfaceColorSuccessSecondary: "rgba(43, 169, 92, 0.3)",
  surfaceColorDangerDefault: "rgba(211, 58, 97, 1)",
  surfaceColorDangerSecondary: "rgba(211, 58, 97, 0.3)",
  surfaceColorWarningDefault: "rgba(242, 221, 6, 1)",
  surfaceColorWarningSecondary: "rgba(242, 221, 6, 0.3)",
  surfaceColorUtilityPurple: "rgba(163, 123, 251, 0.3)",
  surfaceColorUtilityOrange: "rgba(246, 141, 46, 0.3)",
  surfaceColorUtilityBlue: "rgba(71, 145, 255, 0.3)",
  typeColorDefault: "rgba(255, 255, 255, 1)",
  typeColorSecondary: "rgba(217, 227, 233, 0.7)",
  typeColorInverted: "rgba(0, 0, 0, 1)",
  typeColorSecondaryInverted: "rgba(70, 91, 107, 0.7)",
  typeColorPersistent: "rgba(255, 255, 255, 1)",
  typeColorBrandDefault: "rgba(71, 145, 255, 1)",
  typeColorBrandPersistent: "rgba(44, 114, 222, 1)",
  typeColorSuccess: "rgba(43, 169, 92, 1)",
  typeColorDanger: "rgba(230, 162, 162, 1)",
  typeColorWarning: "rgba(242, 221, 6, 1)",
  typeColorDisabled: "rgba(255, 255, 255, 0.3)",
  typeColorPersistentDisabled: "rgba(255, 255, 255, 0.3)",
  iconColorDefault: "rgba(255, 255, 255, 1)",
  iconColorSecondary: "rgba(217, 227, 233, 0.7)",
  iconColorInverted: "rgba(0, 0, 0, 1)",
  iconColorPersistent: "rgba(255, 255, 255, 1)",
  iconColorBrandDefault: "rgba(71, 145, 255, 1)",
  iconColorBrandPersistent: "rgba(44, 114, 222, 1)",
  iconColorSuccess: "rgba(43, 169, 92, 1)",
  iconColorDanger: "rgba(211, 58, 97, 1)",
  iconColorWarning: "rgba(242, 221, 6, 1)",
  iconColorDisabled: "rgba(255, 255, 255, 0.3)",
  iconColorPersistentDisabled: "rgba(255, 255, 255, 0.3)",
  interactiveColorNeutralDefault: "rgba(61, 72, 82, 1)",
  interactiveColorNeutralHover: "rgba(70, 91, 107, 1)",
  interactiveColorNeutralPressed: "rgba(88, 121, 143, 1)",
  interactiveColorPrimaryDefault: "rgba(217, 227, 233, 1)",
  interactiveColorPrimaryHover: "rgba(195, 212, 222, 1)",
  interactiveColorPrimaryPressed: "rgba(152, 182, 201, 1)",
  interactiveColorSecondaryDefault: "rgba(152, 182, 201, 0)",
  interactiveColorSecondaryHover: "rgba(152, 182, 201, 0.1)",
  interactiveColorSecondaryPressed: "rgba(152, 182, 201, 0.3)",
  interactiveColorSuccessDefault: "rgba(43, 169, 92, 1)",
  interactiveColorSuccessHover: "rgba(83, 206, 115, 1)",
  interactiveColorSuccessPressed: "rgba(161, 232, 165, 1)",
  interactiveColorDangerDefault: "rgba(211, 58, 97, 1)",
  interactiveColorDangerHover: "rgba(217, 111, 126, 1)",
  interactiveColorDangerPressed: "rgba(230, 162, 162, 1)",
  interactiveColorBrandDefault: "rgba(71, 145, 255, 1)",
  interactiveColorBrandHover: "rgba(100, 187, 250, 1)",
  interactiveColorBrandPressed: "rgba(152, 215, 252, 1)",
  interactiveColorPersistentDefault: "rgba(0, 0, 0, 1)",
  interactiveColorPersistentHover: "rgba(42, 50, 56, 1)",
  interactiveColorPersistentPressed: "rgba(61, 72, 82, 1)",
  interactiveColorPersistentActive: "rgba(255, 255, 255, 1)",
  interactiveColorDisabled: "rgba(255, 255, 255, 0.1)",
  borderColorDefault: "rgba(88, 121, 143, 0.5)",
  borderColorSecondary: "rgba(23, 27, 31, 1)",
  borderColorInverted: "rgba(88, 121, 143, 0.5)",
  borderColorPersistent: "rgba(88, 121, 143, 0.5)",
  borderColorBrand: "rgba(71, 145, 255, 1)",
  borderColorSuccess: "rgba(43, 169, 92, 1)",
  borderColorWarning: "rgba(242, 221, 6, 1)",
  borderColorDanger: "rgba(211, 58, 97, 1)",
  focusBorderColorDefault: "rgba(0, 0, 0, 1)",
  focusBorderColorSuccess: "rgba(0, 0, 0, 1)",
  focusBorderColorDanger: "rgba(0, 0, 0, 1)",
  focusBorderColorPersistent: "rgba(0, 0, 0, 1)",
  focusColorHighlightDefault: "rgba(255, 255, 255, 1)",
  focusColorHighlightSuccess: "rgba(161, 232, 165, 1)",
  focusColorHighlightDanger: "rgba(244, 195, 191, 1)",
  focusColorHighlightPersistent: "rgba(255, 255, 255, 1)",
  scrimColor: "rgba(42, 50, 56, 0.7)",
  highlightBackgroundColor: "rgba(165, 148, 30, 0.7)",
  highlightTypeColor: "rgba(255, 255, 255, 1)",
  badgeColorZomp: "rgba(41, 150, 157, 1)",
  badgeColorRed: "rgba(253, 76, 111, 1)",
  badgeColorViolet: "rgba(125, 51, 255, 1)",
  badgeColorOrange: "rgba(246, 141, 46, 1)",
  badgeColorAzure: "rgba(64, 144, 255, 1)",
  badgeColorDeeppurple: "rgba(153, 41, 119, 1)",
  badgeColorGreen: "rgba(0, 170, 110, 1)",
  badgeColorBlue: "rgba(0, 192, 243, 1)",
  badgeColorCitron: "rgba(242, 221, 6, 1)",
  badgeColorBlack: "rgba(255, 255, 255, 1)",
  badgeColorGrey: "rgba(152, 182, 201, 0.7)",
  badgeColorQueenblue: "rgba(53, 103, 153, 1)",
  badgeColorBrand: "rgba(71, 145, 255, 1)",
  badgeColorDisabled: "rgba(255, 255, 255, 0.3)",
  badgeColorAssist: "rgba(41, 150, 157, 1)",
  badgeColorCustomer: "rgba(253, 76, 111, 1)",
  badgeColorGotoresolve: "rgba(125, 51, 255, 1)",
  badgeColorMeeting: "rgba(246, 141, 46, 1)",
  badgeColorMessage: "rgba(64, 144, 255, 1)",
  badgeColorTraining: "rgba(153, 41, 119, 1)",
  badgeColorVoice: "rgba(0, 170, 110, 1)",
  badgeColorWebinar: "rgba(0, 192, 243, 1)",
  badgeColorAudio: "rgba(242, 221, 6, 1)",
  badgeColorCustom: "rgba(255, 255, 255, 1)",
  badgeColorFiles: "rgba(152, 182, 201, 0.7)",
  badgeColorDigitalEngagement: "rgba(53, 103, 153, 1)",
  avatarColor00: "rgba(190, 217, 254, 1)",
  avatarColor01: "rgba(63, 192, 193, 1)",
  avatarColor02: "rgba(31, 156, 182, 1)",
  avatarColor10: "rgba(127, 254, 209, 1)",
  avatarColor11: "rgba(112, 206, 95, 1)",
  avatarColor12: "rgba(0, 169, 110, 1)",
  avatarColor20: "rgba(254, 231, 139, 1)",
  avatarColor21: "rgba(203, 184, 93, 1)",
  avatarColor22: "rgba(216, 172, 0, 1)",
  avatarColor30: "rgba(254, 189, 127, 1)",
  avatarColor31: "rgba(239, 137, 83, 1)",
  avatarColor32: "rgba(218, 120, 28, 1)",
  avatarColor40: "rgba(249, 179, 193, 1)",
  avatarColor41: "rgba(240, 134, 186, 1)",
  avatarColor42: "rgba(252, 76, 111, 1)",
  avatarColor50: "rgba(212, 190, 254, 1)",
  avatarColor51: "rgba(191, 158, 255, 1)",
  avatarColor52: "rgba(154, 102, 254, 1)",
  avatarColorPrimary: "rgba(126, 134, 139, 1)",
  avatarColorSecondary: "rgba(61, 72, 82, 1)",
  avatarInteractiveColorOverlayHover: "rgba(0, 0, 0, 0.2)",
  avatarInteractiveColorOverlayPressed: "rgba(0, 0, 0, 0.3)",
  datavizColorBlueDefault: "rgba(100, 187, 250, 0.9)",
  datavizColorBlueHover: "rgba(203, 243, 254, 0.9)",
  datavizColorBluePressed: "rgba(44, 114, 222, 0.9)",
  datavizColorGreenDefault: "rgba(83, 206, 115, 0.9)",
  datavizColorGreenHover: "rgba(209, 246, 207, 0.9)",
  datavizColorGreenPressed: "rgba(27, 135, 86, 0.9)",
  datavizColorRedDefault: "rgba(230, 162, 162, 0.9)",
  datavizColorRedHover: "rgba(254, 231, 226, 0.9)",
  datavizColorRedPressed: "rgba(211, 58, 97, 0.9)",
  datavizColorYellowDefault: "rgba(242, 221, 6, 0.9)",
  datavizColorYellowHover: "rgba(255, 253, 169, 0.9)",
  datavizColorYellowPressed: "rgba(165, 148, 30, 0.9)",
  datavizColorPurpleDefault: "rgba(194, 164, 255, 0.9)",
  datavizColorPurpleHover: "rgba(235, 222, 255, 0.9)",
  datavizColorPurplePressed: "rgba(133, 82, 246, 0.9)",
  brandColorPrimaryYellow: "rgba(255, 233, 0, 1)",
  brandColorBlack: "rgba(255, 255, 255, 1)",
  brandColorWhite: "rgba(0, 0, 0, 1)",
  brandColorAdminBlue: "rgba(2, 166, 255, 1)",
  brandColorResolvePurple: "rgba(146, 84, 255, 1)",
  brandColorGotoAppGreen: "rgba(7, 203, 115, 1)",
  brandColorSecureRed: "rgba(233, 42, 96, 1)",
  brandColorGray100: "rgba(217, 230, 236, 1)",
  brandColorGray200: "rgba(178, 205, 219, 1)",
  brandColorGray300: "rgba(140, 180, 200, 1)",
  brandColorGray400: "rgba(99, 155, 182, 1)",
  blue500: "rgba(44, 114, 222, 1)",
  blue200: "rgba(152, 215, 252, 1)",
  blue100: "rgba(203, 243, 254, 1)",
  blue600: "rgba(29, 82, 186, 1)",
  blue300: "rgba(100, 187, 250, 1)",
  blue700: "rgba(15, 53, 153, 1)",
  blue400: "rgba(71, 145, 255, 1)",
  green500: "rgba(27, 135, 86, 1)",
  green200: "rgba(161, 232, 165, 1)",
  green100: "rgba(209, 246, 207, 1)",
  green600: "rgba(20, 100, 89, 1)",
  green300: "rgba(83, 206, 115, 1)",
  green700: "rgba(0, 79, 73, 1)",
  green400: "rgba(43, 169, 92, 1)",
  red500: "rgba(211, 58, 97, 1)",
  red200: "rgba(244, 195, 191, 1)",
  red100: "rgba(254, 231, 226, 1)",
  red600: "rgba(165, 34, 81, 1)",
  red300: "rgba(230, 162, 162, 1)",
  red700: "rgba(128, 18, 72, 1)",
  red400: "rgba(217, 111, 126, 1)",
  yellow500: "rgba(165, 148, 30, 1)",
  yellow200: "rgba(255, 251, 123, 1)",
  yellow100: "rgba(255, 253, 169, 1)",
  yellow600: "rgba(134, 117, 28, 1)",
  yellow300: "rgba(242, 221, 6, 1)",
  yellow700: "rgba(104, 87, 20, 1)",
  yellow400: "rgba(214, 194, 18, 1)",
  purple500: "rgba(133, 82, 246, 1)",
  purple200: "rgba(218, 196, 255, 1)",
  purple100: "rgba(235, 222, 255, 1)",
  purple600: "rgba(95, 54, 211, 1)",
  purple300: "rgba(194, 164, 255, 1)",
  purple700: "rgba(50, 28, 156, 1)",
  purple400: "rgba(163, 123, 251, 1)",
  orange500: "rgba(179, 95, 17, 1)",
  orange200: "rgba(255, 196, 140, 1)",
  orange100: "rgba(254, 237, 222, 1)",
  orange600: "rgba(140, 68, 0, 1)",
  orange300: "rgba(246, 141, 46, 1)",
  orange700: "rgba(112, 60, 10, 1)",
  orange400: "rgba(219, 120, 28, 1)",
  neutral900: "rgba(0, 0, 0, 1)",
  neutral850: "rgba(23, 27, 31, 1)",
  neutral800: "rgba(34, 41, 46, 1)",
  neutral700: "rgba(61, 72, 82, 1)",
  neutral600: "rgba(70, 91, 107, 1)",
  neutral500: "rgba(88, 121, 143, 1)",
  neutral400: "rgba(115, 153, 175, 1)",
  neutral300: "rgba(152, 182, 201, 1)",
  neutral200: "rgba(195, 212, 222, 1)",
  neutral100: "rgba(217, 227, 233, 1)",
  neutral050: "rgba(242, 246, 247, 1)",
  neutral000: "rgba(255, 255, 255, 1)"
};

const spacingLight = {
  spacing00: "0rem",
  spacing01: "0.25rem",
  spacing02: "0.5rem",
  spacing03: "0.75rem",
  spacing04: "1rem",
  spacing05: "1.25rem",
  spacing06: "1.5rem",
  spacing07: "2rem",
  spacing08: "2.5rem",
  spacing09: "3rem",
  spacing10: "3.5rem",
  spacing11: "4rem",
  layout00: "0rem",
  layout01: "1rem",
  layout02: "1.5rem",
  layout03: "2rem",
  layout04: "3rem",
  layout05: "4rem",
  layout06: "6rem",
  layout07: "10rem"
};

var styles$u = {"root":"ua-common_10-0-0_AutocompleteTextField__root__f2fcd","Mui-disabled":"ua-common_10-0-0_AutocompleteTextField__Mui-disabled__f2fcd","focused":"ua-common_10-0-0_AutocompleteTextField__focused__f2fcd","field":"ua-common_10-0-0_AutocompleteTextField__field__f2fcd","fullWidth":"ua-common_10-0-0_AutocompleteTextField__fullWidth__f2fcd","mainContainer":"ua-common_10-0-0_AutocompleteTextField__mainContainer__f2fcd","labelContainer":"ua-common_10-0-0_AutocompleteTextField__labelContainer__f2fcd","flexContainer":"ua-common_10-0-0_AutocompleteTextField__flexContainer__f2fcd","invalid":"ua-common_10-0-0_AutocompleteTextField__invalid__f2fcd"};

var _excluded$F = ["children"];
var HelperText = function HelperText(_ref) {
  var children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded$F);
  return jsx(Typography, _objectSpread2(_objectSpread2({}, otherProps), {}, {
    variant: "caption-medium",
    color: "type-color-secondary",
    children: children
  }));
};

var _excluded$E = ["disabled", "helperText", "label", "inputProps", "InputProps", "InputLabelProps", "fullWidth", "freeSolo", "name", "inputClasses"];
var AutocompleteTextField = function AutocompleteTextField(_ref) {
  var disabled = _ref.disabled,
    helperText = _ref.helperText,
    label = _ref.label,
    inputProps = _ref.inputProps,
    InputProps = _ref.InputProps,
    InputLabelProps = _ref.InputLabelProps,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
    _ref$freeSolo = _ref.freeSolo,
    freeSolo = _ref$freeSolo === void 0 ? false : _ref$freeSolo,
    name = _ref.name,
    inputClasses = _ref.inputClasses,
    otherProps = _objectWithoutProperties(_ref, _excluded$E);
  var _useField = useField(name || ''),
    _useField2 = _slicedToArray(_useField, 2),
    meta = _useField2[1];
  return jsx("div", {
    className: styles$u.mainContainer,
    children: jsxs("div", {
      className: styles$u.flexContainer,
      children: [jsxs("div", {
        className: styles$u.flexContainer,
        children: [label && jsx("div", {
          className: styles$u.labelContainer,
          children: jsx(Typography, {
            variant: "caption-medium-strong",
            tag: "label",
            children: label
          })
        }), jsx("div", {
          children: freeSolo ? jsx(TextField, _objectSpread2({
            variant: "standard",
            InputLabelProps: _objectSpread2({
              shrink: true
            }, InputLabelProps),
            fullWidth: fullWidth,
            className: clsx(styles$u.field, fullWidth && styles$u.fullWidth),
            disabled: disabled,
            InputProps: _objectSpread2({
              classes: {
                root: clsx(styles$u.root, inputClasses && inputClasses),
                fullWidth: styles$u.fullWidth,
                focused: styles$u.focused
              },
              disableUnderline: true,
              autoComplete: 'disabled',
              startAdornment: (InputProps === null || InputProps === void 0 ? void 0 : InputProps.startAdornment) && jsx(InputAdornment, {
                disableTypography: true,
                position: "start",
                children: InputProps.startAdornment
              }),
              endAdornment: (InputProps === null || InputProps === void 0 ? void 0 : InputProps.endAdornment) && jsx(InputAdornment, {
                disableTypography: true,
                position: "end",
                children: InputProps.endAdornment
              })
            }, omit(InputProps, ['className', 'endEndorment', 'startEndorment'])),
            inputProps: _objectSpread2({
              'aria-describedby': "textfield-helper-text",
              'data-lpignore': true,
              disabled: disabled,
              style: {
                padding: 0
              }
            }, inputProps)
          }, otherProps)) : jsx(Field, _objectSpread2({
            id: "textfield-".concat(name),
            component: TextField$1,
            name: name,
            InputLabelProps: _objectSpread2({
              shrink: true
            }, InputLabelProps),
            fullWidth: fullWidth,
            className: clsx(styles$u.field, fullWidth && styles$u.fullWidth),
            disabled: disabled,
            InputProps: _objectSpread2({
              classes: _objectSpread2(_objectSpread2({}, InputProps === null || InputProps === void 0 ? void 0 : InputProps.classes), {}, {
                root: styles$u.root,
                fullWidth: styles$u.fullWidth,
                focused: styles$u.focused
              }),
              className: clsx(InputProps === null || InputProps === void 0 ? void 0 : InputProps.className, Object.values((meta === null || meta === void 0 ? void 0 : meta.error) || {}).length > 1 && (meta === null || meta === void 0 ? void 0 : meta.touched) && styles$u.invalid),
              disableUnderline: true,
              autoComplete: 'disabled',
              startAdornment: (InputProps === null || InputProps === void 0 ? void 0 : InputProps.startAdornment) && jsx(InputAdornment, {
                disableTypography: true,
                position: "start",
                children: InputProps.startAdornment
              }),
              endAdornment: (InputProps === null || InputProps === void 0 ? void 0 : InputProps.endAdornment) && jsx(InputAdornment, {
                disableTypography: true,
                position: "end",
                children: InputProps.endAdornment
              })
            }, omit(InputProps, ['className', 'endEndorment', 'startEndorment'])),
            inputProps: _objectSpread2({
              'aria-describedby': "textfield-".concat(name, "-helper-text"),
              'data-lpignore': true,
              disabled: disabled,
              style: {
                padding: 0
              }
            }, inputProps)
          }, omit(otherProps, 'id')))
        })]
      }), helperText && jsx("div", {
        style: {
          marginTop: tokens.spacing01
        },
        children: jsx(HelperText, {
          id: "textfield-helper-text",
          children: helperText
        })
      })]
    })
  });
};
var AutocompleteTextField$1 = memo(AutocompleteTextField);

function SearchBar(_ref) {
  var query = _ref.query,
    setQuery = _ref.setQuery,
    className = _ref.className;
  var t = useTranslate();
  var _useState = useState(query),
    _useState2 = _slicedToArray(_useState, 2),
    val = _useState2[0],
    setVal = _useState2[1];
  var _useDebounce = useDebounce(function () {
      setQuery(val);
    }, 275, [val]);
    _slicedToArray(_useDebounce, 1);
  useEffect(function () {
    // Prefill the search input if there's already a search query param
    if (document.getElementById('searchBar') && query) {
      document.getElementById('searchBar').value = query;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return jsx(SearchField, {
    labelId: t('Search bar'),
    "aria-label": t('Search bar'),
    "data-testid": "search-menu",
    autoComplete: "off",
    "aria-describedby": undefined,
    value: val,
    id: "searchBar",
    className: className,
    placeholder: t('Search...'),
    onChange: function onChange(event) {
      return setVal(event.target.value || '');
    }
  });
}

var _excluded$D = ["children", "disabled", "fullWidth", "onBlur", "onChange", "style"];
var FormikCheckbox = function FormikCheckbox(_ref) {
  var children = _ref.children,
    disabled = _ref.disabled,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    _onBlur = _ref.onBlur,
    _onChange = _ref.onChange,
    style = _ref.style,
    otherProps = _objectWithoutProperties(_ref, _excluded$D);
  var _useFormikContext = useFormikContext(),
    getFieldMeta = _useFormikContext.getFieldMeta,
    handleBlur = _useFormikContext.handleBlur,
    isSubmitting = _useFormikContext.isSubmitting;
  var meta = getFieldMeta(otherProps.name);
  return jsx(Checkbox, _objectSpread2(_objectSpread2({}, otherProps), {}, {
    checked: meta.value,
    disabled: isSubmitting || !!disabled,
    onBlur: function onBlur(e) {
      handleBlur(e);
      _onBlur && _onBlur(e);
    },
    onChange: function onChange(e) {
      // This value check is made in order to fix a bug where the onChange event is triggered on component mount
      // It's also preventing the onChange to be triggered when the value is programmatically changed, as expected according to the web standards
      if (_onChange && meta.value !== e.target.checked) {
        // This is a quick fix to allow Formik to handle events from this control easily.
        // handleChange works with the target value. Chameleon-web uses on and off for the switch value and it doesn't work for boolean value out of the box.
        e.target.value = e.target.checked;
        _onChange(e);
      }
    },
    style: _objectSpread2(_objectSpread2({}, style), {}, {
      width: fullWidth ? '100%' : undefined
    }),
    children: children
  }));
};

function hasErrorToShow(meta, submitCount) {
  var skipSubmitCountValidation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var runValidationOnInitialValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return meta.error !== undefined && meta.touched && (runValidationOnInitialValue || meta.value !== meta.initialValue) || meta.error !== undefined && meta.touched && meta.value === '' || (skipSubmitCountValidation ? meta.error !== undefined : meta.error !== undefined && submitCount > 0);
}

var _excluded$C = ["disabled", "fullWidth", "label", "onBlur", "style", "runValidationOnInitialValue"];
var FormikNumberField = function FormikNumberField(_ref) {
  var disabled = _ref.disabled,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    label = _ref.label,
    _onBlur = _ref.onBlur,
    style = _ref.style,
    _ref$runValidationOnI = _ref.runValidationOnInitialValue,
    runValidationOnInitialValue = _ref$runValidationOnI === void 0 ? false : _ref$runValidationOnI,
    otherProps = _objectWithoutProperties(_ref, _excluded$C);
  var _useFormikContext = useFormikContext(),
    getFieldMeta = _useFormikContext.getFieldMeta,
    handleBlur = _useFormikContext.handleBlur,
    isSubmitting = _useFormikContext.isSubmitting,
    submitCount = _useFormikContext.submitCount;
  var meta = getFieldMeta(otherProps.name);
  var error = hasErrorToShow(meta, submitCount, false, runValidationOnInitialValue);
  return jsx(NumberField, _objectSpread2(_objectSpread2({}, otherProps), {}, {
    disabled: isSubmitting || !!disabled,
    error: error,
    helperText: error ? meta.error : undefined,
    onBlur: function onBlur(e) {
      handleBlur(e);
      _onBlur && _onBlur(e);
    },
    role: "textbox",
    style: _objectSpread2(_objectSpread2({}, style), {}, {
      width: fullWidth ? '100%' : undefined
    }),
    value: meta.value,
    children: label
  }));
};

var _excluded$B = ["children", "disabled", "fullWidth", "label", "onBlur", "onChange", "style"];
var FormikRadioGroup = function FormikRadioGroup(_ref) {
  var children = _ref.children,
    disabled = _ref.disabled,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    label = _ref.label,
    _onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    style = _ref.style,
    otherProps = _objectWithoutProperties(_ref, _excluded$B);
  var _useFormikContext = useFormikContext(),
    getFieldMeta = _useFormikContext.getFieldMeta,
    handleBlur = _useFormikContext.handleBlur,
    isSubmitting = _useFormikContext.isSubmitting,
    handleChange = _useFormikContext.handleChange;
  var meta = getFieldMeta(otherProps.name);
  return jsx(RadioGroup, _objectSpread2(_objectSpread2({}, otherProps), {}, {
    disabled: isSubmitting || !!disabled,
    label: label,
    onBlur: function onBlur(e) {
      handleBlur(e);
      _onBlur && _onBlur(e);
    },
    onChange: onChange !== null && onChange !== void 0 ? onChange : handleChange,
    style: _objectSpread2(_objectSpread2({}, style), {}, {
      width: fullWidth ? '100%' : undefined
    }),
    value: meta.value,
    children: children
  }));
};

var styles$t = {"select":"ua-common_10-0-0_FormikSelect__select__306d1","selectLarger":"ua-common_10-0-0_FormikSelect__selectLarger__306d1","selectNoValue":"ua-common_10-0-0_FormikSelect__selectNoValue__306d1"};

var _excluded$A = ["className", "disabled", "onBlur", "style", "runValidationOnInitialValue"];
// Necessary so the helpertext with error is displayed
var DEFAULT_HELPERTEXT = ' ';
var FormikSelect = function FormikSelect(_ref) {
  var className = _ref.className,
    disabled = _ref.disabled,
    _onBlur = _ref.onBlur,
    style = _ref.style,
    _ref$runValidationOnI = _ref.runValidationOnInitialValue,
    runValidationOnInitialValue = _ref$runValidationOnI === void 0 ? false : _ref$runValidationOnI,
    otherProps = _objectWithoutProperties(_ref, _excluded$A);
  var _useFormikContext = useFormikContext(),
    getFieldMeta = _useFormikContext.getFieldMeta,
    handleBlur = _useFormikContext.handleBlur,
    isSubmitting = _useFormikContext.isSubmitting,
    submitCount = _useFormikContext.submitCount;
  var meta = getFieldMeta(otherProps.name);
  var error = hasErrorToShow(meta, submitCount, false, runValidationOnInitialValue);
  return jsxs(Select, _objectSpread2(_objectSpread2({}, otherProps), {}, {
    className: clsx(className, styles$t.select, !disabled && !meta.value && styles$t.selectNoValue, otherProps.size !== 'small' && styles$t.selectLarger),
    disabled: isSubmitting || !!disabled,
    error: error,
    helperText: error ? meta.error : DEFAULT_HELPERTEXT,
    label: otherProps.label,
    onBlur: function onBlur(e) {
      handleBlur(e);
      _onBlur && _onBlur(e);
    },
    style: style,
    value: meta.value || 'placeholder',
    children: [otherProps.placeholder && jsx(Option, {
      value: "placeholder",
      style: {
        display: 'none'
      },
      children: otherProps.placeholder
    }), otherProps.children]
  }));
};

function trimAllSpaces(str) {
  return str && str.replace(/(^[\s\u200b\u180e]*|[\s\u200b\u180e]*$)/g, '');
}

var styles$s = {"labelNoValue":"ua-common_10-0-0_FormikTextArea__labelNoValue__64147","noBackground":"ua-common_10-0-0_FormikTextArea__noBackground__64147","noBorder":"ua-common_10-0-0_FormikTextArea__noBorder__64147","noPadding":"ua-common_10-0-0_FormikTextArea__noPadding__64147"};

var _excluded$z = ["className", "disabled", "label", "helperText", "onBlur", "onChange", "style", "showError", "noBackground", "noBorder", "noPadding", "runValidationOnInitialValue"];
var FormikTextArea = function FormikTextArea(_ref) {
  var className = _ref.className,
    disabled = _ref.disabled,
    label = _ref.label,
    helperText = _ref.helperText,
    _onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    style = _ref.style,
    _ref$showError = _ref.showError,
    showError = _ref$showError === void 0 ? true : _ref$showError,
    _ref$noBackground = _ref.noBackground,
    noBackground = _ref$noBackground === void 0 ? false : _ref$noBackground,
    _ref$noBorder = _ref.noBorder,
    noBorder = _ref$noBorder === void 0 ? false : _ref$noBorder,
    _ref$noPadding = _ref.noPadding,
    noPadding = _ref$noPadding === void 0 ? false : _ref$noPadding,
    _ref$runValidationOnI = _ref.runValidationOnInitialValue,
    runValidationOnInitialValue = _ref$runValidationOnI === void 0 ? false : _ref$runValidationOnI,
    otherProps = _objectWithoutProperties(_ref, _excluded$z);
  var _useFormikContext = useFormikContext(),
    getFieldMeta = _useFormikContext.getFieldMeta,
    handleBlur = _useFormikContext.handleBlur,
    isSubmitting = _useFormikContext.isSubmitting,
    submitCount = _useFormikContext.submitCount;
  var meta = getFieldMeta(otherProps.name);
  var error = hasErrorToShow(meta, submitCount, false, runValidationOnInitialValue);
  return jsx(TextArea, _objectSpread2(_objectSpread2({}, otherProps), {}, {
    className: clsx(className, !label && styles$s.labelNoValue, noBackground && styles$s.noBackground, noBorder && styles$s.noBorder, noPadding && styles$s.noPadding),
    disabled: isSubmitting || !!disabled,
    error: error,
    helperText: showError && error ? meta.error : helperText,
    onBlur: function onBlur(e) {
      e.target.value = trimAllSpaces(e.target.value);
      onChange && onChange(e);
      handleBlur(e);
      _onBlur && _onBlur(e);
    },
    onChange: onChange,
    role: "textbox",
    style: style,
    value: meta.value,
    children: label
  }));
};

var styles$r = {"labelNoValue":"ua-common_10-0-0_FormikTextField__labelNoValue__64147","noBackground":"ua-common_10-0-0_FormikTextField__noBackground__64147","noBorder":"ua-common_10-0-0_FormikTextField__noBorder__64147","noPadding":"ua-common_10-0-0_FormikTextField__noPadding__64147"};

var _excluded$y = ["className", "disabled", "label", "helperText", "onBlur", "onChange", "style", "showError", "noBackground", "noBorder", "noPadding", "skipSubmitCountValidation", "formatValue", "runValidationOnInitialValue"];
var FormikTextField = function FormikTextField(_ref) {
  var className = _ref.className,
    disabled = _ref.disabled,
    label = _ref.label,
    helperText = _ref.helperText,
    _onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    style = _ref.style,
    _ref$showError = _ref.showError,
    showError = _ref$showError === void 0 ? true : _ref$showError,
    _ref$noBackground = _ref.noBackground,
    noBackground = _ref$noBackground === void 0 ? false : _ref$noBackground,
    _ref$noBorder = _ref.noBorder,
    noBorder = _ref$noBorder === void 0 ? false : _ref$noBorder,
    _ref$noPadding = _ref.noPadding,
    noPadding = _ref$noPadding === void 0 ? false : _ref$noPadding,
    _ref$skipSubmitCountV = _ref.skipSubmitCountValidation,
    skipSubmitCountValidation = _ref$skipSubmitCountV === void 0 ? false : _ref$skipSubmitCountV,
    formatValue = _ref.formatValue,
    _ref$runValidationOnI = _ref.runValidationOnInitialValue,
    runValidationOnInitialValue = _ref$runValidationOnI === void 0 ? false : _ref$runValidationOnI,
    otherProps = _objectWithoutProperties(_ref, _excluded$y);
  var _useFormikContext = useFormikContext(),
    getFieldMeta = _useFormikContext.getFieldMeta,
    handleBlur = _useFormikContext.handleBlur,
    isSubmitting = _useFormikContext.isSubmitting,
    submitCount = _useFormikContext.submitCount;
  var meta = getFieldMeta(otherProps.name);
  var error = hasErrorToShow(meta, submitCount, skipSubmitCountValidation, runValidationOnInitialValue);
  return jsx(TextField$2, _objectSpread2(_objectSpread2({}, otherProps), {}, {
    className: clsx(className, !label && styles$r.labelNoValue, noBackground && styles$r.noBackground, noBorder && styles$r.noBorder, noPadding && styles$r.noPadding),
    disabled: isSubmitting || !!disabled,
    error: error,
    helperText: showError && error ? jsxs("div", {
      style: {
        display: 'flex',
        flexDirection: 'column'
      },
      children: [jsx("div", {
        children: meta.error
      }), jsx("div", {
        style: {
          color: tokens.typeColorSecondary
        },
        children: helperText
      })]
    }) : helperText,
    onBlur: function onBlur(e) {
      e.target.value = trimAllSpaces(e.target.value);
      onChange && onChange(e);
      handleBlur(e);
      _onBlur && _onBlur(e);
    },
    onChange: onChange,
    role: "textbox",
    style: style,
    value: formatValue ? formatValue(meta.value) : meta.value,
    children: label
  }));
};

var styles$q = {"host":"ua-common_10-0-0_PatchedCheckbox__host__7c7c3","Mui-disabled":"ua-common_10-0-0_PatchedCheckbox__Mui-disabled__7c7c3","Mui-checked":"ua-common_10-0-0_PatchedCheckbox__Mui-checked__7c7c3","emptyBoxStyle":"ua-common_10-0-0_PatchedCheckbox__emptyBoxStyle__7c7c3","enabled":"ua-common_10-0-0_PatchedCheckbox__enabled__7c7c3","disabled":"ua-common_10-0-0_PatchedCheckbox__disabled__7c7c3","boxWithIcon":"ua-common_10-0-0_PatchedCheckbox__boxWithIcon__7c7c3","active":"ua-common_10-0-0_PatchedCheckbox__active__7c7c3"};

var _excluded$x = ["disabled"];
var PatchedCheckbox = function PatchedCheckbox(_ref) {
  var _clsx, _clsx2, _clsx3;
  var disabled = _ref.disabled,
    otherProps = _objectWithoutProperties(_ref, _excluded$x);
  return jsx(Checkbox$1, _objectSpread2({
    className: clsx(styles$q.host),
    icon: jsx("div", {
      className: clsx(styles$q.emptyBoxStyle, (_clsx = {}, _defineProperty(_clsx, styles$q.disabled, disabled), _defineProperty(_clsx, styles$q.enabled, !disabled), _clsx))
    }),
    checkedIcon: jsx("div", {
      className: clsx(styles$q.boxWithIcon, (_clsx2 = {}, _defineProperty(_clsx2, styles$q.disabled, disabled), _defineProperty(_clsx2, styles$q.enabled, !disabled), _clsx2)),
      children: jsx(CheckboxCheckIcon, {})
    }),
    indeterminateIcon: jsx("div", {
      className: clsx(styles$q.boxWithIcon, (_clsx3 = {}, _defineProperty(_clsx3, styles$q.disabled, disabled), _defineProperty(_clsx3, styles$q.enabled, !disabled), _clsx3)),
      children: jsx(CheckboxLineIcon, {})
    }),
    disabled: disabled
  }, otherProps));
};
var PatchedCheckbox$1 = memo(PatchedCheckbox);

var usePerformanceMeasure = function usePerformanceMeasure() {
  var isFirstMount = useFirstMountState();
  var measureFromStartMark = useCallback(function (measureName, startMark) {
    var _window$goToAdminPerf;
    //@ts-ignore
    (_window$goToAdminPerf = window.goToAdminPerformer) === null || _window$goToAdminPerf === void 0 ? void 0 : _window$goToAdminPerf.createAndLogMeasureFromStartMark({
      measureName: measureName,
      startMark: startMark
    });
  }, []);
  var measureFromStartMarkOnFirstMount = useCallback(function (measureName, startMark) {
    isFirstMount && measureFromStartMark(measureName, startMark);
  }, [isFirstMount, measureFromStartMark]);
  var mark = function mark(markName) {
    performance.mark(markName);
  };
  var markOnFirstMount = useCallback(function (markName) {
    isFirstMount && mark(markName);
  }, [isFirstMount]);
  return {
    mark: mark,
    markOnFirstMount: markOnFirstMount,
    measureFromStartMark: measureFromStartMark,
    measureFromStartMarkOnFirstMount: measureFromStartMarkOnFirstMount
  };
};

var PageHeaderHeightContext = createContext({
  height: 0
});
var usePageHeaderContext = function usePageHeaderContext() {
  return useContext(PageHeaderHeightContext);
};

var usePageHeader = function usePageHeader() {
  var pageHeaderContext = usePageHeaderContext();
  var pageLayoutSubHeaderStyle = useMemo(function () {
    return {
      position: 'sticky',
      top: pageHeaderContext.height,
      zIndex: 3,
      backgroundColor: tokens.backgroundColorDefault
    };
  }, [pageHeaderContext.height]);
  return {
    pageLayoutSubHeaderStyle: pageLayoutSubHeaderStyle
  };
};

var Roles;
(function (Roles) {
  Roles["SuperAdmin"] = "SUPER_USER";
  Roles["Admin"] = "MANAGE_ACCOUNT";
  Roles["BillingAdmin"] = "BILLING_ADMIN";
  Roles["SystemUser"] = "SYSTEM_USER";
  Roles["ManageUsers"] = "MANAGE_USERS";
  Roles["ManageGroups"] = "MANAGE_GROUPS";
  Roles["ManageSeats"] = "MANAGE_SEATS";
  Roles["ManageSettings"] = "MANAGE_SETTINGS";
  Roles["ManageDeviceGroups"] = "MANAGE_DEVICE_GROUPS";
  Roles["ManageSettingsProfiles"] = "MANAGE_SETTINGS_PROFILES";
  Roles["ManageEmergencyServies"] = "MANAGE_EMERGENCY_SERVICES";
  Roles["RunReports"] = "RUN_REPORTS";
  Roles["ViewInvoices"] = "VIEW_INVOICES";
  Roles["ViewAndPayInvoices"] = "VIEW_AND_PAY_INVOICES";
  Roles["ViewCallRecordings"] = "VIEW_CALL_RECORDINGS";
  Roles["Partner"] = "PARTNER";
})(Roles || (Roles = {}));
var BillingRoles;
(function (BillingRoles) {
  BillingRoles["BillingAdmin"] = "BILLING_ADMIN";
  BillingRoles["AddModifyBillingAdmins"] = "ADD_MODIFY_BILLING_ADMINS";
  BillingRoles["CancelSubscriptions"] = "CANCEL_SUBSCRIPTIONS";
  BillingRoles["CreateEditCustomBillingAdminRole"] = "CREATE_EDIT_CUSTOM_BILLING_ADMIN_ROLE";
  BillingRoles["EditAddresses"] = "EDIT_ADDRESSES";
  BillingRoles["EditPaymentMethods"] = "EDIT_PAYMENT_METHODS";
  BillingRoles["EditSubscriptions"] = "EDIT_SUBSCRIPTIONS";
  BillingRoles["EditTaxExemption"] = "EDIT_TAX_EXEMPTION";
  BillingRoles["ParentAccess"] = "PARENT_ACCESS";
  BillingRoles["PayInvoices"] = "PAY_INVOICES";
  BillingRoles["ProcessQuotes"] = "PROCESS_QUOTES";
  BillingRoles["ViewAddresses"] = "VIEW_ADDRESSES";
  BillingRoles["ViewInvoices"] = "VIEW_INVOICES";
  BillingRoles["ViewPaymentMethods"] = "VIEW_PAYMENT_METHODS";
  BillingRoles["ViewQuotes"] = "VIEW_QUOTES";
  BillingRoles["ViewSubscriptions"] = "VIEW_SUBSCRIPTIONS";
  BillingRoles["ViewTaxExemption"] = "VIEW_TAX_EXEMPTION";
  BillingRoles["ViewTIB"] = "VIEW_TIB";
})(BillingRoles || (BillingRoles = {}));
var ALL_PRIVILEGES = 'all-privileges';
var GlobalSecurityContext = createContext({});
// To simplify unit testing, we export these utilities to enable and disable the security
// checks
var isSecurityContextEnabled = true;
var disableSecurityContext = function disableSecurityContext() {
  return isSecurityContextEnabled = false;
};
var enableSecurityContext = function enableSecurityContext() {
  return isSecurityContextEnabled = true;
};
var isPrivilegeGranted = function isPrivilegeGranted(privilege, context) {
  if (!isSecurityContextEnabled) return true;
  if (privilege in context) {
    return context[privilege];
  }
  return ALL_PRIVILEGES in context ? context[ALL_PRIVILEGES] : false;
};
var buildSecurityContext = function buildSecurityContext(roles, mappers) {
  return roles.reduce(function (securityContext, role) {
    var mapping = [superAdminToPrivilegesMappper, systemUserToPrivilegesMappper, adminToPrivilegesMappper].concat(_toConsumableArray(mappers)).map(function (mapper) {
      return mapper(role);
    });
    mapping.map(function (m) {
      return m.privilegesGranted;
    }).reduce(function (allPrivilegesGranted, privileges) {
      return allPrivilegesGranted.concat(privileges);
    }, []).forEach(function (privilege) {
      return securityContext[privilege] = true;
    });
    mapping.map(function (m) {
      return m.privilegesRevoked;
    }).reduce(function (privilegesRevoked, privileges) {
      return privilegesRevoked.concat(privileges);
    }, []).forEach(function (privilege) {
      return securityContext[privilege] = false;
    });
    return securityContext;
  }, {});
};
var buildRolesBasedSecurityContext = function buildRolesBasedSecurityContext(availablePrivileges, privilegesAssigned) {
  var allPrivileges = [];
  if (Array.isArray(availablePrivileges)) {
    availablePrivileges.forEach(function (privilege) {
      var _allPrivileges;
      return (_allPrivileges = allPrivileges).push.apply(_allPrivileges, _toConsumableArray(Object.values(privilege)));
    });
  } else {
    allPrivileges = Object.values(availablePrivileges);
  }
  var assignedPrivilegesSet = new Set(_toConsumableArray(privilegesAssigned));
  var assignedPrivileges = Array.from(assignedPrivilegesSet);
  var unassignedPrivileges = allPrivileges.filter(function (privilege) {
    return !assignedPrivileges.includes(privilege);
  });
  var securityContext = {};
  assignedPrivileges.forEach(function (privilege) {
    return securityContext[privilege] = true;
  });
  unassignedPrivileges.forEach(function (privilege) {
    return securityContext[privilege] = false;
  });
  return securityContext;
};
var superAdminToPrivilegesMappper = function superAdminToPrivilegesMappper(role) {
  return {
    privilegesGranted: role === Roles.SuperAdmin ? [ALL_PRIVILEGES] : [],
    privilegesRevoked: []
  };
};
var adminToPrivilegesMappper = function adminToPrivilegesMappper(role) {
  return {
    privilegesGranted: role === Roles.Admin ? [ALL_PRIVILEGES] : [],
    privilegesRevoked: []
  };
};
var systemUserToPrivilegesMappper = function systemUserToPrivilegesMappper(role) {
  return {
    privilegesGranted: role === Roles.SystemUser ? [ALL_PRIVILEGES] : [],
    privilegesRevoked: []
  };
};

var usePrivilege = function usePrivilege(privilege) {
  var securityContext = useContext(GlobalSecurityContext);
  return isPrivilegeGranted(privilege, securityContext);
};

var COUNTRIES = {
  GB: 'United Kingdom',
  US: 'United States',
  CA: 'Canada',
  CH: 'Switzerland',
  DE: 'Germany',
  BR: 'Brazil',
  MX: 'Mexico',
  ES: 'Spain',
  FR: 'France',
  RO: 'Romania',
  IE: 'Ireland',
  AU: 'Australia',
  NL: 'Netherlands',
  NZ: 'New Zealand',
  DK: 'Denmark',
  IT: 'Italy',
  AT: 'Austria',
  BE: 'Belgium',
  HR: 'Croatia',
  PL: 'Poland',
  SE: 'Sweden',
  LV: 'Latvia',
  IL: 'Israel',
  HU: 'Hungary',
  PT: 'Portugal',
  FI: 'Finland',
  SG: 'Singapore'
};
var useTranslateRegion = function useTranslateRegion() {
  var t = useTranslate();
  return useCallback(function (name) {
    switch (name) {
      case COUNTRIES.GB:
        return t('United Kingdom');
      case COUNTRIES.US:
        return t('United States');
      case COUNTRIES.CA:
        return t('Canada');
      case COUNTRIES.CH:
        return t('Switzerland');
      case COUNTRIES.DE:
        return t('Germany');
      case COUNTRIES.BR:
        return t('Brazil');
      case COUNTRIES.MX:
        return t('Mexico');
      case COUNTRIES.ES:
        return t('Spain');
      case COUNTRIES.FR:
        return t('France');
      case COUNTRIES.RO:
        return t('Romania');
      case COUNTRIES.IE:
        return t('Ireland');
      case COUNTRIES.AU:
        return t('Australia');
      case COUNTRIES.NL:
        return t('Netherlands');
      case COUNTRIES.NZ:
        return t('New Zealand');
      case COUNTRIES.DK:
        return t('Denmark');
      case COUNTRIES.IT:
        return t('Italy');
      case COUNTRIES.AT:
        return t('Austria');
      case COUNTRIES.BE:
        return t('Belgium');
      case COUNTRIES.HR:
        return t('Croatia');
      case COUNTRIES.PL:
        return t('Poland');
      case COUNTRIES.SE:
        return t('Sweden');
      case COUNTRIES.LV:
        return t('Latvia');
      case COUNTRIES.IL:
        return t('Israel');
      case COUNTRIES.HU:
        return t('Hungary');
      case COUNTRIES.PT:
        return t('Portugal');
      case COUNTRIES.FI:
        return t('Finland');
      case COUNTRIES.SG:
        return t('Singapore');
      default:
        console.error("Unsupported region. Please provide a translation for region ".concat(name));
        return name;
    }
  }, [t]);
};

/* istanbul ignore file */
var DATE_FORMAT_1 = 'DD MMM YYYY';
var DATE_FORMAT_2 = 'DD MMM YYYY, hh:mm:ss A';
var DATE_FORMAT_3 = 'DD MMM YYYY, hh:mm A';
var DATE_FORMAT_4 = 'DD MMM';
var DATE_FORMAT_5 = 'M/D/YYYY hh:mm A';
var DATE_ISO_8601_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
var HOUR_FORMAT_1 = 'hh:mm A';
var EN_US_LOCALE = 'en-US';

var schedulerTimeRange = function schedulerTimeRange(startSeconds, endSeconds) {
  var dateOffset = moment().utcOffset();
  return {
    startDate: moment().utcOffset(dateOffset) // utc(true) doesn't work here. However taking the offset and setting it with utcOffset works.
    .startOf('isoWeek') // Using 'isoWeek' (starts monday whatever the locale is) because 'week' is locale dependent
    .subtract(1, 'days') // Since 'isoWeek' starts a monday - subtracting one day to have ANSI standard used for GoToAdmin
    .add(startSeconds || 0, 'seconds'),
    endDate: moment().utcOffset(dateOffset).startOf('isoWeek').subtract(1, 'days').add(endSeconds || 3600, 'seconds')
  };
};
var convertHoursStringToMoment = function convertHoursStringToMoment(startHour, endHour, day) {
  var dateOffset = moment().utcOffset();
  return {
    startDateMoment: moment(startHour, HOUR_FORMAT_1, true).utcOffset(dateOffset).day(day).seconds(0).milliseconds(0),
    endDateMoment: moment(endHour, HOUR_FORMAT_1, true).utcOffset(dateOffset).day(day).seconds(0).milliseconds(0)
  };
};
var backendSchedulerTimeRange = function backendSchedulerTimeRange(startDate, endDate) {
  var isAllDay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var dateOffset = moment().utcOffset();
  var startDateMoment = moment.isMoment(startDate) ? startDate.clone() : moment(startDate);
  var endDateMoment = moment.isMoment(endDate) ? endDate.clone() : moment(endDate);
  if (isAllDay) {
    var day = moment(startDateMoment, HOUR_FORMAT_1, true).day();
    startDateMoment = moment().utcOffset(dateOffset).day(day).hours(0).minutes(0).seconds(0).milliseconds(0);
    endDateMoment = moment().utcOffset(dateOffset).day(day).hours(24).minutes(0).seconds(0).milliseconds(0);
  }
  return {
    startSeconds: startDateMoment.subtract(moment().utcOffset(dateOffset).startOf('isoWeek').subtract(1, 'days')).unix(),
    endSeconds: endDateMoment.subtract(moment().utcOffset(dateOffset).startOf('isoWeek').subtract(1, 'days')).unix()
  };
};
var sortHolidays = function sortHolidays(holidays, sortByFromParams) {
  return orderBy(holidays === null || holidays === void 0 ? void 0 : holidays.map(function (holiday) {
    var _holiday$interval;
    var startDate = moment(holiday === null || holiday === void 0 ? void 0 : (_holiday$interval = holiday.interval) === null || _holiday$interval === void 0 ? void 0 : _holiday$interval.split('/')[0]);
    return _objectSpread2(_objectSpread2({}, holiday), {}, {
      id: v4(),
      startDate: startDate
    }); // id here is only as an id for each row it's not saved or use anywhere else
  }), sortByFromParams.map(function (_ref) {
    var id = _ref.id;
    return id === 'interval' ? 'startDate' : id;
  }), sortByFromParams.map(function (_ref2) {
    var direction = _ref2.direction;
    return direction;
  }));
};

var Analytics = /*#__PURE__*/function () {
  function Analytics() {
    _classCallCheck(this, Analytics);
  }
  _createClass(Analytics, null, [{
    key: "identify",
    value: function identify(userId, properties) {
      if (this.isAnalyticsInitialised()) {
        window.analytics.identify("".concat(this._prefix).concat(userId), properties);
      }
    }
  }, {
    key: "track",
    value: function track(event, properties) {
      if (this.isAnalyticsInitialised()) {
        // If addblock is present will block acquiring traits which will cause errors
        // Need to force traits to be passed down from Segment to Mixpanel
        var traits = !!window.analytics.user && !!window.analytics.user().traits ? {
          traits: window.analytics.user().traits()
        } : undefined;
        window.analytics.track(event, properties, traits);
      }
    }
  }, {
    key: "group",
    value: function group(groupId, properties) {
      if (this.isAnalyticsInitialised()) {
        window.analytics.group("".concat(this._prefix).concat(groupId), properties);
      }
    }
  }, {
    key: "init",
    value: function init(config) {
      if (config.writeKey) {
        var analytics = window.analytics = window.analytics || [];
        if (!analytics.initialize) {
          if (analytics.invoked) window.console && console.error && console.error('Segment snippet included twice.');else {
            analytics.invoked = !0;
            analytics.methods = ['trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview', 'identify', 'reset', 'group', 'track', 'ready', 'alias', 'debug', 'page', 'once', 'off', 'on', 'addSourceMiddleware', 'addIntegrationMiddleware', 'setAnonymousId', 'addDestinationMiddleware'];
            analytics.factory = function (e) {
              return function () {
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = arguments[_key];
                }
                var t = Array.prototype.slice.call(args);
                t.unshift(e);
                analytics.push(t);
                return analytics;
              };
            };
            for (var e = 0; e < analytics.methods.length; e++) {
              var key = analytics.methods[e];
              analytics[key] = analytics.factory(key);
            }
            analytics.load = function (key, e) {
              var t = document.createElement('script');
              t.type = 'text/javascript';
              t.async = !0;
              t.src = 'https://cdn.segment.com/analytics.js/v1/' + key + '/analytics.min.js';
              var n = document.getElementsByTagName('script')[0];
              n.parentNode.insertBefore(t, n);
              analytics._loadOptions = e;
            };
            analytics._writeKey = config.writeKey;
            analytics.SNIPPET_VERSION = '4.13.2';
            analytics.load(config.writeKey);
            analytics.page();
            this._prefix = config.environment === 'production' ? '' : config.environment;
          }
        }
      }
    }
  }, {
    key: "isAnalyticsInitialised",
    value: function isAnalyticsInitialised() {
      return !!window.analytics;
    }
  }]);
  return Analytics;
}();
_defineProperty(Analytics, "_prefix", '');

var styles$p = {"field":"ua-common_10-0-0_AutoComplete__field__55ec6","fullWidth":"ua-common_10-0-0_AutoComplete__fullWidth__55ec6","optionMedium":"ua-common_10-0-0_AutoComplete__optionMedium__55ec6"};

var _excluded$w = ["className", "fullWidth", "fetchOptions"];
/**
 * @deprecated Only used by TimeAutocomplete
 */
function AutoComplete(_ref) {
  var className = _ref.className,
    fullWidth = _ref.fullWidth,
    fetchOptions = _ref.fetchOptions,
    props = _objectWithoutProperties(_ref, _excluded$w);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    autocompleteOpen = _useState2[0],
    setAutocompleteOpen = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    options = _useState4[0],
    setOptions = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    query = _useState6[0],
    setQuery = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isSearching = _useState8[0],
    setIsSearching = _useState8[1];
  var updateOptions = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(query, isInitial) {
      var options;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!autocompleteOpen && !isInitial)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            setIsSearching(true);
            _context.next = 5;
            return fetchOptions(query);
          case 5:
            options = _context.sent;
            setIsSearching(false);
            setOptions(options);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [fetchOptions, autocompleteOpen]);
  var handleOpen = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          setAutocompleteOpen(true);
          updateOptions('', true);
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [updateOptions]);
  var handleClose = useCallback(function () {
    setAutocompleteOpen(false);
    setOptions([]);
  }, []);
  var _useDebounce = useDebounce(function () {
      return updateOptions(query, false);
    }, 275, [query]);
    _slicedToArray(_useDebounce, 1);
  var onInputChange = function onInputChange(e, value) {
    setQuery(value);
  };
  return jsx(Autocomplete, _objectSpread2({
    autoComplete: true,
    openOnFocus: true,
    forcePopupIcon: true,
    clearOnEscape: true,
    blurOnSelect: true,
    options: options,
    onInputChange: onInputChange,
    fullWidth: fullWidth,
    onOpen: handleOpen,
    onClose: handleClose,
    open: autocompleteOpen,
    loading: isSearching,
    className: clsx(styles$p.field, fullWidth && styles$p.fullWidth, className),
    classes: {
      option: styles$p.optionMedium
    },
    popupIcon: jsx(ChevronDownOutlinedIcon, {}),
    closeIcon: jsx(CloseOutlinedIcon, {}),
    ChipProps: {
      deleteIcon: jsx(CloseOutlinedIcon, {})
    }
  }, props));
}

var _excluded$v = ["children", "to"];
var BreadcrumbLink = function BreadcrumbLink(_ref) {
  var children = _ref.children,
    to = _ref.to,
    otherProps = _objectWithoutProperties(_ref, _excluded$v);
  return jsx(Link, {
    "data-testid": "breadcrumb-link",
    to: to,
    children: jsx(Link$1, _objectSpread2(_objectSpread2({}, otherProps), {}, {
      children: children
    }))
  });
};
var BreadcrumbLink$1 = memo(BreadcrumbLink);

var BreadcrumbLoader = function BreadcrumbLoader() {
  return jsx("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    },
    children: jsx(Skeleton, {
      variant: "rectangle",
      size: "xsmall",
      width: 100
    })
  });
};
var BreadcrumbLoader$1 = memo(BreadcrumbLoader);

var styles$o = {"container":"ua-common_10-0-0_ChipTabs__container__b8f0e","linkContainer":"ua-common_10-0-0_ChipTabs__linkContainer__b8f0e","link":"ua-common_10-0-0_ChipTabs__link__b8f0e","icon":"ua-common_10-0-0_ChipTabs__icon__b8f0e"};

var ChipTabs = function ChipTabs(_ref) {
  var tabs = _ref.tabs;
  var match = useRouteMatch();
  var location = useLocation();
  var history = useHistory();
  return jsx("div", {
    className: styles$o.container,
    children: tabs.map(function (_ref2, i) {
      var path = _ref2.path,
        activeIcon = _ref2.activeIcon,
        icon = _ref2.icon,
        label = _ref2.label;
      var activeRoute = location.pathname.includes(path);
      return jsx("div", {
        className: styles$o.linkContainer,
        children: jsx(Chip, {
          type: "radio",
          className: activeIcon || icon ? styles$o.icon : '',
          avatar: activeRoute ? activeIcon : icon,
          active: activeRoute,
          "data-cy": label,
          role: "radio",
          onAction: function onAction() {
            return history.push("".concat(match.url, "/").concat(path));
          },
          children: label
        })
      }, i);
    })
  });
};

/* istanbul ignore file */
var AT_LEAST_4_DIGITS_REGEXP = new RegExp(/(\D*\d){4}/);
var CANADIAN_POSTAL_CODE_REGEX = new RegExp(/^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/);
var EMAIL_REGEX = new RegExp(/^([a-zA-Z0-9_.+!~'-]+)@([a-zA-Z0-9_.-]+)\.([a-zA-Z][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
var FIRST_NAME_AND_LAST_NAME_REGEXP = new RegExp(/.+\s.+(.+)*/);
var IP_ADDRESS_REGEXP = new RegExp(/\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b/);
var IP_ADDRESS_PORT_REGEXP = new RegExp(/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]).){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]):[0-9]+$/);
var MAC_ADDRESS_REGEXP = new RegExp(/^([0-9A-Fa-f]){12}$/);
var NETWORK_IPV4_IPV6_REGEX = new RegExp(/^((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))$/);
var NETWORK_IPV4_REGEXP = new RegExp(/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/);
var NETWORK_REGEXP = new RegExp(/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}(\/\d{1,2})?$/);
var ONLY_NUMBERS_OR_ASTERISK_REGEXP = new RegExp(/^[0-9*]+$/);
var ONLY_NUMBERS_REGEXP = new RegExp(/^[0-9]*$/);
var PHONE_NUMBER_REGEXP = new RegExp(/^\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/);
var US_ZIP_CODE_REGEX = new RegExp(/^\d{5}(?:[-\s]\d{4})?$/);

var DialogMode;
(function (DialogMode) {
  DialogMode["CREATE"] = "create";
  DialogMode["UPDATE"] = "update";
  DialogMode["DPE_CREATE"] = "cfe_create";
})(DialogMode || (DialogMode = {}));

var useConferenceBridgesValidationSchema = function useConferenceBridgesValidationSchema(_ref) {
  var mode = _ref.mode,
    extensionDigits = _ref.extensionDigits,
    isExtensionNumberAvailable = _ref.isExtensionNumberAvailable,
    conferenceBridge = _ref.conferenceBridge,
    isReservedNumber = _ref.isReservedNumber;
  var t = useTranslate();
  return {
    validationSchema: Yup.object().shape({
      extensionNumber: Yup.string().nullable().test('number', t('Must only contain numbers'), function (val) {
        return ONLY_NUMBERS_REGEXP.test(val || '');
      }).length(extensionDigits, t('Extensions require %{amountOfDigits} digits', {
        amountOfDigits: extensionDigits
      })).test('existing', t('Extension number already taken'), function (value) {
        return isExtensionNumberAvailable(value || undefined, extensionDigits, mode === DialogMode.UPDATE ? (conferenceBridge === null || conferenceBridge === void 0 ? void 0 : conferenceBridge.extensionNumber) || undefined : undefined);
      }).test('reservedNumber', t('Reserved numbers are not allowed'), function (value) {
        if (mode !== DialogMode.UPDATE || mode === DialogMode.UPDATE && value !== (conferenceBridge === null || conferenceBridge === void 0 ? void 0 : conferenceBridge.extensionNumber)) {
          return !isReservedNumber(value || undefined);
        }
        return true;
      }),
      name: Yup.string().max(255, t('Maximum %{maxCharacters} characters', {
        maxCharacters: 255
      })).required(t('Required'))
    })
  };
};

var styles$n = {"dialogTitleRoot":"ua-common_10-0-0_Dialog__dialogTitleRoot__64f21","dialogTitleBorderBottom":"ua-common_10-0-0_Dialog__dialogTitleBorderBottom__64f21","dialogTitleText":"ua-common_10-0-0_Dialog__dialogTitleText__64f21","dialogTitleTextOpen":"ua-common_10-0-0_Dialog__dialogTitleTextOpen__64f21","dialogTitleTextClose":"ua-common_10-0-0_Dialog__dialogTitleTextClose__64f21","dialogContentRoot":"ua-common_10-0-0_Dialog__dialogContentRoot__64f21","container":"ua-common_10-0-0_Dialog__container__64f21","noTopPadding":"ua-common_10-0-0_Dialog__noTopPadding__64f21"};

var _excluded$u = ["children", "noBorderBottom", "onClose", "actions"],
  _excluded2$2 = ["children", "showOverflow", "withTabs", "noMargin", "className"],
  _excluded3$1 = ["onClose", "fullScreen", "noMargin", "withTabs", "size", "children", "actions", "open", "showOverflow", "title"];
var DialogTitle = function DialogTitle(_ref) {
  var children = _ref.children,
    _ref$noBorderBottom = _ref.noBorderBottom,
    noBorderBottom = _ref$noBorderBottom === void 0 ? false : _ref$noBorderBottom,
    onClose = _ref.onClose,
    actions = _ref.actions,
    otherProps = _objectWithoutProperties(_ref, _excluded$u);
  var t = useTranslate();
  return jsxs(DialogTitle$1, _objectSpread2(_objectSpread2({
    "data-testid": "dialogTitle",
    disableTypography: true,
    className: clsx(styles$n.dialogTitleRoot, !noBorderBottom && styles$n.dialogTitleBorderBottom)
  }, otherProps), {}, {
    children: [jsx(Typography, {
      variant: "heading-small",
      noWrap: true,
      title: children && children.toString() || '',
      style: {
        paddingRight: onClose ? 40 : 0,
        flexGrow: 1
      },
      className: clsx(styles$n.dialogTitleText, onClose ? styles$n.dialogTitleTextClose : styles$n.dialogTitleTextOpen),
      children: children
    }), actions && actions(), onClose && jsxs(Fragment, {
      children: [jsx(IconButton, {
        id: "close-icon-button",
        labelId: "close-icon-button-label",
        size: "small",
        "data-testid": "dialogCloseButton",
        onClick: onClose,
        children: jsx(CloseOutlinedIcon, {})
      }), jsx(Tooltip, {
        triggerId: "close-icon-button",
        children: jsx("span", {
          id: "close-icon-button-label",
          children: t('Close')
        })
      })]
    })]
  }));
};
var DIALOG_ACTIONS_HEIGHT = 69;
var DialogContent = function DialogContent(_ref2) {
  var children = _ref2.children,
    _ref2$showOverflow = _ref2.showOverflow,
    showOverflow = _ref2$showOverflow === void 0 ? false : _ref2$showOverflow,
    _ref2$withTabs = _ref2.withTabs,
    withTabs = _ref2$withTabs === void 0 ? false : _ref2$withTabs,
    _ref2$noMargin = _ref2.noMargin,
    noMargin = _ref2$noMargin === void 0 ? false : _ref2$noMargin,
    className = _ref2.className,
    otherProps = _objectWithoutProperties(_ref2, _excluded2$2);
  return jsx(DialogContent$1, _objectSpread2(_objectSpread2({
    className: clsx(styles$n.dialogContentRoot, withTabs && styles$n.noTopPadding, className),
    style: {
      marginBottom: noMargin ? 0 : DIALOG_ACTIONS_HEIGHT,
      overflowX: showOverflow ? 'unset' : 'hidden',
      overflowY: showOverflow ? 'unset' : 'auto'
    }
  }, otherProps), {}, {
    children: children
  }));
};
var Dialog = function Dialog(_ref3) {
  var onClose = _ref3.onClose,
    fullScreen = _ref3.fullScreen,
    noMargin = _ref3.noMargin,
    _ref3$withTabs = _ref3.withTabs,
    withTabs = _ref3$withTabs === void 0 ? false : _ref3$withTabs,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 'sm' : _ref3$size,
    children = _ref3.children,
    actions = _ref3.actions,
    open = _ref3.open,
    showOverflow = _ref3.showOverflow,
    title = _ref3.title,
    otherProps = _objectWithoutProperties(_ref3, _excluded3$1);
  return jsx(Dialog$1, _objectSpread2(_objectSpread2({
    fullWidth: true,
    maxWidth: size,
    scroll: "paper",
    onClose: onClose,
    "aria-labelledby": "dialog-title",
    open: open,
    fullScreen: fullScreen
  }, otherProps), {}, {
    children: jsxs(Container, {
      maxWidth: fullScreen ? false : 'xl',
      disableGutters: true,
      className: styles$n.container,
      children: [jsx(DialogTitle, {
        id: "dialog-title",
        noBorderBottom: fullScreen,
        onClose: onClose,
        actions: actions,
        children: title
      }), jsx(DialogContent, {
        withTabs: withTabs,
        noMargin: noMargin,
        dividers: true,
        showOverflow: showOverflow,
        children: children
      })]
    })
  }));
};
// wrapper for dialog content with bottom padding to accommodate the dialog actions
var DialogContentWrapper = function DialogContentWrapper(_ref4) {
  var children = _ref4.children;
  return jsx("div", {
    style: {
      paddingBottom: DIALOG_ACTIONS_HEIGHT
    },
    children: children
  });
};

var styles$m = {"root":"ua-common_10-0-0_DialogActions__root__bb392","isFixed":"ua-common_10-0-0_DialogActions__isFixed__bb392"};

var _excluded$t = ["isFixed"];
var DialogActions = function DialogActions(_ref) {
  var isFixed = _ref.isFixed,
    otherProps = _objectWithoutProperties(_ref, _excluded$t);
  return jsx(DialogActions$1, _objectSpread2({
    className: clsx(styles$m.root, isFixed && styles$m.isFixed)
  }, otherProps));
};

var ConferenceBridgesEditorDialog = function ConferenceBridgesEditorDialog(_ref) {
  var open = _ref.open,
    title = _ref.title,
    onClose = _ref.onClose,
    onCancel = _ref.onCancel,
    mode = _ref.mode,
    conferenceBridge = _ref.conferenceBridge,
    onSubmit = _ref.onSubmit,
    extensionDigits = _ref.extensionDigits,
    nextExtensionNumber = _ref.nextExtensionNumber,
    isExtensionNumberAvailable = _ref.isExtensionNumberAvailable,
    isReservedNumber = _ref.isReservedNumber;
  var t = useTranslate();
  var _useConferenceBridges = useConferenceBridgesValidationSchema({
      mode: mode,
      conferenceBridge: conferenceBridge,
      isExtensionNumberAvailable: isExtensionNumberAvailable,
      extensionDigits: extensionDigits,
      isReservedNumber: isReservedNumber
    }),
    validationSchema = _useConferenceBridges.validationSchema;
  if (mode === DialogMode.UPDATE && !conferenceBridge) {
    return jsx(Fragment, {});
  }
  return jsx(Dialog, {
    open: open,
    title: title,
    onClose: onClose,
    children: jsx(Formik, {
      initialValues: {
        extensionNumber: conferenceBridge ? conferenceBridge.extensionNumber : nextExtensionNumber,
        name: conferenceBridge ? conferenceBridge.name : ''
      },
      isInitialValid: false,
      validateOnBlur: false,
      validationSchema: validationSchema,
      onSubmit: onSubmit,
      children: function children(_ref2) {
        var isValid = _ref2.isValid,
          isSubmitting = _ref2.isSubmitting,
          setFieldValue = _ref2.setFieldValue;
        return jsxs(Form, {
          noValidate: true,
          autoComplete: "off",
          "data-testid": "form",
          children: [jsx(FormikTextField, {
            helperText: t('If set, conference bridge can be accessed by dialing its extension'),
            label: t('Extension (optional)'),
            fullwidth: true,
            maxLength: extensionDigits,
            hideCounter: true,
            "data-testid": "input-extension",
            placeholder: t('Enter an extension number'),
            name: "extensionNumber",
            onChange: function onChange(e) {
              setFieldValue('extensionNumber', e.target.value);
            },
            onKeyDown: function onKeyDown(evt) {
              return evt.stopPropagation();
            },
            style: {
              marginBottom: tokens.spacing04
            }
          }), jsx(FormikTextField, {
            autoFocus: true,
            label: t('Name'),
            fullwidth: true,
            name: "name",
            placeholder: t('Enter a name'),
            "data-testid": "input-name",
            onChange: function onChange(e) {
              setFieldValue('name', e.target.value);
            },
            onKeyDown: function onKeyDown(evt) {
              return evt.stopPropagation();
            }
          }), jsxs(DialogActions, {
            children: [jsx(Button, {
              variant: "neutral",
              onClick: onCancel,
              "data-testid": "cancel-button",
              children: t('Cancel')
            }), jsx(Button, {
              disabled: !isValid || isSubmitting,
              type: "submit",
              variant: "primary",
              "data-testid": "save-button",
              children: t('Save')
            })]
          })]
        });
      }
    })
  });
};
var ConferenceBridgesEditorDialog$1 = memo(ConferenceBridgesEditorDialog);

var ConfirmDeleteDialog = function ConfirmDeleteDialog(_ref) {
  var onClose = _ref.onClose,
    onConfirm = _ref.onConfirm,
    _children = _ref.children;
  // Hooks
  var t = useTranslate();
  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            onConfirm();
            // Closing the dialog
            onClose();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  return jsx(Formik, {
    initialValues: {},
    onSubmit: onSubmit,
    children: function children(_ref3) {
      var isValid = _ref3.isValid,
        isSubmitting = _ref3.isSubmitting;
      return jsxs(Form, {
        noValidate: true,
        autoComplete: "off",
        "data-testid": "confirm-delete-dialog",
        children: [jsx(Typography, {
          children: _children
        }), jsxs(DialogActions, {
          children: [jsx(Button, {
            variant: "neutral",
            onClick: onClose,
            children: t('Cancel')
          }), jsx(Button, {
            disabled: !isValid || isSubmitting,
            variant: "danger",
            onClick: onSubmit,
            children: t('Delete')
          })]
        })]
      });
    }
  });
};

/**
 * Render prop component that wraps element in a Tooltip that shows "Copied to clipboard!" when the
 * copy function is invoked
 */
var CopyToClipboard = function CopyToClipboard(_ref) {
  var TooltipProps = _ref.TooltipProps,
    children = _ref.children;
  // Hooks
  var t = useTranslate();
  var onCopy = function onCopy(content) {
    navigator && navigator.clipboard && navigator.clipboard.writeText(content);
  };
  return jsxs(Fragment, {
    children: [jsx("div", {
      id: "copy-to-clipboard",
      children: children({
        copy: onCopy
      })
    }), jsx(Tooltip, _objectSpread2(_objectSpread2({
      triggerId: "copy-to-clipboard"
    }, TooltipProps || {}), {}, {
      children: t('Copied to clipboard!')
    }))]
  });
};
var CopyToClipboard$1 = memo(CopyToClipboard);

/* istanbul ignore file */
var BANNER_HEIGHT = 36;
var CHAMELEON_TABS_HEIGHT = 55;
var DEFAULT_PAGE_SIZE = 25;
var DRAWER_WIDTH = 320;
var EMPTY_SYMBOL = '-';
var TABLE_HEIGHT = 284; // Usual table height
var TABLE_HEIGHT_NO_TABS = 227; // When the page layout has no tabs
var TABLE_HEIGHT_NO_TABS_NO_SEARCH = 223; // When the page layout has no tabs and no searchbar
var TABLE_HEIGHT_WITH_SEARCHBAR = 182; // When the page layout has no tabs and a searchbar
var TABLE_HEIGHT_WITH_SEARCHBAR_AND_TABS = 339; // When the page layout has tabs and a searchbar
var TABLE_HEIGHT_WITH_SEARCHBAR_AND_TABS_AND_DETAILS_HEADER = 359; // when the page layout has tabs, a search bar, and a details header
var TABLE_HEIGHT_WITH_SEARCHBAR_AND_CHIPS = 276; // When the page layout has chips and a searchbar
var TABLE_HEIGHT_WITH_HIGHLIGHTS = 280; // When the page layout has information highlights
var TABLE_HEIGHT_WITH_FILTERS = 242; // When the page layout has chips, a searchbar and filters
var TABLE_HEIGHT_ONLY = 173; // When the page layout has no tabs, no pagination and no searchbar
var TABLE_HEIGHT_WITH_CHIPS = 343; // When the page layout has chips as sub-routes
var TABLE_SUB_ROW_INDENT_WIDTH = 32;
var TABLE_MAX_SUB_ROWS_EXPANDED_BY_DEFAULT = 100;
var TABLE_SUB_ROW_INDENT_MAX_DEPTH = 6;
var TOP_BAR_HEIGHT = 49;
var BULK_DELETE_USERS_LIMIT = 50;
var MAX_FILTERS = 20;
var DATATABLE_PAGE_SIZES = [5, 10, 25, 50];
var APP_PREFIX = 'unified-admin-common';
var DETAILS_PAGE_HEADER_PADDING_TOP = 24;
var HEADER_PADDING_TOP = 16;
var ADD_FILTER_BUTTON_ID = 'add-filter-button';
var FILTER_POPOVER_TRIGGER_ID = 'table-filter-button';
var DATE_RANGE_FILTER_TRIGGERID = 'chip-filter-date-range';

var marginToHeight = function marginToHeight(margin, isBannerDisplayed) {
  return "calc(100vh - ".concat(isBannerDisplayed ? margin + BANNER_HEIGHT : margin, "px)");
};
var useAppHeights = function useAppHeights() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var shellUiState = useSelector(function (state) {
    return state.shellUiState;
  }) || {
    isBannerDisplayed: false,
    bannerOffset: 0
  };
  var pageHeaderContext = usePageHeaderContext();
  var baseOffset = offset ? offset : shellUiState.bannerOffset || 0;
  return useMemo(function () {
    return {
      pageLayoutHeight: marginToHeight(TOP_BAR_HEIGHT + baseOffset, shellUiState.isBannerDisplayed),
      pageTabLayoutHeight: marginToHeight(TOP_BAR_HEIGHT + baseOffset + pageHeaderContext.height + CHAMELEON_TABS_HEIGHT, shellUiState.isBannerDisplayed),
      tableHeight: marginToHeight(TABLE_HEIGHT + baseOffset, shellUiState.isBannerDisplayed),
      tableHeightNoTabs: marginToHeight(TABLE_HEIGHT_NO_TABS + baseOffset, shellUiState.isBannerDisplayed),
      tableHeightNoTabsNoSearch: marginToHeight(TABLE_HEIGHT_NO_TABS_NO_SEARCH + baseOffset, shellUiState.isBannerDisplayed),
      tableHeightWithHighlights: marginToHeight(TABLE_HEIGHT_WITH_HIGHLIGHTS + baseOffset, shellUiState.isBannerDisplayed),
      tableHeightWithFilters: marginToHeight(TABLE_HEIGHT_WITH_FILTERS + baseOffset, shellUiState.isBannerDisplayed),
      tableHeightWithSearchbar: marginToHeight(TABLE_HEIGHT_WITH_SEARCHBAR + baseOffset, shellUiState.isBannerDisplayed),
      tableHeightWithSearchbarAndTabs: marginToHeight(TABLE_HEIGHT_WITH_SEARCHBAR_AND_TABS + baseOffset, shellUiState.isBannerDisplayed),
      tableHeightWithSearchbarAndTabsAndDetailsHeader: marginToHeight(TABLE_HEIGHT_WITH_SEARCHBAR_AND_TABS_AND_DETAILS_HEADER + baseOffset, shellUiState.isBannerDisplayed),
      tableHeightOnly: marginToHeight(TABLE_HEIGHT_ONLY + baseOffset, shellUiState.isBannerDisplayed),
      tableHeightWithChips: marginToHeight(TABLE_HEIGHT_WITH_CHIPS + baseOffset, shellUiState.isBannerDisplayed),
      tableHeightWithSearchbarAndChips: marginToHeight(TABLE_HEIGHT_WITH_SEARCHBAR_AND_CHIPS + baseOffset, shellUiState.isBannerDisplayed)
    };
  }, [baseOffset, pageHeaderContext.height, shellUiState.isBannerDisplayed]);
};

/* istanbul ignore file */
var TABLE_PREFERENCES_KEY = 'tablePreferences';

var DEFAULT_SINGLE_TABLE_PREFERENCES = {
  showFilters: false,
  hiddenColumns: [],
  columnOrder: [],
  pageIndex: 0,
  sortBy: '',
  sortDirection: 'asc',
  searchQuery: '',
  filters: []
};
var DEFAULT_COMMON_TABLE_PREFERENCES = {
  pageSize: DEFAULT_PAGE_SIZE,
  compactView: false
};
var DEFAULT_TABLE_PREFERENCES = _objectSpread2(_objectSpread2({}, DEFAULT_SINGLE_TABLE_PREFERENCES), DEFAULT_COMMON_TABLE_PREFERENCES);
var isKeyOfInterface = function isKeyOfInterface(key, _obj) {
  return key in _obj;
};
var mergePreferences = function mergePreferences(pref) {
  var result = _objectSpread2({}, pref);
  // the way Partial type is defined in Typescript does not prevent of having a property present but with undefined value
  // this would cause undefined value to override defined values if we use only the spread operator
  // We would end-up with undefined values in the result object even if the type TablePreference does not allow it
  for (var _len = arguments.length, newPreferences = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    newPreferences[_key - 1] = arguments[_key];
  }
  for (var _i = 0, _newPreferences = newPreferences; _i < _newPreferences.length; _i++) {
    var newValues = _newPreferences[_i];
    for (var key in newValues) {
      if (newValues[key] !== undefined) {
        result[key] = newValues[key];
      }
    }
  }
  return result;
};
var useTablePreferences = function useTablePreferences(tableId) {
  var customDefaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _useLocalStorage = useLocalStorage(TABLE_PREFERENCES_KEY, {}),
    _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
    allTablePrefs = _useLocalStorage2[0],
    setAllTablePrefs = _useLocalStorage2[1];
  var tablePrefs = useMemo(function () {
    var _allTablePrefs, _allTablePrefs$common;
    return mergePreferences(DEFAULT_TABLE_PREFERENCES, customDefaults, (_allTablePrefs = allTablePrefs[tableId !== null && tableId !== void 0 ? tableId : '']) !== null && _allTablePrefs !== void 0 ? _allTablePrefs : {}, (_allTablePrefs$common = allTablePrefs.commonPreferences) !== null && _allTablePrefs$common !== void 0 ? _allTablePrefs$common : {});
  }, [customDefaults, allTablePrefs, tableId]);
  var updateFunc = useCallback(function (newPrefs) {
    if (tableId) {
      var _objectSpread2$1;
      var singleTablePrefs = DEFAULT_SINGLE_TABLE_PREFERENCES;
      var commonTablePrefs = DEFAULT_COMMON_TABLE_PREFERENCES;
      var allPrefs = mergePreferences(tablePrefs, newPrefs);
      for (var key in allPrefs) {
        if (isKeyOfInterface(key, singleTablePrefs)) {
          singleTablePrefs[key] = allPrefs[key];
        }
        if (isKeyOfInterface(key, commonTablePrefs)) {
          commonTablePrefs[key] = allPrefs[key];
        }
      }
      setAllTablePrefs(_objectSpread2(_objectSpread2({}, allTablePrefs), {}, (_objectSpread2$1 = {}, _defineProperty(_objectSpread2$1, tableId, singleTablePrefs), _defineProperty(_objectSpread2$1, "commonPreferences", commonTablePrefs), _objectSpread2$1)));
    }
  }, [tableId, tablePrefs, setAllTablePrefs, allTablePrefs]);
  return [tablePrefs, updateFunc];
};

var forwardRefTyped = React__default.forwardRef;
var memoTyped = React__default.memo;

// This aims to use react-router's `replace` instead of `push` for query params
// That way the back button works as expected
var useQueryParamReplace = function useQueryParamReplace(paramName, paramType) {
  var _useQueryParam = useQueryParam(paramName, paramType),
    _useQueryParam2 = _slicedToArray(_useQueryParam, 2),
    query = _useQueryParam2[0],
    setQuery = _useQueryParam2[1];
  var setQueryReplace = function setQueryReplace(newQuery) {
    var updateType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'replaceIn';
    return setQuery(newQuery, updateType);
  };
  return [query, setQueryReplace];
};

var toHex = function toHex(text) {
  if (!text) return;
  var hex = '';
  for (var i = text.length - 1; i >= 0; i--) hex = text.charCodeAt(i).toString(16) + hex;
  return hex;
};
var fromHex = function fromHex(hex) {
  if (!hex) return;
  var string = '';
  for (var i = 0; i < hex.length; i += 2) {
    string += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
  }
  return string;
};

var styles$l = {"root":"ua-common_10-0-0_Divider__root__3e982"};

var _excluded$s = ["className"];
var Divider = function Divider(_ref) {
  var className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded$s);
  return jsx(Divider$2, _objectSpread2({
    className: clsx(styles$l.root, className)
  }, otherProps));
};
var Divider$1 = memo(Divider);

var styles$k = {"tableContainer":"ua-common_10-0-0_DataTable__tableContainer__3a20f","tableHighlights":"ua-common_10-0-0_DataTable__tableHighlights__3a20f","searchBar":"ua-common_10-0-0_DataTable__searchBar__3a20f","divider":"ua-common_10-0-0_DataTable__divider__3a20f","verticalDivider":"ua-common_10-0-0_DataTable__verticalDivider__3a20f"};

var useDelayedRender = function useDelayedRender(delay) {
  var _useState = useState(delay > 0),
    _useState2 = _slicedToArray(_useState, 2),
    delayed = _useState2[0],
    setDelayed = _useState2[1];
  useEffect(function () {
    if (delay > 0) {
      setDelayed(true);
      var timeout = setTimeout(function () {
        return setDelayed(false);
      }, delay);
      return function () {
        return clearTimeout(timeout);
      };
    }
  }, [delay]);
  return function (fn) {
    return !delayed && fn();
  };
};

var DelayRender = function DelayRender(_ref) {
  var delay = _ref.delay,
    children = _ref.children;
  return useDelayedRender(delay)(function () {
    return children;
  });
};

var styles$j = {"noPadding":"ua-common_10-0-0_DataTableContent__noPadding__bc96d","filterButton":"ua-common_10-0-0_DataTableContent__filterButton__bc96d","filterButtonRight":"ua-common_10-0-0_DataTableContent__filterButtonRight__bc96d","cell":"ua-common_10-0-0_DataTableContent__cell__bc96d","headerCell":"ua-common_10-0-0_DataTableContent__headerCell__bc96d","headerText":"ua-common_10-0-0_DataTableContent__headerText__bc96d","compactCell":"ua-common_10-0-0_DataTableContent__compactCell__bc96d","dynamicSetupCell":"ua-common_10-0-0_DataTableContent__dynamicSetupCell__bc96d","tableFooterDivider":"ua-common_10-0-0_DataTableContent__tableFooterDivider__bc96d","tableWrapper":"ua-common_10-0-0_DataTableContent__tableWrapper__bc96d","invisibleCell":"ua-common_10-0-0_DataTableContent__invisibleCell__bc96d","subDataTableCell":"ua-common_10-0-0_DataTableContent__subDataTableCell__bc96d","subDataTable":"ua-common_10-0-0_DataTableContent__subDataTable__bc96d","clickable":"ua-common_10-0-0_DataTableContent__clickable__bc96d","sticky":"ua-common_10-0-0_DataTableContent__sticky__bc96d","tableFooter":"ua-common_10-0-0_DataTableContent__tableFooter__bc96d","selectedRow":"ua-common_10-0-0_DataTableContent__selectedRow__bc96d","expandedRow":"ua-common_10-0-0_DataTableContent__expandedRow__bc96d","expandedCell":"ua-common_10-0-0_DataTableContent__expandedCell__bc96d","selectionColumn":"ua-common_10-0-0_DataTableContent__selectionColumn__bc96d","cellContainer":"ua-common_10-0-0_DataTableContent__cellContainer__bc96d","cellCheckboxContainer":"ua-common_10-0-0_DataTableContent__cellCheckboxContainer__bc96d","expandButtonContainer":"ua-common_10-0-0_DataTableContent__expandButtonContainer__bc96d","table":"ua-common_10-0-0_DataTableContent__table__bc96d","rowClickable":"ua-common_10-0-0_DataTableContent__rowClickable__bc96d","rowHoverable":"ua-common_10-0-0_DataTableContent__rowHoverable__bc96d","firstColumnSelection":"ua-common_10-0-0_DataTableContent__firstColumnSelection__bc96d","firstRowSelection":"ua-common_10-0-0_DataTableContent__firstRowSelection__bc96d"};

var DataTableNoResults = function DataTableNoResults() {
  var t = useTranslate();
  return jsx("div", {
    style: {
      padding: tokens.spacing06,
      marginTop: tokens.spacing02,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 1
    },
    children: jsx(EmptyState, {
      icon: jsx(SearchOutlinedIcon, {}),
      title: t('No results found'),
      children: t("We couldn't find any results matching your search.")
    })
  });
};
var DataTableNoResults$1 = memo(DataTableNoResults);

var DataTablePagination = function DataTablePagination(_ref) {
  var pageSize = _ref.pageSize,
    pageIndex = _ref.pageIndex,
    pageOptions = _ref.pageOptions,
    setPageSize = _ref.setPageSize,
    canPreviousPage = _ref.canPreviousPage,
    previousPage = _ref.previousPage,
    nextPage = _ref.nextPage,
    canNextPage = _ref.canNextPage,
    _ref$matchCount = _ref.matchCount,
    matchCount = _ref$matchCount === void 0 ? 0 : _ref$matchCount;
  var t = useTranslate();
  return jsxs("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'nowrap'
    },
    children: [jsxs("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'nowrap',
        gap: tokens.spacing04
      },
      children: [jsx("div", {
        children: jsx(Typography, {
          variant: "caption-medium-strong",
          color: "type-color-secondary",
          children: t('Rows per page')
        })
      }), jsx("div", {
        children: jsx(Select, {
          name: "pageSize",
          size: "small",
          value: pageSize.toString(),
          fullwidth: true,
          defaultValue: pageSize,
          onChange: function onChange(e) {
            return setPageSize(Number(e.target.value));
          },
          children: DATATABLE_PAGE_SIZES.map(function (pageSize) {
            return jsx(Option, {
              value: pageSize.toString(),
              children: pageSize
            }, pageSize);
          })
        })
      })]
    }), jsxs("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flexWrap: 'nowrap',
        gap: tokens.spacing02
      },
      children: [jsx("div", {
        children: jsxs(Typography, {
          variant: "caption-medium-strong",
          color: "type-color-secondary",
          children: [pageIndex * pageSize + 1, "-", pageIndex * pageSize + pageSize <= matchCount ? pageIndex * pageSize + pageSize : matchCount, " ", t('of'), ' ', matchCount]
        })
      }), jsxs("div", {
        children: [jsx(IconButton, {
          id: "previous-page-btn",
          size: "small",
          variant: "secondary",
          "aria-label": t('Previous page'),
          onClick: function onClick() {
            return previousPage();
          },
          disabled: !canPreviousPage,
          children: jsx(ChevronLeftOutlinedIcon, {})
        }), jsx(Tooltip, {
          zIndex: 3,
          triggerId: "previous-page-btn",
          children: jsx("span", {
            children: t('Previous page')
          })
        })]
      }), jsx("div", {
        children: jsxs(Typography, {
          variant: "caption-medium-strong",
          color: "type-color-secondary",
          children: [t('Page'), " ", pageIndex + 1, "/", pageOptions.length]
        })
      }), jsxs("div", {
        children: [jsx(IconButton, {
          id: "next-page-btn",
          variant: "secondary",
          size: "small",
          "aria-label": t('Next page'),
          onClick: function onClick() {
            return nextPage();
          },
          disabled: !canNextPage,
          children: jsx(ChevronRightOutlinedIcon, {})
        }), jsx(Tooltip, {
          zIndex: 3,
          triggerId: "next-page-btn",
          children: jsxs("span", {
            children: [t('Next page'), " "]
          })
        })]
      })]
    })]
  });
};

var styles$i = {"drawerPaper":"ua-common_10-0-0_Drawer__drawerPaper__29e21","closeButton":"ua-common_10-0-0_Drawer__closeButton__29e21","drawerHeader":"ua-common_10-0-0_Drawer__drawerHeader__29e21","drawerHeaderContent":"ua-common_10-0-0_Drawer__drawerHeaderContent__29e21"};

var _excluded$r = ["open", "setOpen", "title", "children", "setDrawerOpen", "paperClasses", "subtitle"];
var Drawer = function Drawer(_ref) {
  var open = _ref.open,
    setOpen = _ref.setOpen,
    title = _ref.title,
    children = _ref.children,
    setDrawerOpen = _ref.setDrawerOpen,
    _ref$paperClasses = _ref.paperClasses,
    paperClasses = _ref$paperClasses === void 0 ? '' : _ref$paperClasses,
    subtitle = _ref.subtitle,
    otherProps = _objectWithoutProperties(_ref, _excluded$r);
  var t = useTranslate();
  var dispatch = useDispatch();
  useEffect(function () {
    if (setDrawerOpen) {
      var action = setDrawerOpen(open);
      if (action) {
        dispatch(action);
      }
    }
  }, [dispatch, setDrawerOpen, open]);
  return jsxs(Drawer$2, _objectSpread2(_objectSpread2({
    classes: {
      paper: clsx(styles$i.drawerPaper, paperClasses)
    },
    variant: "persistent",
    anchor: "right",
    open: open,
    elevation: 0,
    onEscapeKeyDown: function onEscapeKeyDown() {
      return setOpen(false);
    },
    onBackdropClick: function onBackdropClick() {
      return setOpen(false);
    }
  }, otherProps), {}, {
    children: [jsxs("div", {
      className: styles$i.drawerHeader,
      children: [jsxs("div", {
        className: styles$i.drawerHeaderContent,
        children: [jsx("div", {
          children: jsx(Typography, {
            variant: "heading-small",
            children: title
          })
        }), setOpen && jsxs(Fragment, {
          children: [jsx(IconButton, {
            id: "close-drawer-btn",
            label: t('Close'),
            size: "small",
            className: styles$i.closeButton,
            onClick: function onClick() {
              return setOpen(!open);
            },
            children: jsx(CloseOutlinedIcon, {})
          }), jsx(Tooltip, {
            triggerId: "close-drawer-btn",
            children: jsx("span", {
              children: t('Close')
            })
          })]
        })]
      }), subtitle && jsx(Typography, {
        variant: "caption-medium",
        color: "type-color-secondary",
        children: subtitle
      })]
    }), children]
  }));
};
var Drawer$1 = memo(Drawer);

var resetColumnsOrder = function resetColumnsOrder(defaultColumnsOrder, columns) {
  var result = [];
  defaultColumnsOrder.forEach(function (defaultColumn) {
    var element = columns.find(function (column) {
      return column.id === defaultColumn.accessor;
    });
    if (element) {
      result.push(element);
    }
  });
  return result;
};
var getColumnsIds = function getColumnsIds(columns) {
  return columns.map(function (column) {
    return column && column.id;
  });
};
function reorder(list, startIndex, endIndex) {
  var result = Array.from(list);
  var _result$splice = result.splice(startIndex, 1),
    _result$splice2 = _slicedToArray(_result$splice, 1),
    removed = _result$splice2[0];
  result.splice(endIndex, 0, removed);
  return result;
}
var ColumnComponent = memoTyped(function (props) {
  var column = props.column,
    index = props.index,
    toggleHiddenHandler = props.toggleHiddenHandler;
  var t = useTranslate();
  return jsx(Draggable, {
    draggableId: column.id,
    index: index,
    children: function children(provided) {
      return jsx("div", _objectSpread2(_objectSpread2(_objectSpread2({
        ref: provided.innerRef
      }, provided.draggableProps), provided.dragHandleProps), {}, {
        children: jsx("div", {
          style: {
            height: 48,
            display: 'flex',
            borderTop: "1px solid ".concat(tokens.borderColorDefault),
            backgroundColor: tokens.surfaceColorDefault
          },
          children: jsx("div", {
            style: {
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'nowrap',
              flex: 1
            },
            children: jsxs("div", {
              style: {
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'nowrap',
                flex: 1
              },
              children: [jsx("div", {
                style: {
                  marginRight: tokens.spacing02
                },
                children: jsx(DragFreeIcon, {
                  style: {
                    color: tokens.iconColorDefault,
                    position: 'relative',
                    top: 2
                  }
                })
              }), jsx("div", {
                style: {
                  display: 'flex',
                  flex: 1
                },
                children: jsx(FormControlLabel, {
                  style: {
                    flex: 1,
                    justifyContent: 'space-between',
                    marginLeft: tokens.spacing00,
                    marginRight: tokens.spacing00
                  },
                  control: jsx(Checkbox, _objectSpread2(_objectSpread2({}, column.getToggleHiddenProps()), {}, {
                    onChange: function onChange(e) {
                      return toggleHiddenHandler(e, column);
                    },
                    size: "small"
                  })),
                  label: jsx(Typography, {
                    children: column.Header || t('Misc.')
                  }),
                  labelPlacement: "start"
                })
              })]
            })
          })
        })
      }));
    }
  });
});
var ColumnsList = memoTyped(function (_ref) {
  var columns = _ref.columns,
    toggleHiddenHandler = _ref.toggleHiddenHandler;
  return jsx(Fragment, {
    children: columns.map(function (column, index) {
      return index !== 0 && jsx(ColumnComponent, {
        column: column,
        index: index,
        toggleHiddenHandler: toggleHiddenHandler
      }, column.id);
    })
  });
});
function ModifyDataTableColumns(props) {
  var columns = props.columns,
    defaultColumns = props.defaultColumns,
    onResetColumnSelection = props.onResetColumnSelection,
    onColumnOrderChange = props.onColumnOrderChange,
    onColumnSelectionChange = props.onColumnSelectionChange;
  var t = useTranslate();
  var displayedColumns = useMemo(function () {
    return columns.filter(function (column) {
      return column && !column.isControlColumn && column.id && column.id.toLowerCase() !== 'actions';
    });
  }, [columns]); // remove control and actions columns, e.g. the selection checkbox and the "Actions"
  var controlColumnIds = useMemo(function () {
    return getColumnsIds(columns.filter(function (c) {
      return c.isControlColumn;
    }));
  }, [columns]);
  var toggleHiddenHandler = useCallback(function (e, column) {
    var _column$getToggleHidd = column.getToggleHiddenProps(),
      onChange = _column$getToggleHidd.onChange;
    onChange(e);
    onColumnSelectionChange(column.id, e.target.checked);
  }, [onColumnSelectionChange]);
  var onDragEnd = useCallback(function (result) {
    if (!result.destination) {
      return;
    }
    if (result.destination.index === result.source.index) {
      return;
    }
    var columns = reorder(displayedColumns, result.source.index, result.destination.index);
    // Add the control columns always at the beginning
    var onlyColumnsIds = [].concat(_toConsumableArray(controlColumnIds), _toConsumableArray(getColumnsIds(columns)));
    onColumnOrderChange(onlyColumnsIds);
  }, [controlColumnIds, displayedColumns, onColumnOrderChange]);
  var resetColumnSelectionHandler = useCallback(function () {
    var columnsOrdered = resetColumnsOrder(defaultColumns, displayedColumns);
    var onlyColumnsIds = getColumnsIds(columnsOrdered);
    onResetColumnSelection(onlyColumnsIds);
  }, [defaultColumns, displayedColumns, onResetColumnSelection]);
  return jsxs(Fragment, {
    children: [jsx("div", {
      style: {
        height: 48,
        display: 'flex'
      },
      children: jsx("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'nowrap',
          flex: 1
        },
        children: jsxs("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'nowrap'
          },
          children: [jsx("div", {
            style: {
              marginRight: tokens.spacing02
            },
            children: jsx(LockedOutlinedIcon, {
              style: {
                color: tokens.iconColorDefault,
                position: 'relative',
                top: 2
              }
            })
          }), jsx("div", {
            children: jsx(Typography, {
              children: displayedColumns[0].Header
            })
          })]
        })
      })
    }), jsx(DragDropContext, {
      onDragEnd: onDragEnd,
      children: jsx(Droppable, {
        droppableId: "list",
        children: function children(provided) {
          return jsxs("div", _objectSpread2(_objectSpread2({
            style: {
              borderBottom: "1px solid ".concat(tokens.borderColorDefault)
            },
            ref: provided.innerRef
          }, provided.droppableProps), {}, {
            children: [jsx(ColumnsList, {
              columns: displayedColumns,
              toggleHiddenHandler: toggleHiddenHandler
            }), provided.placeholder]
          }));
        }
      })
    }), jsx("div", {
      style: {
        marginTop: tokens.spacing04
      },
      children: jsx(Button, {
        variant: "secondary",
        leadingIcon: jsx(RefreshOutlinedIcon, {}),
        onClick: resetColumnSelectionHandler,
        children: t('Reset')
      })
    })]
  });
}

var styles$h = {"tableSettingsDrawer":"ua-common_10-0-0_DataTableSettings__tableSettingsDrawer__c50e3"};

var DisplayDensity;
(function (DisplayDensity) {
  DisplayDensity["COMFORTABLE"] = "comfortable";
  DisplayDensity["COMPACT"] = "compact";
})(DisplayDensity || (DisplayDensity = {}));
function DataTableSettings(_ref) {
  var allColumns = _ref.allColumns,
    _ref$compactView = _ref.compactView,
    compactView = _ref$compactView === void 0 ? false : _ref$compactView,
    defaultColumns = _ref.defaultColumns,
    _ref$defaultTablePref = _ref.defaultTablePreferences,
    defaultTablePreferences = _ref$defaultTablePref === void 0 ? {} : _ref$defaultTablePref,
    onResetColumnSelection = _ref.onResetColumnSelection,
    onSetColumnOrder = _ref.onSetColumnOrder,
    setDrawerOpen = _ref.setDrawerOpen,
    setTableSettingsDrawerOpen = _ref.setTableSettingsDrawerOpen,
    tableId = _ref.tableId,
    _ref$tableSettingsDra = _ref.tableSettingsDrawerOpen,
    tableSettingsDrawerOpen = _ref$tableSettingsDra === void 0 ? false : _ref$tableSettingsDra;
  var t = useTranslate();
  var _useTablePreferences = useTablePreferences(tableId, defaultTablePreferences),
    _useTablePreferences2 = _slicedToArray(_useTablePreferences, 2),
    tablePreferences = _useTablePreferences2[0],
    setTablePreferences = _useTablePreferences2[1];
  var handleResetColumnSelection = useCallback(function (orderIds) {
    var _defaultTablePreferen, _defaultTablePreferen2, _defaultTablePreferen3;
    onResetColumnSelection((_defaultTablePreferen = defaultTablePreferences.hiddenColumns) !== null && _defaultTablePreferen !== void 0 ? _defaultTablePreferen : []);
    onSetColumnOrder(orderIds);
    // reset columnOrder and hiddenColumns to their default values
    setTablePreferences({
      columnOrder: (_defaultTablePreferen2 = defaultTablePreferences.columnOrder) !== null && _defaultTablePreferen2 !== void 0 ? _defaultTablePreferen2 : [],
      hiddenColumns: (_defaultTablePreferen3 = defaultTablePreferences.hiddenColumns) !== null && _defaultTablePreferen3 !== void 0 ? _defaultTablePreferen3 : []
    });
  }, [onResetColumnSelection, onSetColumnOrder, defaultTablePreferences.columnOrder, defaultTablePreferences.hiddenColumns, setTablePreferences]);
  var handleSetColumnCorder = useCallback(function (columnOrder) {
    onSetColumnOrder(columnOrder);
    setTablePreferences({
      columnOrder: columnOrder
    });
  }, [onSetColumnOrder, setTablePreferences]);
  var columnSelectionHandler = useCallback(function (colId, visible) {
    var hiddenColumns = tablePreferences.hiddenColumns;
    if (visible) {
      hiddenColumns = hiddenColumns.filter(function (c) {
        return c !== colId;
      });
    } else {
      hiddenColumns.push(colId);
    }
    setTablePreferences({
      hiddenColumns: hiddenColumns
    });
  }, [setTablePreferences, tablePreferences.hiddenColumns]);
  return jsxs(Drawer$1, {
    paperClasses: styles$h.tableSettingsDrawer,
    title: t('Modify table'),
    setDrawerOpen: setDrawerOpen,
    open: tableSettingsDrawerOpen,
    setOpen: setTableSettingsDrawerOpen,
    variant: "temporary",
    BackdropProps: {
      invisible: true
    },
    children: [jsx("div", {
      style: {
        marginBottom: tokens.spacing02
      },
      children: jsx(Typography, {
        variant: "caption-medium-strong",
        color: "type-color-secondary",
        children: t('Display density')
      })
    }), jsxs(RadioGroup, {
      name: "compactView",
      value: compactView ? DisplayDensity.COMPACT : DisplayDensity.COMFORTABLE,
      onChange: function onChange(e) {
        return setTablePreferences({
          compactView: e.currentTarget.value === DisplayDensity.COMPACT
        });
      },
      children: [jsx(RadioButton, {
        value: DisplayDensity.COMFORTABLE,
        children: t('Comfortable')
      }), jsx(RadioButton, {
        value: DisplayDensity.COMPACT,
        children: t('Compact')
      })]
    }), jsx("div", {
      style: {
        marginBottom: tokens.spacing02,
        marginTop: tokens.spacing06
      },
      children: jsx(Typography, {
        variant: "caption-medium-strong",
        color: "type-color-secondary",
        children: t('Column visibility')
      })
    }), jsx(ModifyDataTableColumns, {
      columns: allColumns,
      defaultColumns: defaultColumns,
      onResetColumnSelection: handleResetColumnSelection,
      onColumnOrderChange: handleSetColumnCorder,
      onColumnSelectionChange: columnSelectionHandler
    })]
  });
}

var styles$g = {"cell":"ua-common_10-0-0_DataTableSkeleton__cell__0e43e","compactCell":"ua-common_10-0-0_DataTableSkeleton__compactCell__0e43e","tableRow":"ua-common_10-0-0_DataTableSkeleton__tableRow__0e43e","selection":"ua-common_10-0-0_DataTableSkeleton__selection__0e43e","cellContent":"ua-common_10-0-0_DataTableSkeleton__cellContent__0e43e"};

var DataTableSkeleton = function DataTableSkeleton(_ref) {
  var pageSize = _ref.pageSize,
    useSelection = _ref.useSelection,
    headerGroups = _ref.headerGroups,
    compactView = _ref.compactView;
  return jsx(Fragment, {
    children: headerGroups.map(function (headerGroup, i) {
      return jsx(Fragment$1, {
        children: _toConsumableArray(new Array(pageSize)).map(function (_row, index) {
          return jsx(TableRow, {
            className: styles$g.tableRow,
            children: headerGroup.headers.map(function (column, i) {
              return jsx(TableCell, {
                className: clsx(styles$g.cell, compactView && styles$g.compactCell),
                children: i === 0 && useSelection ? jsx("div", {
                  className: styles$g.selection,
                  children: jsx(Skeleton, {
                    width: 16,
                    size: "xxsmall",
                    variant: "rectangle"
                  })
                }) : jsx("div", {
                  className: styles$g.cellContent,
                  children: jsx(Skeleton, {
                    width: "".concat(Math.floor(Math.random() * 50 + 50), "%"),
                    size: compactView ? 'xxsmall' : 'small',
                    variant: "rectangle"
                  })
                })
              }, i);
            })
          }, index);
        })
      }, i);
    })
  });
};
var DataTableSkeleton$1 = memo(DataTableSkeleton);

var _excluded$q = ["allSelected", "checkOnClick", "className", "columns", "compactView", "data", "defaultColumn", "defaultTablePreferences", "expanded", "expandSubRowsByDefault", "getRowId", "getSubRows", "initialColumnOrder", "initialHiddenColumns", "initialPageIndex", "initialPageSize", "initialSelectedRowIds", "initialSortBy", "isRowHoverable", "isSubDataTable", "loading", "matchCount", "maxSubRowsExpandedByDefault", "onPageSizeChange", "onPageIndexChange", "onRowClick", "onRowCtrlClick", "onSelectedRowIds", "onSetPageSize", "onSortByChange", "pageCount", "setDrawerOpen", "setTableSettingsDrawerOpen", "showTableHead", "showToggleAll", "skeletonDelay", "showPagination", "subRowComponent", "subRowIndentMaxDepth", "tableHeight", "tableId", "tableMaxWidth", "tableSettingsDrawerOpen", "useDynamicSetupCell", "useSelection", "useSubRows"];
var DEFAULT_SELECTED_ROW_IDS$1 = {};
function GetDefaultRowID$1(row) {
  var defaultRow = row;
  return defaultRow.addressJrn || defaultRow.lineJrn || defaultRow.jrn || defaultRow.userAgentId || defaultRow.key || defaultRow.id || '';
}
var DataTableContent = React__default.forwardRef(function (_ref, ref) {
  var _ref$allSelected = _ref.allSelected,
    allSelected = _ref$allSelected === void 0 ? false : _ref$allSelected,
    _ref$checkOnClick = _ref.checkOnClick,
    checkOnClick = _ref$checkOnClick === void 0 ? false : _ref$checkOnClick,
    className = _ref.className,
    columns = _ref.columns,
    _ref$compactView = _ref.compactView,
    compactView = _ref$compactView === void 0 ? false : _ref$compactView,
    data = _ref.data,
    defaultColumn = _ref.defaultColumn,
    defaultTablePreferences = _ref.defaultTablePreferences,
    _ref$expanded = _ref.expanded,
    expanded = _ref$expanded === void 0 ? {} : _ref$expanded,
    _ref$expandSubRowsByD = _ref.expandSubRowsByDefault,
    expandSubRowsByDefault = _ref$expandSubRowsByD === void 0 ? false : _ref$expandSubRowsByD,
    _ref$getRowId = _ref.getRowId,
    getRowId = _ref$getRowId === void 0 ? GetDefaultRowID$1 : _ref$getRowId,
    getSubRows = _ref.getSubRows,
    _ref$initialColumnOrd = _ref.initialColumnOrder,
    initialColumnOrder = _ref$initialColumnOrd === void 0 ? [] : _ref$initialColumnOrd,
    _ref$initialHiddenCol = _ref.initialHiddenColumns,
    initialHiddenColumns = _ref$initialHiddenCol === void 0 ? [] : _ref$initialHiddenCol,
    _ref$initialPageIndex = _ref.initialPageIndex,
    initialPageIndex = _ref$initialPageIndex === void 0 ? 0 : _ref$initialPageIndex,
    initialPageSize = _ref.initialPageSize,
    _ref$initialSelectedR = _ref.initialSelectedRowIds,
    initialSelectedRowIds = _ref$initialSelectedR === void 0 ? DEFAULT_SELECTED_ROW_IDS$1 : _ref$initialSelectedR,
    _ref$initialSortBy = _ref.initialSortBy,
    initialSortBy = _ref$initialSortBy === void 0 ? [] : _ref$initialSortBy,
    _ref$isRowHoverable = _ref.isRowHoverable,
    isRowHoverable = _ref$isRowHoverable === void 0 ? false : _ref$isRowHoverable,
    _ref$isSubDataTable = _ref.isSubDataTable,
    isSubDataTable = _ref$isSubDataTable === void 0 ? false : _ref$isSubDataTable,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    matchCount = _ref.matchCount,
    _ref$maxSubRowsExpand = _ref.maxSubRowsExpandedByDefault,
    maxSubRowsExpandedByDefault = _ref$maxSubRowsExpand === void 0 ? TABLE_MAX_SUB_ROWS_EXPANDED_BY_DEFAULT : _ref$maxSubRowsExpand,
    onPageSizeChange = _ref.onPageSizeChange,
    onPageIndexChange = _ref.onPageIndexChange,
    onRowClick = _ref.onRowClick,
    onRowCtrlClick = _ref.onRowCtrlClick,
    onSelectedRowIds = _ref.onSelectedRowIds,
    onSetPageSize = _ref.onSetPageSize,
    onSortByChange = _ref.onSortByChange,
    pageCount = _ref.pageCount,
    setDrawerOpen = _ref.setDrawerOpen,
    setTableSettingsDrawerOpen = _ref.setTableSettingsDrawerOpen,
    _ref$showTableHead = _ref.showTableHead,
    showTableHead = _ref$showTableHead === void 0 ? true : _ref$showTableHead,
    showToggleAll = _ref.showToggleAll,
    _ref$skeletonDelay = _ref.skeletonDelay,
    skeletonDelay = _ref$skeletonDelay === void 0 ? 1500 : _ref$skeletonDelay,
    _ref$showPagination = _ref.showPagination,
    showPagination = _ref$showPagination === void 0 ? 'always' : _ref$showPagination,
    subRowComponent = _ref.subRowComponent,
    _ref$subRowIndentMaxD = _ref.subRowIndentMaxDepth,
    subRowIndentMaxDepth = _ref$subRowIndentMaxD === void 0 ? TABLE_SUB_ROW_INDENT_MAX_DEPTH : _ref$subRowIndentMaxD,
    tableHeight = _ref.tableHeight,
    tableId = _ref.tableId,
    tableMaxWidth = _ref.tableMaxWidth,
    _ref$tableSettingsDra = _ref.tableSettingsDrawerOpen,
    tableSettingsDrawerOpen = _ref$tableSettingsDra === void 0 ? false : _ref$tableSettingsDra,
    _ref$useDynamicSetupC = _ref.useDynamicSetupCell,
    useDynamicSetupCell = _ref$useDynamicSetupC === void 0 ? false : _ref$useDynamicSetupC,
    _ref$useSelection = _ref.useSelection,
    useSelection = _ref$useSelection === void 0 ? false : _ref$useSelection,
    _ref$useSubRows = _ref.useSubRows,
    useSubRows = _ref$useSubRows === void 0 ? false : _ref$useSubRows,
    rest = _objectWithoutProperties(_ref, _excluded$q);
  var isRowClickable = !!onRowClick || !!onRowCtrlClick || checkOnClick;
  var t = useTranslate();
  var getSubRowIndentWidth = useCallback(function (row) {
    return Math.min(row.depth || 0, subRowIndentMaxDepth) * TABLE_SUB_ROW_INDENT_WIDTH;
  }, [subRowIndentMaxDepth]);
  var _useTable = useTable({
      columns: columns,
      data: data,
      initialState: {
        expanded: expanded,
        pageIndex: initialPageIndex,
        pageSize: initialPageSize,
        sortBy: initialSortBy,
        columnOrder: initialColumnOrder,
        hiddenColumns: initialHiddenColumns,
        selectedRowIds: initialSelectedRowIds
      },
      manualPagination: true,
      autoResetExpanded: false,
      autoResetSelectedRows: false,
      pageCount: pageCount,
      manualSortBy: true,
      useControlledState: function useControlledState(state) {
        var selectedObj = DEFAULT_SELECTED_ROW_IDS$1;
        if (allSelected) {
          data.map(function (d) {
            var key = getRowId(d);
            selectedObj[key] = true;
          });
        } else {
          selectedObj = _objectSpread2({}, state.selectedRowIds);
        }
        return useMemo(function () {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            selectedRowIds: selectedObj
          });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [state, allSelected]);
      },
      stateReducer: useCallback(function (newState, action, prevState) {
        if (action.type === 'toggleAllRowsSelected' && action.value === false) {
          newState.selectedRowIds = {};
        }
        if (useSelection && JSON.stringify(newState) !== JSON.stringify(prevState) && action.type !== 'init') {
          onSelectedRowIds && onSelectedRowIds(newState.selectedRowIds);
        }
        return newState;
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [onSelectedRowIds, tableId, useSelection]),
      disableSortRemove: true,
      disableMultiSort: true,
      defaultColumn: defaultColumn,
      autoResetHiddenColumns: false,
      getRowId: getRowId,
      getSubRows: getSubRows
    }, useSortBy, useExpanded, usePagination, useRowSelect, useAbsoluteLayout, useColumnOrder, function (hooks) {
      if (useSelection) {
        hooks.getToggleAllPageRowsSelectedProps = [function (props, _ref2) {
          var instance = _ref2.instance;
          return [props, {
            // @ts-ignore:next-line
            onChange: function onChange(e) {
              return instance.toggleAllPageRowsSelected(e.target.checked);
            },
            indeterminate: !(instance.isAllRowsSelected || allSelected || Object.values(selectedRowIds).length === 0),
            checked: instance.isAllRowsSelected || allSelected || false,
            style: {
              cursor: allSelected ? 'not-allowed' : 'pointer'
            },
            disabled: allSelected
          }];
        }];
        hooks.visibleColumns.push(function (columns) {
          return [
          // Let's make a column for selection
          {
            id: 'selection',
            Header: function Header(_ref3) {
              var getToggleAllPageRowsSelectedProps = _ref3.getToggleAllPageRowsSelectedProps;
              var toggleAllPageRowsSelectedProp = getToggleAllPageRowsSelectedProps();
              return showToggleAll && jsx("div", {
                className: styles$j.selectionColumn,
                children: jsx(PatchedCheckbox$1, _objectSpread2(_objectSpread2({}, toggleAllPageRowsSelectedProp), {}, {
                  inputProps: {
                    'data-testid': 'thead-select-all'
                  },
                  "aria-label": t('Toggle page rows'),
                  title: t('Toggle page rows')
                }))
              });
            },
            Cell: function Cell(_ref4) {
              var row = _ref4.row,
                getToggleAllPageRowsSelectedProps = _ref4.getToggleAllPageRowsSelectedProps;
              var toggleRowSelectedProp = row.getToggleRowSelectedProps();
              var toggleAllPageRowsSelectedProp = getToggleAllPageRowsSelectedProps();
              return jsx("div", {
                style: {
                  left: getSubRowIndentWidth(row)
                },
                className: styles$j.cellContainer,
                children: jsx("div", {
                  className: styles$j.cellCheckboxContainer,
                  onClick: function onClick(e) {
                    e.stopPropagation();
                    // @ts-ignore:next-line
                    toggleRowSelectedProp.onChange && toggleRowSelectedProp.onChange(e);
                  },
                  children: jsx(PatchedCheckbox$1, _objectSpread2(_objectSpread2({}, toggleRowSelectedProp), {}, {
                    checked: toggleAllPageRowsSelectedProp.checked ? true : toggleRowSelectedProp.checked,
                    style: _objectSpread2({}, toggleAllPageRowsSelectedProp.style),
                    disabled: toggleAllPageRowsSelectedProp.disabled,
                    "aria-label": t('Toggle row'),
                    inputProps: {
                      'data-testid': "checkbox-select-row-".concat(row.index).concat(row.depth !== 0 ? "-".concat(row.depth) : '')
                    },
                    onClick: function onClick(e) {
                      e.stopPropagation();
                    },
                    title: t('Toggle row')
                  }))
                })
              });
            },
            isControlColumn: true
          }].concat(_toConsumableArray(columns));
        });
      }
      if (useSubRows) {
        var expandButtonOffset = useSelection ? 12 : 0;
        hooks.visibleColumns.push(function (columns) {
          return [{
            id: 'expansion',
            Cell: function Cell(_ref5) {
              var row = _ref5.row;
              var label = row.isExpanded ? t('Collapse') : t('Expand');
              // @ts-ignore:next-line
              var toggleRowExpandedProps = row.getToggleRowExpandedProps({
                title: null
              });
              return row.canExpand &&
              // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
              jsxs("div", {
                style: {
                  left: getSubRowIndentWidth(row) + expandButtonOffset
                },
                className: styles$j.expandButtonContainer,
                onClick: function onClick(e) {
                  e.stopPropagation();
                },
                children: [jsx(IconButton, _objectSpread2(_objectSpread2({
                  id: "collapse-expand-icon",
                  labelId: "collapse-expand-icon-label"
                }, toggleRowExpandedProps), {}, {
                  onClick: function onClick(e) {
                    e.stopPropagation();
                    // @ts-ignore:next-line
                    toggleRowExpandedProps.onClick(e);
                  },
                  size: "small",
                  children: row.isExpanded ? jsx(ChevronDownOutlinedIcon, {}) : jsx(ChevronRightOutlinedIcon, {})
                })), jsx(Tooltip, {
                  triggerId: "collapse-expand-icon",
                  children: jsx("span", {
                    id: "collapse-expand-icon-label",
                    children: label
                  })
                })]
              });
            },
            isControlColumn: true
          }].concat(_toConsumableArray(columns));
        });
      }
    }, function (hooks) {
      var EXPAND_NEW_ROWS_ACTION_TYPE = 'expandNewRows';
      hooks.useInstance.push(function (instance) {
        var data = instance.data,
          dispatch = instance.dispatch;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(function () {
          if (useSubRows && expandSubRowsByDefault) {
            dispatch({
              type: EXPAND_NEW_ROWS_ACTION_TYPE
            });
          }
        }, [data, dispatch]);
      });
      hooks.stateReducers.push(function (state, action, _previousState, instance) {
        if (action.type === EXPAND_NEW_ROWS_ACTION_TYPE) {
          var newRowIds = instance && instance.flatRows.map(function (r) {
            return r.id;
          }) || [];
          if (newRowIds.length <= maxSubRowsExpandedByDefault) {
            var oldRowIds = keyBy(state.rowsExpandedByDefault || []);
            var addedRowIds = newRowIds.filter(function (id) {
              return !oldRowIds[id];
            });
            if (addedRowIds.length) {
              var newExpanded = _objectSpread2(_objectSpread2({}, state.expanded), addedRowIds.reduce(function (expanded, rowId) {
                expanded[rowId] = true;
                return expanded;
              }, {}));
              return _objectSpread2(_objectSpread2({}, state), {}, {
                expanded: newExpanded,
                rowsExpandedByDefault: _toConsumableArray(newRowIds)
              });
            }
          }
        }
        return state;
      });
    }),
    getTableProps = _useTable.getTableProps,
    getTableBodyProps = _useTable.getTableBodyProps,
    headerGroups = _useTable.headerGroups,
    prepareRow = _useTable.prepareRow,
    page = _useTable.page,
    canPreviousPage = _useTable.canPreviousPage,
    canNextPage = _useTable.canNextPage,
    pageOptions = _useTable.pageOptions,
    toggleAllRowsSelected = _useTable.toggleAllRowsSelected,
    setHiddenColumns = _useTable.setHiddenColumns,
    setColumnOrder = _useTable.setColumnOrder,
    gotoPage = _useTable.gotoPage,
    nextPage = _useTable.nextPage,
    allColumns = _useTable.allColumns,
    previousPage = _useTable.previousPage,
    setPageSize = _useTable.setPageSize,
    _useTable$state = _useTable.state,
    pageIndex = _useTable$state.pageIndex,
    selectedRowIds = _useTable$state.selectedRowIds,
    pageSize = _useTable$state.pageSize,
    sortBy = _useTable$state.sortBy;
  var isPaginationVisible = page.length > 0 && (showPagination === 'always' || showPagination === 'auto-hide' && matchCount && matchCount > pageSize);
  var firstDataColumnIndex = useMemo(function () {
    return allColumns.findIndex(function (c) {
      return !c.isControlColumn;
    });
  }, [allColumns]);
  var handleSetPageSize = useCallback(function (pageSize) {
    setPageSize(pageSize);
    onSetPageSize(pageSize);
  }, [onSetPageSize, setPageSize]);
  useImperativeHandle(ref, function () {
    return {
      gotoPage: gotoPage,
      toggleAllRowsSelected: toggleAllRowsSelected
    };
  }, [gotoPage, toggleAllRowsSelected]);
  useEffect(function () {
    onPageSizeChange(pageSize);
  }, [onPageSizeChange, pageSize]);
  useEffect(function () {
    onPageIndexChange(pageIndex);
  }, [onPageIndexChange, pageIndex]);
  useEffect(function () {
    onSortByChange(sortBy);
  }, [onSortByChange, sortBy]);
  return jsxs(Fragment, {
    children: [jsx(DataTableSettings, {
      allColumns: allColumns,
      compactView: compactView,
      defaultColumns: columns,
      defaultTablePreferences: defaultTablePreferences,
      onResetColumnSelection: setHiddenColumns,
      onSetColumnOrder: setColumnOrder,
      setDrawerOpen: setDrawerOpen,
      setTableSettingsDrawerOpen: setTableSettingsDrawerOpen,
      tableId: tableId,
      tableSettingsDrawerOpen: tableSettingsDrawerOpen
    }), jsxs("div", {
      className: styles$j.tableWrapper,
      // if filters open, removing that height from the table height so it still fits
      // in the page without the scrollbar showing
      style: {
        height: tableHeight,
        maxWidth: tableMaxWidth
      },
      tabIndex: -1,
      children: [jsxs(Table, _objectSpread2(_objectSpread2(_objectSpread2({
        stickyHeader: true
      }, getTableProps()), {}, {
        className: clsx(styles$j.table, isSubDataTable && styles$j.subDataTable, isRowClickable && styles$j.rowClickable, isRowHoverable && styles$j.rowHoverable, useSelection && styles$j.firstColumnSelection, useSelection && styles$j.firstRowSelection, className)
      }, rest), {}, {
        children: [showTableHead && jsx(TableHead, {
          children: headerGroups.map(function (headerGroup) {
            return jsx(TableRow, _objectSpread2(_objectSpread2({}, headerGroup.getHeaderGroupProps()), {}, {
              children: headerGroup.headers.map(function (column) {
                return jsx(TableCell, _objectSpread2(_objectSpread2({
                  className: styles$j.headerCell
                }, column.isControlColumn ? column.getHeaderProps() : column.getHeaderProps(column.getSortByToggleProps())), {}, {
                  title: undefined,
                  style: {
                    width: column.id.toLowerCase() === 'actions' ? '100%' : column.width,
                    textAlign: column.align
                  },
                  // @ts-ignore:next-line
                  sortDirection: column.isSorted ? column.isSortedDesc ? 'desc' : 'asc' : 'none',
                  children: column.isControlColumn || column.disableSortBy ? jsxs("div", {
                    className:
                    // Hide the "Actions" column header will keeping it in DOM for accessibility
                    clsx(styles$j.headerText, column.id.toLowerCase() === 'actions' && styles$j.invisibleCell),
                    children: [column.render('Header'), " ", column.headerExtra]
                  }) : jsxs(Button$1, {
                    className: clsx(styles$j.filterButton, column.align === 'right' && styles$j.filterButtonRight),
                    startIcon: column.isSorted ? column.isSortedDesc ? jsx(ArrowDownOutlinedIcon, {}) : jsx(ArrowUpOutlinedIcon, {}) : undefined,
                    variant: "text",
                    children: [column.render('Header'), " ", column.headerExtra]
                  })
                }));
              })
            }));
          })
        }), jsx(TableBody, _objectSpread2(_objectSpread2({}, getTableBodyProps()), {}, {
          children: loading ? jsx(DelayRender, {
            delay: skeletonDelay,
            children: jsx(DataTableSkeleton$1, {
              compactView: compactView,
              pageSize: pageSize,
              useSelection: useSelection,
              headerGroups: headerGroups
            })
          }) : page.map(function (row, i) {
            prepareRow(row);
            return jsxs(Fragment$1, {
              children: [createElement(TableRow, _objectSpread2(_objectSpread2({}, row.getRowProps()), {}, {
                "data-testid": "dataTableRow-".concat(i),
                key: "dataTableRow-".concat(i),
                onClick: function onClick(e) {
                  if (checkOnClick) {
                    var onChange = row.getToggleRowSelectedProps().onChange;
                    // @ts-ignore:next-line
                    onChange && onChange(e);
                  }
                  if (onRowCtrlClick && (e.ctrlKey || e.metaKey)) {
                    onRowCtrlClick(getRowId(row.original), row.original);
                  } else if (onRowClick) {
                    onRowClick(getRowId(row.original), row.original);
                  }
                },
                className: clsx(row.isSelected && styles$j.selectedRow, isRowClickable && styles$j.clickable)
              }), row.cells.map(function (cell, i) {
                return createElement(TableCell, _objectSpread2(_objectSpread2({}, cell.getCellProps()), {}, {
                  className: clsx(styles$j.cell, isSubDataTable && styles$j.subDataTableCell, compactView && styles$j.compactCell, useDynamicSetupCell && styles$j.dynamicSetupCell, cell.column.id.toLowerCase() === 'actions' && styles$j.sticky, row.isExpanded && !useSubRows && styles$j.expandedCell),
                  key: "tableCell-".concat(i),
                  style: _objectSpread2(_objectSpread2(_objectSpread2({
                    textAlign: cell.column.align,
                    paddingTop: '10px',
                    paddingRight: '8px',
                    paddingBottom: '9px'
                  }, cell.column.width ? {
                    width: cell.column.width
                  } : {}), cell.column.isControlColumn ? {
                    overflow: 'visible'
                  } : {}), useSubRows && i === firstDataColumnIndex ? {
                    paddingLeft: "".concat(getSubRowIndentWidth(row), "px")
                  } : {
                    paddingLeft: '8px'
                  })
                }), cell.render('Cell'));
              })), subRowComponent && subRowComponent(row) && jsx("tr", {
                children: jsx("td", {
                  colSpan: 9999,
                  className: styles$j.noPadding,
                  children: jsx(Collapse, {
                    "in": !!row.isExpanded,
                    children: jsx("div", {
                      className: styles$j.expandedRow,
                      children: subRowComponent(row)
                    })
                  })
                })
              })]
            }, row.getRowProps().key);
          })
        }))]
      })), page.length === 0 && !loading && jsx(DataTableNoResults$1, {})]
    }), isPaginationVisible && jsxs(Fragment, {
      children: [jsx(Divider$1, {
        className: styles$j.tableFooterDivider
      }), jsx(TableFooter, {
        className: styles$j.tableFooter,
        children: jsx(DataTablePagination, {
          pageSize: pageSize,
          pageIndex: pageIndex,
          pageOptions: pageOptions,
          matchCount: matchCount,
          tableId: tableId,
          setPageSize: handleSetPageSize,
          canPreviousPage: canPreviousPage,
          previousPage: previousPage,
          nextPage: nextPage,
          canNextPage: canNextPage
        })
      })]
    })]
  });
});

var _excluded$p = ["children"];
var MenuLabel = function MenuLabel(_ref) {
  var children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded$p);
  return jsx("div", _objectSpread2(_objectSpread2({
    style: {
      padding: "".concat(tokens.spacing02, " ").concat(tokens.spacing04),
      pointerEvents: 'none'
    }
  }, otherProps), {}, {
    children: jsx(Typography, {
      variant: "caption-medium-strong",
      color: "type-color-secondary",
      children: children
    })
  }));
};
var MenuLabel$1 = memo(MenuLabel);

var GroupFilter;
(function (GroupFilter) {
  GroupFilter[GroupFilter["DateRange"] = 0] = "DateRange";
  GroupFilter[GroupFilter["Admin"] = 1] = "Admin";
  GroupFilter[GroupFilter["ActivityType"] = 2] = "ActivityType";
  GroupFilter[GroupFilter["Status"] = 3] = "Status";
})(GroupFilter || (GroupFilter = {}));
var DataTableFilters = function DataTableFilters(_ref) {
  var _ref$filters = _ref.filters,
    filters = _ref$filters === void 0 ? [] : _ref$filters,
    filtersMenu = _ref.filtersMenu,
    showFilters = _ref.showFilters,
    isFiltersMenuOpen = _ref.isFiltersMenuOpen,
    setFilters = _ref.setFilters,
    handleEditFilter = _ref.handleEditFilter;
  var t = useTranslate();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var handleRemoveFilter = function handleRemoveFilter(i) {
    var newFiltersArray = _toConsumableArray(filters);
    newFiltersArray.splice(i, 1);
    if (setFilters) {
      setFilters(newFiltersArray);
    }
  };
  var filterKey = function filterKey(filter) {
    return filter.chipLabel.split(': ')[0];
  };
  return jsxs(Collapse, {
    "in": showFilters,
    children: [jsxs("div", {
      style: {
        minHeight: 56,
        display: 'flex',
        alignItems: 'center',
        paddingBottom: tokens.spacing03,
        paddingTop: tokens.spacing03
      },
      children: [jsxs("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          flexWrap: 'nowrap'
        },
        children: [jsxs("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--goto-spacing-02)'
          },
          children: [filters.map(function (activeFilter, i) {
            return jsx("div", {
              children: activeFilter && (activeFilter.groupId === GroupFilter.DateRange ? jsx("div", {
                id: DATE_RANGE_FILTER_TRIGGERID,
                children: jsxs(Chip, {
                  onClick: function onClick(e) {
                    e.stopPropagation();
                    handleEditFilter(activeFilter.groupId);
                  },
                  active: activeFilter.isPopupOpen,
                  title: activeFilter.chipLabel,
                  "data-testid": "filter-chip-".concat(activeFilter.groupId),
                  children: [t('Date range'), ": ", activeFilter.chipLabel]
                })
              }) : jsx("div", {
                id: activeFilter.triggerId,
                children: jsx(Chip, {
                  style: {
                    maxWidth: 'none'
                  },
                  type: "button",
                  closable: true,
                  onClose: function onClose() {
                    handleRemoveFilter(i);
                    activeFilter.onRemoveFilter && activeFilter.onRemoveFilter();
                  },
                  onAction: function onAction(e) {
                    e.stopPropagation();
                    handleEditFilter(activeFilter.groupId);
                  },
                  active: activeFilter.isPopupOpen,
                  title: activeFilter.chipLabel,
                  "data-testid": "filter-chip-".concat(activeFilter.groupId),
                  children: jsx(Typography, {
                    noWrap: true,
                    style: {
                      maxWidth: 420,
                      textOverflow: 'ellipsis'
                    },
                    children: activeFilter.chipLabel
                  })
                })
              }))
            }, "grid-key-".concat(filterKey(activeFilter)));
          }), filters.length <= MAX_FILTERS && jsxs("div", {
            children: [jsx(Button, {
              "data-testid": "add-filter-button",
              id: ADD_FILTER_BUTTON_ID,
              onClick: function onClick(e) {
                e.stopPropagation();
                setOpen(true);
              },
              leadingIcon: !open && !isFiltersMenuOpen && jsx(AddOutlinedIcon, {}),
              children: open || isFiltersMenuOpen ? jsx(CheckboxLineIcon, {}) : t('Add filter')
            }), jsx("div", {
              id: FILTER_POPOVER_TRIGGER_ID
            })]
          })]
        }), filters.length > 0 && jsxs("div", {
          children: [jsx(IconButton, {
            label: t('Clear filters'),
            variant: "secondary",
            "data-testId": "clearFilterButton",
            size: "small",
            id: "clearFilterButton",
            onClick: function onClick() {
              var alwaysVisibleListOnly = filters.filter(function (filter) {
                return filter.isAlwaysVisible;
              }) || [];
              if (setFilters) {
                setFilters(alwaysVisibleListOnly);
              }
            },
            children: jsx(CloseOutlinedIcon, {})
          }), jsx(Tooltip, {
            zIndex: 3,
            triggerId: "clearFilterButton",
            children: t('Clear filters')
          })]
        })]
      }), jsxs(Popover, {
        width: 180,
        triggerId: ADD_FILTER_BUTTON_ID,
        isOpen: open,
        compact: true,
        onChange: function onChange(e) {
          e.stopPropagation();
          setOpen(e.detail.isOpen);
        },
        position: "bottom-start",
        children: [jsx(MenuLabel$1, {
          children: t('Filter by')
        }), jsx(Menu, {
          label: t('Filter by'),
          children: filtersMenu.map(function (menuFilter) {
            return !(menuFilter && menuFilter.isAlwaysVisible) && jsx(MenuItem, {
              id: "menu-filter-item-".concat(menuFilter.label.toLowerCase()),
              "data-testid": "menu-filter-item-".concat(menuFilter.label.toLowerCase()),
              onClick: function onClick() {
                setOpen(false);
                menuFilter.onClick();
              },
              disabled: !!filters.find(function (filter) {
                return filter.groupId === menuFilter.id;
              }),
              children: menuFilter.label
            }, "".concat(menuFilter.label.toLowerCase(), "-menu-filter"));
          })
        })]
      })]
    }), jsx(Divider$1, {})]
  });
};

var DataTableHighlights = function DataTableHighlights(_ref) {
  var tableHighlights = _ref.tableHighlights;
  return jsx("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      maxWidth: 720,
      flexWrap: 'nowrap'
    },
    children: tableHighlights.map(function (highlight) {
      return jsx("div", {
        style: {
          flex: '0 1 auto'
        },
        children: jsxs(Typography, {
          variant: "heading-medium",
          style: {
            fontVariantNumeric: 'tabular-nums'
          },
          "data-testid": "highlight-".concat(highlight.label.replace(' ', '-').toLowerCase()),
          children: [jsx(AnimatedNumber, {
            value: highlight.number,
            formatValue: function formatValue(value) {
              return value.toFixed(0);
            }
          }), jsx("div", {
            style: {
              marginLeft: tokens.spacing03,
              display: 'inline-block'
            },
            children: jsx(Typography, {
              variant: "caption-medium-strong",
              color: "type-color-secondary",
              children: highlight.label
            })
          })]
        })
      }, highlight.label);
    })
  });
};
var DataTableHighlights$1 = memo(DataTableHighlights);

var styles$f = {"toolBarContainer":"ua-common_10-0-0_DataTableToolbar__toolBarContainer__b89fd","toolbarSection":"ua-common_10-0-0_DataTableToolbar__toolbarSection__b89fd"};

function DataTableToolbar(_ref) {
  var left = _ref.left,
    right = _ref.right;
  return jsxs("div", {
    className: styles$f.toolBarContainer,
    children: [jsx("div", {
      className: styles$f.toolbarSection,
      children: left.filter(Boolean)
    }), jsx("div", {
      className: styles$f.toolbarSection,
      children: right.filter(Boolean)
    })]
  });
}

function BulkMenuButton(_ref) {
  var _ref$allSelected = _ref.allSelected,
    allSelected = _ref$allSelected === void 0 ? false : _ref$allSelected,
    bulkMenuContent = _ref.bulkMenuContent,
    onSelectAll = _ref.onSelectAll,
    selectedRowIds = _ref.selectedRowIds;
  var t = useTranslate();
  return jsxs(Fragment, {
    children: [jsx(IconButton, {
      id: "bulk-menu-more-button",
      label: t('More'),
      size: "small",
      "data-testid": "more-menu",
      variant: "secondary",
      onClick: function onClick() {
        if (onSelectAll) {
          onSelectAll(allSelected ? undefined : selectedRowIds);
        }
      },
      children: jsx(MoreMenuVerticalOutlinedIcon, {})
    }), jsx(Tooltip, {
      position: "bottom-center",
      triggerId: "bulk-menu-more-button",
      children: jsx("span", {
        children: t('More')
      })
    }), jsx(Popover, {
      menu: true,
      position: "bottom-end",
      triggerId: "bulk-menu-more-button",
      children: jsx(Menu, {
        label: t('More'),
        children: bulkMenuContent.map(function (el, i) {
          return jsxs(Fragment$1, {
            children: [el.props.hasSeparatorBefore && jsx(MenuSeparator, {}), cloneElement(el, {
              onClick: function onClick() {
                // Closing the popover on menuitem click
                el.props.onClick && el.props.onClick();
              }
            })]
          }, i);
        })
      })
    })]
  });
}

function ClearButton(_ref) {
  var onClear = _ref.onClear;
  var t = useTranslate();
  return jsx(Button, {
    "data-testid": "clear-filter-menu",
    variant: "tertiary",
    onClick: onClear,
    children: t('Clear')
  });
}

function DeleteButton(_ref) {
  var _ref$allSelected = _ref.allSelected,
    allSelected = _ref$allSelected === void 0 ? false : _ref$allSelected,
    _ref$matchCount = _ref.matchCount,
    matchCount = _ref$matchCount === void 0 ? 0 : _ref$matchCount,
    onBulkDelete = _ref.onBulkDelete,
    _ref$showBulkDeleteLi = _ref.showBulkDeleteLimitMessage,
    showBulkDeleteLimitMessage = _ref$showBulkDeleteLi === void 0 ? false : _ref$showBulkDeleteLi;
  var t = useTranslate();
  return jsxs(Fragment, {
    children: [jsx(IconButton, {
      id: "delete-menu-more-button",
      label: t('Delete'),
      size: "small",
      "data-testid": "delete-menu",
      variant: "secondary",
      onClick: onBulkDelete,
      disabled: showBulkDeleteLimitMessage || allSelected && matchCount > BULK_DELETE_USERS_LIMIT,
      children: jsx(TrashOutlinedIcon, {})
    }), jsx(Tooltip, {
      position: "bottom-center",
      triggerId: "delete-menu-more-button",
      children: showBulkDeleteLimitMessage || allSelected && matchCount > BULK_DELETE_USERS_LIMIT ? t('This action is limited to %{amount} users at a time', {
        amount: BULK_DELETE_USERS_LIMIT
      }) : t('Delete selection')
    })]
  });
}

function DownloadButton(_ref) {
  var onDownloadEvent = _ref.onDownloadEvent;
  var t = useTranslate();
  return jsxs(Fragment, {
    children: [jsx(IconButton, {
      id: "download-menu-button",
      label: t('Download details'),
      "data-testid": "downloadIconButton",
      variant: "secondary",
      size: "small",
      onClick: onDownloadEvent,
      children: jsx(DownloadOutlinedIcon, {})
    }), jsx(Tooltip, {
      position: "bottom-center",
      triggerId: "download-menu-button",
      children: t('Download details')
    })]
  });
}

function ExportAllButton(_ref) {
  var onBulkExport = _ref.onBulkExport;
  var t = useTranslate();
  var exportAll = useCallback(function () {
    onBulkExport();
  }, [onBulkExport]);
  return jsxs(Fragment, {
    children: [jsx(IconButton, {
      id: "export-all-menu-button",
      label: t('Export all'),
      variant: "secondary",
      "data-testid": "tableExportAll",
      size: "small",
      onClick: exportAll,
      children: jsx(DownloadOutlinedIcon, {})
    }), jsx(Tooltip, {
      position: "bottom-center",
      triggerId: "export-all-menu-button",
      children: t('Export all')
    })]
  });
}

function ExportButton(_ref) {
  var _ref$allSelected = _ref.allSelected,
    allSelected = _ref$allSelected === void 0 ? false : _ref$allSelected,
    onBulkExport = _ref.onBulkExport,
    selectedRowIds = _ref.selectedRowIds;
  var t = useTranslate();
  return jsxs(Fragment, {
    children: [jsx(IconButton, {
      id: "export-selection-menu-button",
      label: t('Export selection'),
      "data-testid": "export-selection-menu",
      size: "small",
      variant: "secondary",
      onClick: function onClick() {
        return onBulkExport(allSelected ? undefined : selectedRowIds);
      },
      children: jsx(DownloadOutlinedIcon, {})
    }), jsx(Tooltip, {
      position: "bottom-center",
      triggerId: "export-selection-menu-button",
      children: t('Export selection')
    })]
  });
}

function FiltersButton(_ref) {
  var _ref$areFilterActives = _ref.areFilterActives,
    areFilterActives = _ref$areFilterActives === void 0 ? false : _ref$areFilterActives,
    onToggleShowFilters = _ref.onToggleShowFilters;
  var t = useTranslate();
  return jsxs(Fragment, {
    children: [jsx(IconButton, {
      id: "table-filters-button",
      label: t('Table filters'),
      variant: "secondary",
      "data-testid": "tableFilters",
      size: "small",
      onClick: onToggleShowFilters,
      children: areFilterActives ? jsx(FilterFilledIcon, {}) : jsx(FilterOutlinedIcon, {})
    }), jsx(Tooltip, {
      position: "bottom-center",
      triggerId: "table-filters-button",
      children: t('Table filters')
    })]
  });
}

function SelectAllButton(_ref) {
  var matchCount = _ref.matchCount,
    onSelectAll = _ref.onSelectAll,
    selectAllOverrideLabel = _ref.selectAllOverrideLabel;
  var t = useTranslate();
  return jsx(Button, {
    "data-testid": "select-all-menu",
    variant: "tertiary",
    onClick: onSelectAll,
    children: selectAllOverrideLabel ? selectAllOverrideLabel : t('Select all %{number_of_results}', {
      number_of_results: matchCount
    })
  });
}

function SelectedCount(_ref) {
  var selectedCount = _ref.selectedCount;
  var t = useTranslate();
  return jsx(Typography, {
    noWrap: true,
    style: {
      padding: 'var(--goto-button-padding, 0 14px)',
      flex: '0 0 auto'
    },
    children: t('%{smart_count} selected |||| %{smart_count} selected', {
      smart_count: selectedCount
    })
  });
}

function TableSettingsButton(_ref) {
  var onSetTableSettingsDrawerOpen = _ref.onSetTableSettingsDrawerOpen,
    _ref$tableSettingsDra = _ref.tableSettingsDrawerOpen,
    tableSettingsDrawerOpen = _ref$tableSettingsDra === void 0 ? false : _ref$tableSettingsDra;
  var t = useTranslate();
  var toggleTableSettingsDrawerOpen = useCallback(function () {
    return onSetTableSettingsDrawerOpen(!tableSettingsDrawerOpen);
  }, [onSetTableSettingsDrawerOpen, tableSettingsDrawerOpen]);
  return jsxs(Fragment, {
    children: [jsx(IconButton, {
      id: "table-settings-btn",
      label: t('Table settings'),
      variant: "secondary",
      "data-testid": "tableSettings",
      size: "small",
      onClick: toggleTableSettingsDrawerOpen,
      children: tableSettingsDrawerOpen ? jsx(FineAdjustmentFilledIcon, {}) : jsx(FineAdjustmentOutlinedIcon, {})
    }), jsx(Tooltip, {
      position: "bottom-center",
      triggerId: "table-settings-btn",
      children: t('Table settings')
    })]
  });
}

var _excluded$o = ["autoHidePagination", "bulkMenuContent", "cache", "checkOnClick", "columns", "setDrawerOpen", "data", "classNameTableContent", "defaultSort", "setAllSelected", "allSelected", "setSelectedRowIds", "disableUrlParams", "extraToolbarContent", "extraToolbarContextualContent", "fetchData", "filters", "onDownloadEvent", "downloadPrivilege", "initialSelectedRowIds", "invisibleIfEmpty", "isSubDataTable", "isRowHoverable", "loading", "matchCount", "onBulkDelete", "bulkDeletePrivilege", "onBulkExport", "bulkExportPrivilege", "onSelectAll", "onRowClick", "onRowCtrlClick", "pageCount", "showBulkDeleteLimitMessage", "showPagination", "showSearch", "showTableHead", "showTablePreferences", "defaultTablePreferences", "showToggleAll", "showToolbar", "tableHighlights", "subRowComponent", "tableHeight", "tableId", "tableMaxWidth", "totalCount", "useSelectAll", "useDynamicSetupCell", "selectAllOverrideLabel", "useSelection", "handleEditFilter", "useSubRows", "getSubRows", "expanded", "expandSubRowsByDefault", "maxSubRowsExpandedByDefault", "subRowIndentMaxDepth", "getRowId", "exportAll", "exportSelection", "skeletonDelay", "clearSelectionOnDataChange"];
function GetDefaultRowID(row) {
  var defaultRow = row;
  return defaultRow.addressJrn || defaultRow.lineJrn || defaultRow.jrn || defaultRow.userAgentId || defaultRow.key || defaultRow.id || '';
}
var DEFAULT_SELECTED_ROW_IDS = {};
var _a;
var _b;
function DataTable(props, ref) {
  var _tablePreferences$pag;
  var _props$autoHidePagina = props.autoHidePagination,
    autoHidePagination = _props$autoHidePagina === void 0 ? false : _props$autoHidePagina,
    bulkMenuContent = props.bulkMenuContent,
    cache = props.cache,
    _props$checkOnClick = props.checkOnClick,
    checkOnClick = _props$checkOnClick === void 0 ? false : _props$checkOnClick,
    columns = props.columns,
    setDrawerOpen = props.setDrawerOpen,
    data = props.data,
    classNameTableContent = props.classNameTableContent,
    _props$defaultSort = props.defaultSort,
    defaultSort = _props$defaultSort === void 0 ? [] : _props$defaultSort,
    setAllSelected = props.setAllSelected,
    allSelected = props.allSelected,
    setSelectedRowIds = props.setSelectedRowIds,
    _props$disableUrlPara = props.disableUrlParams,
    disableUrlParams = _props$disableUrlPara === void 0 ? false : _props$disableUrlPara,
    extraToolbarContent = props.extraToolbarContent,
    extraToolbarContextualContent = props.extraToolbarContextualContent,
    fetchData = props.fetchData,
    _props$filters = props.filters,
    _props$filters2 = _props$filters === void 0 ? {
      filtersMenu: []
    } : _props$filters,
    _props$filters2$isFil = _props$filters2.isFiltersMenuOpen,
    isFiltersMenuOpen = _props$filters2$isFil === void 0 ? false : _props$filters2$isFil,
    filters = _props$filters2.filters,
    setFilters = _props$filters2.setFilters,
    filtersMenu = _props$filters2.filtersMenu,
    onDownloadEvent = props.onDownloadEvent,
    downloadPrivilege = props.downloadPrivilege,
    _props$initialSelecte = props.initialSelectedRowIds,
    initialSelectedRowIds = _props$initialSelecte === void 0 ? DEFAULT_SELECTED_ROW_IDS : _props$initialSelecte,
    _props$invisibleIfEmp = props.invisibleIfEmpty,
    invisibleIfEmpty = _props$invisibleIfEmp === void 0 ? false : _props$invisibleIfEmp,
    _props$isSubDataTable = props.isSubDataTable,
    isSubDataTable = _props$isSubDataTable === void 0 ? false : _props$isSubDataTable,
    _props$isRowHoverable = props.isRowHoverable,
    isRowHoverable = _props$isRowHoverable === void 0 ? true : _props$isRowHoverable,
    loading = props.loading,
    matchCount = props.matchCount,
    onBulkDelete = props.onBulkDelete,
    bulkDeletePrivilege = props.bulkDeletePrivilege,
    onBulkExport = props.onBulkExport,
    bulkExportPrivilege = props.bulkExportPrivilege,
    onSelectAll = props.onSelectAll,
    onRowClick = props.onRowClick,
    onRowCtrlClick = props.onRowCtrlClick,
    controlledPageCount = props.pageCount,
    _props$showBulkDelete = props.showBulkDeleteLimitMessage,
    showBulkDeleteLimitMessage = _props$showBulkDelete === void 0 ? false : _props$showBulkDelete,
    _props$showPagination = props.showPagination,
    showPagination = _props$showPagination === void 0 ? true : _props$showPagination,
    _props$showSearch = props.showSearch,
    showSearch = _props$showSearch === void 0 ? true : _props$showSearch,
    _props$showTableHead = props.showTableHead,
    showTableHead = _props$showTableHead === void 0 ? true : _props$showTableHead,
    _props$showTablePrefe = props.showTablePreferences,
    showTablePreferences = _props$showTablePrefe === void 0 ? true : _props$showTablePrefe,
    _props$defaultTablePr = props.defaultTablePreferences,
    defaultTablePreferences = _props$defaultTablePr === void 0 ? {} : _props$defaultTablePr,
    _props$showToggleAll = props.showToggleAll,
    showToggleAll = _props$showToggleAll === void 0 ? true : _props$showToggleAll,
    _props$showToolbar = props.showToolbar,
    showToolbar = _props$showToolbar === void 0 ? true : _props$showToolbar,
    _props$tableHighlight = props.tableHighlights,
    tableHighlights = _props$tableHighlight === void 0 ? [] : _props$tableHighlight,
    subRowComponent = props.subRowComponent,
    _props$tableHeight = props.tableHeight,
    tableHeightProp = _props$tableHeight === void 0 ? 'auto' : _props$tableHeight,
    tableId = props.tableId,
    _props$tableMaxWidth = props.tableMaxWidth,
    tableMaxWidth = _props$tableMaxWidth === void 0 ? '100%' : _props$tableMaxWidth,
    totalCount = props.totalCount,
    _props$useSelectAll = props.useSelectAll,
    useSelectAll = _props$useSelectAll === void 0 ? false : _props$useSelectAll,
    _props$useDynamicSetu = props.useDynamicSetupCell,
    useDynamicSetupCell = _props$useDynamicSetu === void 0 ? false : _props$useDynamicSetu,
    selectAllOverrideLabel = props.selectAllOverrideLabel,
    _props$useSelection = props.useSelection,
    useSelection = _props$useSelection === void 0 ? true : _props$useSelection,
    handleEditFilter = props.handleEditFilter,
    _props$useSubRows = props.useSubRows,
    useSubRows = _props$useSubRows === void 0 ? false : _props$useSubRows,
    getSubRows = props.getSubRows,
    _props$expanded = props.expanded,
    expanded = _props$expanded === void 0 ? {} : _props$expanded,
    _props$expandSubRowsB = props.expandSubRowsByDefault,
    expandSubRowsByDefault = _props$expandSubRowsB === void 0 ? false : _props$expandSubRowsB,
    _props$maxSubRowsExpa = props.maxSubRowsExpandedByDefault,
    maxSubRowsExpandedByDefault = _props$maxSubRowsExpa === void 0 ? TABLE_MAX_SUB_ROWS_EXPANDED_BY_DEFAULT : _props$maxSubRowsExpa,
    _props$subRowIndentMa = props.subRowIndentMaxDepth,
    subRowIndentMaxDepth = _props$subRowIndentMa === void 0 ? TABLE_SUB_ROW_INDENT_MAX_DEPTH : _props$subRowIndentMa,
    _props$getRowId = props.getRowId,
    getRowId = _props$getRowId === void 0 ? GetDefaultRowID : _props$getRowId,
    _props$exportAll = props.exportAll,
    exportAll = _props$exportAll === void 0 ? false : _props$exportAll,
    _props$exportSelectio = props.exportSelection,
    exportSelection = _props$exportSelectio === void 0 ? true : _props$exportSelectio,
    _props$skeletonDelay = props.skeletonDelay,
    skeletonDelay = _props$skeletonDelay === void 0 ? 1500 : _props$skeletonDelay,
    _props$clearSelection = props.clearSelectionOnDataChange,
    clearSelectionOnDataChange = _props$clearSelection === void 0 ? true : _props$clearSelection,
    rest = _objectWithoutProperties(props, _excluded$o);
  var dataTableContentRef = useRef(null);
  var _useTablePreferences = useTablePreferences(tableId, defaultTablePreferences),
    _useTablePreferences2 = _slicedToArray(_useTablePreferences, 2),
    tablePreferences = _useTablePreferences2[0],
    setTablePreferences = _useTablePreferences2[1];
  var _useQueryParamReplace = useQueryParamReplace('page', NumberParam),
    _useQueryParamReplace2 = _slicedToArray(_useQueryParamReplace, 2),
    pageUrlParam = _useQueryParamReplace2[0],
    setPageUrlParam = _useQueryParamReplace2[1];
  var _useQueryParamReplace3 = useQueryParamReplace('sort', ObjectParam),
    _useQueryParamReplace4 = _slicedToArray(_useQueryParamReplace3, 2),
    sortUrlParam = _useQueryParamReplace4[0],
    setSortUrlParam = _useQueryParamReplace4[1];
  var _useQueryParamReplace5 = useQueryParamReplace('q', StringParam),
    _useQueryParamReplace6 = _slicedToArray(_useQueryParamReplace5, 2),
    queryUrlParam = _useQueryParamReplace6[0],
    setQueryUrlParam = _useQueryParamReplace6[1];
  var _useQueryParamReplace7 = useQueryParamReplace('filters', StringParam),
    _useQueryParamReplace8 = _slicedToArray(_useQueryParamReplace7, 2),
    setFiltersUrlParam = _useQueryParamReplace8[1];
  var initialPageIndex = (_a = cache && cache.pageIndex || pageUrlParam) !== null && _a !== void 0 ? _a : 0;
  var dispatch = useDispatch();
  var _useState = useState(cache !== undefined ? cache.query : !disableUrlParams ? queryUrlParam : undefined),
    _useState2 = _slicedToArray(_useState, 2),
    query = _useState2[0],
    setQuery = _useState2[1];
  var _useState3 = useState(cache !== undefined ? cache.query : !disableUrlParams ? queryUrlParam : undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    lastQuery = _useState4[0],
    setLastQuery = _useState4[1];
  var _useState5 = useState(filters),
    _useState6 = _slicedToArray(_useState5, 2),
    lastFilters = _useState6[0],
    setLastFilters = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    tableSettingsDrawerOpen = _useState8[0],
    setTableSettingsDrawerOpen = _useState8[1];
  var _ref = useAppHeights() || {},
    defaultTableHeight = _ref.tableHeight;
  var tableHeight = tableHeightProp || defaultTableHeight;
  var sortByFromParams = (_b = cache && cache.sortBy || sortUrlParam && [sortUrlParam]) !== null && _b !== void 0 ? _b : defaultSort;
  var sortByUpdated = sortByFromParams.length ? [{
    id: sortByFromParams[0].id,
    desc: sortByFromParams[0].direction === 'desc'
  }] : [];
  var defaultColumn = useMemo(function () {
    return {
      width: 48
    };
  }, []);
  var _useState9 = useState(initialPageIndex),
    _useState10 = _slicedToArray(_useState9, 2),
    pageIndex = _useState10[0],
    setPageIndex = _useState10[1];
  var _useState11 = useState((_tablePreferences$pag = tablePreferences.pageSize) !== null && _tablePreferences$pag !== void 0 ? _tablePreferences$pag : DEFAULT_PAGE_SIZE),
    _useState12 = _slicedToArray(_useState11, 2),
    pageSize = _useState12[0],
    setPageSize = _useState12[1];
  var _useState13 = useState(sortByUpdated),
    _useState14 = _slicedToArray(_useState13, 2),
    sortBy = _useState14[0],
    setSortBy = _useState14[1];
  var _useState15 = useState(initialSelectedRowIds),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedRowIds = _useState16[0],
    setLocalSelectedRowIds = _useState16[1];
  var securityContext = useContext(GlobalSecurityContext);
  // Listen for changes in pagination, search query, sorting, and use the state to fetch our new data
  useEffect(function () {
    if (query === undefined) {
      setQuery('');
    } else if (query !== lastQuery) {
      var _dataTableContentRef$;
      clearSelectionOnDataChange && ((_dataTableContentRef$ = dataTableContentRef.current) === null || _dataTableContentRef$ === void 0 ? void 0 : _dataTableContentRef$.toggleAllRowsSelected(false));
      setLastQuery(query);
      if (pageIndex !== 0) {
        var _dataTableContentRef$2;
        // Go back to page 0 if search query changes
        // This is one of those odd cases... when you type a new search term, you should always be
        // redirected to page 0, since otherwise you'll keep and offset in your API call
        // but since we don't want to trigger the API call twice, we use a `return` here
        // and only call `fetchData` the second time around when the page is now 0
        (_dataTableContentRef$2 = dataTableContentRef.current) === null || _dataTableContentRef$2 === void 0 ? void 0 : _dataTableContentRef$2.gotoPage(0);
        return;
      }
    }
    if (!disableUrlParams) {
      // Setting search filters in hex in URL, e.g. ?filters=136568342
      setFiltersUrlParam(filters && filters.length ? toHex(JSON.stringify(filters)) : undefined);
      // Setting search query in URL, e.g. ?q=foo
      setQueryUrlParam(query || undefined);
      // Setting current page in URL, e.g. ?page=4
      setPageUrlParam(pageIndex);
      // Setting the sorting in URL, e.g. ?sort=id-name_desc  -  ?sort=id-name_asc
      var _ref2 = !!sortBy.length && sortBy[0] || {},
        id = _ref2.id,
        desc = _ref2.desc;
      // @ts-ignore:next-line
      var direction = desc || desc === 'true' ? 'desc' : 'asc';
      setSortUrlParam({
        id: id,
        direction: direction
      });
      setTablePreferences({
        pageIndex: pageIndex,
        sortBy: id,
        sortDirection: direction,
        searchQuery: query,
        filters: filters
      });
    }
    query !== undefined && fetchData && fetchData({
      filters: filters,
      pageIndex: pageIndex,
      pageSize: pageSize,
      query: query,
      sortBy: sortBy
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchData, filters, pageIndex, pageSize, query, sortBy, disableUrlParams]);
  // Listen for changes in filters and set it to page 0 if changed
  useEffect(function () {
    if (filters) {
      var _dataTableContentRef$3;
      clearSelectionOnDataChange && ((_dataTableContentRef$3 = dataTableContentRef.current) === null || _dataTableContentRef$3 === void 0 ? void 0 : _dataTableContentRef$3.toggleAllRowsSelected(false));
      if (pageIndex !== 0 && lastFilters !== filters) {
        var _dataTableContentRef$4;
        // Go back to page 0 if filters changes
        // This is one of those odd cases... when you add a new filter, you should always be
        // redirected to page 0, since otherwise you'll keep and offset in your API call
        // but since we don't want to trigger the API call twice, we use a `return` here
        // and only call `fetchData` the second time around when the page is now 0
        (_dataTableContentRef$4 = dataTableContentRef.current) === null || _dataTableContentRef$4 === void 0 ? void 0 : _dataTableContentRef$4.gotoPage(0);
        return;
      }
    }
    setLastFilters(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, lastFilters]);
  useEffect(function () {
    if (isEmpty(initialSelectedRowIds)) {
      var _dataTableContentRef$5;
      (_dataTableContentRef$5 = dataTableContentRef.current) === null || _dataTableContentRef$5 === void 0 ? void 0 : _dataTableContentRef$5.toggleAllRowsSelected(false);
    }
    setAllSelected && dispatch(setAllSelected(_defineProperty({}, tableId, false)));
    setSelectedRowIds && dispatch(setSelectedRowIds(_defineProperty({}, tableId, initialSelectedRowIds)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, setAllSelected, setSelectedRowIds, tableId]);
  useImperativeHandle(ref, function () {
    return {
      refreshData: function refreshData() {
        return fetchData && fetchData({
          filters: filters,
          pageIndex: pageIndex,
          pageSize: pageSize,
          query: query,
          sortBy: sortBy
        });
      },
      clearSelectedRows: function clearSelectedRows() {
        return _clearSelectedRows();
      }
    };
  });
  var handleSetPageSize = useCallback(function (pageSize) {
    setTablePreferences({
      pageSize: pageSize
    });
  }, [setTablePreferences]);
  var handleSelectedRowIds = useCallback(function (selectedRowIds) {
    dispatch(setSelectedRowIds && setSelectedRowIds(_defineProperty({}, tableId, _objectSpread2({}, selectedRowIds))));
    setLocalSelectedRowIds(selectedRowIds);
  }, [dispatch, setSelectedRowIds, tableId, setLocalSelectedRowIds]);
  var toggleShowFiltersHandler = useCallback(function () {
    setTablePreferences({
      showFilters: !tablePreferences.showFilters
    });
  }, [setTablePreferences, tablePreferences]);
  if (invisibleIfEmpty && totalCount === 0) {
    return null;
  }
  var hasActionsButtons = onBulkDelete || onBulkExport || bulkMenuContent || extraToolbarContent;
  var _clearSelectedRows = function _clearSelectedRows() {
    var _dataTableContentRef$6;
    (_dataTableContentRef$6 = dataTableContentRef.current) === null || _dataTableContentRef$6 === void 0 ? void 0 : _dataTableContentRef$6.toggleAllRowsSelected(false);
    setLocalSelectedRowIds(DEFAULT_SELECTED_ROW_IDS);
  };
  return jsxs(TableContainer, {
    className: styles$k.tableContainer,
    children: [tableHighlights.length > 0 && jsx("div", {
      className: styles$k.tableHighlights,
      children: jsx(DataTableHighlights$1, {
        tableHighlights: tableHighlights
      })
    }), showToolbar && jsx(DataTableToolbar, {
      left: [showSearch && jsx(SearchBar, {
        className: styles$k.searchBar,
        query: query,
        setQuery: setQuery
      }), !!matchCount && (allSelected || Object.keys(selectedRowIds).length > 0) && jsx(SelectedCount, {
        selectedCount: allSelected ? matchCount : Object.keys(selectedRowIds).length
      }), !!matchCount && (allSelected || Object.keys(selectedRowIds).length > 0) && jsx(Divider$1, {
        orientation: "vertical",
        flexItem: true,
        className: styles$k.divider
      }), !!matchCount && !allSelected && useSelectAll && Object.values(selectedRowIds).length !== matchCount && jsx(SelectAllButton, {
        onSelectAll: function onSelectAll() {
          var _dataTableContentRef$7;
          (_dataTableContentRef$7 = dataTableContentRef.current) === null || _dataTableContentRef$7 === void 0 ? void 0 : _dataTableContentRef$7.toggleAllRowsSelected(true);
          dispatch(setAllSelected && setAllSelected(_defineProperty({}, tableId, true)));
        },
        matchCount: matchCount,
        selectAllOverrideLabel: selectAllOverrideLabel
      }), !!matchCount && (allSelected || Object.keys(selectedRowIds).length > 0) && jsx(ClearButton, {
        onClear: function onClear() {
          var _dataTableContentRef$8;
          (_dataTableContentRef$8 = dataTableContentRef.current) === null || _dataTableContentRef$8 === void 0 ? void 0 : _dataTableContentRef$8.toggleAllRowsSelected(false);
          dispatch(setAllSelected && setAllSelected(_defineProperty({}, tableId, false)));
        }
      })],
      right: [extraToolbarContextualContent, exportSelection && onBulkExport && (!bulkExportPrivilege || isPrivilegeGranted(bulkExportPrivilege, securityContext)) && jsx(ExportButton, {
        onBulkExport: onBulkExport,
        selectedRowIds: selectedRowIds,
        allSelected: allSelected
      }), onBulkDelete && (!bulkDeletePrivilege || isPrivilegeGranted(bulkDeletePrivilege, securityContext)) && jsx(DeleteButton, {
        allSelected: allSelected,
        matchCount: matchCount,
        onBulkDelete: onBulkDelete,
        showBulkDeleteLimitMessage: showBulkDeleteLimitMessage
      }), bulkMenuContent && jsx(BulkMenuButton, {
        allSelected: allSelected,
        bulkMenuContent: bulkMenuContent,
        onSelectAll: onSelectAll,
        selectedRowIds: selectedRowIds
      }), showTablePreferences && hasActionsButtons && jsx(Divider$1, {
        orientation: "vertical",
        flexItem: true,
        className: styles$k.verticalDivider
      }), extraToolbarContent, onDownloadEvent && (!downloadPrivilege || isPrivilegeGranted(downloadPrivilege, securityContext)) && jsx(DownloadButton, {
        onDownloadEvent: onDownloadEvent
      }), exportAll && onBulkExport && Object.keys(selectedRowIds).length === 0 && (!bulkExportPrivilege || isPrivilegeGranted(bulkExportPrivilege, securityContext)) && jsx(ExportAllButton, {
        onBulkExport: onBulkExport
      }), filtersMenu && filtersMenu.length > 0 && jsx(FiltersButton, {
        areFilterActives: (filters !== null && filters !== void 0 ? filters : []).length > 0,
        onToggleShowFilters: toggleShowFiltersHandler
      }), showTablePreferences && jsx(TableSettingsButton, {
        tableSettingsDrawerOpen: tableSettingsDrawerOpen,
        onSetTableSettingsDrawerOpen: setTableSettingsDrawerOpen
      })]
    }), handleEditFilter && filtersMenu && filtersMenu.length > 0 && jsx(DataTableFilters, {
      handleEditFilter: handleEditFilter,
      filters: filters,
      filtersMenu: filtersMenu,
      isFiltersMenuOpen: !!isFiltersMenuOpen,
      setFilters: setFilters,
      showFilters: tablePreferences.showFilters
    }), jsx(DataTableContent, _objectSpread2({
      ref: dataTableContentRef,
      allSelected: allSelected,
      checkOnClick: checkOnClick,
      className: classNameTableContent,
      columns: columns,
      compactView: tablePreferences && tablePreferences.compactView,
      data: data,
      defaultColumn: defaultColumn,
      defaultTablePreferences: defaultTablePreferences,
      expanded: expanded,
      expandSubRowsByDefault: expandSubRowsByDefault,
      getRowId: getRowId,
      getSubRows: getSubRows,
      initialColumnOrder: tablePreferences.columnOrder,
      initialHiddenColumns: tablePreferences.hiddenColumns,
      initialPageIndex: initialPageIndex,
      initialPageSize: tablePreferences.pageSize,
      initialSelectedRowIds: initialSelectedRowIds,
      initialSortBy: sortByUpdated,
      isRowHoverable: isRowHoverable,
      isSubDataTable: isSubDataTable,
      loading: loading,
      matchCount: matchCount,
      maxSubRowsExpandedByDefault: maxSubRowsExpandedByDefault,
      onPageIndexChange: setPageIndex,
      onPageSizeChange: setPageSize,
      onRowClick: onRowClick,
      onRowCtrlClick: onRowCtrlClick,
      onSelectedRowIds: handleSelectedRowIds,
      onSetPageSize: handleSetPageSize,
      onSortByChange: setSortBy,
      pageCount: controlledPageCount,
      setDrawerOpen: setDrawerOpen,
      setTableSettingsDrawerOpen: setTableSettingsDrawerOpen,
      showPagination: !showPagination ? 'never' : autoHidePagination ? 'auto-hide' : 'always',
      showTableHead: showTableHead,
      showToggleAll: showToggleAll,
      skeletonDelay: skeletonDelay,
      subRowComponent: subRowComponent,
      subRowIndentMaxDepth: subRowIndentMaxDepth,
      tableHeight: handleEditFilter && filtersMenu && filtersMenu.length > 0 && tablePreferences.showFilters ? "calc(".concat(tableHeight, " - 42px)") : tableHeight,
      tableId: tableId,
      tableMaxWidth: tableMaxWidth,
      tableSettingsDrawerOpen: tableSettingsDrawerOpen,
      useDynamicSetupCell: useDynamicSetupCell,
      useSelection: useSelection,
      useSubRows: useSubRows
    }, rest))]
  });
}
var DataTable$1 = forwardRefTyped(DataTable);

var SectionDivider = function SectionDivider(props) {
  return jsx("div", _objectSpread2(_objectSpread2({
    style: {
      marginTop: tokens.spacing02,
      marginBottom: tokens.spacing02,
      position: 'relative'
    }
  }, props), {}, {
    children: jsx(Divider$1, {})
  }));
};
var SectionDivider$1 = memo(SectionDivider);

var styles$e = {"floatingButtons":"ua-common_10-0-0_DataTableRowActions__floatingButtons__800e0","iconBackground":"ua-common_10-0-0_DataTableRowActions__iconBackground__800e0","buttonClicked":"ua-common_10-0-0_DataTableRowActions__buttonClicked__800e0","buttonDisabled":"ua-common_10-0-0_DataTableRowActions__buttonDisabled__800e0","wrapWhiteSpace":"ua-common_10-0-0_DataTableRowActions__wrapWhiteSpace__800e0"};

var _excluded$n = ["children", "disabled", "onButtonClick", "id"];
var ActionButton = forwardRef(function (_ref) {
  var children = _ref.children,
    disabled = _ref.disabled,
    onButtonClick = _ref.onButtonClick,
    id = _ref.id,
    otherProps = _objectWithoutProperties(_ref, _excluded$n);
  return jsx(IconButton, _objectSpread2(_objectSpread2({
    id: id,
    size: "small",
    disabled: disabled,
    variant: "secondary",
    className: styles$e.iconBackground,
    onClick: function onClick(e) {
      e.stopPropagation();
      if (!disabled) {
        // We do the disabled effect this way to avoid a bug in Chrome
        onButtonClick(e);
      }
    }
  }, otherProps), {}, {
    children: children
  }));
});
var setCtxMenuItemDefaults = function setCtxMenuItemDefaults(item) {
  return _objectSpread2(_objectSpread2({}, item), {}, {
    visible: item.visible || item.visible === undefined,
    disabled: item.disabled || false,
    onClick: item.onClick || function (e, item) {
      console.log("Click on context menu item '%s'.", item.id);
    }
  });
};
var DataTableRowActions = function DataTableRowActions(_ref2) {
  var addButtonTooltip = _ref2.addButtonTooltip,
    addUserLabel = _ref2.addUserLabel,
    className = _ref2.className,
    cloneDisabled = _ref2.cloneDisabled,
    cloneDisabledTooltip = _ref2.cloneDisabledTooltip,
    _ref2$ctxMenuItems = _ref2.ctxMenuItems,
    ctxMenuItems = _ref2$ctxMenuItems === void 0 ? [] : _ref2$ctxMenuItems,
    deleteDisabled = _ref2.deleteDisabled,
    _ref2$floatingActionB = _ref2.floatingActionButtons,
    floatingActionButtons = _ref2$floatingActionB === void 0 ? true : _ref2$floatingActionB,
    removeDisabled = _ref2.removeDisabled,
    deleteLabel = _ref2.deleteLabel,
    _ref2$deleteTooltipPo = _ref2.deleteTooltipPosition,
    deleteTooltipPosition = _ref2$deleteTooltipPo === void 0 ? 'top-center' : _ref2$deleteTooltipPo,
    removeLabel = _ref2.removeLabel,
    deletePrivilege = _ref2.deletePrivilege,
    removePrivilege = _ref2.removePrivilege,
    exportOrDownloadPrivilege = _ref2.exportOrDownloadPrivilege,
    addUserPrivilege = _ref2.addUserPrivilege,
    downloadDisabled = _ref2.downloadDisabled,
    downloadLabel = _ref2.downloadLabel,
    editDisabled = _ref2.editDisabled,
    editLabel = _ref2.editLabel,
    exportDisabled = _ref2.exportDisabled,
    exportLabel = _ref2.exportLabel,
    viewItemDisabled = _ref2.viewItemDisabled,
    viewItemLabel = _ref2.viewItemLabel,
    swapDisabled = _ref2.swapDisabled,
    swapLabel = _ref2.swapLabel,
    label = _ref2.label,
    onAddClick = _ref2.onAddClick,
    onAddUserClick = _ref2.onAddUserClick,
    onCloneClick = _ref2.onCloneClick,
    onCtxMenuClick = _ref2.onCtxMenuClick,
    onDeleteClick = _ref2.onDeleteClick,
    onRemoveClick = _ref2.onRemoveClick,
    onDownloadClick = _ref2.onDownloadClick,
    onEditClick = _ref2.onEditClick,
    onExportClick = _ref2.onExportClick,
    onLinkClick = _ref2.onLinkClick,
    onPlayClick = _ref2.onPlayClick,
    onSettingsClick = _ref2.onSettingsClick,
    onViewItemClick = _ref2.onViewItemClick,
    onSwapClick = _ref2.onSwapClick,
    onViewPastReportClick = _ref2.onViewPastReportClick,
    row = _ref2.row,
    settingsDisabled = _ref2.settingsDisabled,
    showCollapse = _ref2.showCollapse,
    _ref2$cloning = _ref2.cloning,
    cloning = _ref2$cloning === void 0 ? false : _ref2$cloning;
  var t = useTranslate();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    loadingAction = _useState2[0],
    setLoadingAction = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    ctxMenuOpen = _useState4[0],
    setCtxMenuOpen = _useState4[1];
  var securityContext = useContext(GlobalSecurityContext);
  var effectiveCtxMenuItems = ctxMenuItems.map(setCtxMenuItemDefaults).filter(function (item) {
    return item.visible && (!item.privilege || isPrivilegeGranted(item.privilege, securityContext));
  });
  return jsxs("div", {
    style: {
      display: 'flex',
      justifyContent: 'flex-end',
      paddingRight: tokens.spacing01,
      paddingLeft: tokens.spacing02,
      flexWrap: 'nowrap',
      alignItems: 'center',
      gap: tokens.spacing02
    },
    className: clsx(className, ctxMenuOpen && styles$e.buttonClicked, floatingActionButtons && styles$e.floatingButtons),
    children: [showCollapse && jsxs("div", {
      children: [jsx(ActionButton, {
        id: "expand-collapse-button",
        onButtonClick: function onButtonClick(e) {
          row.getToggleRowExpandedProps().onClick(e);
        },
        "aria-label": row.isExpanded ? t('Collapse') : t('Expand'),
        children: row.isExpanded ? jsx(ChevronUpOutlinedIcon, {}) : jsx(ChevronDownOutlinedIcon, {})
      }), jsx(Tooltip, {
        triggerId: "expand-collapse-button",
        children: jsx("span", {
          children: row.isExpanded ? t('Collapse') : t('Expand')
        })
      })]
    }), onAddClick && jsxs("div", {
      children: [jsx(ActionButton, {
        id: "table-row-add-action",
        onButtonClick: function onButtonClick() {
          onAddClick();
        },
        disabled: settingsDisabled,
        "aria-label": t('Add'),
        "data-testid": "tableRowAddButton",
        children: jsx(AddOutlinedIcon, {})
      }), jsx(Tooltip, {
        "data-testid": "tableRowAddLabel",
        triggerId: "table-row-add-action",
        children: addButtonTooltip || t('Add')
      })]
    }), onLinkClick && jsx("div", {
      children: jsx(Button$1, {
        onClick: function onClick() {
          return onLinkClick();
        },
        children: label
      })
    }), onEditClick && jsxs("div", {
      children: [jsx(ActionButton, {
        id: "table-row-edit-action",
        onButtonClick: function onButtonClick() {
          onEditClick();
        },
        disabled: editDisabled,
        "aria-label": editLabel || t('Edit %{label}', {
          label: label
        }),
        "data-testid": "tableRowEditButton",
        children: jsx(EditFilledIcon, {})
      }), jsx(Tooltip, {
        "data-testid": "tableRowEditLabel",
        triggerId: "table-row-edit-action",
        children: editLabel || t('Edit %{label}', {
          label: label
        })
      })]
    }), onViewItemClick && jsxs("div", {
      children: [jsx(ActionButton, {
        id: "table-row-view-item-action",
        onButtonClick: function onButtonClick() {
          onViewItemClick();
        },
        disabled: viewItemDisabled,
        "aria-label": viewItemLabel || t('View %{label}', {
          label: label
        }),
        "data-testid": "tableRowViewItemButton",
        children: jsx(VisibilityOnFilledIcon, {})
      }), jsx(Tooltip, {
        "data-testid": "tableRowViewItemLabel",
        triggerId: "table-row-view-item-action",
        children: viewItemLabel || t('View %{label}', {
          label: label
        })
      })]
    }), onSwapClick && jsxs("div", {
      children: [jsx(ActionButton, {
        id: "table-row-swap-action",
        onButtonClick: function onButtonClick() {
          onSwapClick();
        },
        disabled: swapDisabled,
        "aria-label": swapLabel || t('Swap %{label}', {
          label: label
        }),
        "data-testid": "tableRowSwapButton",
        children: jsx(SwapFilledIcon, {})
      }), jsx(Tooltip, {
        "data-testid": "tableRowSwapLabel",
        triggerId: "table-row-swap-action",
        children: swapLabel || t('Swap %{label}', {
          label: label
        })
      })]
    }), onViewPastReportClick && jsxs("div", {
      children: [jsx(ActionButton, {
        id: "table-row-view-past-reports",
        onButtonClick: function onButtonClick() {
          onViewPastReportClick();
        },
        "aria-label": t('View past reports'),
        "data-testid": "tableRowViewPastReportsButton",
        children: jsx(HistoryOutlinedIcon, {})
      }), jsx(Tooltip, {
        "data-testid": "tableRowViewPastReports",
        triggerId: "table-row-view-past-reports",
        children: t('View past reports')
      })]
    }), onAddUserClick && (!addUserPrivilege || isPrivilegeGranted(addUserPrivilege, securityContext)) && jsxs("div", {
      children: [jsx(ActionButton, {
        id: "table-row-add-user-action",
        onButtonClick: function onButtonClick() {
          onAddUserClick();
        },
        disabled: editDisabled,
        "aria-label": addUserLabel || t('Add user to %{label}', {
          label: label
        }),
        "data-testid": "tableRowAddUserButton",
        children: jsx(CreateGroupOutlinedIcon, {})
      }), jsx(Tooltip, {
        "data-testid": "tableRowAddUserLabel",
        triggerId: "table-row-add-user-action",
        children: addUserLabel || t('Add user to %{label}', {
          label: label
        })
      })]
    }), onCloneClick && jsxs("div", {
      children: [jsx(ActionButton, {
        id: "table-row-clone-action",
        onButtonClick: function onButtonClick() {
          onCloneClick();
        },
        "aria-label": t('Clone %{label}', {
          label: label
        }),
        disabled: cloneDisabled || cloning,
        "data-testid": "tableRowCloneButton",
        children: cloning ? jsx(CircularProgress, {
          "data-testid": "cloning",
          color: "inherit",
          size: 16
        }) : jsx(CopyOutlinedIcon, {})
      }), jsx(Tooltip, {
        "data-testid": "tableRowCloneLabel",
        triggerId: "table-row-clone-action",
        children: jsx("span", {
          children: cloneDisabled ? cloneDisabledTooltip || t('Clone %{label}', {
            label: label
          }) : t('Clone %{label}', {
            label: label
          })
        })
      })]
    }), onPlayClick && jsxs("div", {
      children: [jsx(ActionButton, {
        id: "table-row-play-action",
        onButtonClick: function onButtonClick() {
          onPlayClick();
        },
        disabled: settingsDisabled,
        "aria-label": t('Play'),
        "data-testid": "tableRowPlayButton",
        children: jsx(PlayCircleOutlinedIcon, {})
      }), jsx(Tooltip, {
        "data-testid": "tableRowPlayLabel",
        triggerId: "table-row-play-action",
        children: t('Play')
      })]
    }), (onExportClick || onDownloadClick) && (!exportOrDownloadPrivilege || isPrivilegeGranted(exportOrDownloadPrivilege, securityContext)) && jsxs("div", {
      children: [jsx(ActionButton, {
        id: onExportClick ? 'table-row-export-action' : 'table-row-download-action',
        onButtonClick: function onButtonClick() {
          if (onExportClick) {
            onExportClick();
          }
          if (onDownloadClick) {
            onDownloadClick();
          }
        },
        "aria-label": onExportClick ? exportLabel || t('Export %{label}', {
          label: label
        }) : downloadLabel || t('Download %{label}', {
          label: label
        }),
        disabled: exportDisabled || downloadDisabled,
        "data-testid": onExportClick ? 'tableRowExportButton' : 'tableRowDownloadButton',
        children: jsx(DownloadOutlinedIcon, {})
      }), jsx(Tooltip, {
        "data-testid": onExportClick ? 'tableRowExportLabel' : 'tableRowDownloadLabel',
        triggerId: onExportClick ? 'table-row-export-action' : 'table-row-download-action',
        children: onExportClick ? exportLabel || t('Export %{label}', {
          label: label
        }) : downloadLabel || t('Download %{label}', {
          label: label
        })
      })]
    }), onRemoveClick && (!removePrivilege || isPrivilegeGranted(removePrivilege, securityContext)) && jsxs("div", {
      children: [jsx(ActionButton, {
        id: "table-row-remove-action",
        disabled: removeDisabled,
        onButtonClick: function onButtonClick() {
          onRemoveClick();
        },
        "aria-label": removeLabel || "".concat(t('Remove from %{label}', {
          label: label
        })),
        "data-testid": "tableRowRemoveButton",
        children: jsx(PresenceBusyInactiveIcon, {})
      }), jsx(Tooltip, {
        "data-testid": "tableRowRemoveLabel",
        triggerId: "table-row-remove-action",
        children: removeLabel || "".concat(t('Remove from %{label}', {
          label: label
        }))
      })]
    }), onDeleteClick && (!deletePrivilege || isPrivilegeGranted(deletePrivilege, securityContext)) && jsxs("div", {
      children: [jsx(ActionButton, {
        id: "table-row-delete-action",
        disabled: deleteDisabled,
        onButtonClick: function onButtonClick() {
          onDeleteClick();
        },
        "aria-label": deleteLabel || "".concat(t('Delete %{label}', {
          label: label
        })),
        "data-testid": "tableRowDeleteButton",
        children: jsx(TrashOutlinedIcon, {})
      }), jsx(Tooltip, {
        "data-testid": "tableRowDeleteLabel",
        triggerId: "table-row-delete-action",
        className: styles$e.wrapWhiteSpace,
        position: deleteTooltipPosition,
        children: jsx("span", {
          children: deleteLabel || "".concat(t('Delete %{label}', {
            label: label
          }))
        })
      })]
    }), onSettingsClick && jsxs("div", {
      children: [jsx(ActionButton, {
        id: "table-row-settings-action",
        onButtonClick: function onButtonClick() {
          onSettingsClick();
        },
        disabled: settingsDisabled,
        "aria-label": t('Settings'),
        "data-testid": "tableRowSettingsButton",
        children: jsx(SettingsOutlinedIcon, {})
      }), jsx(Tooltip, {
        "data-testid": "tableRowSettingsLabel",
        triggerId: "table-row-settings-action",
        children: t('Settings')
      })]
    }), effectiveCtxMenuItems.length > 0 && jsx(Fragment, {
      children: jsxs("div", {
        children: [jsx(ActionButton
        // @ts-ignore
        , {
          // @ts-ignore
          id: "table-row-contextual-menu-btn",
          onButtonClick: function onButtonClick() {
            if (onCtxMenuClick) {
              onCtxMenuClick();
            }
            setCtxMenuOpen(true);
          },
          "aria-label": t('More'),
          "data-testid": "tableRowActionsBtn",
          children: jsx(MoreMenuVerticalOutlinedIcon, {})
        }), jsx(Tooltip, {
          triggerId: 'table-row-contextual-menu-btn',
          children: t('More')
        }), jsx(Popover, {
          "data-testid": "tableRowActionsMenu",
          isOpen: ctxMenuOpen,
          menu: true,
          triggerId: "table-row-contextual-menu-btn",
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          onChange: function onChange(e) {
            if (!e.detail.isOpen) {
              setCtxMenuOpen(false);
              setLoadingAction(null);
            }
          },
          children: jsx(Menu, {
            label: t('More'),
            children: effectiveCtxMenuItems.map(setCtxMenuItemDefaults).map(function (item, idx) {
              return jsxs(Fragment$1, {
                children: [item.hasSeparatorBefore && idx > 0 && jsx(SectionDivider$1, {}), jsx(MenuItem, {
                  "data-testid": ['tableRowActionsBtnCtxMenuItem', idx].join('-'),
                  disabled: !!loadingAction || item.disabled,
                  onClick: function onClick(e) {
                    e.stopPropagation();
                    setLoadingAction(item.id);
                    item.onClick && item.onClick(e, item);
                    // will trigger a warning in case
                    // of row has been detached - not a big deal
                    setCtxMenuOpen(false);
                    setLoadingAction(null);
                  },
                  children: item.label
                })]
              }, [item.id, idx].join('-'));
            })
          })
        })]
      })
    })]
  });
};

var DefaultEmergencyAcknowledgeDialog = function DefaultEmergencyAcknowledgeDialog(_ref) {
  var title = _ref.title,
    open = _ref.open,
    onCancel = _ref.onCancel,
    onConfirm = _ref.onConfirm,
    location = _ref.location;
  var t = useTranslate();
  var formatAddress = function formatAddress(location) {
    var _location$address, _location$address2, _location$address3, _location$address4, _location$address5, _location$address6, _location$address7, _location$address8;
    return location && location.name && location.address ? [location.name, (_location$address = location.address) === null || _location$address === void 0 ? void 0 : _location$address.addressLine1, (_location$address2 = location.address) === null || _location$address2 === void 0 ? void 0 : _location$address2.addressLine2, (_location$address3 = location.address) === null || _location$address3 === void 0 ? void 0 : _location$address3.addressLine3, (_location$address4 = location.address) === null || _location$address4 === void 0 ? void 0 : _location$address4.addressLine4, (_location$address5 = location.address) === null || _location$address5 === void 0 ? void 0 : _location$address5.city, (_location$address6 = location.address) === null || _location$address6 === void 0 ? void 0 : _location$address6.state, (_location$address7 = location.address) === null || _location$address7 === void 0 ? void 0 : _location$address7.postalCode, (_location$address8 = location.address) === null || _location$address8 === void 0 ? void 0 : _location$address8.country].filter(function (a) {
      return a;
    }).join(', ') : '';
  };
  return jsxs(Dialog, {
    open: open,
    onClose: onCancel,
    title: title,
    children: [jsx(Typography, {
      gutterBottom: true,
      children: t("You're about to change your system's default emergency location to:")
    }), jsx(Typography, {
      gutterBottom: true,
      variant: "body-small-strong",
      children: jsx("i", {
        children: formatAddress(location)
      })
    }), jsx(Typography, {
      children: t("If you don't want to use this address as default emergency location anymore, you'll need to set another location as default.")
    }), jsxs(DialogActions, {
      children: [jsx(Button, {
        variant: "neutral",
        onClick: onCancel,
        children: t('Cancel')
      }), jsx(Button, {
        onClick: onConfirm,
        children: t('Update')
      })]
    })]
  });
};

var styles$d = {"container":"ua-common_10-0-0_DetailsLayout__container__5667c","asideColumn":"ua-common_10-0-0_DetailsLayout__asideColumn__5667c","mainColumn":"ua-common_10-0-0_DetailsLayout__mainColumn__5667c","item":"ua-common_10-0-0_DetailsLayout__item__5667c"};

var DetailsLayout = function DetailsLayout(_ref) {
  var aside = _ref.aside,
    main = _ref.main;
  return jsxs("div", {
    className: styles$d.container,
    children: [jsx("div", {
      className: styles$d.asideColumn,
      children: aside && aside.map(function (child, i) {
        return jsx("div", {
          className: styles$d.item,
          children: child
        }, i);
      })
    }), jsx("div", {
      className: styles$d.mainColumn,
      children: main && main.map(function (child, i) {
        return jsx("div", {
          className: styles$d.item,
          children: child
        }, i);
      })
    })]
  });
};

var DialByNameDirectoryDialog = function DialByNameDirectoryDialog(_ref) {
  var open = _ref.open,
    title = _ref.title,
    onClose = _ref.onClose,
    onCancel = _ref.onCancel,
    onSubmit = _ref.onSubmit;
  var t = useTranslate();
  var validationSchema = Yup.object().shape({
    name: Yup.string().max(255, t('Maximum %{maxCharacters} characters', {
      maxCharacters: 255
    })).required(t('Required'))
  });
  return jsx(Dialog, {
    open: open,
    title: title,
    onClose: onClose,
    children: jsx(Formik, {
      initialValues: {
        name: ''
      },
      isInitialValid: false,
      validateOnBlur: false,
      validationSchema: validationSchema,
      onSubmit: onSubmit,
      children: function children(_ref2) {
        var isValid = _ref2.isValid,
          isSubmitting = _ref2.isSubmitting,
          setFieldValue = _ref2.setFieldValue;
        return jsxs(Form, {
          noValidate: true,
          autoComplete: "off",
          "data-testid": "newDialByNameDirectoryForm",
          children: [jsx(FormikTextField, {
            autoFocus: true,
            label: t('Name'),
            placeholder: t('Enter a name'),
            fullwidth: true,
            name: "name",
            maxLength: 255,
            hideCounter: true,
            "data-testid": "nameTestId",
            onChange: function onChange(e) {
              setFieldValue('name', e.target.value);
            },
            onKeyDown: function onKeyDown(evt) {
              return evt.stopPropagation();
            }
          }), jsxs(DialogActions, {
            children: [jsx(Button, {
              variant: "neutral",
              onClick: onCancel,
              "data-testid": "cancelBtn",
              children: t('Cancel')
            }), jsx(Button, {
              disabled: !isValid || isSubmitting,
              type: "submit",
              variant: "primary",
              "data-testid": "saveBtn",
              children: t('Save')
            })]
          })]
        });
      }
    })
  });
};

var styles$c = {"root":"ua-common_10-0-0_Dropzone__root__1b795","light":"ua-common_10-0-0_Dropzone__light__1b795","dark":"ua-common_10-0-0_Dropzone__dark__1b795","active":"ua-common_10-0-0_Dropzone__active__1b795","reject":"ua-common_10-0-0_Dropzone__reject__1b795"};

var _excluded$m = ["extraMessage", "accept", "onFileSelected", "dropzoneRootStyle", "theme"];
var Dropzone = function Dropzone(_ref) {
  var extraMessage = _ref.extraMessage,
    accept = _ref.accept,
    onFileSelected = _ref.onFileSelected,
    dropzoneRootStyle = _ref.dropzoneRootStyle,
    theme = _ref.theme,
    otherProps = _objectWithoutProperties(_ref, _excluded$m);
  // Hooks
  var t = useTranslate();
  var onDrop = useCallback(function (acceptedFiles) {
    // Do something with the files
    onFileSelected(acceptedFiles);
  }, [onFileSelected]);
  var _useDropzone = useDropzone({
      onDrop: onDrop,
      accept: accept,
      multiple: otherProps.multiple
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    isDragActive = _useDropzone.isDragActive,
    isDragReject = _useDropzone.isDragReject;
  return jsxs("div", _objectSpread2(_objectSpread2(_objectSpread2({
    className: clsx(styles$c.root, theme === 'dark' ? styles$c.dark : styles$c.light, isDragActive && styles$c.active, isDragReject && styles$c.reject),
    style: dropzoneRootStyle
  }, getRootProps()), otherProps), {}, {
    children: [jsx("input", _objectSpread2(_objectSpread2({}, getInputProps()), {}, {
      "data-testid": "fileInput"
    })), isDragActive ? jsx(EmptyState, {
      icon: jsx(CloudUploadFilledIcon, {}),
      children: t('Drop files...')
    }) : jsx(EmptyState, {
      icon: jsx(CloudUploadFilledIcon, {}),
      actions: jsx(Button, {
        id: "".concat(otherProps.id || 'dropzone', "-browse-files-btn"),
        variant: "secondary",
        children: t('Browse files')
      }),
      children: extraMessage
    })]
  }));
};

var _excluded$l = ["error"];
var ErrorFallback = function ErrorFallback(_ref) {
  var error = _ref.error,
    otherProps = _objectWithoutProperties(_ref, _excluded$l);
  var t = useTranslate();
  return jsx("div", _objectSpread2(_objectSpread2({
    style: {
      margin: tokens.spacing04
    },
    role: "alert"
  }, otherProps), {}, {
    children: jsxs(Alert, {
      variant: "danger",
      children: [jsx(Typography, {
        children: t('Something went wrong:')
      }), jsxs(Typography, {
        variant: "caption-small",
        children: [t('Error:'), " ", error && error.message]
      })]
    })
  }));
};

var _excluded$k = ["children"];
var FileExtensionChip = function FileExtensionChip(_ref) {
  var children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded$k);
  return jsx("div", _objectSpread2(_objectSpread2({
    style: {
      borderRadius: tokens.spacing01,
      display: 'inline-block',
      padding: "0px ".concat(tokens.spacing01)
    }
  }, otherProps), {}, {
    children: jsx(TextBadge, {
      variant: "info",
      children: children
    })
  }));
};
var FileExtensionChip$1 = memo(FileExtensionChip);

// Converts a number to bytes
// Based on https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
var formatBytes = function formatBytes(a) {
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if (0 === a) {
    return '0 Bytes';
  }
  var c = 0 > b ? 0 : b,
    d = Math.floor(Math.log(a) / Math.log(1024));
  return parseFloat((a / Math.pow(1024, d)).toFixed(c)) + ' ' + ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'][d];
};

var styles$b = {"root":"ua-common_10-0-0_LinearProgress__root__5d567"};

var _excluded$j = ["className"];
var LinearProgress = function LinearProgress(_ref) {
  var className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded$j);
  return jsx(LinearProgress$1, _objectSpread2({
    className: clsx(styles$b.root, className)
  }, otherProps));
};

var wrapSetting = 'nowrap';
var useStyles = {
  uploadingFile: {
    border: "1px solid ".concat(tokens.neutral200),
    borderRadius: tokens.radiusSmall,
    padding: "".concat(tokens.spacing02, " ").concat(tokens.spacing04),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: tokens.spacing04
  },
  fileInError: {
    borderColor: tokens.borderColorDanger
  },
  fileInfo: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: wrapSetting,
    gap: tokens.spacing02,
    overflow: 'auto'
  },
  processingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  processingText: {
    marginRight: tokens.spacing02
  },
  linearProgress: {
    width: 40
  },
  removeButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
};
var FileUpload = function FileUpload(_ref) {
  var id = _ref.id,
    accept = _ref.accept,
    onChange = _ref.onChange,
    extraMessage = _ref.extraMessage,
    dropzoneRootStyle = _ref.dropzoneRootStyle,
    _ref$fileValidation = _ref.fileValidation,
    fileValidation = _ref$fileValidation === void 0 ? function () {
      return true;
    } : _ref$fileValidation,
    theme = _ref.theme,
    initialFile = _ref.initialFile,
    extraFilePreview = _ref.extraFilePreview,
    fileInError = _ref.fileInError;
  var t = useTranslate();
  var _useState = useState(initialFile),
    _useState2 = _slicedToArray(_useState, 2),
    file = _useState2[0],
    setFile = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    processing = _useState4[0],
    setProcessing = _useState4[1];
  var renderFilePreview = function renderFilePreview(file) {
    return jsxs("div", {
      style: _objectSpread2(_objectSpread2({}, useStyles.uploadingFile), fileInError ? useStyles.fileInError : {}),
      children: [jsxs("div", {
        style: useStyles.fileInfo,
        children: [jsx(AttachmentOutlinedIcon, {}), jsx(Typography, {
          title: file.name,
          noWrap: true,
          children: file.name
        }), jsx(Typography, {
          noWrap: true,
          variant: "caption-medium",
          color: "type-color-secondary",
          children: (file === null || file === void 0 ? void 0 : file.size) > 0 && jsx(Fragment, {
            children: "(".concat(formatBytes(file === null || file === void 0 ? void 0 : file.size), ")")
          })
        })]
      }), extraFilePreview, processing ? jsxs("div", {
        style: useStyles.processingContainer,
        children: [jsx(Typography, {
          noWrap: true,
          style: useStyles.processingText,
          variant: "caption-small",
          children: t('Uploading...')
        }), jsx("div", {
          style: useStyles.linearProgress,
          children: jsx(LinearProgress, {})
        })]
      }) : jsxs("div", {
        style: useStyles.removeButtonContainer,
        children: [jsx(IconButton, {
          id: "remove-file-btn",
          label: t('Remove'),
          size: "small",
          role: "button",
          onClick: function onClick() {
            setFile(undefined);
            setProcessing(false);
            onChange(null);
          },
          children: jsx(CloseCircleFilledIcon, {})
        }), jsx(Tooltip, {
          triggerId: "remove-file-btn",
          children: t('Remove')
        })]
      })]
    });
  };
  return jsx("div", {
    style: {
      marginBottom: tokens.spacing02
    },
    children: file ? renderFilePreview(file) : jsx(Dropzone, {
      id: id,
      dropzoneRootStyle: dropzoneRootStyle,
      accept: accept,
      onFileSelected: function () {
        var _onFileSelected = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(files) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!(!files || !fileValidation(files[0]))) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                setFile(files[0]);
                setProcessing(true);
                _context.next = 6;
                return onChange(files[0]);
              case 6:
                setProcessing(false);
              case 7:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function onFileSelected(_x) {
          return _onFileSelected.apply(this, arguments);
        }
        return onFileSelected;
      }(),
      extraMessage: extraMessage,
      theme: theme
    })
  });
};

var FormField = function FormField(_ref) {
  var _ref$helperText = _ref.helperText,
    helperText = _ref$helperText === void 0 ? '' : _ref$helperText,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    _ref$labelId = _ref.labelId,
    labelId = _ref$labelId === void 0 ? undefined : _ref$labelId,
    _ref$margin = _ref.margin,
    margin = _ref$margin === void 0 ? 'normal' : _ref$margin,
    _ref$horizontal = _ref.horizontal,
    horizontal = _ref$horizontal === void 0 ? false : _ref$horizontal,
    _ref$noMargin = _ref.noMargin,
    noMargin = _ref$noMargin === void 0 ? false : _ref$noMargin,
    contentBefore = _ref.contentBefore,
    contentAfter = _ref.contentAfter,
    children = _ref.children,
    name = _ref.name;
  var TextFieldHelperText = function TextFieldHelperText() {
    return isArray(helperText) ? jsx(Fragment, {
      children: helperText.map(function (text, index) {
        return jsx(HelperText, {
          id: "textfield-".concat(name, "-helper-text-").concat(index),
          children: text
        }, index);
      })
    }) : jsx(HelperText, {
      id: "textfield-".concat(name, "-helper-text"),
      children: helperText
    });
  };
  var TextFieldLabel = function TextFieldLabel() {
    var labelProps = labelId ? {
      id: labelId
    } : {};
    return jsx(Typography, _objectSpread2(_objectSpread2({
      variant: horizontal ? 'body-small' : 'caption-default-02',
      tag: "label"
    }, labelProps), {}, {
      children: label
    }));
  };
  return jsx("div", {
    style: {
      marginBottom: noMargin || margin === 'none' ? tokens.spacing00 : margin === 'dense' ? tokens.spacing04 : tokens.spacing06
    },
    children: jsxs("div", {
      style: {
        display: 'flex',
        flexDirection: horizontal ? 'row' : 'column',
        justifyContent: horizontal ? 'space-between' : 'flex-start',
        alignItems: horizontal ? 'center' : undefined
      },
      children: [jsxs("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          width: 'unset'
        },
        children: [label && jsx("div", {
          style: {
            marginBottom: tokens.spacing01
          },
          children: jsx(TextFieldLabel, {})
        }), helperText && horizontal && jsx(TextFieldHelperText, {}), !horizontal && jsx("div", {
          children: children
        })]
      }), !horizontal ? helperText && jsx(TextFieldHelperText, {}) : jsxs("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          width: 'auto',
          gap: tokens.spacing02
        },
        children: [contentBefore && jsx("div", {
          children: contentBefore
        }), jsx("div", {
          style: {
            marginLeft: contentBefore ? tokens.spacing00 : tokens.spacing04,
            display: 'flex',
            alignItems: 'center'
          },
          children: children
        }), contentAfter && jsx("div", {
          children: contentAfter
        })]
      })]
    })
  });
};

var _excluded$i = ["onChange", "checked"],
  _excluded2$1 = ["children", "disabled", "onBlur", "onChange", "style"];
var PatchedSwitch = function PatchedSwitch(_ref) {
  var _onChange = _ref.onChange,
    checked = _ref.checked,
    otherPros = _objectWithoutProperties(_ref, _excluded$i);
  var checkBoxRef = useRef();
  var isSkipUpdate = useRef(false);
  // The chameleon-web switch will emit onChange when setting its value programmatically.
  // If the checkbox has been rendered once (ref.current is not undefined)
  // and if meta value !== checkbox checked property, it means that the value has been set programmatically (without user interaction)
  // When this happens, we skip 1 onChange event.
  // Remove when https://logmein.slack.com/archives/CA5AW4WNN/p1642766147268300 is fixed.
  // This workaround was suggested in https://logmein.slack.com/archives/C02CMP5H51U/p1677531732062209
  isSkipUpdate.current = !!checkBoxRef.current && checked !== checkBoxRef.current.checked;
  return jsx(Switch, _objectSpread2(_objectSpread2({}, otherPros), {}, {
    checked: checked,
    onChange: function onChange(e) {
      if (isSkipUpdate.current) {
        isSkipUpdate.current = false;
        return;
      }
      _onChange === null || _onChange === void 0 ? void 0 : _onChange(e);
    },
    ref: checkBoxRef
  }));
};
var FormikSwitch = function FormikSwitch(_ref2) {
  var _meta$value;
  var children = _ref2.children,
    disabled = _ref2.disabled,
    _onBlur = _ref2.onBlur,
    _onChange2 = _ref2.onChange,
    style = _ref2.style,
    otherProps = _objectWithoutProperties(_ref2, _excluded2$1);
  var _useFormikContext = useFormikContext(),
    getFieldMeta = _useFormikContext.getFieldMeta,
    handleBlur = _useFormikContext.handleBlur,
    isSubmitting = _useFormikContext.isSubmitting;
  var meta = getFieldMeta(otherProps.name);
  return jsx(PatchedSwitch, _objectSpread2(_objectSpread2({}, otherProps), {}, {
    checked: (_meta$value = meta.value) !== null && _meta$value !== void 0 ? _meta$value : false,
    disabled: isSubmitting || !!disabled,
    onBlur: function onBlur(e) {
      handleBlur(e);
      _onBlur && _onBlur(e);
    },
    onChange: function onChange(e) {
      if (_onChange2) {
        // This is a quick fix to allow Formik to handle events from this control easily.
        // handleChange works with the target value. Chameleon-web uses on and off for the switch value and it doesn't work for boolean value out of the box.
        e.target.value = e.target.checked;
        _onChange2(e);
      }
    },
    style: style,
    children: children ? children : undefined
  }));
};

var styles$a = {"field":"ua-common_10-0-0_FormikDatePickerField__field__256a8","fullWidth":"ua-common_10-0-0_FormikDatePickerField__fullWidth__256a8","cursorPointer":"ua-common_10-0-0_FormikDatePickerField__cursorPointer__256a8","cursorNotAllowed":"ua-common_10-0-0_FormikDatePickerField__cursorNotAllowed__256a8","hidden":"ua-common_10-0-0_FormikDatePickerField__hidden__256a8"};

var _excluded$h = ["textFieldProps", "name", "disabled", "setFieldValue", "value", "disableClearable", "clearBtnTooltip", "datePickerProps"];
var FormikDatePickerField = function FormikDatePickerField(_ref) {
  var textFieldProps = _ref.textFieldProps,
    name = _ref.name,
    disabled = _ref.disabled,
    setFieldValue = _ref.setFieldValue,
    value = _ref.value,
    disableClearable = _ref.disableClearable,
    clearBtnTooltip = _ref.clearBtnTooltip,
    datePickerProps = _ref.datePickerProps,
    otherProps = _objectWithoutProperties(_ref, _excluded$h);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    datepickerOpen = _useState2[0],
    setDatepickerOpen = _useState2[1];
  var t = useTranslate();
  return jsxs(Fragment, {
    children: [jsx(TextField$2, _objectSpread2(_objectSpread2({}, textFieldProps), {}, {
      name: name,
      fullwidth: true,
      disabled: disabled,
      onClick: function onClick() {
        return !disabled && setDatepickerOpen(true);
      },
      className: clsx(styles$a.field, styles$a.fullWidth, disabled ? styles$a.cursorNotAllowed : styles$a.cursorPointer),
      leadingIcon: jsxs(InputAdornment, {
        position: "start",
        children: [jsx(IconButton, {
          id: "open-datepicker-leading-btn",
          label: t('Open datepicker'),
          disabled: disabled,
          size: "small",
          onClick: function onClick() {
            return setDatepickerOpen(true);
          },
          children: jsx(CalendarOutlinedIcon, {})
        }), jsx(Tooltip, {
          triggerId: "open-datepicker-leading-btn",
          children: jsx("span", {
            children: t('Open datepicker')
          })
        })]
      }),
      trailingIcon: jsx(InputAdornment, {
        position: "end",
        children: jsxs("div", {
          style: {
            display: 'flex',
            alignItems: 'center'
          },
          children: [value && !disableClearable && jsxs(Fragment, {
            children: [jsx(IconButton, {
              id: "clear-date-btn",
              label: t('Close'),
              size: "small",
              disabled: disabled,
              onClick: function onClick(e) {
                e.stopPropagation();
                if (name && setFieldValue) {
                  setFieldValue(name, null);
                }
              },
              children: jsx(CloseOutlinedIcon, {})
            }), jsx(Tooltip, {
              triggerId: "clear-date-btn",
              children: jsxs("span", {
                children: [clearBtnTooltip, " "]
              })
            })]
          }), jsx(IconButton, {
            id: "open-datepicker-btn",
            label: t('Open datepicker'),
            disabled: disabled,
            size: "small",
            onClick: function onClick() {
              return setDatepickerOpen(true);
            },
            children: jsx(ChevronDownOutlinedIcon, {})
          }), jsx(Tooltip, {
            triggerId: "open-datepicker-btn",
            children: jsx("span", {
              children: t('Open datepicker')
            })
          })]
        })
      }),
      value: value ? moment(value).format(DATE_FORMAT_1) : ''
    }, otherProps)), jsx(DatePicker, _objectSpread2(_objectSpread2({}, datePickerProps), {}, {
      variant: "dialog",
      open: datepickerOpen,
      disableToolbar: true,
      className: styles$a.hidden,
      onOpen: function onOpen() {
        return setDatepickerOpen(true);
      },
      onClose: function onClose() {
        return setDatepickerOpen(false);
      },
      value: value,
      onChange: function onChange(val) {
        if (name && setFieldValue && val) {
          setFieldValue(name, val.toDate());
        }
      }
    }))]
  });
};

var BACKSPACE_KEYCODE = 8;
var TAB_KEYCODE = 9;
var ENTER_KEYCODE = 13;
var LEFT_KEYCODE = 37;
var UP_KEYCODE = 38;
var RIGHT_KEYCODE = 39;
var DOWN_KEYCODE = 40;
var DELETE_KEYCODE = 46;

var _excluded$g = ["name", "debounceMs"];
var onlyDigitsNumber = function onlyDigitsNumber(number) {
  return number.replace(/\D/g, '');
};
var formatPhoneNumber$1 = function formatPhoneNumber(number) {
  var _phoneNumberObject;
  var sanitizedNumber = onlyDigitsNumber(number);
  if (!sanitizedNumber) {
    return '';
  }
  var phoneNumberObject;
  try {
    phoneNumberObject = parsePhoneNumber("+".concat(sanitizedNumber));
  } catch (e) {
    return new AsYouType('US').input("+".concat(sanitizedNumber));
  }
  return (_phoneNumberObject = phoneNumberObject) === null || _phoneNumberObject === void 0 ? void 0 : _phoneNumberObject.formatInternational();
};
var ALLOWED_KEYCODES = [BACKSPACE_KEYCODE, TAB_KEYCODE, ENTER_KEYCODE, LEFT_KEYCODE, UP_KEYCODE, RIGHT_KEYCODE, DOWN_KEYCODE, DELETE_KEYCODE];
var FormikPhoneNumber = function FormikPhoneNumber(_ref) {
  var name = _ref.name,
    _ref$debounceMs = _ref.debounceMs,
    debounceMs = _ref$debounceMs === void 0 ? 0 : _ref$debounceMs,
    props = _objectWithoutProperties(_ref, _excluded$g);
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue;
  var debouncedOnChange = useMemo(function () {
    var onChangeFunction = function onChangeFunction(newValue) {
      setFieldValue(name, "+".concat(onlyDigitsNumber(newValue)));
    };
    if (debounceMs > 0) {
      return debounce(onChangeFunction, debounceMs);
    }
    return onChangeFunction;
  }, [debounceMs, name, setFieldValue]);
  return jsx(FormikTextField, _objectSpread2(_objectSpread2({}, props), {}, {
    "data-testid": "phone-number-field",
    name: name,
    maxLength: 15,
    hideCounter: true,
    formatValue: formatPhoneNumber$1,
    placeholder: '+1',
    onChange: function onChange(e) {
      var _e$target$value;
      debouncedOnChange((_e$target$value = e.target.value) !== null && _e$target$value !== void 0 ? _e$target$value : '');
    },
    onKeyDown: function onKeyDown(e) {
      if (ALLOWED_KEYCODES.includes(e.keyCode)) {
        e.stopPropagation();
      } else if (!ONLY_NUMBERS_REGEXP.test(e.key)) {
        e.preventDefault();
        return false;
      } else {
        e.stopPropagation();
      }
    }
  }));
};

var _excluded$f = ["children"];
var FormSubtitle = function FormSubtitle(_ref) {
  var children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded$f);
  return jsx("div", _objectSpread2(_objectSpread2({
    style: {
      marginBottom: tokens.spacing04,
      marginTop: tokens.spacing06
    }
  }, otherProps), {}, {
    children: jsx("div", {
      style: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: tokens.spacing02
      },
      children: jsx(Typography, {
        variant: "caption-medium-strong",
        children: children
      })
    })
  }));
};
var FormSubtitle$1 = memo(FormSubtitle);

var _excluded$e = ["children"];
var FormTitle = function FormTitle(_ref) {
  var children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded$e);
  return jsx("div", _objectSpread2(_objectSpread2({
    style: {
      marginBottom: tokens.spacing04
    }
  }, otherProps), {}, {
    children: jsx("div", {
      style: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: tokens.spacing02
      },
      children: jsx(Typography, {
        variant: "heading-small",
        children: children
      })
    })
  }));
};
var FormTitle$1 = memo(FormTitle);

var H5AudioPlayer = function H5AudioPlayer(_ref) {
  var src = _ref.src,
    style = _ref.style,
    _ref$autoPlay = _ref.autoPlay,
    autoPlay = _ref$autoPlay === void 0 ? false : _ref$autoPlay,
    _ref$autoPlayAfterSrc = _ref.autoPlayAfterSrcChange,
    autoPlayAfterSrcChange = _ref$autoPlayAfterSrc === void 0 ? false : _ref$autoPlayAfterSrc;
  var t = useTranslate();
  var skin = localStorage.getItem('lmi-unified-admin-skin') || 'goto';
  return jsx(Fragment, {
    children: jsx(AudioPlayer, {
      src: src,
      showJumpControls: false,
      preload: "none",
      layout: "horizontal-reverse",
      showDownloadProgress: false,
      autoPlay: autoPlay,
      autoPlayAfterSrcChange: autoPlayAfterSrcChange,
      className: skin,
      style: style ? style : {
        width: 320
      },
      customAdditionalControls: [],
      customIcons: {
        play: jsxs(Fragment, {
          children: [jsx(IconButton, {
            id: "play-btn",
            label: t('Play'),
            size: "small",
            variant: "secondary",
            children: jsx(PlayCircleOutlinedIcon, {})
          }), jsx(Tooltip, {
            "data-cy": "play",
            triggerId: "play-btn",
            children: t('Play')
          })]
        }),
        pause: jsxs(Fragment, {
          children: [jsx(IconButton, {
            id: "pause-btn",
            label: t('Pause'),
            size: "small",
            variant: "secondary",
            children: jsx(PauseOutlinedIcon, {})
          }), jsx(Tooltip, {
            "data-cy": "pause",
            triggerId: "pause-btn",
            children: t('Pause')
          })]
        }),
        volume: jsxs(Fragment, {
          children: [jsx(IconButton, {
            id: "mute-btn",
            label: t('Mute'),
            size: "small",
            variant: "secondary",
            children: jsx(SpeakerOnOutlinedIcon, {})
          }), jsx(Tooltip, {
            "data-cy": "mute",
            triggerId: "mute-btn",
            children: t('Mute')
          })]
        }),
        volumeMute: jsxs(Fragment, {
          children: [jsx(IconButton, {
            id: "unmute-btn",
            label: t('Unmute'),
            size: "small",
            variant: "secondary",
            children: jsx(SpeakerOffOutlinedIcon, {})
          }), jsx(Tooltip, {
            "data-cy": "unmute",
            triggerId: "unmute-btn",
            children: t('Unmute')
          })]
        })
      }
    })
  });
};

var H5AudioPlayerLight = function H5AudioPlayerLight(_ref) {
  var src = _ref.src,
    _ref$autoPlay = _ref.autoPlay,
    autoPlay = _ref$autoPlay === void 0 ? false : _ref$autoPlay,
    _ref$autoPlayAfterSrc = _ref.autoPlayAfterSrcChange,
    autoPlayAfterSrcChange = _ref$autoPlayAfterSrc === void 0 ? false : _ref$autoPlayAfterSrc,
    style = _ref.style;
  var t = useTranslate();
  return jsx(AudioPlayer, {
    autoPlay: autoPlay,
    autoPlayAfterSrcChange: autoPlayAfterSrcChange,
    layout: "horizontal-reverse",
    preload: "none",
    showDownloadProgress: false,
    showFilledProgress: false,
    showFilledVolume: false,
    showJumpControls: false,
    showSkipControls: false,
    src: src,
    style: style ? style : {
      width: 75
    },
    customProgressBarSection: [],
    customVolumeControls: [],
    customAdditionalControls: [],
    customIcons: {
      play: jsxs(Fragment, {
        children: [jsx(IconButton, {
          id: "play-btn",
          label: t('Play'),
          size: "small",
          variant: "secondary",
          children: jsx(PlayCircleOutlinedIcon, {})
        }), jsx(Tooltip, {
          "data-cy": "play",
          triggerId: "play-btn",
          children: t('Play')
        })]
      }),
      pause: jsxs(Fragment, {
        children: [jsx(IconButton, {
          id: "pause-btn",
          label: t('Pause'),
          size: "small",
          variant: "secondary",
          children: jsx(PauseOutlinedIcon, {})
        }), jsx(Tooltip, {
          "data-cy": "pause",
          triggerId: "pause-btn",
          children: t('Pause')
        })]
      })
    }
  });
};

var localizeNumber = function localizeNumber(value) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  return new Intl.NumberFormat(locale.replace('_', '-')).format(value);
};

var LocalizedNumber = function LocalizedNumber(_ref) {
  var children = _ref.children,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? 'en-US' : _ref$locale;
  return jsx("span", {
    "data-testid": "localizedNumber",
    children: localizeNumber(Number(children), locale)
  });
};
var LocalizedNumber$1 = memo(LocalizedNumber);

var _excluded$d = ["children", "noMaxWidth", "title", "maxWidth", "typographyProps"];
var NumberCell = function NumberCell(_ref) {
  var children = _ref.children,
    _ref$noMaxWidth = _ref.noMaxWidth,
    noMaxWidth = _ref$noMaxWidth === void 0 ? false : _ref$noMaxWidth,
    title = _ref.title,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? 320 : _ref$maxWidth,
    typographyProps = _ref.typographyProps,
    otherProps = _objectWithoutProperties(_ref, _excluded$d);
  return jsx("div", _objectSpread2(_objectSpread2({
    style: {
      maxWidth: noMaxWidth ? 'unset' : maxWidth,
      overflow: 'hidden'
    }
  }, otherProps), {}, {
    children: jsx(Typography, _objectSpread2(_objectSpread2({
      noWrap: true,
      title: title || children && children.toString() || ''
    }, typographyProps), {}, {
      children: children
    }))
  }));
};
var NumberCell$1 = memo(NumberCell);

var _excluded$c = ["pageActions", "style"];
var PageActions = function PageActions(_ref) {
  var pageActions = _ref.pageActions,
    style = _ref.style,
    otherProps = _objectWithoutProperties(_ref, _excluded$c);
  return jsx("div", _objectSpread2(_objectSpread2({
    style: _objectSpread2({
      display: 'flex',
      justifyContent: 'flex-end',
      gap: tokens.spacing02,
      flexWrap: 'nowrap',
      position: 'relative'
    }, style)
  }, otherProps), {}, {
    children: pageActions.map(function (child, i) {
      return jsx("div", {
        style: {
          flex: '0 0 auto'
        },
        children: child
      }, i);
    })
  }));
};
var PageActions$1 = memo(PageActions);

var styles$9 = {"noMargin":"ua-common_10-0-0_pageLayoutStyles__noMargin__f08c1","content":"ua-common_10-0-0_pageLayoutStyles__content__f08c1","contentShift":"ua-common_10-0-0_pageLayoutStyles__contentShift__f08c1","header":"ua-common_10-0-0_pageLayoutStyles__header__f08c1","pageTabLayoutInnerContainer":"ua-common_10-0-0_pageLayoutStyles__pageTabLayoutInnerContainer__f08c1","pageLayoutInnerContainer":"ua-common_10-0-0_pageLayoutStyles__pageLayoutInnerContainer__f08c1","tabSelected":"ua-common_10-0-0_pageLayoutStyles__tabSelected__f08c1"};

var ListNavigator = React__default.memo(function (props) {
  var isPreviousEnabled = !!props.onPreviousClick;
  var isNextEnabled = !!props.onNextClick;
  var t = useTranslate();
  return jsxs("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: tokens.spacing02,
      flexWrap: 'nowrap'
    },
    children: [jsxs(Fragment, {
      children: [jsx(IconButton, _objectSpread2(_objectSpread2({
        id: "previous-btn",
        label: t('Previous'),
        "data-testid": "breadcrumb-nav-previous",
        size: "small",
        variant: "secondary"
      }, isPreviousEnabled ? {
        onClick: props.onPreviousClick
      } : {
        disabled: true
      }), {}, {
        children: jsx(ChevronLeftOutlinedIcon, {})
      })), isPreviousEnabled && jsx(Tooltip, {
        position: "bottom-end",
        triggerId: "previous-btn",
        children: jsx("span", {
          children: isPreviousEnabled ? props.previousTooltip : ''
        })
      })]
    }), jsx(IconButton, _objectSpread2(_objectSpread2({
      label: t('Next'),
      size: "small",
      id: "next-btn",
      variant: "secondary",
      "data-testid": "breadcrumb-nav-next"
    }, isNextEnabled ? {
      onClick: props.onNextClick
    } : {
      disabled: true
    }), {}, {
      children: jsx(ChevronRightOutlinedIcon, {})
    })), jsx(Tooltip, {
      hidden: !isNextEnabled,
      position: "bottom-start",
      triggerId: "next-btn",
      children: jsx("span", {
        children: isNextEnabled ? props.nextTooltip : ''
      })
    })]
  });
});

// Parses the JRN object
var JrnParser = /*#__PURE__*/_createClass(function JrnParser() {
  var _this = this;
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  _classCallCheck(this, JrnParser);
  _defineProperty(this, "parts", void 0);
  _defineProperty(this, "scheme", void 0);
  _defineProperty(this, "service", void 0);
  _defineProperty(this, "location", void 0);
  _defineProperty(this, "landlord", void 0);
  _defineProperty(this, "account", void 0);
  _defineProperty(this, "resources", ['']);
  _defineProperty(this, "getAccount", function () {
    return _this.account;
  });
  _defineProperty(this, "getService", function () {
    return _this.service;
  });
  _defineProperty(this, "getResources", function () {
    return _this.resources;
  });
  this.parts = str && str.split(':') || [];
  if (this.parts.length === 6) {
    this.resources = this.parts[5].split('/');
  } else if (this.parts.length > 6) {
    this.resources = this.parts;
    this.parts.splice(0, 5);
  }
  this.scheme = this.parts[0] || 'jrn';
  this.service = this.parts[1] || '';
  this.location = this.parts[2] || '';
  this.landlord = this.parts[3] || 'jive';
  this.account = this.parts[4] || '';
});

var PrevNextChevronNavigator = function PrevNextChevronNavigator(_ref) {
  var itemId = _ref.itemId,
    itemIdSelector = _ref.itemIdSelector,
    items = _ref.items,
    _ref$nameKey = _ref.nameKey,
    nameKey = _ref$nameKey === void 0 ? 'name' : _ref$nameKey,
    nameSelector = _ref.nameSelector,
    urlRoot = _ref.urlRoot,
    breadcrumbNavigator = _ref.breadcrumbNavigator;
  var activeTab = breadcrumbNavigator && breadcrumbNavigator.activeTab;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  var t = useTranslate();
  var history = useHistory();
  var getItemName = function getItemName(item) {
    return nameSelector ? nameSelector(item) : item[nameKey];
  };
  var getItemId = useCallback(function (item) {
    return itemIdSelector ? itemIdSelector(item) : new JrnParser(item.jrn).getResources()[1];
  }, [itemIdSelector]);
  useEffect(function () {
    setIndex(items && items.findIndex(function (item) {
      return getItemId(item) === itemId;
    }));
  }, [getItemId, itemId, items]);
  if (items && index !== undefined) {
    var previousProps = index > 0 ? {
      onPreviousClick: function onPreviousClick() {
        return history.push("".concat(urlRoot, "/").concat(getItemId(items[index - 1])).concat(activeTab ? "/".concat(activeTab) : ''));
      },
      previousTooltip: "".concat(t('Previous'), ": ").concat(items[index - 1] ? getItemName(items[index - 1]) : '')
    } : {};
    var nextProps = index < items.length - 1 ? {
      onNextClick: function onNextClick() {
        return history.push("".concat(urlRoot, "/").concat(getItemId(items[index + 1])).concat(activeTab ? "/".concat(activeTab) : ''));
      },
      nextTooltip: "".concat(t('Next'), ": ").concat(items[index + 1] ? getItemName(items[index + 1]) : '')
    } : {};
    return jsx(ListNavigator, _objectSpread2(_objectSpread2({}, nextProps), previousProps));
  }
  return null;
};
var PrevNextChevronNavigator$1 = memo(PrevNextChevronNavigator);

// Returns the string "CL" for "Cohan Larivière" (to use in Avatar)
var trimAvatarString = function trimAvatarString(avatarStr) {
  return avatarStr ? avatarStr.split(' ').map(function (str) {
    return str ? str[0].toUpperCase() : '';
  }).join('').substr(0, 2) // maximum 2 letters for Avatar
  : '';
};

var _excluded$b = ["name", "avatarKey", "variant", "avatarUrl", "size"];
var UserAvatar = function UserAvatar(_ref) {
  var name = _ref.name,
    avatarKey = _ref.avatarKey,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'secondary' : _ref$variant,
    avatarUrl = _ref.avatarUrl,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$b);
  return jsx(Avatar, _objectSpread2(_objectSpread2({
    size: size,
    variant: variant,
    style: {
      display: 'flex'
    }
  }, otherProps), {}, {
    children: avatarKey && avatarUrl ? jsx("img", {
      alt: trimAvatarString(name),
      src: avatarKey && avatarUrl && "".concat(avatarUrl, "/").concat(avatarKey, "_").concat(size === 'xsmall' || size === 'small' || size === 'medium' || size === 'large' ? 'small' : 'medium', ".jpg"),
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      decoding: "async",
      title: name,
      loading: "lazy"
    }) : trimAvatarString(name)
  }));
};
var UserAvatar$1 = memo(UserAvatar);

var _excluded$a = ["avatar", "breadcrumbs", "hasAvatar", "pageTitle", "pageSubtitle", "pageActions", "pageActionsId", "status"];
var PageLayoutHeader = function PageLayoutHeader(_ref) {
  var avatar = _ref.avatar,
    breadcrumbs = _ref.breadcrumbs,
    _ref$hasAvatar = _ref.hasAvatar,
    hasAvatar = _ref$hasAvatar === void 0 ? false : _ref$hasAvatar,
    pageTitle = _ref.pageTitle,
    pageSubtitle = _ref.pageSubtitle,
    pageActions = _ref.pageActions,
    pageActionsId = _ref.pageActionsId,
    status = _ref.status,
    navigationProps = _objectWithoutProperties(_ref, _excluded$a);
  return jsxs(Fragment, {
    children: [breadcrumbs && jsx("div", {
      style: {
        marginBottom: hasAvatar ? tokens.spacing02 : tokens.spacing00
      },
      children: jsxs("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'nowrap',
          gap: tokens.spacing04
        },
        children: [jsx("div", {
          children: jsx(Breadcrumbs, {
            separator: "/",
            children: breadcrumbs.map(function (breadcrumb, i) {
              return jsx(Typography, {
                noWrap: true,
                style: {
                  maxWidth: 320
                },
                color: "type-color-default",
                children: breadcrumb.label
              }, "breadcrumb-".concat(i));
            })
          })
        }), jsx("div", {
          children: navigationProps.hasBreadcrumbListNavigator ? jsx(ListNavigator, _objectSpread2({}, navigationProps)) : jsx(PrevNextChevronNavigator$1, _objectSpread2({}, navigationProps))
        })]
      })
    }), jsx("div", {
      style: {
        minHeight: 60
      },
      children: jsxs("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'nowrap',
          gap: tokens.spacing04
        },
        children: [hasAvatar && jsx("div", {
          children: avatar ? avatar.component ? avatar.component : jsx(UserAvatar$1, {
            variant: "primary",
            size: "xlarge",
            name: avatar.name || '',
            avatarKey: avatar.avatarKey
          }) : jsx(Skeleton, {
            size: "xxlarge",
            variant: "circle",
            style: {
              marginRight: tokens.spacing02
            }
          })
        }), jsxs("div", {
          style: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column'
          },
          children: [jsxs("div", {
            style: {
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'nowrap',
              gap: tokens.spacing04
            },
            children: [jsx("div", {
              style: {
                maxWidth: 720,
                paddingTop: tokens.spacing02
              },
              children: pageTitle ? jsx(Typography, {
                title: pageTitle && pageTitle.toString() || '',
                noWrap: true,
                variant: "heading-large",
                tag: "h1",
                "data-testid": "pageTitle",
                children: pageTitle
              }) : jsx(Skeleton, {
                size: "xxlarge",
                variant: "rectangle",
                width: 320
              })
            }), status && jsx("div", {
              style: {
                paddingTop: tokens.spacing03
              },
              children: status
            })]
          }), pageSubtitle && jsx("div", {
            style: {
              paddingTop: tokens.spacing01
            },
            children: jsx(Typography, {
              variant: "body-medium",
              color: "type-color-secondary",
              style: {
                wordBreak: 'break-all'
              },
              children: pageSubtitle
            })
          })]
        }), pageActions && jsx("div", {
          children: jsx(PageActions$1, {
            id: pageActionsId,
            pageActions: pageActions
          })
        })]
      })
    })]
  });
};
var PageLayoutHeader$1 = memo(PageLayoutHeader);

var styles$8 = {"borderlessTabPanel":"ua-common_10-0-0_TabPanel__borderlessTabPanel__a962f","tabPanel":"ua-common_10-0-0_TabPanel__tabPanel__a962f"};

var _excluded$9 = ["flexTabPanel", "id", "children"];
var TabPanel = function TabPanel(_ref) {
  var _ref$flexTabPanel = _ref.flexTabPanel,
    flexTabPanel = _ref$flexTabPanel === void 0 ? false : _ref$flexTabPanel,
    id = _ref.id,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded$9);
  return jsx("div", _objectSpread2(_objectSpread2({
    role: "tabpanel",
    id: "tabpanel-".concat(id),
    "aria-labelledby": "tab-".concat(id),
    className: "".concat(flexTabPanel ? styles$8.flex : '', " ").concat(styles$8.tabPanel)
  }, otherProps), {}, {
    children: children
  }));
};

var _excluded$8 = ["children"];
var TabPanelWrapper = function TabPanelWrapper(_ref) {
  var children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded$8);
  return jsx("div", _objectSpread2(_objectSpread2({
    style: {
      display: 'flex',
      marginTop: tokens.spacing02,
      flex: 1
    }
  }, otherProps), {}, {
    children: children
  }));
};
var TabPanelWrapper$1 = memo(TabPanelWrapper);

var styles$7 = {"root":"ua-common_10-0-0_Tabs__root__f10bd","withNegativeMargins":"ua-common_10-0-0_Tabs__withNegativeMargins__f10bd","tabWrapper":"ua-common_10-0-0_Tabs__tabWrapper__f10bd"};

var _excluded$7 = ["ariaLabel", "className", "onChange", "value", "withNegativeMargins", "children"];
var Tabs = function Tabs(_ref, ref) {
  var ariaLabel = _ref.ariaLabel,
    className = _ref.className,
    onChange = _ref.onChange,
    value = _ref.value,
    _ref$withNegativeMarg = _ref.withNegativeMargins,
    withNegativeMargins = _ref$withNegativeMarg === void 0 ? false : _ref$withNegativeMarg,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded$7);
  var lastUrlSegment = window.location.pathname.split('/').pop();
  return jsx(Tabs$2, _objectSpread2(_objectSpread2({
    variant: "scrollable",
    scrollButtons: "off",
    className: clsx(styles$7.tabWrapper, styles$7.root, withNegativeMargins && styles$7.withNegativeMargins, className),
    onChange: onChange,
    innerRef: ref,
    value: value || lastUrlSegment,
    "aria-label": ariaLabel
  }, otherProps), {}, {
    children: children
  }));
};
var Tabs$1 = memo(forwardRef(Tabs));

var _excluded$6 = ["isDetailsPage", "breadcrumbs", "pageTitle", "pageSubtitle", "pageActions", "pageActionsId", "showTabPanels", "avatar", "children", "tabs", "flexTabPanel", "status", "hasAvatar", "drawerOpen", "isSystemUser", "shellUiState", "selectedTab"];
var PageLayout = function PageLayout(_ref) {
  var _ref$isDetailsPage = _ref.isDetailsPage,
    isDetailsPage = _ref$isDetailsPage === void 0 ? false : _ref$isDetailsPage,
    breadcrumbs = _ref.breadcrumbs,
    pageTitle = _ref.pageTitle,
    pageSubtitle = _ref.pageSubtitle,
    pageActions = _ref.pageActions,
    pageActionsId = _ref.pageActionsId,
    _ref$showTabPanels = _ref.showTabPanels,
    showTabPanels = _ref$showTabPanels === void 0 ? true : _ref$showTabPanels,
    avatar = _ref.avatar,
    children = _ref.children,
    tabs = _ref.tabs,
    _ref$flexTabPanel = _ref.flexTabPanel,
    flexTabPanel = _ref$flexTabPanel === void 0 ? false : _ref$flexTabPanel,
    status = _ref.status,
    _ref$hasAvatar = _ref.hasAvatar,
    hasAvatar = _ref$hasAvatar === void 0 ? false : _ref$hasAvatar,
    drawerOpen = _ref.drawerOpen,
    _ref$isSystemUser = _ref.isSystemUser,
    isSystemUser = _ref$isSystemUser === void 0 ? false : _ref$isSystemUser,
    shellUiState = _ref.shellUiState,
    _ref$selectedTab = _ref.selectedTab,
    selectedTab = _ref$selectedTab === void 0 ? false : _ref$selectedTab,
    navigationProps = _objectWithoutProperties(_ref, _excluded$6);
  // hooks
  var _ref2 = useAppHeights() || {},
    pageLayoutHeight = _ref2.pageLayoutHeight;
  var t = useTranslate();
  var history = useHistory();
  var match = useRouteMatch();
  useTitle("".concat(pageTitle || t('Loading'), " \u2014 GoTo Admin"));
  var _useMeasure = useMeasure(),
    _useMeasure2 = _slicedToArray(_useMeasure, 2),
    headerRef = _useMeasure2[0],
    headerHeight = _useMeasure2[1].height;
  var pageHeaderHeight = isDetailsPage ? headerHeight + DETAILS_PAGE_HEADER_PADDING_TOP : headerHeight + HEADER_PADDING_TOP;
  return jsx("div", {
    className: clsx(styles$9.content, drawerOpen && !shellUiState.rightDrawerOpened && styles$9.contentShift),
    children: jsx(Container, {
      className: clsx(isDetailsPage && styles$9.noMargin),
      maxWidth: isDetailsPage ? 'xl' : false,
      disableGutters: true,
      children: jsxs("div", {
        style: {
          minHeight: pageLayoutHeight
        },
        className: styles$9.pageLayoutInnerContainer,
        children: [jsx("div", {
          className: clsx(styles$9.header),
          children: jsxs("div", {
            ref: headerRef,
            children: [jsx(PageLayoutHeader$1, _objectSpread2({
              avatar: avatar,
              breadcrumbs: breadcrumbs,
              hasAvatar: hasAvatar,
              pageTitle: pageTitle,
              pageSubtitle: pageSubtitle,
              pageActions: pageActions,
              pageActionsId: pageActionsId,
              status: status
            }, navigationProps)), tabs && jsx(Tabs$1, {
              withNegativeMargins: !isDetailsPage,
              value: selectedTab,
              children: tabs.filter(function (tab) {
                return !tab.systemUserOnly || tab.systemUserOnly && isSystemUser;
              }).map(function (_ref3) {
                var path = _ref3.path,
                  label = _ref3.label;
                return jsx(Tab, {
                  id: "tab-".concat(path),
                  value: path,
                  onClick: function onClick() {
                    return history.push({
                      pathname: "".concat(match.url, "/").concat(path),
                      search: history.location.search
                    });
                  },
                  label: label,
                  classes: {
                    selected: styles$9.tabSelected
                  }
                }, "tab-".concat(path));
              })
            })]
          })
        }), jsxs(PageHeaderHeightContext.Provider, {
          value: {
            height: pageHeaderHeight
          },
          children: [tabs && showTabPanels && jsx(TabPanelWrapper$1, {
            children: jsxs(Switch$1, {
              children: [tabs.filter(function (tab) {
                return !tab.systemUserOnly || tab.systemUserOnly && isSystemUser;
              }).map(function (_ref4) {
                var path = _ref4.path,
                  content = _ref4.content;
                return jsx(Route, {
                  exact: true,
                  path: "".concat(match.path, "/").concat(path),
                  children: jsx(TabPanel, {
                    id: path,
                    flexTabPanel: flexTabPanel,
                    children: jsx(Suspense, {
                      fallback: jsx(Fragment, {}),
                      children: content
                    })
                  })
                }, "route-".concat(path));
              }), jsx(Redirect, {
                to: {
                  pathname: "".concat(match.path, "/").concat(tabs[0].path),
                  search: history.location.search
                }
              })]
            })
          }), children]
        })]
      })
    })
  });
};
var PageLayout$1 = withTheme(PageLayout);

var useRenderTabs = function useRenderTabs(_ref) {
  var tabs = _ref.tabs;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    activeTabState = _useState2[0],
    setActiveTabState = _useState2[1];
  var getTabDetails = function getTabDetails(tabPath) {
    return tabs.find(function (tab) {
      return tab.path === tabPath;
    }) || (tabs === null || tabs === void 0 ? void 0 : tabs[0]);
  };
  var renderActiveTab = function renderActiveTab(tabDetails) {
    if (tabDetails !== activeTabState) {
      setActiveTabState(tabDetails.path);
    }
    return jsx(Fragment, {
      children: !isEmpty(tabDetails) && jsx(TabPanel, {
        id: tabDetails === null || tabDetails === void 0 ? void 0 : tabDetails.path,
        children: tabDetails === null || tabDetails === void 0 ? void 0 : tabDetails.content
      })
    });
  };
  var getBreadcrumbActivePath = function getBreadcrumbActivePath(location) {
    var locationParts = location.pathname.split('/');
    var locationPartsMatchingIndex = locationParts.findIndex(function (location) {
      return location === activeTabState;
    });
    var allActiveTabNames = drop(locationParts, locationPartsMatchingIndex);
    var completeTabPath = allActiveTabNames.join('/');
    return completeTabPath;
  };
  var getActiveTabByIndex = useCallback(function (index) {
    return tabs[index];
  }, [tabs]);
  var renderTabPanel = function renderTabPanel(routeProps) {
    var _match$params;
    var match = routeProps === null || routeProps === void 0 ? void 0 : routeProps.match;
    var matchPathParts = match === null || match === void 0 ? void 0 : match.path.split(':');
    var pathKey = matchPathParts[matchPathParts.length - 1];
    var tabName = match === null || match === void 0 ? void 0 : (_match$params = match.params) === null || _match$params === void 0 ? void 0 : _match$params[pathKey];
    var tabDetails = getTabDetails(tabName);
    return renderActiveTab(tabDetails);
  };
  return {
    activeTab: activeTabState,
    getBreadcrumbActivePath: getBreadcrumbActivePath,
    renderTabPanel: renderTabPanel,
    setActiveTabState: setActiveTabState,
    getActiveTabByIndex: getActiveTabByIndex,
    getTabDetails: getTabDetails
  };
};

var TabsSkeleton = function TabsSkeleton() {
  return jsxs("div", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    },
    children: [jsxs("div", {
      style: {
        display: 'flex',
        gap: tokens.spacing04
      },
      children: [jsx("div", {
        children: jsx(Skeleton, {
          width: "6rem",
          variant: "rectangle",
          size: "large"
        })
      }), jsx("div", {
        children: jsx(Skeleton, {
          width: "6rem",
          variant: "rectangle",
          size: "large"
        })
      })]
    }), jsx("div", {
      style: {
        marginTop: tokens.spacing04
      },
      children: jsx(Skeleton, {
        width: "100%",
        variant: "rectangle",
        size: "xxxlarge"
      })
    })]
  });
};

var _excluded$5 = ["drawerOpen", "rightDrawerOpened", "avatar", "breadcrumbs", "hasAvatar", "pageTitle", "pageSubtitle", "pageActions", "pageActionsId", "status", "tabs", "isLoading", "children"];
var PageTabLayout = function PageTabLayout(_ref) {
  var drawerOpen = _ref.drawerOpen,
    _ref$rightDrawerOpene = _ref.rightDrawerOpened,
    rightDrawerOpened = _ref$rightDrawerOpene === void 0 ? false : _ref$rightDrawerOpene,
    avatar = _ref.avatar,
    breadcrumbs = _ref.breadcrumbs,
    _ref$hasAvatar = _ref.hasAvatar,
    hasAvatar = _ref$hasAvatar === void 0 ? false : _ref$hasAvatar,
    pageTitle = _ref.pageTitle,
    pageSubtitle = _ref.pageSubtitle,
    pageActions = _ref.pageActions,
    pageActionsId = _ref.pageActionsId,
    status = _ref.status,
    tabs = _ref.tabs,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    children = _ref.children,
    navigationProps = _objectWithoutProperties(_ref, _excluded$5);
  var _ref2 = useAppHeights() || {},
    pageLayoutHeight = _ref2.pageLayoutHeight;
  var _useMeasure = useMeasure(),
    _useMeasure2 = _slicedToArray(_useMeasure, 2),
    headerRef = _useMeasure2[0],
    headerHeight = _useMeasure2[1].height;
  var t = useTranslate();
  var history = useHistory();
  var match = useRouteMatch();
  var location = useLocation();
  useTitle("".concat(pageTitle || t('Loading'), " \u2014 GoTo Admin"));
  var pageHeaderHeight = useMemo(function () {
    return headerHeight + DETAILS_PAGE_HEADER_PADDING_TOP;
  }, [headerHeight]);
  var _useRenderTabs = useRenderTabs({
      tabs: tabs
    }),
    activeTab = _useRenderTabs.activeTab,
    setActiveTabState = _useRenderTabs.setActiveTabState,
    getActiveTabByIndex = _useRenderTabs.getActiveTabByIndex,
    getTabDetails = _useRenderTabs.getTabDetails;
  useEffectOnce(function () {
    var pathParts = location.pathname.split('/');
    var tabName = pathParts[pathParts.length - 1];
    var tabDetails = getTabDetails(tabName);
    if (tabDetails.path !== tabName) {
      history.push({
        pathname: "".concat(location.pathname, "/").concat(tabDetails.path),
        search: history.location.search
      });
      setActiveTabState(tabDetails.path);
    } else {
      setActiveTabState(getTabDetails(tabName).path);
    }
  });
  var navProps = useMemo(function () {
    return _objectSpread2(_objectSpread2({}, navigationProps), {}, {
      breadcrumbNavigator: _objectSpread2(_objectSpread2({}, navigationProps.breadcrumbNavigator), {}, {
        activeTab: activeTab
      })
    });
  }, [activeTab, navigationProps]);
  return jsx("div", {
    className: clsx(styles$9.content, drawerOpen && !rightDrawerOpened && styles$9.contentShift),
    children: jsx(Container, {
      className: clsx(styles$9.noMargin),
      maxWidth: "xl",
      disableGutters: true,
      children: jsxs("div", {
        style: {
          minHeight: pageLayoutHeight
        },
        className: styles$9.pageTabLayoutInnerContainer,
        children: [jsx("div", {
          className: clsx(styles$9.header),
          children: jsx("div", {
            ref: headerRef,
            children: jsx(PageLayoutHeader$1, _objectSpread2({
              avatar: avatar,
              breadcrumbs: breadcrumbs,
              hasAvatar: hasAvatar,
              pageTitle: pageTitle,
              pageSubtitle: pageSubtitle,
              pageActions: pageActions,
              pageActionsId: pageActionsId,
              status: status
            }, navProps))
          })
        }), !isLoading ? jsxs(Tabs$3, {
          label: t('Page'),
          orientation: "horizontal",
          onChange: function onChange(e) {
            e.target.activeTabIndex !== undefined && setActiveTabState(getActiveTabByIndex(e.target.activeTabIndex).path);
          },
          activeid: "tab-".concat(activeTab),
          children: [tabs.map(function (_ref3) {
            var path = _ref3.path,
              label = _ref3.label;
            return jsx(Tab$1, {
              id: "tab-".concat(path),
              onClick: function onClick() {
                return history.push({
                  pathname: "".concat(match.url, "/").concat(path),
                  search: history.location.search
                });
              },
              style: {
                boxSizing: 'border-box'
              },
              children: label
            }, "tab-".concat(path));
          }), tabs.map(function (_ref4) {
            var path = _ref4.path,
              content = _ref4.content;
            return jsx(TabPanel$1, {
              id: "tabpanel-".concat(path),
              children: jsx(Suspense, {
                fallback: jsx(Fragment, {}),
                children: jsx(PageHeaderHeightContext.Provider, {
                  value: {
                    height: pageHeaderHeight
                  },
                  children: jsx(TabPanelWrapper$1, {
                    children: activeTab === path && content
                  })
                })
              })
            });
          })]
        }) : jsx(TabsSkeleton, {}), children]
      })
    })
  });
};
var PageTabLayout$1 = memo(PageTabLayout);

var SUPPORT_PHONE_NUMBER = '+18668908931';

var formatPhoneNumber = function formatPhoneNumber(number) {
  var parsedNumber = parsePhoneNumberFromString(number || '');
  if (parsedNumber) {
    return parsedNumber.formatInternational();
  }
};

var styles$6 = {"container":"ua-common_10-0-0_PlanLimitMessage__container__7e807","iconContainer":"ua-common_10-0-0_PlanLimitMessage__iconContainer__7e807","planLimitHeader":"ua-common_10-0-0_PlanLimitMessage__planLimitHeader__7e807","planLimitMsg":"ua-common_10-0-0_PlanLimitMessage__planLimitMsg__7e807","learnMoreLink":"ua-common_10-0-0_PlanLimitMessage__learnMoreLink__7e807","fullWidth":"ua-common_10-0-0_PlanLimitMessage__fullWidth__7e807","noOutline":"ua-common_10-0-0_PlanLimitMessage__noOutline__7e807"};

var PlanLimitMessage = function PlanLimitMessage(_ref) {
  var resourceName = _ref.resourceName,
    resourceNamePlural = _ref.resourceNamePlural,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'quota' : _ref$mode,
    _ref$showUpgradeLink = _ref.showUpgradeLink,
    showUpgradeLink = _ref$showUpgradeLink === void 0 ? false : _ref$showUpgradeLink,
    licenses = _ref.licenses,
    ecommUrl = _ref.ecommUrl,
    learnMoreLink = _ref.learnMoreLink;
  var t = useTranslate();
  if (!licenses) {
    return jsx(LinearProgress, {});
  }
  return jsxs("div", {
    className: styles$6.container,
    children: [jsx("div", {
      className: styles$6.iconContainer,
      children: mode === 'quota' ? jsx(UploadOutlinedIcon, {}) : jsx(BlockOutlinedIcon, {})
    }), jsx(Typography, {
      className: styles$6.planLimitHeader,
      variant: "heading-medium",
      children: mode === 'quota' ? t('Plan limit reached') : t('Feature not available')
    }), jsx(Typography, {
      className: styles$6.planLimitMsg,
      variant: "body-medium",
      children: mode === 'quota' ? t("You've created the maximum number of %{resource_name_plural} your plan allows. To create another %{resource_name}, upgrade your plan.", {
        resource_name: resourceName,
        resource_name_plural: resourceNamePlural || resourceName
      }) : t('%{feature_name_cap} is not included with your current plan. To access %{feature_name}, upgrade your plan.', {
        feature_name_cap: capitalize(resourceName),
        feature_name: resourceName
      })
    }), showUpgradeLink ? jsx(Link$1, {
      rel: "noopener noreferrer",
      target: "_blank",
      href: ecommUrl,
      appearance: "primary",
      size: "large",
      className: styles$6.fullWidth,
      "data-testid": "upgradeLinkBtnTestId",
      children: t('Upgrade plan')
    }) : jsx("a", {
      href: "tel:".concat(SUPPORT_PHONE_NUMBER),
      tabIndex: -1,
      className: styles$6.fullWidth,
      style: {
        outline: 0
      },
      children: jsxs(Button, {
        size: "large",
        fullWidth: true,
        variant: "primary",
        "data-testid": "contactUsBtnTestId",
        children: [t('Contact us:'), " ", formatPhoneNumber(SUPPORT_PHONE_NUMBER)]
      })
    }), learnMoreLink && jsx(Typography, {
      className: styles$6.learnMoreLink,
      variant: "body-medium",
      children: jsx(Link$1, {
        target: "_blank",
        href: learnMoreLink,
        children: t('Learn more')
      })
    })]
  });
};

var PreventNavigationPrompt = function PreventNavigationPrompt(_ref) {
  var isActive = _ref.isActive,
    onConfirm = _ref.onConfirm,
    onCancel = _ref.onCancel;
  var t = useTranslate();
  return jsxs(Dialog, {
    open: !!isActive,
    title: t('Warning'),
    onClose: onCancel,
    children: [jsx(Alert, {
      variant: "warning",
      children: t('There are unsaved changes. Are you sure you want to navigate away?')
    }), jsxs(DialogActions, {
      children: [jsx(Button, {
        onClick: onCancel,
        variant: "neutral",
        children: t('Cancel')
      }), jsx(Button, {
        variant: "primary",
        onClick: onConfirm,
        children: t('OK')
      })]
    })]
  });
};
var PreventNavigationPrompt$1 = memo(PreventNavigationPrompt);

var PrivilegedContent = function PrivilegedContent(_ref) {
  var privilege = _ref.privilege,
    _ref$somePrivileges = _ref.somePrivileges,
    somePrivileges = _ref$somePrivileges === void 0 ? [] : _ref$somePrivileges,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'hide' : _ref$mode,
    children = _ref.children;
  var securityContext = useContext(GlobalSecurityContext);
  if (privilege) {
    somePrivileges.push(privilege);
  }
  var recursiveDisableChildren = function recursiveDisableChildren(children) {
    return React__default.Children.map(children, function (child) {
      if (!React__default.isValidElement(child)) {
        return child;
      }
      if (child.props.children) {
        child = React__default.cloneElement(child, {
          children: recursiveDisableChildren(child.props.children)
        });
      }
      return React__default.cloneElement(child, {
        disabled: true
      });
    });
  };
  return somePrivileges.some(function (p) {
    return isPrivilegeGranted(p, securityContext);
  }) ? jsx(Fragment, {
    children: children
  }) : mode === 'disable' ? recursiveDisableChildren(children) : null;
};

var _path$2;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var SvgGoToAssist = function SvgGoToAssist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    viewBox: "0 0 91 100"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    d: "m88.465 65.778-25.574-45.05c-2.056-3.31-4.327-6.229-6.77-8.715C53.504 9.353 49.76 8 44.998 8c-4.76 0-8.5 1.353-11.122 4.013-2.444 2.486-4.71 5.405-6.745 8.672L1.565 65.719C.772 67.314.282 69.826.042 73.457c-.245 3.674.59 7.149 2.477 10.33 1.777 3.208 3.917 5.261 6.344 6.076 2.25.755 4.61 1.137 7.007 1.137h17.339c2.461 0 4.833-.382 7.058-1.137 2.385-.81 4.533-2.83 6.386-5.995 1.828-3.25 2.642-6.74 2.431-10.398-.21-3.636-.688-6.152-1.452-7.692l-1.334-2.197c-.856-1.409-2.245-3.547-4.128-6.355-1.57-2.347-3.17-3.488-4.879-3.488-.785 0-1.557.255-2.288.755-1.025.696-1.646 1.583-1.84 2.64-.249 1.336.19 2.804 1.347 4.484a290.617 290.617 0 0 1 3.735 5.676l1.279 2.015c.81 1.443 1.097 3.174.844 5.24-.262 2.13-.722 3.742-1.363 4.785-.6 1.099-1.389 1.854-2.444 2.376-1.106.543-2.233.819-3.352.819H15.87c-1.06 0-2.157-.276-3.263-.819-1.072-.526-1.895-1.298-2.515-2.355-.591-1.039-1.03-2.66-1.292-4.806-.253-2.066.03-3.797.874-5.295L36.75 21.949a29.392 29.392 0 0 1 3.393-3.695c1.022-.938 2.436-1.519 4.213-1.73l.515.033h.506l.06-.055c1.342.148 2.684.717 3.997 1.701 1.574 1.18 2.882 2.478 3.887 3.86l27.01 47.199c.835 1.489 1.122 3.22.87 5.286-.263 2.146-.702 3.767-1.3 4.823a5.812 5.812 0 0 1-2.508 2.338c-1.106.543-2.203.819-3.263.819h-8.277a4.225 4.225 0 0 0-4.217 4.234c0 2.342 1.887 4.238 4.217 4.238h8.277c2.398 0 4.757-.382 7.007-1.137 2.423-.815 4.563-2.868 6.36-6.105 1.87-3.152 2.702-6.627 2.461-10.3-.24-3.632-.73-6.144-1.494-7.68",
    fill: "currentColor"
  })));
};

var _path$1;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var SvgGoToFlower = function SvgGoToFlower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.08 100"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    d: "M69.36 57.68c-.84.6-1.95.66-2.84.15l-13.07-7.55a.331.331 0 0 1-.16-.28c0-.12.06-.23.16-.28l13-7.5c.9-.51 2.02-.45 2.86.16 4.27 3.06 9.96 3.29 14.46.57 5.95-3.67 8.04-11.33 4.78-17.52a13.148 13.148 0 0 0-15.35-6.35 13.168 13.168 0 0 0-9.34 13.74 2.65 2.65 0 0 1-1.29 2.53L49.5 42.88a.325.325 0 0 1-.49-.28V27.51c0-1.03.61-1.96 1.55-2.39a13.16 13.16 0 0 0 7.36-14.77C56.59 4.31 51.24 0 45.06 0S33.53 4.3 32.21 10.34s1.74 12.18 7.35 14.77c.94.42 1.55 1.36 1.55 2.39v15.09c0 .12-.06.23-.16.28-.1.06-.23.06-.33 0l-13.06-7.54c-.89-.52-1.39-1.5-1.29-2.52.53-6.16-3.29-11.86-9.19-13.69-5.9-1.84-12.28.68-15.34 6.05S-.23 37.32 4.37 41.45s11.44 4.52 16.47.92c.84-.61 1.96-.67 2.86-.16l13 7.5c.1.06.16.17.16.28 0 .12-.06.23-.16.28l-13.1 7.56c-.89.51-2.01.45-2.84-.15a13.16 13.16 0 0 0-14.42-.52C.4 60.84-1.67 68.49 1.58 74.67a13.16 13.16 0 0 0 24.68-7.47c-.1-1.03.4-2.02 1.29-2.54l13.07-7.55a.325.325 0 0 1 .49.28v15.09c0 1.03-.61 1.96-1.55 2.39-5.62 2.58-8.68 8.73-7.36 14.77S38.88 100 45.06 100s11.53-4.3 12.85-10.34a13.171 13.171 0 0 0-7.35-14.77 2.624 2.624 0 0 1-1.55-2.39V57.41c0-.12.06-.23.16-.28.1-.06.23-.06.33 0l13.07 7.55c.89.52 1.4 1.51 1.29 2.54-.58 6.23 3.31 12 9.29 13.81 5.98 1.81 12.42-.84 15.39-6.34 3.25-6.18 1.18-13.83-4.76-17.51a13.121 13.121 0 0 0-14.42.5z"
  })));
};

var _path, _path2;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var SvgGoView = function SvgGoView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.16 128.16",
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.99 128.16H42.17C18.88 128.16 0 109.28 0 85.99V42.17C0 18.88 18.88 0 42.17 0h43.82c23.29 0 42.17 18.88 42.17 42.17v43.82c0 23.29-18.88 42.17-42.17 42.17z",
    fill: "#ffae19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m56.04 26.08 41.71 21.28-3.48 13.47-8.9 4.12-4.35 7.39.22 20.64-8.47-7.39-8.17 8.47 12.3 11.95H51.7L39.1 94.28V81.03l-8.68-4.34 4.56-8.47 8.68 4.12 29.11-16.29v-8.03l-37.58-.44 7.82-8.69 21.07.22-16.07-8.25z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m35.19 47.58 41.65-7.84-4.07 8.28zm20.85-21.5 8.04 13.03-16.07-8.25zm24.98 46.26-8.25-16.29 12.6 8.9zm-13.57 2.54L64.6 94.06l8.17-8.47zM39.1 81.03l12.11 14.82 20.23 4.86 5.46 5.3H51.7L39.1 94.28z",
    style: {
      fill: "#ffebc4"
    }
  }));
};

var _style, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgPrompt = function SvgPrompt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 140"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Prompt_svg__st0{fill:#165c7d}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "Prompt_svg__st0",
    cx: 70,
    cy: 70,
    r: 70,
    id: "Prompt_svg__Layer_1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prompt_svg__Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.41 33.19c-14.62 0-26.56 11.47-27.33 25.9h-.04v47.73h14.01v-18.9h13.16c.06 0 .13.01.19.01 15.11 0 27.37-12.25 27.37-27.37.01-15.12-12.25-27.37-27.36-27.37z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Prompt_svg__st0",
    d: "M72.41 46.89c-7.32 0-13.25 5.93-13.25 13.25v18.57l4.78-5.32h8.47c7.32 0 13.25-5.93 13.25-13.25s-5.93-13.25-13.25-13.25z"
  }))));
};

var getGoToResolveTranslation = function getGoToResolveTranslation(productName, t) {
  var alternateProductName = productName.replace('goto ', '');
  switch (alternateProductName) {
    case 'resolve basic add-on agent (concurrent)':
      return t('Resolve Basic Paid (concurrent)');
    case 'resolve basic add-on agent trial (concurrent)':
      return t('Resolve Basic Trial (concurrent)');
    case 'resolve basic add-on endpoint/devices (concurrent)':
      return t('Resolve Basic Add-on Endpoint/Devices (concurrent)');
    case 'resolve basic add-on endpoint/devices (named)':
      return t('Resolve Basic Add-on Endpoint/Devices (named)');
    case 'resolve basic add-on endpoint/devices trial (concurrent)':
      return t('Resolve Basic Add-on Endpoint/Devices Trial (concurrent)');
    case 'resolve basic add-on endpoint/devices trial (named)':
      return t('Resolve Basic Add-on Endpoint/Devices Trial (named)');
    case 'resolve basic paid (concurrent)':
      return t('Resolve Basic Paid (concurrent)');
    case 'resolve basic paid (named)':
      return t('Resolve Basic Paid (named)');
    case 'resolve basic trial (concurrent)':
      return t('Resolve Basic Trial (concurrent)');
    case 'resolve basic trial (named)':
      return t('Resolve Basic Trial (named)');
    case 'resolve beta':
      return t('Resolve Beta');
    case 'resolve camera share add-on paid (concurrent)':
      return t('Resolve Camera Share Add-on Paid (concurrent)');
    case 'resolve camera share add-on paid (named)':
      return t('Resolve Camera Share Add-on Paid (named)');
    case 'resolve camera share add-on trial (concurrent)':
      return t('Resolve Camera Share Add-on Trial (concurrent)');
    case 'resolve camera share add-on trial (named)':
      return t('Resolve Camera Share Add-on Trial (named)');
    case 'resolve free (named)':
      return t('Resolve Free (named)');
    case 'resolve free add-on endpoint/devices (named)':
      return t('Resolve Free Add-on Endpoint/Devices (named)');
    case 'resolve foundation':
      return t('Resolve Foundation');
    case 'resolve foundation - trial':
      return t('Resolve Foundation - Trial');
    case 'resolve mobile add-on paid (concurrent)':
      return t('Resolve Mobile Add-on Paid (concurrent)');
    case 'resolve mobile add-on paid (named)':
      return t('Resolve Mobile Add-on Paid (named)');
    case 'resolve mobile add-on trial (concurrent)':
      return t('Resolve Mobile Add-on Trial (concurrent)');
    case 'resolve mobile add-on trial (named)':
      return t('Resolve Mobile Add-on Trial (named)');
    case 'resolve msp trial':
      return t('Resolve MSP Trial');
    case 'resolve msp paid (named)':
      return t('Resolve MSP Paid (named)');
    case 'resolve premium (concurrent)':
      return t('Resolve Premium (concurrent)');
    case 'resolve premium add-on agent (concurrent)':
      return t('Resolve Premium Paid (concurrent)');
    case 'resolve premium add-on agent trial (concurrent)':
      return t('Resolve Premium Trial (concurrent)');
    case 'resolve premium add-on endpoint/devices (concurrent)':
      return t('Resolve Premium Add-on Endpoint/Devices (concurrent)');
    case 'resolve premium add-on endpoint/devices (named)':
      return t('Resolve Premium Add-on Endpoint/Devices (named)');
    case 'resolve premium add-on endpoint/devices trial (concurrent)':
      return t('Resolve Premium Add-on Endpoint/Devices Trial (concurrent)');
    case 'resolve premium add-on endpoint/devices trial (named)':
      return t('Resolve Premium Add-on Endpoint/Devices Trial (named)');
    case 'resolve premium paid (named)':
      return t('Resolve Premium Paid (named)');
    case 'resolve premium trial (concurrent)':
      return t('Resolve Premium Trial (concurrent)');
    case 'resolve premium trial (named)':
      return t('Resolve Premium Trial (named)');
    case 'resolve remote support (named)':
      return t('Resolve Remote support (named)');
    case 'resolve remote support (named) - trial':
    case 'resolve remote support trial (named)':
      return t('Resolve Remote Support Trial (named)');
    case 'resolve remote support (concurrent)':
      return t('Resolve Remote support (concurrent)');
    case 'resolve remote support (concurrent) - trial':
      return t('Resolve Remote support (concurrent) - Trial');
    case 'resolve remote support plus add-on agent (named)':
      return t('Resolve Remote Support Plus');
    case 'resolve remote support plus add-on agent trial (named)':
      return t('Resolve Remote Support Plus Trial');
    case 'resolve standard (concurrent)':
      return t('Resolve Standard (concurrent)');
    case 'resolve standard add-on agent (concurrent)':
      return t('Resolve Standard Paid (concurrent)');
    case 'resolve standard add-on agent trial (concurrent)':
      return t('Resolve Standard Trial (concurrent)');
    case 'resolve standard add-on endpoint/devices (concurrent)':
      return t('Resolve Standard Add-on Endpoint/Devices (concurrent)');
    case 'resolve standard add-on endpoint/devices (named)':
      return t('Resolve Standard Add-on Endpoint/Devices (named)');
    case 'resolve standard add-on endpoint/devices trial (named)':
      return t('Resolve Standard Add-on Endpoint/Devices Trial (named)');
    case 'resolve standard paid (named)':
      return t('Resolve Standard Paid (named)');
    case 'resolve standard trial (concurrent)':
      return t('Resolve Standard Trial (concurrent)');
    case 'resolve standard trial (named)':
      return t('Resolve Standard Trial (named)');
    case 'resolve ticketing':
      return t('Resolve Ticketing');
    case 'resolve add agent shared':
      return t('Resolve MSP Shared');
    case 'resolve camera share msp add-on shared':
      return t('Resolve MSP Camera Share Add-on');
    case 'resolve mobile msp add-on shared':
      return t('Resolve MSP Mobile Add-on');
    case 'resolve mdm xc add-on':
      return t('Resolve MDM XC add-on');
    case 'resolve mdm xc add-on - trial':
      return t('Resolve MDM XC add-on - Trial');
    default:
      return productName;
  }
};

var _PRODUCT_ICON_COLORS;
var GoToAssist = 'GoTo Assist';
var GoToConnect = 'GoTo Connect';
var GoToConnectCX = 'GoTo Connect CX';
var GoToMeeting = 'GoTo Meeting';
var GoToRoom = 'GoTo Room';
var GoToTraining = 'GoTo Training';
var GoToWebinar = 'GoTo Webinar';
var GoView = 'GoView';
var HVoice = 'hVoice';
var Jive = 'Jive';
var OpenVoice = 'OpenVoice';
var Partner = 'Partner';
var Prompt = 'Prompt';
var GoToResolve = 'GoTo Resolve';
var GoToResolveMsp = 'GoTo Resolve Msp';
var Resolve = 'Resolve';
var ResolveMsp = 'Resolve Msp';
var CustomerEngagement = 'Customer Engagement';
var ASSIST_MOBILE_PRODUCT_ABRS = ['RAMOBILE'];
var PARTNER_PRODUCT_ABRS = ['PARTNER'];
var TRAINING_PRODUCT_ABRS = ['G2T'];
var WEBINARS_PRODUCT_ABRS = ['G2W'];
var MEETINGS_PRODUCT_ABRS = ['G2M', 'G2MFREE'];
var JIVE_PRODUCT_ABRS = ['G2C', 'JIVE', 'HVOICE'];
var ASSIST_PRODUCT_ABRS = ['G2ARS', 'G2ASEEIT', 'G2ASD'];
var GOTORESOLVE_PRODUCT_ABRS = ['GOTORESOLVE'];
var GOTORESOLVE_REMOTE_SUPPORT_PRODUCT_ABRS = ['GOTORESOLVEREMOTESUPPORT'];
var GOTORESOLVE_HELPDESK_PRODUCT_ABRS = ['GOTORESOLVEHELPDESK'];
var GOTORESOLVE_MOBILE_PRODUCT_ABRS = ['GOTORESOLVEMOBILE'];
var GOTORESOLVE_CAMERA_SHARE_PRODUCT_ABRS = ['GOTORESOLVECAMERASHARE'];
var GOTORESOLVE_MOBILEDEVICEMANAGEMENT_PRODUCT_ABRS = ['GOTORESOLVEDEVICEMGMT'];
var GOTORESOLVE_ENDPOINT_PROTECTION_PRODUCT_ABRS = ['GTREPPADD'];
var GOTORESOLVE_MSP_PRODUCT_ABRS = ['GOTORESOLVEMSP'];
var GOTORESOLVE_MSP_MOBILE_PRODUCT_ABRS = ['GOTORESOLVEMSPMOBILE'];
var GOTORESOLVE_MSP_CAMERA_SHARE_PRODUCT_ABRS = ['GOTORESOLVEMSPCAMERASHARE'];
var CUSTOMER_ENGAGEMENT_PRODUCT_ABRS = ['CUSTOMERENGAGEMENT'];
var ATTENDANT_CONSOLE_PRODUCT_ABRS = ['ATTENDANTCONSOLE'];
var CONTACT_CENTER_PRODUCTS_ABRS = ['CONTACTCENTER'];
var PRODUCT_ICON_COLORS = (_PRODUCT_ICON_COLORS = {}, _defineProperty(_PRODUCT_ICON_COLORS, GoToAssist, gotoAdminLight.badgeColorAssist), _defineProperty(_PRODUCT_ICON_COLORS, GoToConnect, gotoAdminLight.brandColorGotoAppGreen), _defineProperty(_PRODUCT_ICON_COLORS, GoToMeeting, gotoAdminLight.badgeColorMeeting), _defineProperty(_PRODUCT_ICON_COLORS, GoToRoom, gotoAdminLight.badgeColorOrange), _defineProperty(_PRODUCT_ICON_COLORS, GoToTraining, gotoAdminLight.badgeColorTraining), _defineProperty(_PRODUCT_ICON_COLORS, GoToWebinar, gotoAdminLight.badgeColorWebinar), _defineProperty(_PRODUCT_ICON_COLORS, Jive, gotoAdminLight.badgeColorGreen), _defineProperty(_PRODUCT_ICON_COLORS, OpenVoice, gotoAdminLight.badgeColorVoice), _defineProperty(_PRODUCT_ICON_COLORS, Resolve, gotoAdminLight.badgeColorGotoresolve), _defineProperty(_PRODUCT_ICON_COLORS, ResolveMsp, gotoAdminLight.badgeColorGotoresolve), _PRODUCT_ICON_COLORS);
var PRODUCTS_LIST = [GoToAssist, GoToConnect, GoToConnectCX, GoToMeeting, GoToRoom, GoToTraining, GoToWebinar, GoView, HVoice, Jive, OpenVoice, Partner, Prompt, Resolve, ResolveMsp];
var PRODUCT_LOGOS = PRODUCTS_LIST.reduce(function (acc, productName) {
  var iconColor = PRODUCT_ICON_COLORS[productName] || tokens.typeColorDisabled;
  var productIcon = productName === GoToAssist ? jsx(SvgGoToAssist, {
    style: {
      color: iconColor,
      fill: iconColor
    }
  }) : productName === OpenVoice ? jsx(OpenVoiceIcon, {
    style: {
      color: iconColor,
      fill: iconColor
    }
  }) : productName === Prompt ? jsx(SvgPrompt, {}) : productName === GoView ? jsx(SvgGoView, {}) : productName === Partner ? jsx(GotoMarkIcon, {}) : productName === GoToResolve || productName === GoToResolveMsp || productName === Resolve || productName === ResolveMsp ? jsx(GotoIcon, {
    style: {
      color: iconColor,
      fill: iconColor
    }
  }) : jsx(SvgGoToFlower, {
    style: {
      color: iconColor,
      fill: iconColor
    }
  });
  return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, productName, productIcon));
}, {});
var getProductName = function getProductName() {
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var name = product && product.toLowerCase();
  if (name.includes('gotomeeting') || name.includes('g2m') || name.includes('gotoconference')) {
    return GoToMeeting;
  }
  if (name.includes('connect') || name.includes('g2c')) {
    if (name.includes('bundle')) {
      // Use the same icon as GotoMeeting
      return GoToMeeting;
    } else if (name.includes('cx')) {
      return GoToConnectCX;
    } else {
      return GoToConnect;
    }
  }
  if (name.includes('goview')) {
    return GoView;
  }
  if (name.includes('prompt')) {
    return Prompt;
  }
  if (name.includes('engagement')) {
    return CustomerEngagement;
  }
  if (name.includes('gotowebinar') || name.includes('g2w')) {
    return GoToWebinar;
  }
  if (name.includes('gotoassist') || name.includes('g2a') || name.includes('rescue')) {
    return GoToAssist;
  }
  if (name.includes('gototraining') || name.includes('g2t')) {
    return GoToTraining;
  }
  if (name.includes('gotoroom') || name.includes('g2r')) {
    return GoToRoom;
  }
  if (name.includes('openvoice')) {
    return OpenVoice;
  }
  if (name.includes('jive')) {
    return Jive;
  }
  if (name.includes('hvoice')) {
    return HVoice;
  }
  if (name.includes('partner')) {
    return Partner;
  }
  if (name === 'gotoresolve' || name === 'resolve' || name === 'gotoresolvemsp' || name === 'resolvemsp') {
    return name.includes('msp') ? ResolveMsp : Resolve;
  }
  return '';
};
var removeExtraSpaces = function removeExtraSpaces(s) {
  return s.replace(/\s+/g, ' ').trim();
};
var getProductTitle = function getProductTitle(_ref) {
  var _ref$product = _ref.product,
    product = _ref$product === void 0 ? '' : _ref$product,
    t = _ref.t,
    _ref$rebranding = _ref.rebranding,
    rebranding = _ref$rebranding === void 0 ? false : _ref$rebranding;
  var name = product && product.toLowerCase();
  //version of the product
  var version = function version() {
    if (name.includes('bacis') || name.includes('basic')) {
      return t('Basic');
    }
    if (name.includes('business')) {
      return t('Business');
    }
    if (name.includes('enterprise')) {
      return t('Enterprise');
    }
    if (name.includes('essentials')) {
      return t('Essentials');
    }
    if (name.includes('free')) {
      return t('Free');
    }
    if (name.includes('healthcare')) {
      return t('for HealthCare');
    }
    if (name.includes('individual')) {
      return t('Individual');
    }
    if (name.includes('lite')) {
      return t('Lite');
    }
    if (name.includes('mobile add-on')) {
      return t('Mobile Add-on');
    }
    if (name.includes('camera share add-on')) {
      return t('Camera Share Add-on');
    }
    if (name.includes('helpdesk')) {
      return t('Helpdesk');
    }
    if (name.includes('professionnal')) {
      return t('Professionnal');
    }
    /*
    if (name.includes('remote support')) {
        return t('Remote Support')
    }
    */
    if (name.includes('standard')) {
      return t('Standard');
    }
    if (name.includes('starter')) {
      return t('Starter');
    }
    if (name.includes('seeit')) {
      return t('Seeit');
    }
    if (name.includes('service desk')) {
      return t('Service Desk');
    }
    if (name.includes('teams')) {
      return t('Teams');
    }
    if (name.includes('unlimited')) {
      return t('Unlimited');
    }
    if (name.includes('automotive')) {
      return t('for Automotive');
    }
    return '';
  };
  // trial or premium
  var trial = function trial() {
    if (name.includes('premium')) {
      return t('Premium');
    }
    if (name.includes('trial')) {
      return t('Trial');
    }
    if (name.includes('beta')) {
      return t('Beta');
    }
    return '';
  };
  //extra
  var extra = function extra() {
    if (name.includes('plus')) {
      return t('Plus');
    }
    if (name.includes(' pro')) {
      return t('Pro');
    }
    if (name.includes(' legal')) {
      return t('Legal');
    }
    if (name.includes('low usage')) {
      return t('Low Usage');
    }
    return '';
  };
  //Products list
  if (name.includes('connect bundle') && !name.includes('[')) {
    return removeExtraSpaces(t('Connect Bundle %{version} %{extra} %{trial}', {
      version: version(),
      extra: extra(),
      trial: trial()
    }));
  }
  if (name.includes('gotoassist') && !name.includes('[')) {
    if (rebranding) {
      return removeExtraSpaces(t('GoTo Assist %{version} %{extra} %{trial}', {
        version: version(),
        extra: extra(),
        trial: trial()
      }));
    } else {
      return removeExtraSpaces(t('GoToAssist %{version} %{extra} %{trial}', {
        version: version(),
        extra: extra(),
        trial: trial()
      }));
    }
  }
  if (name.includes('gotoconference')) {
    if (rebranding) {
      return t('GoTo Conference');
    } else {
      return t('GoToConference');
    }
  }
  if (name.includes('gotoconnect') && !name.includes('[')) {
    if (name.includes('cx')) {
      if (rebranding) {
        return removeExtraSpaces(t('GoTo Connect CX %{version} %{trial} %{extra}', {
          version: version(),
          extra: extra(),
          trial: trial()
        }));
      } else {
        return removeExtraSpaces(t('GoToConnect CX %{version} %{trial} %{extra}', {
          version: version(),
          extra: extra(),
          trial: trial()
        }));
      }
    } else {
      if (rebranding) {
        return removeExtraSpaces(t('GoTo Connect %{version} %{trial} %{extra}', {
          version: version(),
          extra: extra(),
          trial: trial()
        }));
      } else {
        return removeExtraSpaces(t('GoToConnect %{version} %{trial} %{extra}', {
          version: version(),
          extra: extra(),
          trial: trial()
        }));
      }
    }
  }
  if (name.includes('gotomeeting') && !name.includes('[')) {
    if (rebranding) {
      return removeExtraSpaces(t('GoTo Meeting %{version} %{extra} %{trial}', {
        version: version(),
        extra: extra(),
        trial: trial()
      }));
    } else {
      return removeExtraSpaces(t('GoToMeeting %{version} %{extra} %{trial}', {
        version: version(),
        extra: extra(),
        trial: trial()
      }));
    }
  }
  if (name.includes('gotoroom')) {
    if (rebranding) {
      return t('GoTo Room');
    } else {
      return t('GoToRoom');
    }
  }
  if (name.includes('gototraining') && !name.includes('[')) {
    if (rebranding) {
      return removeExtraSpaces(t('GoTo Training %{version} %{extra} %{trial}', {
        version: version(),
        extra: extra(),
        trial: trial()
      }));
    } else {
      return removeExtraSpaces(t('GoToTraining %{version} %{extra} %{trial}', {
        version: version(),
        extra: extra(),
        trial: trial()
      }));
    }
  }
  if (name.includes('gotowebinar') && !name.includes('[')) {
    if (rebranding) {
      return removeExtraSpaces(t('GoTo Webinar %{version} %{extra} %{trial}', {
        version: version(),
        extra: extra(),
        trial: trial()
      }));
    } else {
      return removeExtraSpaces(t('GoToWebinar %{version} %{extra} %{trial}', {
        version: version(),
        extra: extra(),
        trial: trial()
      }));
    }
  }
  if (name.includes('goview')) {
    return removeExtraSpaces(t('GoView %{trial}', {
      trial: trial()
    }));
  }
  if (name.includes('hvoice')) {
    return removeExtraSpaces(t('HVoice %{trial}', {
      trial: trial()
    }));
  }
  if (name.includes('jive standalone')) {
    if (rebranding) {
      return t('GoTo Connect');
    } else {
      return t('GoToConnect');
    }
  }
  if (name.includes('openvoice')) {
    return removeExtraSpaces(t('OpenVoice %{trial}', {
      trial: trial()
    }));
  }
  if (name.includes('prompt')) {
    return removeExtraSpaces(t('Prompt %{version} %{trial}', {
      version: version(),
      trial: trial()
    }));
  }
  if (name.includes('gotoresolve')) {
    if (name.includes('remote access')) {
      return t('Resolve Remote Access');
    }
    return t('Resolve - Beta');
  }
  if (name.substring(0, 13) === 'goto resolve ' || name.substring(0, 8) === 'resolve ') {
    return removeExtraSpaces(getGoToResolveTranslation(name, t));
  }
  if (name.includes('partner')) {
    return t('GoTo Admin Partner Edition');
  }
  if (name.includes('essentials voice')) {
    return t('GoTo Essentials');
  }
  //all the other cases i.e 'GoToWebinar[30]'
  return product;
};
var getProductDescription = function getProductDescription() {
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var t = arguments.length > 1 ? arguments[1] : undefined;
  var name = product && product.toLowerCase();
  if (name.includes('gotomeeting') || name.includes('g2m') || name.includes('gotoconference')) {
    return t('Online meetings on any device.');
  }
  if (name.includes('connect') || name.includes('g2c')) {
    if (name.includes('bundle')) {
      // Use the same icon as GotoMeeting
      return t('Online meetings on any device.');
    } else if (name.includes('cx')) {
      if (name.includes('automotive')) {
        return t('Automotive platform with calls, meetings, and customer engagement.');
      } else {
        return t('Unified platform for phones, meetings, and your digital channels.');
      }
    } else {
      return t('Unified phone and meeting software.');
    }
  }
  if (name.includes('goview')) {
    return '';
  }
  if (name.includes('prompt')) {
    return '';
  }
  if (name.includes('gotowebinar') || name.includes('g2w')) {
    return t('Easily host engaging events.');
  }
  if (name.includes('g2ars')) {
    return t('Remote support for desktop devices.');
  }
  if (name.includes('ramobile')) {
    return t('Remote support for mobile devices.');
  }
  if (name.includes('gotoassist') || name.includes('g2a') || name.includes('rescue')) {
    return t('Lightweight and affordable remote support.');
  }
  if (name.includes('gototraining') || name.includes('g2t')) {
    return t('Live and on-demand training software.');
  }
  if (name.includes('gotoroom') || name.includes('g2r')) {
    return t('Intuitive hardware for your conference room.');
  }
  if (name.includes('openvoice')) {
    return t('Reservation-less audio conferencing service.');
  }
  if (name.includes('jive')) {
    return t('Cloud calls on any device.');
  }
  if (name.includes('hvoice')) {
    return '';
  }
  if (name.includes('partner')) {
    return t('Central Management interface for our partners.');
  }
  if (name.includes('gotoresolve') || name.includes('goto resolve')) {
    if (name.includes('camera share')) {
      return t('Live end user camera streaming with zero download.');
    }
    if (name.includes('mobile')) {
      return t('Instant, real-time support for Android and iOS devices.');
    }
    if (name.includes('remote access')) {
      return t('Secure device maintenance from anywhere.');
    }
    return t('Streamlined remote support, access, & ticketing.');
  }
  return '';
};
var getChildProductName = function getChildProductName() {
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var t = arguments.length > 2 ? arguments[2] : undefined;
  var name = product === null || product === void 0 ? void 0 : product.toLowerCase();
  var subtext = description === null || description === void 0 ? void 0 : description.toLowerCase();
  if (name === 'g2m') {
    return t('Meetings');
  }
  if (name === 'jive') {
    return t('Phone');
  }
  if (name === 'g2ars') {
    return t('Remote support');
  }
  if (name === 'ramobile') {
    return t('Mobile add-on');
  }
  if (name === 'gotoresolve') {
    return t('Remote support');
  }
  if (name === 'gotoresolvedevicemgmt') {
    return t('Mobile device management');
  }
  if (name === 'gotoresolveremotehourlysupport') {
    return t('Remote hourly support');
  }
  if (name === 'gotoresolveremotesupport') {
    return t('Remote support');
  }
  if (name === 'gotoresolvehelpdesk') {
    return t('Helpdesk');
  }
  if (name === 'gotoresolvemobile') {
    return t('Mobile support');
  }
  if (name === 'gotoresolvecamerashare') {
    return t('Camera share');
  }
  if (name === 'gotoresolvemsp') {
    return t('Remote support');
  }
  if (name === 'gotoresolvemspmobile') {
    return t('Mobile support MSP shared');
  }
  if (name === 'gotoresolvemspcamerashare') {
    return t('Camera share MSP shared');
  }
  if (name === 'gtreppadd') {
    return t('Endpoint protection');
  }
  if (name === 'customerengagement') {
    if (subtext.includes('standard')) {
      return t('Customer Engagement Standard');
    }
    if (subtext.includes('pro')) {
      return t('Customer Engagement Pro');
    }
    return t('Customer Engagement');
  }
  if (name === 'attendantconsole') {
    return t('Attendant console');
  }
  if (name === 'contactcenter') {
    if (subtext.includes('bdc')) {
      return t('BDC Complete');
    } else {
      return t('Contact Center');
    }
  }
  return '';
};
var getChildProductDescription = function getChildProductDescription() {
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var t = arguments.length > 2 ? arguments[2] : undefined;
  var name = product === null || product === void 0 ? void 0 : product.toLowerCase();
  var subtext = description === null || description === void 0 ? void 0 : description.toLowerCase();
  if (name.includes('gotomeeting') || name.includes('g2m') || name.includes('gotoconference')) {
    return t('Online meetings on any device.');
  }
  if (name.includes('connect') || name.includes('g2c')) {
    if (name.includes('bundle')) {
      // Use the same icon as GotoMeeting
      return t('Online meetings on any device.');
    } else if (name.includes('cx')) {
      if (name.includes('automotive')) {
        return t('Automotive platform with calls, meetings, and customer engagement.');
      } else {
        return t('Unified platform for phones, meetings, and your digital channels.');
      }
    } else {
      return t('Unified phone and meeting software.');
    }
  }
  if (name.includes('goview')) {
    return '';
  }
  if (name.includes('prompt')) {
    return '';
  }
  if (name.includes('gotowebinar') || name.includes('g2w')) {
    return t('Easily host engaging events.');
  }
  if (name.includes('g2ars')) {
    return t('Remote support for desktop devices.');
  }
  if (name.includes('ramobile')) {
    return t('Remote support for mobile devices.');
  }
  if (name.includes('engagement')) {
    if (subtext.includes('standard')) {
      return t('Multi-channel shared inbox and SMS campaigns');
    }
    if (subtext.includes('pro')) {
      return t('Multi-channel shared inbox and pro SMS campaigns');
    }
    return t('SMS campaigns and a multi-channel shared inbox');
  }
  if (name.includes('attendant')) {
    return t('Call management in one simple view');
  }
  if (name.includes('gotoassist') || name.includes('g2a') || name.includes('rescue')) {
    return t('Lightweight and affordable remote support.');
  }
  if (name.includes('gototraining') || name.includes('g2t')) {
    return t('Live and on-demand training software.');
  }
  if (name.includes('gotoroom') || name.includes('g2r')) {
    return t('Intuitive hardware for your conference room.');
  }
  if (name.includes('openvoice')) {
    return t('Reservation-less audio conferencing service.');
  }
  if (name.includes('jive')) {
    return t('Cloud calls on any device');
  }
  if (name.includes('hvoice')) {
    return '';
  }
  if (name.includes('partner')) {
    return t('Central Management interface for our partners.');
  }
  if (name.includes('gotoresolvedevicemgmt')) {
    return t('Manage the security and settings of your mobile devices.');
  }
  if (name.includes('gotoresolveremotesupport')) {
    return t('Real-time device access and control for PCs and Macs.');
  }
  if (name.includes('gotoresolvehelpdesk')) {
    return t('Ticketing and incident management system which works in MS Teams.');
  }
  if (name.includes('gotoresolvemobile') || name.includes('gotoresolvemspmobile')) {
    return t('Instant, real-time support for Android and iOS devices.');
  }
  if (name.includes('gotoresolvecamerashare') || name.includes('gotoresolvemspcamerashare')) {
    return t('Live end user camera streaming with zero download.');
  }
  if (name.includes('gtreppadd')) {
    return t('Cyber threat protection for managed devices powered by Bitdefender.');
  }
  if (name.includes('gotoresolve')) {
    return t('Real-time device access and control for PCs and Macs.');
  }
  if (name.includes('contactcenter')) {
    if (subtext.includes('bdc')) {
      return t('Automotive contact center for BDC efficiency and performance.');
    } else {
      return t('A cloud-based contact center enhanced by AI');
    }
  }
  return '';
};
var getProductLogo = function getProductLogo(productName) {
  return PRODUCT_LOGOS[productName];
};

var ProductIcon = function ProductIcon(_ref) {
  var title = _ref.title,
    icon = _ref.icon,
    iconColor = _ref.iconColor,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$invited = _ref.invited,
    invited = _ref$invited === void 0 ? false : _ref$invited;
  var testid = title.toLowerCase().replace(/ /g, '-');
  var invitedStyle = invited ? {
    opacity: 0.35
  } : {};
  var disabledStyle = disabled ? {
    '--goto-surface-color-default': "".concat(tokens.interactiveColorDisabled, " !important")
  } : {};
  return jsxs("div", {
    style: {
      display: 'flex'
    },
    children: [jsx(IconBadge, {
      id: "product-icon-badge",
      "data-testid": "product-icon-badge-".concat(testid),
      size: "small",
      disabled: disabled,
      colorToken: iconColor,
      style: _objectSpread2(_objectSpread2({}, invitedStyle), disabledStyle),
      label: "".concat(title, " icon"),
      children: icon
    }), jsx(Tooltip, {
      triggerId: "product-icon-badge",
      children: title
    })]
  });
};

var ProductIcons = function ProductIcons(_ref) {
  var _ref$products = _ref.products,
    products = _ref$products === void 0 ? [] : _ref$products,
    _ref$disabledProducts = _ref.disabledProducts,
    disabledProducts = _ref$disabledProducts === void 0 ? [] : _ref$disabledProducts,
    _ref$invitedProducts = _ref.invitedProducts,
    invitedProducts = _ref$invitedProducts === void 0 ? [] : _ref$invitedProducts;
  var t = useTranslate();
  var mergedProducts = [].concat(_toConsumableArray(products), _toConsumableArray(disabledProducts), _toConsumableArray(invitedProducts));
  return jsxs("div", {
    style: {
      display: 'flex',
      gap: tokens.spacing02,
      alignItems: 'center',
      flexWrap: 'nowrap'
    },
    children: [JIVE_PRODUCT_ABRS.some(function (el) {
      return mergedProducts.includes(el);
    }) && jsx(ProductIcon, {
      title: t('Phone'),
      icon: jsx(PhoneUpFilledIcon, {}),
      iconColor: "goto-badge-color-green",
      invited: JIVE_PRODUCT_ABRS.some(function (el) {
        return invitedProducts.includes(el);
      }),
      disabled: JIVE_PRODUCT_ABRS.some(function (el) {
        return disabledProducts.includes(el);
      })
    }), MEETINGS_PRODUCT_ABRS.some(function (el) {
      return mergedProducts.includes(el);
    }) && jsx(ProductIcon, {
      title: t('Meetings'),
      icon: jsx(WebcamOnFilledIcon, {}),
      iconColor: "goto-badge-color-orange",
      invited: MEETINGS_PRODUCT_ABRS.some(function (el) {
        return invitedProducts.includes(el);
      }),
      disabled: MEETINGS_PRODUCT_ABRS.some(function (el) {
        return disabledProducts.includes(el);
      })
    }), PARTNER_PRODUCT_ABRS.some(function (el) {
      return mergedProducts.includes(el);
    }) && jsx(ProductIcon, {
      title: t('Partner'),
      icon: jsx(GotoIcon, {}),
      iconColor: "goto-badge-color-red",
      invited: PARTNER_PRODUCT_ABRS.some(function (el) {
        return invitedProducts.includes(el);
      }),
      disabled: PARTNER_PRODUCT_ABRS.some(function (el) {
        return disabledProducts.includes(el);
      })
    }), TRAINING_PRODUCT_ABRS.some(function (el) {
      return mergedProducts.includes(el);
    }) && jsx(ProductIcon, {
      title: t('Training'),
      icon: jsx(EducationFilledIcon, {}),
      iconColor: "goto-badge-color-deeppurple",
      invited: TRAINING_PRODUCT_ABRS.some(function (el) {
        return invitedProducts.includes(el);
      }),
      disabled: TRAINING_PRODUCT_ABRS.some(function (el) {
        return disabledProducts.includes(el);
      })
    }), WEBINARS_PRODUCT_ABRS.some(function (el) {
      return mergedProducts.includes(el);
    }) && jsx(ProductIcon, {
      title: t('Webinars'),
      icon: jsx(LoudspeakerFilledIcon, {}),
      iconColor: "goto-badge-color-blue",
      invited: WEBINARS_PRODUCT_ABRS.some(function (el) {
        return invitedProducts.includes(el);
      }),
      disabled: WEBINARS_PRODUCT_ABRS.some(function (el) {
        return disabledProducts.includes(el);
      })
    }), ASSIST_PRODUCT_ABRS.some(function (el) {
      return mergedProducts.includes(el);
    }) && jsx(ProductIcon, {
      title: t('Assist'),
      icon: jsx(ScreenMirroringOutlinedIcon, {}),
      iconColor: "goto-badge-color-zomp",
      invited: ASSIST_PRODUCT_ABRS.some(function (el) {
        return invitedProducts.includes(el);
      }),
      disabled: ASSIST_PRODUCT_ABRS.some(function (el) {
        return disabledProducts.includes(el);
      })
    }), ASSIST_MOBILE_PRODUCT_ABRS.some(function (el) {
      return mergedProducts.includes(el);
    }) && jsx(ProductIcon, {
      title: t('Mobile'),
      icon: jsx(SmartphoneOutlinedIcon, {}),
      iconColor: "goto-badge-color-zomp",
      invited: ASSIST_PRODUCT_ABRS.some(function (el) {
        return invitedProducts.includes(el);
      }),
      disabled: ASSIST_PRODUCT_ABRS.some(function (el) {
        return disabledProducts.includes(el);
      })
    }), GOTORESOLVE_PRODUCT_ABRS.some(function (el) {
      return mergedProducts.includes(el);
    }) && jsx(ProductIcon, {
      title: t('Remote Support'),
      icon: jsx(RemoteSupportOutlinedIcon, {}),
      iconColor: "goto-badge-color-violet",
      invited: GOTORESOLVE_PRODUCT_ABRS.some(function (el) {
        return invitedProducts.includes(el);
      }),
      disabled: GOTORESOLVE_PRODUCT_ABRS.some(function (el) {
        return disabledProducts.includes(el);
      })
    }), GOTORESOLVE_REMOTE_SUPPORT_PRODUCT_ABRS.some(function (el) {
      return mergedProducts.includes(el);
    }) && jsx(ProductIcon, {
      title: t('Remote Support'),
      iconColor: "goto-badge-color-violet",
      icon: jsx(RemoteSupportOutlinedIcon, {}),
      invited: GOTORESOLVE_REMOTE_SUPPORT_PRODUCT_ABRS.some(function (el) {
        return invitedProducts.includes(el);
      }),
      disabled: GOTORESOLVE_REMOTE_SUPPORT_PRODUCT_ABRS.some(function (el) {
        return disabledProducts.includes(el);
      })
    }), GOTORESOLVE_HELPDESK_PRODUCT_ABRS.some(function (el) {
      return mergedProducts.includes(el);
    }) && jsx(ProductIcon, {
      title: t('Helpdesk'),
      icon: jsx(TicketOutlinedIcon, {}),
      iconColor: "goto-badge-color-violet",
      invited: GOTORESOLVE_HELPDESK_PRODUCT_ABRS.some(function (el) {
        return invitedProducts.includes(el);
      }),
      disabled: GOTORESOLVE_HELPDESK_PRODUCT_ABRS.some(function (el) {
        return disabledProducts.includes(el);
      })
    }), GOTORESOLVE_MOBILE_PRODUCT_ABRS.some(function (el) {
      return mergedProducts.includes(el);
    }) && jsx(ProductIcon, {
      title: t('Mobile support'),
      icon: jsx(MobileSupportOutlinedIcon, {}),
      iconColor: "goto-badge-color-violet",
      invited: GOTORESOLVE_MOBILE_PRODUCT_ABRS.some(function (el) {
        return invitedProducts.includes(el);
      }),
      disabled: GOTORESOLVE_MOBILE_PRODUCT_ABRS.some(function (el) {
        return disabledProducts.includes(el);
      })
    }), GOTORESOLVE_CAMERA_SHARE_PRODUCT_ABRS.some(function (el) {
      return mergedProducts.includes(el);
    }) && jsx(ProductIcon, {
      title: t('Camera share'),
      icon: jsx(CameraShareOutlinedIcon, {}),
      iconColor: "goto-badge-color-violet",
      invited: GOTORESOLVE_CAMERA_SHARE_PRODUCT_ABRS.some(function (el) {
        return invitedProducts.includes(el);
      }),
      disabled: GOTORESOLVE_CAMERA_SHARE_PRODUCT_ABRS.some(function (el) {
        return disabledProducts.includes(el);
      })
    }), GOTORESOLVE_MSP_PRODUCT_ABRS.some(function (el) {
      return mergedProducts.includes(el);
    }) && jsx(ProductIcon, {
      title: t('Remote Support'),
      icon: jsx(RemoteSupportOutlinedIcon, {}),
      iconColor: "goto-badge-color-violet",
      invited: GOTORESOLVE_MSP_PRODUCT_ABRS.some(function (el) {
        return invitedProducts.includes(el);
      }),
      disabled: GOTORESOLVE_MSP_PRODUCT_ABRS.some(function (el) {
        return disabledProducts.includes(el);
      })
    }), GOTORESOLVE_MSP_MOBILE_PRODUCT_ABRS.some(function (el) {
      return mergedProducts.includes(el);
    }) && jsx(ProductIcon, {
      title: t('Mobile support'),
      icon: jsx(MobileSupportOutlinedIcon, {}),
      iconColor: "goto-badge-color-violet",
      invited: GOTORESOLVE_MSP_MOBILE_PRODUCT_ABRS.some(function (el) {
        return invitedProducts.includes(el);
      }),
      disabled: GOTORESOLVE_MSP_MOBILE_PRODUCT_ABRS.some(function (el) {
        return disabledProducts.includes(el);
      })
    }), GOTORESOLVE_MSP_CAMERA_SHARE_PRODUCT_ABRS.some(function (el) {
      return mergedProducts.includes(el);
    }) && jsx(ProductIcon, {
      title: t('Camera share'),
      icon: jsx(CameraShareOutlinedIcon, {}),
      iconColor: "goto-badge-color-violet",
      invited: GOTORESOLVE_MSP_CAMERA_SHARE_PRODUCT_ABRS.some(function (el) {
        return invitedProducts.includes(el);
      }),
      disabled: GOTORESOLVE_MSP_CAMERA_SHARE_PRODUCT_ABRS.some(function (el) {
        return disabledProducts.includes(el);
      })
    }), CONTACT_CENTER_PRODUCTS_ABRS.some(function (el) {
      return mergedProducts.includes(el);
    }) && jsx(ProductIcon, {
      title: t('Contact Center'),
      icon: jsx(VoipOutlinedIcon, {}),
      iconColor: "goto-badge-color-queenblue",
      invited: CONTACT_CENTER_PRODUCTS_ABRS.some(function (el) {
        return invitedProducts.includes(el);
      }),
      disabled: CONTACT_CENTER_PRODUCTS_ABRS.some(function (el) {
        return disabledProducts.includes(el);
      })
    }), CUSTOMER_ENGAGEMENT_PRODUCT_ABRS.some(function (el) {
      return mergedProducts.includes(el);
    }) && jsx(ProductIcon, {
      title: t('Customer Engagement'),
      icon: jsx(BroadcastOutlinedIcon, {}),
      iconColor: "goto-badge-color-blue",
      invited: CUSTOMER_ENGAGEMENT_PRODUCT_ABRS.some(function (el) {
        return invitedProducts.includes(el);
      }),
      disabled: CUSTOMER_ENGAGEMENT_PRODUCT_ABRS.some(function (el) {
        return disabledProducts.includes(el);
      })
    }), ATTENDANT_CONSOLE_PRODUCT_ABRS.some(function (el) {
      return mergedProducts.includes(el);
    }) && jsx(ProductIcon, {
      title: t('Attendant Console'),
      icon: jsx(PhoneLogFilledIcon, {}),
      iconColor: "goto-badge-color-queenblue",
      invited: ATTENDANT_CONSOLE_PRODUCT_ABRS.some(function (el) {
        return invitedProducts.includes(el);
      }),
      disabled: ATTENDANT_CONSOLE_PRODUCT_ABRS.some(function (el) {
        return disabledProducts.includes(el);
      })
    }), GOTORESOLVE_MOBILEDEVICEMANAGEMENT_PRODUCT_ABRS.some(function (el) {
      return mergedProducts.includes(el);
    }) && jsx(ProductIcon, {
      title: t('Mobile Device Management'),
      icon: jsx(MobileDeviceManagementOutlinedIcon, {}),
      iconColor: "goto-badge-color-violet",
      invited: GOTORESOLVE_MOBILEDEVICEMANAGEMENT_PRODUCT_ABRS.some(function (el) {
        return invitedProducts.includes(el);
      }),
      disabled: GOTORESOLVE_MOBILEDEVICEMANAGEMENT_PRODUCT_ABRS.some(function (el) {
        return disabledProducts.includes(el);
      })
    }), GOTORESOLVE_ENDPOINT_PROTECTION_PRODUCT_ABRS.some(function (el) {
      return mergedProducts.includes(el);
    }) && jsx(ProductIcon, {
      title: t('Endpoint protection'),
      icon: jsx(ResolveEndpointProtectionOutlinedIcon, {}),
      iconColor: "goto-badge-color-violet",
      invited: GOTORESOLVE_ENDPOINT_PROTECTION_PRODUCT_ABRS.some(function (el) {
        return invitedProducts.includes(el);
      }),
      disabled: GOTORESOLVE_ENDPOINT_PROTECTION_PRODUCT_ABRS.some(function (el) {
        return disabledProducts.includes(el);
      })
    })]
  });
};
var ProductIcons$1 = memo(ProductIcons);

var styles$5 = {"faded":"ua-common_10-0-0_ProductLogo__faded__7fa6d","size":"ua-common_10-0-0_ProductLogo__size__7fa6d"};

var ProductLogo = function ProductLogo(_ref) {
  var product = _ref.product,
    withTooltip = _ref.withTooltip,
    _ref$faded = _ref.faded,
    faded = _ref$faded === void 0 ? false : _ref$faded;
  var productName = getProductName(product);
  var icon = jsx("span", {
    className: "".concat(styles$5.size, " ").concat(faded ? styles$5.faded : ''),
    children: getProductLogo(productName)
  });
  if (!withTooltip) {
    return icon;
  }
  return jsxs(Fragment, {
    children: [jsx("div", {
      id: "product-icon",
      children: icon
    }), jsx(Tooltip, {
      triggerId: "product-icon",
      children: jsx("span", {
        children: productName
      })
    })]
  });
};
var ProductLogo$1 = memo(ProductLogo);

var _excluded$4 = ["label", "value", "linkTo"];
var ReadOnlyTextField = function ReadOnlyTextField(_ref) {
  var label = _ref.label,
    value = _ref.value,
    linkTo = _ref.linkTo,
    otherProps = _objectWithoutProperties(_ref, _excluded$4);
  return jsxs("div", _objectSpread2(_objectSpread2({
    style: {
      marginBottom: tokens.spacing04
    }
  }, otherProps), {}, {
    children: [jsx(Typography, {
      title: label,
      style: {
        hyphens: 'auto',
        overflowWrap: 'anywhere'
      },
      variant: "caption-medium-strong",
      color: "type-color-secondary",
      children: label
    }), jsx("div", {
      style: {
        marginTop: tokens.spacing01
      },
      children: jsx(Typography, {
        style: {
          hyphens: 'auto',
          overflowWrap: 'anywhere'
        },
        children: linkTo ? jsx(Link, {
          to: linkTo,
          children: jsx(Link$1, {
            children: value || EMPTY_SYMBOL
          })
        }) : value || EMPTY_SYMBOL
      })
    })]
  }));
};
var ReadOnlyTextField$1 = memo(ReadOnlyTextField);

// Returns an interval in the format 2020-11-03T00:00:00/2020-11-06T23:59:59
var formatHolidayInterval = function formatHolidayInterval(values) {
  if (values.allDay) {
    return "".concat(moment(values.start).hours(0).minutes(0).seconds(0).format(DATE_ISO_8601_FORMAT), "/").concat(moment(values.end).hours(23).minutes(59).seconds(59).format(DATE_ISO_8601_FORMAT));
  }
  var start = moment(values.startTime, 'LT', EN_US_LOCALE);
  var end = moment(values.endTime, 'LT', EN_US_LOCALE);
  var startHours = start.hours();
  var startMinutes = start.minutes();
  var endHours = end.hours();
  var endMinutes = end.minutes();
  return "".concat(moment(values.start).hours(startHours).minutes(startMinutes).seconds(0).format(DATE_ISO_8601_FORMAT), "/").concat(moment(values.end).hours(endHours).minutes(endMinutes).seconds(0).format(DATE_ISO_8601_FORMAT));
};

var HolidayEditorDialog = function HolidayEditorDialog(_ref) {
  var _holiday$interval3, _holiday$interval4, _holiday$interval5, _holiday$interval6;
  var onCancel = _ref.onCancel,
    holiday = _ref.holiday,
    onSubmit = _ref.onSubmit,
    formValues = _ref.formValues,
    setHolidaysValue = _ref.setHolidaysValue,
    scheduleDetails = _ref.scheduleDetails,
    scheduleMode = _ref.scheduleMode,
    mode = _ref.mode;
  // Hooks
  var t = useTranslate();
  var validateDate = function validateDate(date) {
    return moment(date, HOUR_FORMAT_1, true).isValid();
  };
  // Validation schema
  var Schema = Yup.object().shape({
    name: Yup.string().max(255, t('Maximum %{maxCharacters} characters', {
      maxCharacters: 255
    })).required(t('Required')),
    allDay: Yup.mixed().oneOf([true, false]).required(t('Required')),
    start: Yup.string().required(t('Required')),
    end: Yup.string().required(t('Required')),
    startTime: Yup.string().when('allDay', {
      is: false,
      then: Yup.string().required(t('Required')).test('start-date-valid', t("Format 'hh:mm A' is required."), function (date) {
        return validateDate(date);
      })
    }),
    endTime: Yup.string().when('allDay', {
      is: false,
      then: Yup.string().required(t('Required')).test('end-date-valid', t("Format 'hh:mm A' is required."), function (date) {
        return validateDate(date);
      })
    })
  });
  var isAllDay = function isAllDay(holiday) {
    var _holiday$interval, _holiday$interval2;
    return holiday && moment(holiday === null || holiday === void 0 ? void 0 : (_holiday$interval = holiday.interval) === null || _holiday$interval === void 0 ? void 0 : _holiday$interval.split('/')[0]).format('hh:mm A') === '12:00 AM' && moment(holiday === null || holiday === void 0 ? void 0 : (_holiday$interval2 = holiday.interval) === null || _holiday$interval2 === void 0 ? void 0 : _holiday$interval2.split('/')[1]).format('hh:mm A') === '11:59 PM';
  };
  var initialValues = {
    name: (holiday === null || holiday === void 0 ? void 0 : holiday.name) || '',
    allDay: holiday ? isAllDay(holiday) : true,
    interval: (holiday === null || holiday === void 0 ? void 0 : holiday.interval) || '',
    start: (holiday === null || holiday === void 0 ? void 0 : (_holiday$interval3 = holiday.interval) === null || _holiday$interval3 === void 0 ? void 0 : _holiday$interval3.split('/')[0]) || new Date().toISOString(),
    end: (holiday === null || holiday === void 0 ? void 0 : (_holiday$interval4 = holiday.interval) === null || _holiday$interval4 === void 0 ? void 0 : _holiday$interval4.split('/')[1]) || new Date().toISOString(),
    startTime: holiday && moment(holiday === null || holiday === void 0 ? void 0 : (_holiday$interval5 = holiday.interval) === null || _holiday$interval5 === void 0 ? void 0 : _holiday$interval5.split('/')[0]).format('hh:mm A') || '12:00 AM',
    endTime: holiday && moment(holiday === null || holiday === void 0 ? void 0 : (_holiday$interval6 = holiday.interval) === null || _holiday$interval6 === void 0 ? void 0 : _holiday$interval6.split('/')[1]).format('hh:mm A') || '11:59 PM'
  };
  var endDate = useCallback(function (values, setFieldValue) {
    if (!values.end || !values.start) {
      return '';
    }
    var startDate = moment(values.start);
    var endDate = moment(values.end);
    var newDate = endDate.toDate().toISOString();
    if (endDate.isBefore(startDate)) {
      newDate = startDate.toDate().toISOString();
      setFieldValue('end', newDate);
      return newDate;
    }
    return newDate;
  }, []);
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values) {
      var interval, holidayToReplaceIndex, updatedValues, _scheduleDetails$holi, holidayIndexToReplace, updatedHolidays;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            interval = formatHolidayInterval(values);
            if (scheduleMode === 'ON') {
              if (mode === 'create') {
                setHolidaysValue([].concat(_toConsumableArray(formValues.holidays), [_objectSpread2(_objectSpread2({}, values), {}, {
                  interval: interval
                })]));
              } else {
                holidayToReplaceIndex = formValues.holidays.findIndex(function (h) {
                  return h.name === (holiday === null || holiday === void 0 ? void 0 : holiday.name) && h.interval === (holiday === null || holiday === void 0 ? void 0 : holiday.interval);
                });
                updatedValues = _toConsumableArray(formValues.holidays);
                if (holidayToReplaceIndex !== undefined && holidayToReplaceIndex !== -1) {
                  updatedValues[holidayToReplaceIndex] = _objectSpread2(_objectSpread2({}, values), {}, {
                    interval: interval
                  });
                }
                setHolidaysValue(updatedValues);
              }
            } else {
              if (mode === 'create') {
                onSubmit && onSubmit(values, interval);
              } else {
                holidayIndexToReplace = scheduleDetails === null || scheduleDetails === void 0 ? void 0 : (_scheduleDetails$holi = scheduleDetails.holidays) === null || _scheduleDetails$holi === void 0 ? void 0 : _scheduleDetails$holi.findIndex(function (h) {
                  return h.name === (holiday === null || holiday === void 0 ? void 0 : holiday.name) && h.interval === (holiday === null || holiday === void 0 ? void 0 : holiday.interval);
                });
                updatedHolidays = _toConsumableArray((scheduleDetails === null || scheduleDetails === void 0 ? void 0 : scheduleDetails.holidays) || []);
                if (holidayIndexToReplace !== undefined && holidayIndexToReplace !== -1) {
                  updatedHolidays[holidayIndexToReplace] = _objectSpread2(_objectSpread2({}, values), {}, {
                    interval: interval
                  });
                }
                onSubmit && onSubmit(updatedHolidays);
              }
            }
            onCancel();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return jsx(Formik, {
    initialValues: initialValues,
    isInitialValid: !!holiday,
    validateOnBlur: false,
    validationSchema: Schema,
    onSubmit: handleSubmit,
    children: function children(_ref3) {
      var values = _ref3.values,
        setFieldValue = _ref3.setFieldValue,
        isValid = _ref3.isValid,
        isSubmitting = _ref3.isSubmitting;
      return jsxs(Form, {
        noValidate: true,
        autoComplete: "off",
        "data-testid": "holiday-editor-dialog",
        children: [jsx(FormikTextField, {
          autoFocus: true,
          label: t('Name'),
          "aria-label": t('Name'),
          fullwidth: true,
          name: "name",
          placeholder: t('Enter a name'),
          onChange: function onChange(e) {
            setFieldValue('name', e.target.value);
          },
          onKeyDown: function onKeyDown(evt) {
            return evt.stopPropagation();
          },
          style: {
            marginBottom: tokens.spacing04
          }
        }), jsx(FormikSwitch, {
          name: "allDay",
          onChange: function onChange(e) {
            return setFieldValue('allDay', e.target.checked);
          },
          style: {
            marginBottom: tokens.spacing04
          },
          children: t('All day')
        }), jsx(FormikDatePickerField, {
          name: "start",
          value: values.start,
          setFieldValue: setFieldValue,
          clearBtnTooltip: t('Remove start date'),
          textFieldProps: {
            helperText: t('Start date'),
            placeholder: t('Select start date'),
            labelId: t('Start date'),
            disabled: isSubmitting
          },
          datePickerProps: {
            inputProps: {
              'data-testid': 'input-startDate-testid'
            }
          }
        }), jsx(FormikDatePickerField, {
          name: "end",
          value: endDate(values, setFieldValue),
          setFieldValue: setFieldValue,
          clearBtnTooltip: t('Remove end date'),
          textFieldProps: {
            helperText: t('End date'),
            placeholder: t('Select end date'),
            labelId: t('End date'),
            disabled: isSubmitting
          },
          datePickerProps: {
            minDate: values.start,
            inputProps: {
              'data-testid': 'input-endDate-testid'
            }
          }
        }), !values.allDay && jsxs("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            gap: tokens.spacing04
          },
          children: [jsx(FormikTextField, {
            label: t('Start time'),
            "aria-label": t('Start time'),
            fullwidth: true,
            name: "startTime",
            placeholder: t('Enter a start time'),
            onChange: function onChange(e) {
              setFieldValue('startTime', e.target.value);
            },
            onKeyDown: function onKeyDown(evt) {
              return evt.stopPropagation();
            }
          }), jsx("div", {
            style: {
              paddingTop: tokens.spacing01
            },
            children: jsx(Typography, {
              children: t('to')
            })
          }), jsx(FormikTextField, {
            label: t('End time'),
            "aria-label": t('End time'),
            fullwidth: true,
            name: "endTime",
            placeholder: t('Enter an end time'),
            onChange: function onChange(e) {
              setFieldValue('endTime', e.target.value);
            },
            onKeyDown: function onKeyDown(evt) {
              return evt.stopPropagation();
            }
          })]
        }), jsxs(DialogActions, {
          children: [jsx(Button, {
            variant: "neutral",
            onClick: onCancel,
            children: t('Cancel')
          }), jsx(Button, {
            "data-testid": "holiday-editor-save-btn",
            disabled: !isValid || isSubmitting,
            type: "submit",
            variant: "primary",
            children: t('Save')
          })]
        })]
      });
    }
  });
};

var RecurrenceModal = function RecurrenceModal(_ref) {
  var appointmentData = _ref.appointmentData,
    schedulerData = _ref.schedulerData,
    onSubmit = _ref.onSubmit,
    onCancel = _ref.onCancel;
  var t = useTranslate();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    matchedAppoints = _useState4[0],
    setMatchedAppoints = _useState4[1];
  // Used for displaying the buttons and have translation on them
  var daysOfWeekCompactTranslated = useMemo(function () {
    return [t('S'), t('M'), t('T'), t('W'), t('T'), t('F'), t('S')];
  }, [t]);
  // Used only to calculate things
  var daysOfWeekExtended = useMemo(function () {
    return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  }, []);
  // Used only for displaying the tooltip and have translation on them
  var daysOfWeekExtendedTranslated = useMemo(function () {
    return [t('Sunday'), t('Monday'), t('Tuesday'), t('Wednesday'), t('Thursday'), t('Friday'), t('Saturday')];
  }, [t]);
  /**
   * Compares the startHour and endHour of two appointments to see if they are equal (reccuring appointment)
   * @param appoint1 Object
   * @param appoint2 Object
   * @returns boolean
   */
  var compareTwoAppointmentsHours = function compareTwoAppointmentsHours(appoint1, appoint2) {
    var startHourMatch = moment(appoint1.startDate).format('hh:mm') === moment(appoint2.startDate).format('hh:mm');
    var endHourMatch = moment(appoint1.endDate).format('hh:mm') === moment(appoint2.endDate).format('hh:mm');
    return startHourMatch && endHourMatch;
  };
  /**
   * Get all recurring appointments in schedulerData
   */
  var computeReccuringAppoint = useCallback(function () {
    var matching = schedulerData.filter(function (oneAppoint) {
      var areAppointsMatching = compareTwoAppointmentsHours(oneAppoint, appointmentData);
      return areAppointsMatching;
    });
    return matching.map(function (oneMatched) {
      return moment(oneMatched.startDate).format('dddd');
    });
  }, [appointmentData, schedulerData]);
  useEffect(function () {
    setMatchedAppoints(computeReccuringAppoint());
  }, [computeReccuringAppoint]);
  var isSelected = useCallback(function (index) {
    return matchedAppoints.some(function (oneMatchedAppoint) {
      return oneMatchedAppoint === daysOfWeekExtended[index];
    });
  }, [daysOfWeekExtended, matchedAppoints]);
  var onClickHandler = useCallback(function (index, isSelected) {
    var dayClicked = daysOfWeekExtended[index];
    if (isSelected) {
      var spliceMatchedAppoints = _toConsumableArray(matchedAppoints);
      spliceMatchedAppoints.splice(matchedAppoints.indexOf(dayClicked), 1);
      setMatchedAppoints(spliceMatchedAppoints);
    } else {
      setMatchedAppoints(matchedAppoints.concat(dayClicked));
    }
  }, [daysOfWeekExtended, matchedAppoints]);
  var onSave = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var updatedScheduleData, updatedRecurringAppointments, filteredSchedulerData, _filteredSchedulerData;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsLoading(true);
            updatedScheduleData = [];
            if (matchedAppoints.length !== 0) {
              // If user has one or more recurring day
              updatedRecurringAppointments = matchedAppoints.map(function (oneMatchedApp) {
                var appointment = {
                  startDate: moment(appointmentData.startDate).day(oneMatchedApp),
                  endDate: appointmentData.allDay ? moment(appointmentData.endDate).day(oneMatchedApp).add(1, 'd') : moment(appointmentData.endDate).day(oneMatchedApp)
                };
                return appointment;
              });
              filteredSchedulerData = schedulerData.filter(function (oneApp) {
                return !updatedRecurringAppointments.some(function (oneUpdated) {
                  return compareTwoAppointmentsHours(oneUpdated, oneApp);
                });
              });
              updatedScheduleData = [].concat(_toConsumableArray(filteredSchedulerData), _toConsumableArray(updatedRecurringAppointments));
            } else {
              // If user decide to remove all recurring appointments, it's like a delete
              _filteredSchedulerData = schedulerData.filter(function (oneAppoint) {
                return !compareTwoAppointmentsHours(oneAppoint, appointmentData);
              });
              updatedScheduleData = _toConsumableArray(_filteredSchedulerData);
            }
            onSubmit(updatedScheduleData);
            setIsLoading(false);
            onCancel();
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onSave() {
      return _ref2.apply(this, arguments);
    };
  }();
  return jsxs(Fragment, {
    children: [jsx("div", {
      style: {
        display: 'flex',
        flexDirection: 'row',
        gap: tokens.spacing04
      },
      children: daysOfWeekCompactTranslated.map(function (day, index) {
        return jsxs("div", {
          style: {
            display: 'flex',
            justifyContent: 'center'
          },
          children: [jsx(RoundButton, {
            id: "".concat(daysOfWeekExtendedTranslated[index], "-round-button"),
            "data-testid": "".concat(daysOfWeekExtendedTranslated[index], "-button"),
            variant: isSelected(index) ? 'primary' : 'secondary',
            onClick: function onClick() {
              onClickHandler(index, isSelected(index));
            },
            "aria-label": "".concat(daysOfWeekExtendedTranslated[index], "-button"),
            children: jsx(Typography, {
              variant: "body-medium-strong",
              color: isSelected(index) ? 'type-color-inverted' : 'type-color-default',
              children: day
            })
          }), jsx(Tooltip, {
            triggerId: "".concat(daysOfWeekExtendedTranslated[index], "-round-button"),
            children: daysOfWeekExtendedTranslated[index]
          })]
        }, index);
      })
    }), jsxs(DialogActions, {
      children: [jsx(Button, {
        variant: "neutral",
        onClick: function onClick() {
          return onCancel();
        },
        children: t('Cancel')
      }), jsx(Button, {
        disabled: isLoading,
        variant: "primary",
        onClick: function onClick() {
          return onSave();
        },
        children: t('Save')
      })]
    })]
  });
};

var TablePageEmptyState = function TablePageEmptyState(props) {
  return jsx("div", {
    style: {
      flex: 1,
      margin: 'auto',
      maxWidth: 480,
      display: 'flex',
      alignItems: 'center'
    },
    children: jsx(EmptyState, _objectSpread2({}, props))
  });
};
var TablePageEmptyState$1 = memo(TablePageEmptyState);

var _excluded$3 = ["children", "noMaxWidth", "title", "maxWidth", "typographyProps", "style", "component"];
var TextCell = function TextCell(_ref) {
  var children = _ref.children,
    _ref$noMaxWidth = _ref.noMaxWidth,
    noMaxWidth = _ref$noMaxWidth === void 0 ? false : _ref$noMaxWidth,
    title = _ref.title,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? 320 : _ref$maxWidth,
    typographyProps = _ref.typographyProps,
    style = _ref.style,
    _ref$component = _ref.component,
    Component = _ref$component === void 0 ? 'div' : _ref$component,
    otherProps = _objectWithoutProperties(_ref, _excluded$3);
  return jsx(Component, _objectSpread2(_objectSpread2({
    style: _objectSpread2({
      maxWidth: noMaxWidth ? 'unset' : maxWidth,
      overflow: 'hidden'
    }, style)
  }, otherProps), {}, {
    children: jsx(Typography, _objectSpread2(_objectSpread2({
      noWrap: true,
      title: title || children && children.toString() || ''
    }, typographyProps), {}, {
      children: children
    }))
  }));
};
var TextCell$1 = memo(TextCell);

var DEFAULT_SORT = [{
  id: 'name',
  direction: 'asc'
}];
var ScheduleHolidays = function ScheduleHolidays(_ref) {
  var mode = _ref.mode,
    values = _ref.values,
    holidays = _ref.holidays,
    scheduleDetails = _ref.scheduleDetails,
    onHolidayCreateSubmit = _ref.onHolidayCreateSubmit,
    onHolidayEditSubmit = _ref.onHolidayEditSubmit,
    onDeleteConfirm = _ref.onDeleteConfirm,
    classNamePrefix = _ref.classNamePrefix,
    setHolidaysValue = _ref.setHolidaysValue;
  // Hooks
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    editDialogOpen = _useState2[0],
    setEditDialogOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    newDialogOpen = _useState4[0],
    setNewDialogOpen = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    holidayToEdit = _useState6[0],
    setHolidayToEdit = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    holidayToDelete = _useState8[0],
    setHolidayToDelete = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    deleteDialogOpen = _useState10[0],
    setDeleteDialogOpen = _useState10[1];
  var _useQueryParamReplace = useQueryParamReplace('sort', ObjectParam),
    _useQueryParamReplace2 = _slicedToArray(_useQueryParamReplace, 1),
    sortUrlParam = _useQueryParamReplace2[0];
  var t = useTranslate();
  var scheduleMode = mode === 'createSchedule' ? 'ON' : 'OFF';
  var sortByFromParams = useMemo(function () {
    return sortUrlParam ? [sortUrlParam] : DEFAULT_SORT;
  }, [sortUrlParam]);
  var newScheduleHolidays = useMemo(function () {
    return sortHolidays(values === null || values === void 0 ? void 0 : values.holidays, sortByFromParams);
  }, [values === null || values === void 0 ? void 0 : values.holidays, sortByFromParams]);
  var holidaysExtended = useMemo(function () {
    return sortHolidays(holidays, sortByFromParams);
  }, [holidays, sortByFromParams]);
  var columns = useMemo(function () {
    return [{
      Header: t('Name'),
      accessor: 'name',
      width: '40%',
      Cell: function Cell(_ref2) {
        var value = _ref2.value;
        return jsx(TextCell$1, {
          children: value
        });
      }
    }, {
      Header: t('Date'),
      accessor: 'interval',
      width: '60%',
      Cell: function Cell(_ref3) {
        var value = _ref3.value;
        var interval = value === null || value === void 0 ? void 0 : value.split('/');
        if (interval) {
          var date1 = moment(interval[0]).format(DATE_FORMAT_1);
          var date2 = moment(interval[1]).format(DATE_FORMAT_1);
          var date1Details = moment(interval[0]).format(DATE_FORMAT_3);
          var date2Details = moment(interval[1]).format(DATE_FORMAT_3);
          var formattedDate = "".concat(date1, " ").concat(date1 !== date2 ? " - ".concat(date2) : '');
          var formattedDateDetails = "".concat(date1Details, " - ").concat(date2Details);
          return jsx(TextCell$1, {
            title: formattedDateDetails,
            component: "time",
            children: formattedDate
          });
        } else {
          return jsx(Typography, {
            children: value
          });
        }
      }
    }, {
      Header: t('Actions'),
      disableSortBy: true,
      Cell: function Cell(_ref4) {
        var row = _ref4.row;
        return jsx(DataTableRowActions, {
          label: t('holiday'),
          onEditClick: mode === 'createSchedule' ? function () {
            setHolidayToEdit(row.original);
            setEditDialogOpen(true);
          } : undefined,
          onDeleteClick: function onDeleteClick() {
            setHolidayToDelete(row.original);
            setDeleteDialogOpen(true);
          }
        });
      }
    }];
  }, [mode, t]);
  return jsxs(Fragment, {
    children: [jsx(Dialog, {
      open: editDialogOpen,
      title: t('Edit holiday details'),
      onClose: function onClose() {
        return setEditDialogOpen(false);
      },
      children: jsx(HolidayEditorDialog, {
        mode: 'update',
        scheduleMode: scheduleMode,
        holiday: holidayToEdit,
        formValues: values,
        onCancel: function onCancel() {
          return setEditDialogOpen(false);
        },
        onSubmit: onHolidayEditSubmit,
        setHolidaysValue: setHolidaysValue,
        scheduleDetails: scheduleDetails
      })
    }), jsx(Dialog, {
      open: newDialogOpen,
      title: t('New holiday'),
      onClose: function onClose() {
        return setNewDialogOpen(false);
      },
      children: jsx(HolidayEditorDialog, {
        scheduleMode: scheduleMode,
        mode: 'create',
        formValues: values,
        onCancel: function onCancel() {
          return setNewDialogOpen(false);
        },
        onSubmit: onHolidayCreateSubmit,
        setHolidaysValue: setHolidaysValue,
        scheduleDetails: scheduleDetails
      })
    }), jsx(Dialog, {
      onClose: function onClose() {
        return setDeleteDialogOpen(false);
      },
      title: t('Confirm delete'),
      open: deleteDialogOpen,
      children: jsx(ConfirmDeleteDialog, {
        onClose: function onClose() {
          return setDeleteDialogOpen(false);
        },
        onConfirm: function () {
          var _onConfirm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
            var updatedHolidayValues, _scheduleDetails$holi, holidayIndexToReplace, updatedHolidays;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  if (mode === 'createSchedule') {
                    updatedHolidayValues = values.holidays.filter(function (holiday) {
                      return holiday.name !== holidayToDelete.name && holiday.interval !== holidayToDelete.interval;
                    });
                    onDeleteConfirm(updatedHolidayValues);
                  } else {
                    holidayIndexToReplace = scheduleDetails === null || scheduleDetails === void 0 ? void 0 : (_scheduleDetails$holi = scheduleDetails.holidays) === null || _scheduleDetails$holi === void 0 ? void 0 : _scheduleDetails$holi.findIndex(function (h) {
                      return h.name === (holidayToDelete === null || holidayToDelete === void 0 ? void 0 : holidayToDelete.name) && h.interval === (holidayToDelete === null || holidayToDelete === void 0 ? void 0 : holidayToDelete.interval);
                    });
                    updatedHolidays = _toConsumableArray((scheduleDetails === null || scheduleDetails === void 0 ? void 0 : scheduleDetails.holidays) || []);
                    if (holidayIndexToReplace !== undefined && holidayIndexToReplace !== -1) {
                      updatedHolidays.splice(holidayIndexToReplace, 1);
                    }
                    onDeleteConfirm(updatedHolidays);
                  }
                case 1:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          function onConfirm() {
            return _onConfirm.apply(this, arguments);
          }
          return onConfirm;
        }(),
        children: t('Are you sure you want to remove the holiday %{holidayName}?', {
          holidayName: holidayToDelete === null || holidayToDelete === void 0 ? void 0 : holidayToDelete.name
        })
      })
    }), mode === 'createSchedule' ? values.holidays.length > 0 ? jsx("div", {
      style: {
        marginTop: tokens.spacing04
      },
      children: jsx(DataTable$1, {
        classNamePrefix: classNamePrefix,
        "data-testid": "createSchedule-holiday-table",
        data: newScheduleHolidays,
        useSelection: false,
        showSearch: false,
        showPagination: false,
        tableId: "createScheduleHolidaysTable",
        extraToolbarContent: jsx(Button, {
          leadingIcon: jsx(AddOutlinedIcon, {}),
          variant: "secondary",
          onClick: function onClick() {
            return setNewDialogOpen(true);
          },
          children: t('Add holiday')
        }),
        columns: columns,
        defaultSort: [{
          id: 'name',
          direction: 'asc'
        }]
      })
    }) : jsx(TablePageEmptyState$1, {
      style: {
        top: 0
      },
      icon: jsx(CalendarFilledIcon, {}),
      actions: jsx(Button, {
        leadingIcon: jsx(AddOutlinedIcon, {}),
        variant: "secondary",
        id: "addNewHoliday",
        onClick: function onClick() {
          return setNewDialogOpen(true);
        },
        children: t('Add holiday')
      }),
      title: t('No holidays'),
      children: t("Holidays' schedules you create will appear here.")
    }) : holidaysExtended && jsx(DataTable$1, {
      classNamePrefix: classNamePrefix,
      data: holidaysExtended,
      useSelection: false,
      showSearch: false,
      showPagination: false,
      "data-testid": "scheduleDetailsHolidaysTable",
      tableId: "scheduleDetailsHolidaysTable",
      extraToolbarContent: jsx(Button, {
        leadingIcon: jsx(AddOutlinedIcon, {}),
        variant: "secondary",
        onClick: function onClick() {
          return setNewDialogOpen(true);
        },
        children: t('Add holiday')
      }),
      onRowClick: function onRowClick(clickedRowId) {
        var holiday = holidaysExtended === null || holidaysExtended === void 0 ? void 0 : holidaysExtended.find(function (holiday) {
          return holiday.id === clickedRowId;
        });
        setHolidayToEdit(holiday);
        setEditDialogOpen(true);
      },
      columns: columns,
      defaultSort: DEFAULT_SORT
    })]
  });
};

var styles$4 = {"field":"ua-common_10-0-0_TimeAutocomplete__field__8a636","inputClasses":"ua-common_10-0-0_TimeAutocomplete__inputClasses__8a636","timeAutocomplete":"ua-common_10-0-0_TimeAutocomplete__timeAutocomplete__8a636","inputFieldError":"ua-common_10-0-0_TimeAutocomplete__inputFieldError__8a636","option":"ua-common_10-0-0_TimeAutocomplete__option__8a636","popper":"ua-common_10-0-0_TimeAutocomplete__popper__8a636","hours":"ua-common_10-0-0_TimeAutocomplete__hours__8a636","listBox":"ua-common_10-0-0_TimeAutocomplete__listBox__8a636"};

var TIME_TYPE;
(function (TIME_TYPE) {
  TIME_TYPE["HOURS"] = "HOURS";
  TIME_TYPE["MINUTES"] = "MINUTES";
  TIME_TYPE["AMPM"] = "AMPM";
})(TIME_TYPE || (TIME_TYPE = {}));
var TimeAutocomplete = function TimeAutocomplete(_ref) {
  var type = _ref.type,
    value = _ref.value,
    _onChange = _ref.onChange,
    _ref$errors = _ref.errors,
    errors = _ref$errors === void 0 ? false : _ref$errors,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    id = _ref.id,
    name = _ref.name;
  var getTypedOption = function getTypedOption(value) {
    if (value !== '0' && value.length === 1) {
      return "0".concat(value);
    } else if (value.length > 2 && value.startsWith('0')) {
      return value.substring(1);
    }
    return value.substring(0, 2);
  };
  var fetchTimeOptions = useCallback(function () {
    return type === TIME_TYPE.HOURS ? range(1, 13, 1).map(function (option) {
      return option < 10 ? "0".concat(option) : option.toString();
    }) : range(0, 60, 5).map(function (option) {
      return option < 10 ? "0".concat(option) : option.toString();
    });
  }, [type]);
  return jsx(AutoComplete, {
    id: id,
    "data-testid": "data-testid-".concat(id),
    className: clsx(styles$4.timeAutocomplete, styles$4.field, errors && styles$4.error),
    fetchOptions: function fetchOptions() {
      return Promise.resolve(fetchTimeOptions());
    },
    freeSolo: true,
    disableClearable: true,
    placeholder: '00',
    style: {
      width: 40
    },
    forcePopupIcon: false,
    value: value,
    inputValue: value,
    disabled: disabled,
    classes: {
      option: styles$4.option,
      listbox: clsx(styles$4.listBox, type === TIME_TYPE.HOURS && styles$4.hours),
      popper: clsx(styles$4.popper, type === TIME_TYPE.HOURS && styles$4.hours)
    },
    onChange: _onChange,
    getOptionSelected: function getOptionSelected(option) {
      return option === value;
    },
    renderInput: function renderInput(params) {
      return jsx(AutocompleteTextField$1, _objectSpread2(_objectSpread2({}, params), {}, {
        freeSolo: true,
        fullWidth: true,
        name: name,
        onChange: function onChange(val) {
          _onChange(val.target.value ? getTypedOption(val.target.value) : '');
        },
        placeholder: '00',
        disabled: disabled,
        InputProps: _objectSpread2(_objectSpread2({}, params.InputProps), {}, {
          autoComplete: 'off' // disable autocomplete and autofill
        }),
        inputProps: _objectSpread2(_objectSpread2({}, params.inputProps), {}, {
          autoComplete: 'off',
          'data-lpignore': true
        }),
        inputClasses: clsx(styles$4.inputClasses, errors && styles$4.inputFieldError)
      }));
    },
    renderOption: function renderOption(option) {
      return jsx(Typography, {
        tag: "span",
        "data-testid": option,
        children: option
      }, "".concat(option));
    }
  });
};

var MERIDIEM = ['AM', 'PM'];

var useTimeFunctions = function useTimeFunctions() {
  var getHour = function getHour(date) {
    return date.split(':')[0];
  };
  var getMin = function getMin(date) {
    return date.split(':')[1].split(' ')[0];
  };
  var getMeridiem = function getMeridiem(date) {
    return date.split(' ')[1];
  };
  var get24Time = function get24Time(date) {
    var endTimeHour = 0;
    var hour = date < '10' ? parseInt(getHour(date)[1]) : parseInt(getHour(date));
    var min = getMin(date);
    var meridiem = getMeridiem(date);
    if (meridiem === 'PM' && hour < 12) {
      endTimeHour = hour + 12;
    } else if (meridiem === 'AM' && hour === 12) {
      endTimeHour = hour - 12;
    } else {
      endTimeHour = hour;
    }
    var timeHour = endTimeHour < 10 ? "0".concat(endTimeHour) : endTimeHour.toString();
    return "".concat(timeHour, ":").concat(min);
  };
  return {
    getHour: getHour,
    getMin: getMin,
    getMeridiem: getMeridiem,
    get24Time: get24Time
  };
};

var useTimeValidations = function useTimeValidations() {
  var _useTimeFunctions = useTimeFunctions(),
    getMin = _useTimeFunctions.getMin,
    getHour = _useTimeFunctions.getHour,
    get24Time = _useTimeFunctions.get24Time;
  var validateEndDateTime = useCallback(function (endDate, startDate) {
    var startDateTime = get24Time(startDate);
    var endDateTime = get24Time(endDate);
    return startDateTime < endDateTime;
  }, [get24Time]);
  var validateHourRange = useCallback(function (date) {
    var hours = getHour(date);
    return parseInt(hours) <= 12 && parseInt(hours) >= 1;
  }, [getHour]);
  var validateMinRange = useCallback(function (date) {
    var minutes = getMin(date);
    return parseInt(minutes) <= 59 && parseInt(minutes) >= 0;
  }, [getMin]);
  return {
    validateEndDateTime: validateEndDateTime,
    validateHourRange: validateHourRange,
    validateMinRange: validateMinRange
  };
};

var styles$3 = {"meridiemSelector":"ua-common_10-0-0_ScheduleListView__meridiemSelector__6a613"};

var SetTimeRangesValues = function SetTimeRangesValues(_ref) {
  var mode = _ref.mode;
  var _useFormikContext = useFormikContext(),
    isValid = _useFormikContext.isValid,
    values = _useFormikContext.values,
    initialValues = _useFormikContext.initialValues,
    handleSubmit = _useFormikContext.handleSubmit,
    submitForm = _useFormikContext.submitForm;
  useEffect(function () {
    if (mode === 'createSchedule' && !isEqual(initialValues, values)) {
      submitForm();
    }
  }, [isValid, handleSubmit, submitForm, mode, initialValues, values]);
  return null;
};
var ScheduleListView = function ScheduleListView(_ref2) {
  var _formValues$timeRange, _scheduleDetails$time;
  var onClose = _ref2.onClose,
    formValues = _ref2.formValues,
    mode = _ref2.mode,
    scheduleDetails = _ref2.scheduleDetails,
    _ref2$listViewInEdito = _ref2.listViewInEditorDialog,
    listViewInEditorDialog = _ref2$listViewInEdito === void 0 ? false : _ref2$listViewInEdito,
    onSubmit = _ref2.onSubmit;
  var t = useTranslate();
  var validateDate = function validateDate(date) {
    return moment(date, HOUR_FORMAT_1, true).isValid();
  };
  var displayErrorStartDate = function displayErrorStartDate(fk, index) {
    var _fk$errors$timeRanges;
    return ((_fk$errors$timeRanges = fk.errors.timeRanges) === null || _fk$errors$timeRanges === void 0 ? void 0 : _fk$errors$timeRanges[index]) && isString(fk.errors.timeRanges[index].startDate);
  };
  var displayErrorEndDate = function displayErrorEndDate(fk, index) {
    var _fk$errors$timeRanges2;
    return ((_fk$errors$timeRanges2 = fk.errors.timeRanges) === null || _fk$errors$timeRanges2 === void 0 ? void 0 : _fk$errors$timeRanges2[index]) && isString(fk.errors.timeRanges[index].endDate);
  };
  var _useTimeFunctions = useTimeFunctions(),
    getMin = _useTimeFunctions.getMin,
    getHour = _useTimeFunctions.getHour,
    getMeridiem = _useTimeFunctions.getMeridiem;
  var _useTimeValidations = useTimeValidations(),
    validateEndDateTime = _useTimeValidations.validateEndDateTime,
    validateHourRange = _useTimeValidations.validateHourRange,
    validateMinRange = _useTimeValidations.validateMinRange;
  var getNewTimeValue = useCallback(function (type, initialTime, option) {
    var newTimeValue = '';
    if (type === TIME_TYPE.HOURS) {
      var min = initialTime.split(':')[1];
      var hour = option;
      newTimeValue = "".concat(hour.concat(":".concat(min)));
    } else if (type === TIME_TYPE.MINUTES) {
      var _min = option;
      var _hour = getHour(initialTime);
      var meridiem = getMeridiem(initialTime);
      newTimeValue = "".concat(_hour.concat(":".concat(_min, " ").concat(meridiem)));
    } else if (type === TIME_TYPE.AMPM) {
      var time = initialTime.split(' ')[0];
      var _meridiem = option;
      newTimeValue = "".concat(time.concat(" ".concat(_meridiem)));
    }
    return newTimeValue;
  }, [getHour, getMeridiem]);
  var _onChange = function onChange(_ref3) {
    var type = _ref3.type,
      field = _ref3.field,
      val = _ref3.val,
      option = _ref3.option,
      fk = _ref3.fk,
      index = _ref3.index;
    if (option) {
      var newtime = getNewTimeValue(type, fk.values.timeRanges[index][field], option);
      fk.setFieldValue("timeRanges.".concat(index, ".").concat(field), newtime);
    } else if (val && ONLY_NUMBERS_REGEXP.test(val) || isEmpty(val)) {
      var typedOption = isEmpty(val) ? '' : val;
      var _newtime = getNewTimeValue(type, fk.values.timeRanges[index][field], typedOption);
      fk.setFieldValue("timeRanges.".concat(index, ".").concat(field), _newtime);
    }
  };
  // Validation schema
  var Schema = Yup.object().shape({
    timeRanges: Yup.array().of(Yup.object().shape({
      allDay: Yup["boolean"]().required(t('Required')),
      day: Yup.number().required(t('Required')),
      startDate: Yup.string().typeError(t('Required')).when('allDay', {
        is: false,
        then: Yup.string().required(t('Valid date is required.')).test('validate-hour-range', t('Hours must be between 1 and 12'), validateHourRange).test('validate-min-range', t('Minutes must be between 0 and 59'), validateMinRange).test('start-date-valid', t("Format 'hh:mm A' is required."), validateDate).when('endDate', function (endDate, schema) {
          return endDate && schema.test('endDate-validation', t('The start time must be earlier than the end time.'), function (date) {
            return validateEndDateTime(endDate, date);
          });
        })
      }).when('allDay', {
        is: true,
        then: Yup.string().nullable()
      }).nullable(),
      endDate: Yup.string().typeError(t('Required')).when('allDay', {
        is: false,
        then: Yup.string().required(t('Valid date is required.')).test('validate-hour-range', t('Hours must be between 1 and 12'), validateHourRange).test('validate-min-range', t('Minutes must be between 0 and 59'), validateMinRange).test('end-date-valid', t("Format 'hh:mm A' is required."), validateDate).when('startDate', function (startDate, schema) {
          return startDate && schema.test('endDate-validation', t('The start time must be earlier than the end time.'), function (date) {
            return validateEndDateTime(date, startDate);
          });
        })
      }).when('allDay', {
        is: true,
        then: Yup.string().nullable()
      }).nullable()
    }))
  });
  var initialValues = mode === 'createSchedule' ? {
    timeRanges: (_formValues$timeRange = formValues.timeRanges) === null || _formValues$timeRange === void 0 ? void 0 : _formValues$timeRange.map(function (_ref4, i) {
      var startSeconds = _ref4.startSeconds,
        endSeconds = _ref4.endSeconds;
      var _schedulerTimeRange = schedulerTimeRange(startSeconds, endSeconds),
        startDate = _schedulerTimeRange.startDate,
        endDate = _schedulerTimeRange.endDate;
      return {
        allDay: Number(endDate) - Number(startDate) === 86400000,
        day: startDate.day(),
        startDate: startDate.format(HOUR_FORMAT_1),
        endDate: endDate.format(HOUR_FORMAT_1),
        id: i
      };
    })
  } : {
    timeRanges: scheduleDetails === null || scheduleDetails === void 0 ? void 0 : (_scheduleDetails$time = scheduleDetails.timeRanges) === null || _scheduleDetails$time === void 0 ? void 0 : _scheduleDetails$time.map(function (_ref5, i) {
      var startSeconds = _ref5.startSeconds,
        endSeconds = _ref5.endSeconds;
      var _schedulerTimeRange2 = schedulerTimeRange(startSeconds, endSeconds),
        startDate = _schedulerTimeRange2.startDate,
        endDate = _schedulerTimeRange2.endDate;
      return {
        allDay: Number(endDate) - Number(startDate) === 86400000,
        day: startDate.day(),
        startDate: startDate.format(HOUR_FORMAT_1),
        endDate: endDate.format(HOUR_FORMAT_1),
        id: i
      };
    })
  };
  return jsx(Formik, {
    initialValues: _objectSpread2({}, initialValues),
    isInitialValid: false,
    validateOnBlur: true,
    validationSchema: Schema,
    onSubmit: onSubmit,
    enableReinitialize: true,
    validateOnMount: true,
    children: function children(fk) {
      return jsxs(Form, {
        style: {
          marginTop: 16,
          maxWidth: 800
        },
        noValidate: true,
        autoComplete: "off",
        "data-testid": "schedule-list-view-form",
        children: [jsx(FieldArray, {
          name: "timeRanges",
          render: function render(arrayHelpers) {
            var _fk$values, _fk$values$timeRanges, _fk$values$timeRanges2, _fk$values2;
            return jsxs(Fragment, {
              children: [(_fk$values = fk.values) === null || _fk$values === void 0 ? void 0 : (_fk$values$timeRanges = _fk$values.timeRanges) === null || _fk$values$timeRanges === void 0 ? void 0 : _fk$values$timeRanges.map(function (timeRange, index) {
                var _fk$errors$timeRanges3, _fk$errors, _fk$errors$timeRanges4, _fk$errors$timeRanges5, _fk$errors2, _fk$errors2$timeRange;
                return jsxs("div", {
                  style: {
                    marginBottom: tokens.spacing02
                  },
                  children: [jsxs("div", {
                    style: {
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: fk.errors ? 0 : 4,
                      justifyContent: 'center',
                      flexWrap: 'nowrap',
                      gap: "0 ".concat(tokens.spacing02)
                    },
                    children: [jsx("div", {
                      style: {
                        minWidth: 164
                      },
                      children: jsx(Select, {
                        fullwidth: true,
                        onChange: function onChange(e) {
                          return fk.setFieldValue("timeRanges.".concat(index, ".day"), e.target.value);
                        },
                        "data-testid": "select-day-testid-".concat(index),
                        size: "large",
                        inDialog: true,
                        value: "".concat(fk.values.timeRanges[index].day),
                        children: [0, 1, 2, 3, 4, 5, 6].map(function (i) {
                          return jsx(Option, {
                            value: i,
                            children: moment(i, 'e').startOf('week').isoWeekday(i).format('dddd')
                          }, i);
                        })
                      })
                    }), jsxs("div", {
                      style: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: tokens.spacing02
                      },
                      children: [jsx("div", {
                        style: {
                          marginTop: tokens.spacing00
                        },
                        children: jsx(Typography, {
                          color: "type-color-secondary",
                          children: t('from')
                        })
                      }), jsx(TimeAutocomplete, {
                        id: "startDateHoursInput.".concat(index),
                        name: "startDateHoursInput.".concat(index),
                        type: TIME_TYPE.HOURS,
                        value: getHour(fk.values.timeRanges[index].startDate),
                        onChange: function onChange(val, option) {
                          return _onChange({
                            type: TIME_TYPE.HOURS,
                            option: option,
                            val: val,
                            index: index,
                            fk: fk,
                            field: 'startDate'
                          });
                        },
                        disabled: fk.values.timeRanges[index].allDay,
                        "data-testid": "startDateHoursInput.".concat(index),
                        errors: displayErrorStartDate(fk, index)
                      }), jsx(Typography, {
                        color: "type-color-secondary",
                        children: ':'
                      }), jsx(TimeAutocomplete, {
                        id: "startDateMinInput.".concat(index),
                        name: "startDateMinInput.".concat(index),
                        type: TIME_TYPE.MINUTES,
                        value: getMin(fk.values.timeRanges[index].startDate),
                        onChange: function onChange(val, option) {
                          return _onChange({
                            type: TIME_TYPE.MINUTES,
                            option: option,
                            val: val,
                            index: index,
                            fk: fk,
                            field: 'startDate'
                          });
                        },
                        disabled: fk.values.timeRanges[index].allDay,
                        "data-testid": "startDateMinInput.".concat(index),
                        errors: displayErrorStartDate(fk, index)
                      }), jsx(Select, {
                        fitContent: true,
                        className: styles$3.meridiemSelector,
                        onChange: function onChange(e) {
                          var option = e.target.value;
                          var newtime = getNewTimeValue(TIME_TYPE.AMPM, fk.values.timeRanges[index].startDate, option);
                          fk.setFieldValue("timeRanges.".concat(index, ".startDate"), newtime);
                        },
                        "data-testid": "startDateMeridiemSelector-".concat(index),
                        inDialog: true,
                        value: getMeridiem(fk.values.timeRanges[index].startDate),
                        children: MERIDIEM.map(function (meridiem) {
                          return jsx(Option, {
                            "data-testid": "option-startDate-meridiem-testid-".concat(index),
                            value: meridiem,
                            children: meridiem
                          }, meridiem);
                        })
                      })]
                    }), jsxs("div", {
                      style: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: tokens.spacing02
                      },
                      children: [jsx("div", {
                        style: {
                          marginTop: tokens.spacing00
                        },
                        children: jsx(Typography, {
                          color: "type-color-secondary",
                          children: t('to')
                        })
                      }), jsx(TimeAutocomplete, {
                        type: TIME_TYPE.HOURS,
                        id: "endDateHoursInput.".concat(index),
                        name: "endDateHoursInput.".concat(index),
                        value: getHour(fk.values.timeRanges[index].endDate),
                        onChange: function onChange(val, option) {
                          return _onChange({
                            type: TIME_TYPE.HOURS,
                            option: option,
                            val: val,
                            index: index,
                            fk: fk,
                            field: 'endDate'
                          });
                        },
                        disabled: fk.values.timeRanges[index].allDay,
                        "data-testid": "endDateHoursInput.".concat(index),
                        errors: displayErrorEndDate(fk, index)
                      }), jsx(Typography, {
                        color: "type-color-secondary",
                        children: ':'
                      }), jsx(TimeAutocomplete, {
                        type: TIME_TYPE.MINUTES,
                        id: "endDateMinInput.".concat(index),
                        name: "endDateMinInput.".concat(index),
                        value: getMin(fk.values.timeRanges[index].endDate),
                        onChange: function onChange(val, option) {
                          return _onChange({
                            type: TIME_TYPE.MINUTES,
                            option: option,
                            val: val,
                            index: index,
                            fk: fk,
                            field: 'endDate'
                          });
                        },
                        disabled: fk.values.timeRanges[index].allDay,
                        "data-testid": "endDateMinInput.".concat(index),
                        errors: displayErrorEndDate(fk, index)
                      }), jsx(Select, {
                        className: styles$3.meridiemSelector,
                        onChange: function onChange(e) {
                          var option = e.target.value;
                          var newtime = getNewTimeValue(TIME_TYPE.AMPM, fk.values.timeRanges[index].endDate, option);
                          fk.setFieldValue("timeRanges.".concat(index, ".endDate"), newtime);
                        },
                        "data-testid": "endDateMeridiemSelector-".concat(index),
                        fitContent: true,
                        inDialog: true,
                        value: getMeridiem(fk.values.timeRanges[index].endDate),
                        children: MERIDIEM.map(function (meridiem) {
                          return jsx(Option, {
                            "data-testid": "option-endDate-meridiem-testid-".concat(index),
                            value: meridiem,
                            children: meridiem
                          }, meridiem);
                        })
                      })]
                    }), jsx("div", {
                      style: {
                        minWidth: 93,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      },
                      children: jsx(Checkbox, {
                        name: "timeRanges.".concat(index, ".allDay"),
                        "data-testid": "allDayCheckbox-timeRanges.".concat(index),
                        checked: fk.values.timeRanges[index].allDay || false,
                        onClick: function onClick() {
                          return fk.setFieldValue("timeRanges.".concat(index, ".allDay"), !fk.values.timeRanges[index].allDay);
                        },
                        children: t('All day')
                      })
                    }), jsx("div", {
                      style: {
                        display: 'flex',
                        alignItems: 'center'
                      },
                      children: jsxs(Fragment, {
                        children: [jsx(IconButton, {
                          id: "remove-time-btn",
                          label: t('Remove time'),
                          "data-testid": "icon-delete-testid",
                          disabled: fk.isSubmitting,
                          onClick: function onClick() {
                            return arrayHelpers.remove(index);
                          },
                          children: jsx(CloseCircleFilledIcon, {})
                        }), jsx(Tooltip, {
                          position: "right-center",
                          triggerId: "remove-time-btn",
                          children: t('Remove time')
                        })]
                      })
                    })]
                  }, timeRange.id), jsxs("div", {
                    style: {
                      display: 'flex',
                      justifyContent: 'flex-start'
                    },
                    children: [jsx("div", {
                      style: {
                        position: 'relative',
                        left: 161
                      },
                      children: (_fk$errors$timeRanges3 = fk.errors.timeRanges) !== null && _fk$errors$timeRanges3 !== void 0 && _fk$errors$timeRanges3[index] && isString(fk.errors.timeRanges[index].startDate) ? jsx(Typography, {
                        variant: "caption-medium",
                        color: "danger-01",
                        children: (_fk$errors = fk.errors) === null || _fk$errors === void 0 ? void 0 : (_fk$errors$timeRanges4 = _fk$errors.timeRanges) === null || _fk$errors$timeRanges4 === void 0 ? void 0 : _fk$errors$timeRanges4[index].startDate
                      }) : jsx("div", {
                        style: {
                          width: 205
                        }
                      })
                    }), jsx("div", {
                      style: {
                        position: 'relative',
                        left: 196
                      },
                      children: ((_fk$errors$timeRanges5 = fk.errors.timeRanges) === null || _fk$errors$timeRanges5 === void 0 ? void 0 : _fk$errors$timeRanges5[index]) && isString(fk.errors.timeRanges[index].endDate) && jsx(Typography, {
                        variant: "caption-medium",
                        color: "danger-01",
                        children: (_fk$errors2 = fk.errors) === null || _fk$errors2 === void 0 ? void 0 : (_fk$errors2$timeRange = _fk$errors2.timeRanges) === null || _fk$errors2$timeRange === void 0 ? void 0 : _fk$errors2$timeRange[index].endDate
                      })
                    })]
                  })]
                });
              }), jsx(Button, {
                "data-testid": "button-addtime-testid",
                onClick: function onClick() {
                  return arrayHelpers.push({
                    allDay: false,
                    day: 0,
                    startDate: moment().minute(0).format(HOUR_FORMAT_1),
                    endDate: moment().add(1, 'hour').minute(0).format(HOUR_FORMAT_1)
                  });
                },
                disabled: fk.isSubmitting || Object.values((_fk$values$timeRanges2 = (_fk$values2 = fk.values) === null || _fk$values2 === void 0 ? void 0 : _fk$values2.timeRanges) !== null && _fk$values$timeRanges2 !== void 0 ? _fk$values$timeRanges2 : {}).length > 99,
                leadingIcon: jsx(AddOutlinedIcon, {}),
                variant: "tertiary",
                children: t('Add time')
              })]
            });
          }
        }), mode === 'createSchedule' && !listViewInEditorDialog && jsx(SetTimeRangesValues, {
          mode: mode
        }), listViewInEditorDialog && jsxs(DialogActions, {
          children: [jsx(Button, {
            id: "editScheduleCancelBtn",
            variant: "neutral",
            onClick: onClose,
            children: t('Cancel')
          }), jsx(Button, {
            disabled: !fk.isValid || fk.isSubmitting,
            id: "editScheduleSaveBtn",
            type: "submit",
            color: "primary",
            children: t('Save')
          })]
        })]
      });
    }
  });
};

var styles$2 = {"weekDayCell":"ua-common_10-0-0_Scheduler__weekDayCell__998f2","allDay":"ua-common_10-0-0_Scheduler__allDay__998f2","allDayTitleCell":"ua-common_10-0-0_Scheduler__allDayTitleCell__998f2","weekDayLayout":"ua-common_10-0-0_Scheduler__weekDayLayout__998f2","appointment":"ua-common_10-0-0_Scheduler__appointment__998f2","allDayAppointment":"ua-common_10-0-0_Scheduler__allDayAppointment__998f2","scheduler":"ua-common_10-0-0_Scheduler__scheduler__998f2","schedulerContainer":"ua-common_10-0-0_Scheduler__schedulerContainer__998f2","timeScale":"ua-common_10-0-0_Scheduler__timeScale__998f2","timeScaleLabel":"ua-common_10-0-0_Scheduler__timeScaleLabel__998f2","timeTableCell":"ua-common_10-0-0_Scheduler__timeTableCell__998f2","allDayCell":"ua-common_10-0-0_Scheduler__allDayCell__998f2","allDayContainer":"ua-common_10-0-0_Scheduler__allDayContainer__998f2","contextMenu":"ua-common_10-0-0_Scheduler__contextMenu__998f2","popoverPaper":"ua-common_10-0-0_Scheduler__popoverPaper__998f2","editDialog":"ua-common_10-0-0_Scheduler__editDialog__998f2","appointmentContent":"ua-common_10-0-0_Scheduler__appointmentContent__998f2","popover":"ua-common_10-0-0_Scheduler__popover__998f2","overrideContainer":"ua-common_10-0-0_Scheduler__overrideContainer__998f2"};

var _excluded$2 = ["startDate", "endDate"],
  _excluded2 = ["data", "children"],
  _excluded3 = ["startDate", "endDate"];
var Scheduler = function Scheduler(_ref) {
  var setEditDialogOpen = _ref.setEditDialogOpen,
    mode = _ref.mode,
    values = _ref.values,
    editDialogOpen = _ref.editDialogOpen,
    scheduleDetails = _ref.scheduleDetails,
    onListViewSubmit = _ref.onListViewSubmit,
    onSubmit = _ref.onSubmit,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 'auto' : _ref$height;
  // Hooks
  var t = useTranslate();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    schedulerData = _useState2[0],
    setSchedulerData = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    reccurModalOpen = _useState4[0],
    setReccurModalOpen = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    currentAppointSelected = _useState6[0],
    setCurrentAppointSelected = _useState6[1];
  useEffect(function () {
    if (mode === 'createSchedule') {
      if ((values === null || values === void 0 ? void 0 : values.timeRanges.length) !== 0) {
        var _values$timeRanges;
        setSchedulerData((_values$timeRanges = values.timeRanges) === null || _values$timeRanges === void 0 ? void 0 : _values$timeRanges.map(function (_ref2, i) {
          var startSeconds = _ref2.startSeconds,
            endSeconds = _ref2.endSeconds;
          var _schedulerTimeRange = schedulerTimeRange(startSeconds, endSeconds),
            startDate = _schedulerTimeRange.startDate,
            endDate = _schedulerTimeRange.endDate;
          return {
            allDay: Number(endDate) - Number(startDate) === 86400000,
            startDate: startDate,
            endDate: endDate,
            id: i
          };
        }));
      }
    } else {
      if (scheduleDetails) {
        var _scheduleDetails$time;
        setSchedulerData((_scheduleDetails$time = scheduleDetails.timeRanges) === null || _scheduleDetails$time === void 0 ? void 0 : _scheduleDetails$time.map(function (_ref3, i) {
          var startSeconds = _ref3.startSeconds,
            endSeconds = _ref3.endSeconds;
          var _schedulerTimeRange2 = schedulerTimeRange(startSeconds, endSeconds),
            startDate = _schedulerTimeRange2.startDate,
            endDate = _schedulerTimeRange2.endDate;
          return {
            allDay: Number(endDate) - Number(startDate) === 86400000,
            startDate: startDate,
            endDate: endDate,
            id: i
          };
        }));
      }
    }
  }, [mode, scheduleDetails, values === null || values === void 0 ? void 0 : values.timeRanges]);
  var WeekDayCell = function WeekDayCell(_ref4) {
    var otherProps = _extends$4({}, (_objectDestructuringEmpty(_ref4), _ref4));
    return jsx(WeekView.DayScaleCell, _objectSpread2(_objectSpread2({}, otherProps), {}, {
      className: styles$2.weekDayCell,
      formatDate: function formatDate(date, options) {
        var momentDate = moment(date);
        var weekday = options.weekday;
        return jsx(Typography, {
          color: "type-color-inverted",
          variant: "caption-default-02",
          children: weekday && momentDate.format('dddd')
        });
      }
    }));
  };
  var WeekDayLayout = function WeekDayLayout(_ref5) {
    var otherProps = _extends$4({}, (_objectDestructuringEmpty(_ref5), _ref5));
    return jsx(WeekView.DayScaleLayout, _objectSpread2(_objectSpread2({}, otherProps), {}, {
      className: styles$2.weekDayLayout
    }));
  };
  var onCommitChanges = useCallback(function (_ref6) {
    var changed = _ref6.changed;
    if (changed) {
      var newSchedulerData = schedulerData === null || schedulerData === void 0 ? void 0 : schedulerData.map(function (appointment) {
        return changed[appointment.id] ? _objectSpread2(_objectSpread2({}, appointment), changed[appointment.id]) : appointment;
      });
      setSchedulerData(newSchedulerData);
      onSubmit(newSchedulerData);
    }
  }, [setSchedulerData, onSubmit, schedulerData]);
  var onDelete = useCallback(function (data) {
    var newSchedulerData = schedulerData === null || schedulerData === void 0 ? void 0 : schedulerData.filter(function (appointment) {
      return appointment.id !== data.id;
    });
    setSchedulerData(newSchedulerData);
    onSubmit(newSchedulerData);
  }, [onSubmit, schedulerData]);
  var duplicateAppointment = useCallback(function (data) {
    var startingAddedId = schedulerData.length > 0 ? (schedulerData === null || schedulerData === void 0 ? void 0 : schedulerData[schedulerData.length - 1].id) + 1 : 0;
    var day = data.startDate.day();
    var appointmentToAdd = {
      allDay: data.allDay,
      startDate: day === 6 ? data.startDate.clone().subtract(6, 'd') : data.startDate.clone().add(1, 'd'),
      endDate: day === 6 ? data.endDate.clone().subtract(6, 'd') : data.endDate.clone().add(1, 'd')
    };
    var newSchedulerData = [].concat(_toConsumableArray(schedulerData || []), [_objectSpread2({
      id: startingAddedId
    }, appointmentToAdd)]);
    setSchedulerData(newSchedulerData);
    onSubmit(newSchedulerData);
    setCurrentAppointSelected(undefined);
  }, [onSubmit, schedulerData]);
  var TimeTableCell = function TimeTableCell(_ref7) {
    var startDate = _ref7.startDate,
      endDate = _ref7.endDate,
      restProps = _objectWithoutProperties(_ref7, _excluded$2);
    var t = useTranslate();
    var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      contextMenuOpen = _useState8[0],
      setContextMenuOpen = _useState8[1];
    var createNewAppointment = useCallback(function () {
      if (!endDate) {
        return;
      }
      var startingAddedId = schedulerData.length > 0 ? (schedulerData === null || schedulerData === void 0 ? void 0 : schedulerData[schedulerData.length - 1].id) + 1 : 0;
      var added = {
        startDate: startDate,
        endDate: endDate.setHours(endDate.getHours())
      };
      var newSchedulerData = [].concat(_toConsumableArray(schedulerData || []), [_objectSpread2({
        id: startingAddedId
      }, added)]);
      setSchedulerData(newSchedulerData);
      onSubmit(newSchedulerData);
    }, [endDate, startDate]);
    var pasteAppointment = useCallback(function () {
      if (!startDate) {
        return;
      }
      if (!currentAppointSelected) {
        return;
      }
      var startingAddedId = schedulerData.length > 0 ? (schedulerData === null || schedulerData === void 0 ? void 0 : schedulerData[schedulerData.length - 1].id) + 1 : 0;
      var startDateDay = startDate.getDay();
      var currentAppointmentDay = moment(currentAppointSelected.endDate).day();
      var dayDiff = startDateDay - currentAppointmentDay;
      var newStartDate = new Date(currentAppointSelected.startDate);
      var newEndDate = new Date(currentAppointSelected.endDate);
      var getNewDate = function getNewDate(date) {
        return date.setDate(date.getDate() + dayDiff);
      };
      var appointmentToAdd = {
        startDate: currentAppointSelected.allDay ? startDate : new Date(getNewDate(newStartDate)),
        endDate: currentAppointSelected.allDay ? endDate : getNewDate(newEndDate),
        allDay: currentAppointSelected.allDay
      };
      var newSchedulerData = [].concat(_toConsumableArray(schedulerData || []), [_objectSpread2({
        id: startingAddedId
      }, appointmentToAdd)]);
      setSchedulerData(newSchedulerData);
      onSubmit(newSchedulerData);
      setCurrentAppointSelected(undefined);
    }, [endDate, startDate]);
    return jsxs(Fragment, {
      children: [jsx(WeekView.TimeTableCell, _objectSpread2(_objectSpread2({}, restProps), {}, {
        className: styles$2.timeTableCell,
        startDate: startDate,
        endDate: endDate,
        onContextMenu: function onContextMenu(event) {
          event.preventDefault();
          setContextMenuOpen(event.currentTarget);
        },
        onClick: createNewAppointment
      })), jsx(Popover$1, {
        open: !!contextMenuOpen,
        anchorEl: contextMenuOpen,
        PaperProps: {
          className: styles$2.popoverPaper
        },
        onClose: function onClose() {
          return setContextMenuOpen(null);
        },
        anchorOrigin: {
          vertical: 'center',
          horizontal: 'center'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left'
        },
        children: jsxs(Menu, {
          className: styles$2.contextMenu,
          children: [jsx(MenuItem, {
            size: "small",
            "data-testid": "menu-createNew-action",
            onClick: function onClick() {
              setContextMenuOpen(null);
              var startingAddedId = schedulerData.length > 0 ? (schedulerData === null || schedulerData === void 0 ? void 0 : schedulerData[schedulerData.length - 1].id) + 1 : 0;
              if (!endDate) {
                return;
              }
              var added = {
                startDate: startDate,
                endDate: endDate.setHours(endDate.getHours())
              };
              var newSchedulerData = [].concat(_toConsumableArray(schedulerData || []), [_objectSpread2({
                id: startingAddedId
              }, added)]);
              setSchedulerData(newSchedulerData);
              onSubmit(newSchedulerData);
            },
            children: t('Create new')
          }), jsx(MenuItem, {
            size: "small",
            "data-testid": "menu-paste-action",
            onClick: function onClick() {
              setContextMenuOpen(null);
              pasteAppointment();
            },
            disabled: !currentAppointSelected,
            children: t('Paste')
          })]
        })
      })]
    });
  };
  var TimeScaleLabel = function TimeScaleLabel(_ref8) {
    var restProps = _extends$4({}, (_objectDestructuringEmpty(_ref8), _ref8));
    return jsx(WeekView.TimeScaleLabel, _objectSpread2({
      className: styles$2.timeScaleLabel
    }, restProps));
  };
  var TimeScaleLayout = function TimeScaleLayout(_ref9) {
    var restProps = _extends$4({}, (_objectDestructuringEmpty(_ref9), _ref9));
    return jsx(WeekView.TimeScaleLayout, _objectSpread2(_objectSpread2({}, restProps), {}, {
      className: styles$2.timeScale,
      labelComponent: TimeScaleLabel
    }));
  };
  var CustomAppointmentContent = function CustomAppointmentContent(props) {
    return jsx(Appointments.AppointmentContent, _objectSpread2({
      className: styles$2.appointmentContent
    }, props));
  };
  var CustomAppointment = function CustomAppointment(_ref10) {
    var data = _ref10.data,
      children = _ref10.children,
      restProps = _objectWithoutProperties(_ref10, _excluded2);
    var t = useTranslate();
    var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      popoverMenuTrigger = _useState10[0],
      setPopoverMenuTrigger = _useState10[1];
    var getTestid = function getTestid(data) {
      if (data.allDay) {
        return "appointment-".concat(moment(data.startDate).format('dddd'), "-allDay");
      }
      return "appointment-".concat(moment(data.startDate).format('dddd hh:mm A'), "-").concat(moment(data.endDate).format('hh:mm A'));
    };
    return jsxs(Fragment, {
      children: [jsxs(Appointments.Appointment, _objectSpread2(_objectSpread2({
        onClick: function onClick() {
          return setEditDialogOpen(true);
        },
        data: data
      }, restProps), {}, {
        className: clsx(styles$2.appointment, data.allDay && styles$2.allDayAppointment),
        "data-testid": getTestid(data),
        onContextMenu: function onContextMenu(e) {
          e.stopPropagation();
          e.preventDefault();
          setPopoverMenuTrigger(e.currentTarget);
        },
        children: [data.allDay && jsx(Typography, {
          variant: "caption-default-01",
          color: "interactive-color-success-hover",
          children: t('All day')
        }), children]
      })), jsx(Popover$1, {
        open: !!popoverMenuTrigger,
        className: styles$2.popover,
        anchorEl: popoverMenuTrigger,
        onClose: function onClose() {
          return setPopoverMenuTrigger(null);
        },
        anchorOrigin: {
          vertical: 'center',
          horizontal: 'center'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left'
        },
        children: jsxs(Menu, {
          className: styles$2.contextMenu,
          children: [jsx(MenuItem, {
            size: "small",
            "data-testid": "menu-copy-action",
            onClick: function onClick() {
              setPopoverMenuTrigger(null);
              setCurrentAppointSelected(data);
            },
            children: t('Copy')
          }), jsx(MenuItem, {
            size: "small",
            "data-testid": "menu-duplicate-action",
            onClick: function onClick() {
              setPopoverMenuTrigger(null);
              setCurrentAppointSelected(data);
              duplicateAppointment(data);
            },
            children: t('Copy to next day')
          }), jsx(MenuItem, {
            size: "small",
            "data-testid": "menu-recurrence-action",
            onClick: function onClick() {
              setPopoverMenuTrigger(null);
              setCurrentAppointSelected(data);
              setReccurModalOpen(true);
            },
            children: t('Edit recurrence')
          }), jsx(MenuSeparator, {}), jsx(MenuItem, {
            size: "small",
            "data-testid": "menu-delete-action",
            onClick: function onClick() {
              setPopoverMenuTrigger(null);
              onDelete(data);
            },
            variant: "danger",
            children: t('Delete')
          })]
        })
      })]
    });
  };
  var AllDayCell = function AllDayCell(_ref11) {
    var startDate = _ref11.startDate,
      endDate = _ref11.endDate,
      restProps = _objectWithoutProperties(_ref11, _excluded3);
    return jsx(AllDayPanel.Cell, _objectSpread2(_objectSpread2({}, restProps), {}, {
      className: styles$2.allDayCell,
      startDate: startDate,
      endDate: endDate,
      onDoubleClick: function onDoubleClick() {
        var startingAddedId = schedulerData.length > 0 ? (schedulerData === null || schedulerData === void 0 ? void 0 : schedulerData[schedulerData.length - 1].id) + 1 : 0;
        var added = {
          startDate: startDate,
          endDate: endDate,
          allDay: true
        };
        var newSchedulerData = [].concat(_toConsumableArray(schedulerData || []), [_objectSpread2({
          id: startingAddedId
        }, added)]);
        setSchedulerData(newSchedulerData);
        onSubmit(newSchedulerData);
      }
    }));
  };
  var DraftAppointment = function DraftAppointment(_ref12) {
    var restProps = _extends$4({}, (_objectDestructuringEmpty(_ref12), _ref12));
    return jsx(DragDropProvider.DraftAppointment, _objectSpread2(_objectSpread2({}, restProps), {}, {
      className: styles$2.appointment
    }));
  };
  var AllDay = function AllDay(_ref13) {
    var restProps = _extends$4({}, (_objectDestructuringEmpty(_ref13), _ref13));
    return jsx(AllDayPanel.Layout, _objectSpread2(_objectSpread2({}, restProps), {}, {
      className: styles$2.allDay
    }));
  };
  var AllDayTitleCell = function AllDayTitleCell(_ref14) {
    var restProps = _extends$4({}, (_objectDestructuringEmpty(_ref14), _ref14));
    return jsx(AllDayPanel.TitleCell, _objectSpread2(_objectSpread2({}, restProps), {}, {
      className: styles$2.allDayTitleCell
    }));
  };
  var Override = function Override() {
    return jsx("div", {
      className: styles$2.overrideContainer,
      children: jsx(Typography, {
        variant: "heading-large",
        children: mode === 'createSchedule' ? (values === null || values === void 0 ? void 0 : values.overrideState) === 'OPEN' ? t('All hours open') : t('All hours closed') : (scheduleDetails === null || scheduleDetails === void 0 ? void 0 : scheduleDetails.overrideState) === 'OPEN' ? t('All hours open') : t('All hours closed')
      })
    });
  };
  return jsxs(Fragment, {
    children: [jsx(Dialog, {
      size: "md",
      className: styles$2.editDialog,
      open: editDialogOpen,
      title: t('Edit schedule'),
      onClose: function onClose() {
        return setEditDialogOpen(false);
      },
      children: jsx(ScheduleListView, {
        scheduleDetails: scheduleDetails,
        formValues: values,
        mode: mode,
        listViewInEditorDialog: true,
        onClose: function onClose() {
          return setEditDialogOpen(false);
        },
        onSubmit: onListViewSubmit
      })
    }), jsx("div", {
      className: styles$2.scheduler,
      children: jsxs("div", {
        className: styles$2.schedulerContainer,
        children: [mode === 'createSchedule' ? (values === null || values === void 0 ? void 0 : values.overrideState) !== 'NONE' && jsx(Override, {}) : (scheduleDetails === null || scheduleDetails === void 0 ? void 0 : scheduleDetails.overrideState) !== 'NONE' && jsx(Override, {}), jsxs(Scheduler$1, {
          height: height,
          data: schedulerData,
          children: [jsx(ViewState, {
            currentDate: new Date().toISOString().slice(0, 10)
          }), jsx(EditingState, {
            onCommitChanges: onCommitChanges
          }), jsx(IntegratedEditing, {}), jsx(WeekView, {
            cellDuration: 60,
            timeScaleLayoutComponent: TimeScaleLayout,
            dayScaleCellComponent: WeekDayCell,
            dayScaleLayoutComponent: WeekDayLayout,
            timeTableCellComponent: TimeTableCell
          }), jsx(Appointments, {
            appointmentComponent: CustomAppointment,
            appointmentContentComponent: CustomAppointmentContent
          }), jsx(AllDayPanel, {
            layoutComponent: AllDay,
            cellComponent: AllDayCell,
            titleCellComponent: AllDayTitleCell
          }), jsx(DragDropProvider, {
            draftAppointmentComponent: DraftAppointment
          })]
        })]
      })
    }), jsx(Dialog, {
      open: reccurModalOpen,
      title: t('Repeats on'),
      onClose: function onClose() {
        return setReccurModalOpen(false);
      },
      children: jsx(RecurrenceModal, {
        appointmentData: currentAppointSelected,
        schedulerData: schedulerData,
        onSubmit: onSubmit,
        onCancel: function onCancel() {
          return setReccurModalOpen(false);
        }
      })
    })]
  });
};

var styles$1 = {"link":"ua-common_10-0-0_ScrollSpy__link__e7318","active":"ua-common_10-0-0_ScrollSpy__active__e7318","sidebar":"ua-common_10-0-0_ScrollSpy__sidebar__e7318"};

var ScrollSpySkeleton = function ScrollSpySkeleton(_ref) {
  var _ref$nb = _ref.nb,
    nb = _ref$nb === void 0 ? 4 : _ref$nb;
  return jsx("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: tokens.spacing02
    },
    children: Array(nb).fill(0).map(function (_, i) {
      return jsx("div", {
        style: {
          width: '100%'
        },
        children: jsx(Skeleton, {
          width: "100%",
          variant: "rectangle",
          size: "large"
        })
      }, i);
    })
  });
};
var ScrollSpySkeleton$1 = memo(ScrollSpySkeleton);

var IN_VIEW_OFFSET = 64;
var SPY_THROTTLE_MS = 75;
var SUB_APP_VIEWPORT_ID = 'subapp-viewport';
var ScrollSpy = function ScrollSpy(_ref) {
  var data = _ref.data,
    tabs = _ref.tabs,
    _ref$noData = _ref.noData,
    noData = _ref$noData === void 0 ? false : _ref$noData,
    _ref$topPositionOffse = _ref.topPositionOffset,
    topPositionOffset = _ref$topPositionOffse === void 0 ? 0 : _ref$topPositionOffse,
    _ref$scrollContainerI = _ref.scrollContainerId,
    scrollContainerId = _ref$scrollContainerI === void 0 ? SUB_APP_VIEWPORT_ID : _ref$scrollContainerI,
    _ref$insideChamTab = _ref.insideChamTab,
    insideChamTab = _ref$insideChamTab === void 0 ? false : _ref$insideChamTab;
  var pageHeaderContext = usePageHeaderContext();
  var bannerOffset = useSelector(function (state) {
    var _state$shellUiState;
    return ((_state$shellUiState = state.shellUiState) === null || _state$shellUiState === void 0 ? void 0 : _state$shellUiState.bannerOffset) || 0;
  });
  var topPosition = pageHeaderContext.height + topPositionOffset;
  var insideWrapper = getScrollableContainer(scrollContainerId) != window;
  return jsx("div", {
    className: styles$1.sidebar,
    style: {
      top: topPosition && topPosition > 0 ? topPosition - 16 : 16
    },
    children: noData || data ? jsx(Navigation, {
      containerElement: jsx("div", {}),
      itemElement: jsx("span", {}),
      itemClassName: styles$1.link,
      activeItemClassName: styles$1.active,
      ids: tabs.map(function (_ref2) {
        var path = _ref2.path;
        return path;
      }),
      offset: insideChamTab ? 0 : topPosition + (insideWrapper ? TOP_BAR_HEIGHT + bannerOffset : 0),
      scrollContainerId: scrollContainerId,
      insideChamTab: insideChamTab
    }) : jsx(ScrollSpySkeleton$1, {})
  });
};
/*
        A hash prefix is required to prevent the default scrolling behavior in safari that was happening along with the
        programmatic scroll in the ScrollSpy that was creating a buggy experience. Since the id with the prefix is no longer
        visible in the dom, it prevents the default behavior.
*/
var HASH_PREFIX = 'section-';
var Navigation = function Navigation(_ref3) {
  var ids = _ref3.ids,
    _ref3$offset = _ref3.offset,
    offset = _ref3$offset === void 0 ? 0 : _ref3$offset,
    itemContainerClassName = _ref3.itemContainerClassName,
    activeItemClassName = _ref3.activeItemClassName,
    itemClassName = _ref3.itemClassName,
    _ref3$containerElemen = _ref3.containerElement,
    containerElement = _ref3$containerElemen === void 0 ? jsx("ul", {}) : _ref3$containerElemen,
    _ref3$itemElement = _ref3.itemElement,
    itemElement = _ref3$itemElement === void 0 ? jsx("li", {}) : _ref3$itemElement,
    scrollContainerId = _ref3.scrollContainerId,
    insideChamTab = _ref3.insideChamTab;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var history = useHistory();
  var sectionIds = useDeepCompareMemo(function () {
    return ids;
  }, [ids]);
  var scrollTimeoutRef = useRef(null);
  var updateLocationHash = useCallback(function (sectionId) {
    if (history.location.hash !== "#".concat(HASH_PREFIX).concat(sectionId)) {
      history.replace("#".concat(HASH_PREFIX).concat(sectionId));
    }
  }, [history]);
  var computeSpyItems = useCallback(function () {
    var sections = getAvailableSections(sectionIds);
    var firstSectionInView = getFirstSectionInView(sections, offset, scrollContainerId, insideChamTab);
    return sections.map(function (section) {
      return {
        id: section.id,
        active: !!firstSectionInView && section.id === firstSectionInView.id,
        element: section
      };
    });
  }, [offset, sectionIds, scrollContainerId, insideChamTab]);
  var clearScrollTimeoutIfAny = useCallback(function () {
    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
      scrollTimeoutRef.current = null;
    }
  }, []);
  var spy = useCallback(function () {
    clearScrollTimeoutIfAny();
    var spyItems = computeSpyItems();
    var activeItem = spyItems.find(function (item) {
      return item.active;
    });
    if (activeItem) {
      setItems(spyItems);
      scrollTimeoutRef.current = setTimeout(function () {
        updateLocationHash(activeItem.id);
        scrollTimeoutRef.current = null;
      }, SPY_THROTTLE_MS + 25);
    }
  }, [clearScrollTimeoutIfAny, computeSpyItems, updateLocationHash]);
  var handleLocationHashChange = useCallback(function (hash) {
    var section = document.getElementById(hash.replace(new RegExp("^#".concat(HASH_PREFIX)), ''));
    if (section) {
      var firstInView = getFirstSectionInView(getAvailableSections(sectionIds), offset, scrollContainerId, insideChamTab);
      if ((firstInView === null || firstInView === void 0 ? void 0 : firstInView.id) !== section.id) {
        setTimeout(function () {
          return scrollTo(section, offset, scrollContainerId, insideChamTab);
        }, 0);
        return true;
      }
    }
    return false;
  }, [offset, sectionIds, scrollContainerId, insideChamTab]);
  useEffect(function () {
    var throttledSpy = throttle(spy, SPY_THROTTLE_MS);
    var scrollableContainer = getScrollableContainer(scrollContainerId);
    scrollableContainer.addEventListener('scroll', throttledSpy);
    var unlistenHistory = history.listen(function (loc) {
      var _loc$location;
      var hash = loc.hash || ((_loc$location = loc.location) === null || _loc$location === void 0 ? void 0 : _loc$location.hash); // Memory history's listen() has different signature
      if (hash) {
        handleLocationHashChange(hash);
      }
    });
    if (!history.location.hash || !handleLocationHashChange(history.location.hash)) {
      spy();
    }
    return function () {
      scrollableContainer.removeEventListener('scroll', throttledSpy);
      unlistenHistory();
      clearScrollTimeoutIfAny();
    };
  }, [clearScrollTimeoutIfAny, handleLocationHashChange, history, spy, scrollContainerId]);
  var renderItems = function renderItems() {
    return items.map(function (item, key) {
      return cloneElement(itemElement, _objectSpread2({
        key: key,
        className: clsx(itemClassName, item.active ? activeItemClassName : null),
        onClick: function onClick() {
          return history.push("#".concat(HASH_PREFIX).concat(item.id));
        },
        role: 'menuitem',
        children: item.element.innerText
      }, item.active ? {
        'aria-current': true
      } : {}));
    });
  };
  return cloneElement(containerElement, {
    role: 'navigation',
    className: itemContainerClassName,
    children: renderItems()
  });
};
var getFirstSectionInView = function getFirstSectionInView(sections, offset, scrollContainerId, insideChamTab) {
  if (isAtBottomOfPage(scrollContainerId)) {
    return sections[sections.length - 1];
  }
  return sections.find(function (section, index) {
    var rect = section.getBoundingClientRect();
    if (rect.bottom > window.innerHeight) {
      return false;
    }
    var sectionTop = insideChamTab ? rect.top - getScrollableContainerClientRect(scrollContainerId, insideChamTab).top : rect.top;
    var closeToTop = sectionTop >= offset - IN_VIEW_OFFSET;
    if (closeToTop) {
      return true;
    }
    var nextSection = sections[index + 1];
    var nextSectionStillFarAway = !nextSection || (insideChamTab ? nextSection.getBoundingClientRect().top - getScrollableContainerClientRect(scrollContainerId, insideChamTab).top >= offset + IN_VIEW_OFFSET : nextSection.getBoundingClientRect().top >= offset + IN_VIEW_OFFSET);
    return nextSectionStillFarAway;
  });
};
var scrollTo = function scrollTo(element, offset, scrollContainerId, insideChamTab) {
  var scrollableContainer = getScrollableContainer(scrollContainerId);
  var scrollTop = insideChamTab ? element.getBoundingClientRect().top - offset - getScrollableContainerClientRect(scrollContainerId, insideChamTab).top : element.getBoundingClientRect().top - offset;
  scrollableContainer.scrollBy({
    top: scrollTop,
    behavior: 'smooth'
  });
};
var getScrollableContainerClientRect = function getScrollableContainerClientRect(scrollContainerId, insideChamTab) {
  var container = getScrollableContainer(scrollContainerId);
  return insideChamTab && !(container instanceof Window) ? container.getBoundingClientRect() : {
    top: 0
  };
};
var getScrollableContainer = function getScrollableContainer(scrollContainerId) {
  return document.getElementById(scrollContainerId) || window;
};
var isAtBottomOfPage = function isAtBottomOfPage(scrollContainerId) {
  var scrollableContainer = getScrollableContainer(scrollContainerId);
  return scrollableContainer instanceof Window ? window.innerHeight + window.scrollY >= document.body.offsetHeight - 2 : scrollableContainer.scrollTop >= scrollableContainer.scrollHeight - scrollableContainer.offsetHeight - 2;
};
var getAvailableSections = function getAvailableSections(sectionIds) {
  return sectionIds.map(function (id) {
    return document.getElementById(id);
  }).filter(function (el) {
    return el;
  });
};

var _excluded$1 = ["title", "open", "onClose", "onConfirm", "children", "isDanger"];
var SimpleConfirmDialog = function SimpleConfirmDialog(_ref) {
  var title = _ref.title,
    open = _ref.open,
    onClose = _ref.onClose,
    onConfirm = _ref.onConfirm,
    children = _ref.children,
    _ref$isDanger = _ref.isDanger,
    isDanger = _ref$isDanger === void 0 ? false : _ref$isDanger,
    otherProps = _objectWithoutProperties(_ref, _excluded$1);
  var t = useTranslate();
  return jsxs(Dialog, _objectSpread2(_objectSpread2({
    id: "confirmation-dialog",
    title: title,
    open: open,
    onClose: onClose
  }, otherProps), {}, {
    children: [children, jsxs(DialogActions, {
      children: [jsx(Button, {
        variant: "neutral",
        onClick: onClose,
        children: t('Cancel')
      }), jsx(Button, {
        variant: isDanger ? 'danger' : 'primary',
        onClick: function onClick() {
          onConfirm();
          onClose();
        },
        children: t('Confirm')
      })]
    })]
  }));
};
var SimpleConfirmDialog$1 = memo(SimpleConfirmDialog);

var GlobalStyle = function GlobalStyle(_ref) {
  var children = _ref.children;
  useEffect(function () {
    var style = document.createElement('style');
    style.textContent = "\n\t\t\t* {\n\t\t\t\t-webkit-font-smoothing: antialiased;\n\t\t\t\t-moz-osx-font-smoothing: grayscale;\n\t\t\t}\n\t\t\thtml {\n\t\t\t\toverflow-x: hidden;\n\t\t\t}\n\t\t\tbody {\n\t\t\t\tpadding: 0 !important;\n\t\t\t}\n\t\t\t";
    document.head.appendChild(style);
    return function () {
      document.head.removeChild(style);
    };
  }, []);
  return jsxs(Fragment, {
    children: [jsx(CssBaseline, {}), children]
  });
};

var shadows = ['none', tokens.elevationSmall, tokens.elevationMedium, tokens.elevationLarge, tokens.elevationXlarge,
// TODO remove the following and let MUI be happy
'0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)', '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)', '0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)', '0px 5px 5px -3px rgba(0, 0, 0, 0.12),0px 8px 10px 1px rgba(0, 0, 0, 0.08),0px 3px 14px 2px rgba(0, 0, 0, 0.04)', '0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)', '0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)', '0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)', '0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)', '0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)', '0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)', '0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)', '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)', '0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)', '0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)', '0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)', '0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)', '0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)', '0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)', '0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)', '0px 8px 10px -5px rgba(0, 0, 0, 0.12),0px 16px 24px 2px rgba(0, 0, 0, 0.08),0px 6px 30px 5px rgba(0, 0, 0, 0.04)'];

var _$disabled, _root;
// Everything Material-UI related that we want to override goes here
// https://material-ui.com/customization/components/#global-theme-override
var overrides = {
  MuiButton: {
    root: {
      minWidth: 36,
      textTransform: 'unset',
      lineHeight: 'unset',
      '-webkit-app-region': 'no-drag'
    }
  },
  MuiIconButton: {
    root: {
      borderRadius: 4
    }
  },
  // @ts-ignore
  MuiSkeleton: {
    root: {
      borderRadius: 4
    }
  },
  MuiDrawer: {
    paper: {
      zIndex: 1195
    }
  },
  MuiLink: {
    root: {
      fontWeight: 500
    }
  },
  MuiMobileStepper: {
    root: {
      background: 'transparent'
    }
  },
  MuiBreadcrumbs: {
    ol: {
      flexWrap: 'nowrap'
    }
  },
  MuiAlert: {
    message: {
      alignSelf: 'center'
    }
  },
  MuiInputAdornment: {
    positionStart: {
      marginRight: 4,
      marginLeft: -4
    },
    positionEnd: {
      marginRight: -4,
      marginLeft: 4
    }
  },
  MuiPopover: {
    paper: {
      overflowX: 'unset',
      overflowY: 'unset'
    }
  },
  MuiDivider: {
    root: {
      backgroundColor: tokens.interactiveColorNeutralDefault
    }
  },
  MuiListItemIcon: {
    root: {
      backgroundColor: 'transparent',
      minWidth: 32
    }
  },
  MuiMenu: {
    paper: {
      boxShadow: shadows[3],
      overflowY: 'auto',
      overflowX: 'hidden',
      maxHeight: '70vh'
    }
  },
  MuiMenuItem: {
    root: {
      fontSize: 14
    }
  },
  // @ts-ignore
  MuiAutocomplete: {
    endAdornment: {
      top: 'calc(50% - 13px)',
      right: 11
    },
    option: {
      fontSize: 14
    },
    tag: {
      margin: 4
    }
  },
  MuiSnackbarContent: {
    root: {
      backgroundColor: colorLight.neutral600,
      maxWidth: 480,
      boxShadow: shadows[3]
    }
  },
  MuiSnackbar: {
    anchorOriginBottomLeft: {
      alignItems: 'flex-end'
    }
  },
  MuiSvgIcon: {
    fontSizeSmall: {
      fontSize: '1rem!important'
    }
  },
  MuiBackdrop: {
    root: {
      opacity: 1,
      backgroundColor: tokens.scrimColor
    }
  },
  MuiDialog: {
    paperWidthXs: {
      maxWidth: 400
    },
    paperWidthSm: {
      maxWidth: 480
    },
    paperWidthMd: {
      maxWidth: 640
    }
  },
  MuiChip: {
    icon: {
      marginLeft: 10,
      color: 'rgba(37, 40, 45, 0.64)'
    },
    clickable: {
      '&:hover': {
        backgroundColor: 'rgba(154, 168, 187, 0.32)'
      },
      '&:active': {
        backgroundColor: 'rgba(154, 168, 187, 0.48)'
      }
    },
    iconSmall: {
      marginLeft: 6
    },
    root: (_root = {
      boxShadow: 'none',
      border: "1px solid transparent",
      backgroundColor: 'rgba(154, 168, 187, 0.16)',
      '&:hover': {
        '&$disabled': {
          pointerEvents: 'auto'
        }
      }
    }, _defineProperty(_root, "& .".concat(window.CLASSNAME_PREFIX, "-MuiChip-avatar"), {
      width: 32,
      height: 32,
      marginLeft: 0,
      marginRight: -4
    }), _defineProperty(_root, '&$disabled', (_$disabled = {
      color: 'rgba(37, 40, 45, 0.36)',
      backgroundColor: 'rgba(154, 168, 187, 0.12);',
      opacity: 1
    }, _defineProperty(_$disabled, "& .".concat(window.CLASSNAME_PREFIX, "-MuiChip-icon"), {
      color: 'rgba(37, 40, 45, 0.24)'
    }), _defineProperty(_$disabled, "& .".concat(window.CLASSNAME_PREFIX, "-MuiChip-deleteIcon"), {
      color: 'rgba(37, 40, 45, 0.24)'
    }), _defineProperty(_$disabled, "& .".concat(window.CLASSNAME_PREFIX, "-MuiChip-avatar"), {
      opacity: 0.7
    }), _$disabled)), _root),
    deleteIcon: {
      color: 'rgba(37, 40, 45, 0.64)',
      marginRight: 10,
      width: 16,
      height: 16,
      '&:hover': {
        color: 'rgba(37, 40, 45, 0.64)'
      }
    },
    deleteIconSmall: {
      marginRight: 6
    },
    clickableColorPrimary: {
      '&:hover': {
        backgroundColor: colorLight.blue600
      },
      '&:active': {
        backgroundColor: '#003989'
      }
    },
    sizeSmall: _defineProperty({
      height: 24
    }, "& .".concat(window.CLASSNAME_PREFIX, "-MuiChip-avatar"), {
      width: 24,
      height: 24,
      marginLeft: 0,
      marginRight: -2
    })
  },
  MuiSwitch: {
    colorSecondary: {
      '&:hover': {
        backgroundColor: 'transparent'
      },
      '&$checked': {
        color: tokens.neutral000,
        '& + $track': {
          backgroundColor: tokens.surfaceColorBrandDefault,
          opacity: 1
        },
        '&$disabled': {
          '& + $track': {
            backgroundColor: tokens.neutral200
          }
        },
        '&:hover': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        color: tokens.neutral000,
        '& + $track': {
          backgroundColor: tokens.neutral200,
          opacity: 1
        }
      }
    },
    switchBase: {
      color: tokens.neutral000,
      padding: 2,
      '&::before': {
        transition: 'inherit',
        left: 0
      },
      '&$checked': {
        transform: 'translateX(18px)',
        '&::before': {
          transition: 'inherit',
          transform: 'translateX(-18px)'
        }
      }
    },
    root: {
      border: "1px solid transparent",
      padding: 0,
      height: 22,
      width: 40,
      overflow: 'unset'
    },
    thumb: {
      width: 16,
      height: 16,
      boxShadow: '0px 3px 1px -2px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.08), 0px 1px 5px 0px rgba(0, 0, 0, 0.04)'
    },
    track: {
      borderRadius: 10,
      backgroundColor: tokens.borderColorDefault,
      opacity: 1
    }
  },
  MuiButtonBase: {
    root: {
      '&:disabled': {
        pointerEvents: 'auto'
      },
      '&$disabled': {
        pointerEvents: 'auto'
      }
    }
  },
  MuiInputBase: {
    root: {
      '&:hover': {
        '&$disabled': {
          pointerEvents: 'auto'
        }
      },
      '&$disabled': {
        color: tokens.typeColorDisabled,
        borderColor: tokens.interactiveColorDisabled,
        backgroundColor: tokens.interactiveColorDisabled
      }
    },
    input: {
      '&$disabled': {
        pointerEvents: 'none'
      }
    }
  },
  MuiTab: {
    root: {
      minWidth: '80px !important',
      textTransform: 'unset'
    }
  },
  MuiTableCell: {
    root: {
      height: 24,
      borderBottom: 'none'
    },
    head: {
      fontSize: 12,
      fontWeight: 600,
      paddingTop: 0,
      paddingBottom: 0,
      cursor: 'auto',
      color: colorLight.neutral400,
      borderBottom: "1px solid ".concat(tokens.interactiveColorNeutralDefault)
    },
    body: {
      fontSize: 14,
      borderBottom: "1px solid ".concat(tokens.interactiveColorNeutralDefault)
    }
  },
  MuiTabs: {
    indicator: {
      height: 4,
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
      backgroundColor: tokens.surfaceColorBrandDefault
    }
  },
  MuiExpansionPanelSummary: {
    root: {
      padding: '0px 20px'
    },
    content: {
      margin: '20px 0px'
    }
  },
  MuiAccordionSummary: {
    root: {
      padding: '0px 20px'
    },
    content: {
      margin: '20px 0px'
    }
  },
  MuiBadge: {
    root: {
      width: '100%'
    }
  },
  MuiAvatar: {
    // Need to specify this for AvatarGroup
    root: {
      height: 36,
      width: 36,
      fontSize: '0.875rem',
      fontWeight: 500
    }
  },
  MuiPickersCalendarHeader: {
    switchHeader: {
      color: tokens.typeColorDefault
    }
  }
};

var gotoPalette = {
  'blue-700': '#00327E'
};
// Our Material-UI palette
// https://material-ui.com/customization/palette/#palette
var lightPalette = _objectSpread2({
  type: 'light',
  text: {
    disabled: 'rgba(37, 40, 45, 0.36)',
    primary: colorLight.neutral600,
    secondary: colorLight.neutral400,
    primaryReverse: colorLight.neutral000
  },
  background: {
    "default": colorLight.neutral000,
    disabled: '#EFF1F4',
    paper: colorLight.neutral000,
    neutral: 'rgba(0, 0, 0, 0.08)',
    neutralLight: 'rgba(0, 0, 0, 0.04)',
    table: colorLight.neutral050,
    tableBorder: 'rgba(224, 224, 224, 1)'
  },
  primary: {
    lighter: colorLight.blue300,
    light: colorLight.blue400,
    main: colorLight.blue500,
    dark: colorLight.blue600,
    contrastText: colorLight.neutral000,
    darker: gotoPalette['blue-700'],
    icon: gotoAdminLight.iconColorBrandDefault
  },
  secondary: {
    main: colorLight.blue500,
    dark: colorLight.blue600,
    contrastText: colorLight.neutral000
  },
  tertiary: {
    hover: alpha(colorLight.blue300, 0.12),
    active: alpha(colorLight.blue300, 0.24)
  },
  action: {
    hover: colorLight.blue600,
    focus: alpha(colorLight.blue500, 0.25),
    disabledBackground: '#EFF1F4',
    disabledBorder: 'rgba(76, 83, 93, 0.24)',
    active: gotoPalette['blue-700'],
    selected: alpha(colorLight.blue400, 0.08)
  },
  info: {
    light: alpha(colorLight.blue400, 0.08),
    main: colorLight.blue500
  },
  error: {
    main: colorLight.red500,
    contrastText: colorLight.neutral000
  }
}, colorLight);
var darkPalette = _objectSpread2({
  type: 'dark',
  text: {
    disabled: 'rgba(255, 255, 255, 0.36)',
    primary: colorDark.neutral000,
    secondary: 'rgba(255, 255, 255, 0.7)',
    primaryReverse: colorDark.neutral600
  },
  background: {
    "default": colorDark.neutral600,
    disabled: '#484F57',
    paper: colorDark.neutral600,
    neutral: 'rgba(255, 255, 255, 0.16)',
    neutralLight: 'rgba(255, 255, 255, 0.08)',
    table: colorDark.surfaceColorDefault,
    tableBorder: 'rgba(81, 81, 81, 1)'
  },
  primary: {
    lighter: colorDark.blue200,
    light: colorDark.blue300,
    main: colorDark.blue400,
    dark: colorDark.blue500,
    darker: colorDark.blue600,
    contrastText: colorDark.neutral600,
    icon: gotoAdminDark.iconColorBrandDefault
  },
  secondary: {
    main: colorDark.blue400,
    dark: colorDark.blue500,
    contrastText: colorDark.neutral600
  },
  tertiary: {
    hover: alpha(colorDark.blue400, 0.12),
    active: alpha(colorDark.blue300, 0.24)
  },
  action: {
    hover: colorDark.blue300,
    focus: alpha(colorDark.blue400, 0.24),
    disabledBackground: 'rgba(154, 168, 187, 0.16)',
    disabledBorder: 'rgba(255, 255, 255, 0.35)',
    active: colorDark.blue200,
    selected: 'rgba(0, 79, 189, 0.08)'
  },
  info: {
    light: 'rgba(0, 79, 189, 0.08)',
    main: colorDark.blue400
  },
  error: {
    main: colorDark.red400,
    contrastText: colorDark.neutral000
  }
}, colorDark);

var getSpacingArray = function getSpacingArray() {
  return Object.keys(spacingLight).filter(function (key) {
    return key.includes('spacing');
  }).map(function (key) {
    return parseFloat(spacingLight[key].replace('rem', '')) * 16;
  }); // to avoid using rems
};

var themeBase = {
  shadows: shadows,
  typography: {
    fontFamily: gotoAdminTypography.fontFamily
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1440
    }
  },
  spacing: getSpacingArray(),
  zIndex: {
    drawer: 1195
  },
  props: {
    // Name of the component ⚛️
    MuiButtonBase: {
      // The properties to apply
      disableRipple: true // No more ripple, on the whole application 💣!
    }
  }
};

var lightThemeBase = _objectSpread2(_objectSpread2({}, themeBase), {}, {
  overrides: _objectSpread2({}, overrides)
});
var darkThemeBase = _objectSpread2(_objectSpread2({}, themeBase), {}, {
  overrides: _objectSpread2({}, overrides)
});
var gotoLightTheme = _objectSpread2(_objectSpread2({}, lightThemeBase), {}, {
  palette: lightPalette,
  tokens: gotoAdminLight
});
var gotoDarkTheme = _objectSpread2(_objectSpread2({}, darkThemeBase), {}, {
  palette: darkPalette,
  tokens: gotoAdminDark
});

var createCustomGenerateClassName = function () {
  var generateClassName;
  return function (prefix) {
    if (!generateClassName) {
      generateClassName = createGenerateClassName({
        seed: prefix
      });
    }
    return generateClassName;
  };
}();

var _excluded = ["children", "theme", "classNamePrefix"];
var MuiThemeProvider = function MuiThemeProvider(_ref) {
  var children = _ref.children,
    theme = _ref.theme,
    classNamePrefix = _ref.classNamePrefix,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var isDarkMode = theme === 'dark';
  var generateClassName = createCustomGenerateClassName(classNamePrefix);
  // Setting the prefix globally
  // @ts-ignore
  window.CLASSNAME_PREFIX = classNamePrefix;
  var chameleonTheme = _objectSpread2({}, createTheme(isDarkMode ? gotoDarkTheme : gotoLightTheme));
  return jsx(StylesProvider, _objectSpread2(_objectSpread2({
    generateClassName: generateClassName
  }, otherProps), {}, {
    children: jsx(ThemeProvider, {
      theme: chameleonTheme,
      children: children
    })
  }));
};

var useVirtualFaxValidationSchema = function useVirtualFaxValidationSchema(_ref) {
  var mode = _ref.mode,
    extensionDigits = _ref.extensionDigits,
    isExtensionNumberAvailable = _ref.isExtensionNumberAvailable,
    virtualFax = _ref.virtualFax,
    isReservedNumber = _ref.isReservedNumber;
  var t = useTranslate();
  return {
    validationSchema: Yup.object().shape({
      extensionNumber: Yup.string().nullable().test('number', t('Must only contain numbers'), function (val) {
        return /^(\s*|\d+)$/.test(val || '');
      }).length(extensionDigits, t('Extensions require %{amountOfDigits} digits', {
        amountOfDigits: extensionDigits
      })).test('existing', t('Extension number already taken'), function (value) {
        return isExtensionNumberAvailable(value || undefined, extensionDigits, mode === DialogMode.UPDATE ? (virtualFax === null || virtualFax === void 0 ? void 0 : virtualFax.extensionNumber) || undefined : undefined);
      }).test('reservedNumber', t('Reserved numbers are not allowed'), function (value) {
        if (mode !== DialogMode.UPDATE || mode === DialogMode.UPDATE && value !== (virtualFax === null || virtualFax === void 0 ? void 0 : virtualFax.extensionNumber)) {
          return !isReservedNumber(value || undefined);
        }
        return true;
      }),
      name: Yup.string().max(255, t('Maximum %{maxCharacters} characters', {
        maxCharacters: 255
      })).required(t('Required'))
    })
  };
};

var VirtualFaxEditorDialog = function VirtualFaxEditorDialog(_ref) {
  var open = _ref.open,
    title = _ref.title,
    onClose = _ref.onClose,
    onCancel = _ref.onCancel,
    mode = _ref.mode,
    virtualFax = _ref.virtualFax,
    onSubmit = _ref.onSubmit,
    extensionDigits = _ref.extensionDigits,
    nextExtensionNumber = _ref.nextExtensionNumber,
    isExtensionNumberAvailable = _ref.isExtensionNumberAvailable,
    isReservedNumber = _ref.isReservedNumber;
  var t = useTranslate();
  var _useVirtualFaxValidat = useVirtualFaxValidationSchema({
      mode: mode,
      virtualFax: virtualFax,
      isExtensionNumberAvailable: isExtensionNumberAvailable,
      extensionDigits: extensionDigits,
      isReservedNumber: isReservedNumber
    }),
    validationSchema = _useVirtualFaxValidat.validationSchema;
  // When update virtualFax prop must be set
  if (mode === DialogMode.UPDATE && !virtualFax) {
    return jsx(Fragment, {});
  }
  return jsx(Dialog, {
    open: open,
    title: title,
    onClose: onClose,
    children: jsx(Formik, {
      initialValues: {
        extensionNumber: mode === DialogMode.UPDATE && virtualFax !== null && virtualFax !== void 0 && virtualFax.extensionNumber ? virtualFax === null || virtualFax === void 0 ? void 0 : virtualFax.extensionNumber : nextExtensionNumber,
        name: (virtualFax === null || virtualFax === void 0 ? void 0 : virtualFax.name) || ''
      },
      isInitialValid: false,
      validateOnBlur: false,
      validationSchema: validationSchema,
      onSubmit: onSubmit,
      children: function children(_ref2) {
        var isValid = _ref2.isValid,
          isSubmitting = _ref2.isSubmitting,
          setFieldValue = _ref2.setFieldValue;
        return jsxs(Form, {
          noValidate: true,
          autoComplete: "off",
          "data-testid": "form",
          children: [jsx(FormikTextField, {
            label: t('Extension (optional)'),
            fullwidth: true,
            name: "extensionNumber",
            placeholder: t('Enter an extension number'),
            helperText: t('The extension can be dialed internally, dialed from a dial plan, and calls can be transferred to it. Extensions must be unique.'),
            maxLength: extensionDigits,
            hideCounter: true,
            "data-testid": "input-extension",
            onChange: function onChange(e) {
              setFieldValue('extensionNumber', e.target.value);
            },
            onKeyDown: function onKeyDown(evt) {
              return evt.stopPropagation();
            },
            style: {
              marginBottom: tokens.spacing04
            }
          }), jsx(FormikTextField, {
            autoFocus: true,
            label: t('Name'),
            fullwidth: true,
            placeholder: t('Enter a name'),
            name: "name",
            "data-testid": "input-name",
            onChange: function onChange(e) {
              setFieldValue('name', e.target.value);
            },
            onKeyDown: function onKeyDown(evt) {
              return evt.stopPropagation();
            }
          }), jsxs(DialogActions, {
            children: [jsx(Button, {
              variant: "neutral",
              onClick: onCancel,
              "data-testid": "cancel-button",
              children: t('Cancel')
            }), jsx(Button, {
              disabled: !isValid || isSubmitting,
              type: "submit",
              variant: "primary",
              "data-testid": "save-button",
              children: t('Save')
            })]
          })]
        });
      }
    })
  });
};
var VirtualFaxEditorDialog$1 = memo(VirtualFaxEditorDialog);

var styles = {"root":"ua-common_10-0-0_VisibleOnDevOnly__root__67ad3"};

var VisibleOnDevOnly = function VisibleOnDevOnly(_ref) {
  var env = _ref.env,
    children = _ref.children;
  return env !== 'production' ? jsx("div", {
    "data-testid": "root",
    className: styles.root,
    children: children
  }) : null;
};

/* istanbul ignore file */
var ACTIVITY_ROUTE = 'activity';
var BUSINESS_CONTINUITY_ROUTE = 'business-continuity';
var CALL_QUEUES_ROUTE = 'call-queues';
var DASHBOARD_ROUTE = 'dashboard';
var DEVICES_ROUTE = 'devices';
var DIGITAL_WORKFORCE_ROUTE = 'digital-workforce';
var NUMBERS_ROUTE = 'numbers';
var ORDERS_ROUTE = 'orders';
var OVERVIEW_ROUTE = 'overview';
var INTEGRATIONS_ROUTE = 'integrations';
var PEOPLE_ROUTE = 'people';
var PHONES_ROUTE = 'phone-system';
var PLACES_ROUTE = 'locations';
var PRODUCTS_ROUTE = 'products';
var REPORTS_ROUTE = 'reports';
var SETTINGS_ROUTE = 'settings';
var NETWORK_ROUTE = 'network';
var BILLING_ROUTE = 'billing';
var DIAL_PLANS_ROUTE = 'dial-plans';
var BILLING_GROUPS_ROUTE = 'billing-groups';
var SMS_CAMPAIGN_ROUTE = 'sms-campaign';
var GTC_BILLING_ROUTE = 'gtc-billing';
var ADD_ONS_ROUTE = 'add-ons';
var TENANTS_ROUTE = 'tenants';

var useDialogVisibility = function useDialogVisibility() {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    dialogsVisiblity = _useState2[0],
    setDialogsVisiblity = _useState2[1];
  var toggleDialogVisibility = function toggleDialogVisibility(dialogName) {
    setDialogsVisiblity(function (current) {
      return _objectSpread2(_objectSpread2({}, current), {}, _defineProperty({}, dialogName, !dialogsVisiblity[dialogName]));
    });
  };
  var hideDialog = function hideDialog(dialogName) {
    setDialogsVisiblity(function (current) {
      return _objectSpread2(_objectSpread2({}, current), {}, _defineProperty({}, dialogName, false));
    });
  };
  return {
    dialogsVisiblity: dialogsVisiblity,
    toggleDialogVisibility: toggleDialogVisibility,
    hideDialog: hideDialog
  };
};

var useReportTranslations = function useReportTranslations() {
  var t = useTranslate();
  return useMemo(function () {
    return {
      activityhistoryreport: t('Activity history report'),
      activityreport: t('Activity report'),
      allusersaudiousagereport: t('Audio usage report'),
      allusersactivityreport: t('Activity report'),
      allusersconferenceidsreport: t('Conference room report'),
      allusersintegratedaudiousagereport: t('Integrated audio usage report'),
      allusersmeetingattendeereport: t('Meeting attendee report'),
      allusersmeetinghistoryreport: t('Meeting history report'),
      allusersregistrantreport: t('Registrant report'),
      allusersreport: t('Users report'),
      allusersscheduledmeetingreport: t('Scheduled meeting report'),
      alluserswebinarrecordingregistrantreport: t('Webinar recording registrant report'),
      audiousagereport: t('Audio usage report'),
      billinghistoryreport: t('Billing history report'),
      billingratereport: t('Billing history report'),
      meetingattendeereport: t('Meeting attendee report'),
      meetinghistoryreport: t('Meeting history report'),
      registrantreport: t('Registrant report'),
      scheduledmeetingreport: t('Scheduled meeting report'),
      usersaudiousagereport: t('OpenVoice usage report'),
      usersintegratedaudiousagereport: t('Integrated audio usage report'),
      usersreport: t('Users report'),
      licenseusersreport: t('License users report'),
      groupusersreport: t('Group users report'),
      webinarrecordingregistrantreport: t('Webinar recording registrant report'),
      job_activityreport: t('Activity report'),
      integrated_audio_usagereport: t('Integrated audio usage report'),
      audio_billing_historyreport: t('Billing history report'),
      audio_billing_ratereport: t('Billing rate report'),
      audio_conference_idsreport: t('Conference IDs report'),
      audio_usagereport: t('Usage report'),
      meeting_attendeereport: t('Meeting attendee report'),
      meeting_historyreport: t('Meeting history report'),
      product_activity_historyreport: t('Product activity report'),
      scheduled_meetingreport: t('Scheduled meeting report'),
      webinar_recording_registrantreport: t('Webinar recording registrant report'),
      webinar_registrantreport: t('Webinar registrant report'),
      groupusersactivityreport: t('Group users activity report'),
      groupusersaudiousagereport: t('Group users audio usage report'),
      groupusersintegratedaudiousagereport: t('Group users integrated audio usage report'),
      groupusersmeetingattendeereport: t('Group users meeting attendee report'),
      groupusersmeetinghistoryreport: t('Group users meeting history report'),
      groupusersregistrantreport: t('Group users registrant report'),
      groupusersscheduledmeetingreport: t('Group users scheduled meeting report'),
      groupuserswebinarrecordingregistrantreport: t('Group users webinar recording registrant report'),
      licenseusersactivityreport: t('License users activity report'),
      licenseusersaudiousagereport: t('License users audio usage report'),
      licenseusersintegratedaudiousagereport: t('License users integrated audio usage report'),
      licenseusersmeetingattendeereport: t('License users meeting attendee report'),
      licenseusersmeetinghistoryreport: t('License users meeting history report'),
      licenseusersregistrantreport: t('License users registrant report'),
      licenseusersscheduledmeetingreport: t('License users scheduled meeting report'),
      licenseuserswebinarrecordingregistrantreport: t('License users webinar recording registrant report'),
      voiceuseractivityreport: t('Voice activity report'),
      voice_user_activityreport: t('Voice activity report'),
      phonenumberactivityreport: t('Phone number activity report'),
      phone_number_activityreport: t('Phone number activity report'),
      smsusagereport: t('SMS usage report'),
      sms_usagereport: t('SMS usage report')
    };
  }, [t]);
};

// FIXME in theory this could loop indefinitely if used with something that never shows up
var useWaitForElement = function useWaitForElement(selector) {
  var retryMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    element = _useState2[0],
    setElement = _useState2[1];
  useEffect(function () {
    var findElement = function findElement() {
      var el = document.querySelector(selector);
      if (!el) {
        setTimeout(findElement, retryMs);
      } else {
        setElement(el);
      }
    };
    findElement();
  }, [selector, retryMs]);
  return element;
};

var calculateNextExtension = function calculateNextExtension(extension) {
  if (!extension) return '';
  var extensionNumber = Number(extension);
  extensionNumber++;
  return extensionNumber.toString().padStart(extension.length, '0');
};

var MAX_LEN = 20;
var CALL_FILTER_NUMBER_REGEXP = new RegExp("^\\+?[0-9*]{1,".concat(MAX_LEN + 1, "}$"));
var callFilterNumberValidation = (function (val) {
  if (val === undefined) {
    return true;
  }
  var strVal = val;
  // first global check: only digits and asterisk and a first optional +
  if (!CALL_FILTER_NUMBER_REGEXP.test(strVal)) {
    return false;
  }
  // only one asterisk is accepted
  var nbMasks = (strVal.match(/\*/g) || []).length;
  if (nbMasks > 1) {
    return false;
  }
  var containsPlus = strVal[0] === '+';
  if (nbMasks > 0) {
    var maskPos = strVal.indexOf('*');
    // checks if the asterisk is at the begining (after the optional +) or at the end
    if (maskPos > +containsPlus && maskPos < strVal.length - 1) {
      return false;
    }
  }
  // final length check (max MAX_LEN chars with the +)
  return strVal.length <= MAX_LEN + +containsPlus;
});

// Transforms "SUPER_ADMIN" into "Super admin"
var constantToText = function constantToText(str) {
  return upperFirst(join(split(toLower(str), '_'), ' '));
};

// Transforms 'SUPER_USER' into "Super admin"
var constSuToFormattedRole = function constSuToFormattedRole(str) {
  switch (str) {
    case 'SUPER_USER':
      return 'Super admin';
    case 'MANAGE_ACCOUNT':
      return 'Admin';
    default:
      return constantToText(str);
  }
};

/* istanbul ignore file */
var convertFileToXml = function convertFileToXml(file) {
  return new window.DOMParser().parseFromString(file, 'text/xml');
};

// This function creates an <a> link, assigns the file to it, triggers the download of the file
// then removes the <a> afterwards
var downloadFile = function downloadFile(_ref) {
  var blob = _ref.blob,
    file = _ref.file,
    fileType = _ref.fileType,
    mimeType = _ref.mimeType,
    name = _ref.name;
  var mime = "data:".concat(mimeType, ";charset=utf-8");
  var fileName = "".concat(name, ".").concat(fileType);
  var element = document.createElement('a');
  if (blob) {
    element.setAttribute('href', URL.createObjectURL(blob));
  }
  if (file) {
    element.setAttribute('href', "".concat(mime, ",").concat(encodeURIComponent(file)));
  }
  element.setAttribute('download', fileName);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};

// This function creates an <a> link, assigns the file to it, triggers the download of the file
// then removes the <a> afterwards
var downloadFileFromUrl = function downloadFileFromUrl(_ref) {
  var url = _ref.url,
    fileName = _ref.fileName;
  var element = document.createElement('a');
  element.setAttribute('href', url);
  element.setAttribute('download', fileName || '');
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};

var escapeHtml = function escapeHtml(value) {
  if (value === null || value === undefined) {
    return '';
  }
  if (typeof value !== 'string') {
    return value;
  }
  return encode(value);
};

// 'john' => ['John', '']
// 'john frusciante' => ['John', 'Frusciante']
// 'john doe frusciante' => ['John Doe', 'Frusciante']
var extractFirstAndLastName = function extractFirstAndLastName(name) {
  var splitName = split(name || '', ' ').filter(function (s) {
    return s;
  });
  if (!splitName.length) {
    return ['', ''];
  }
  if (splitName.length === 1) {
    return [splitName[0], ''];
  }
  var lastName = splitName.pop() || '';
  var firstName = join(splitName, ' ');
  return [firstName, lastName];
};

var illegalFieldInputCharacters = ['%', '&', '<', '>', '[', ']', '{', '}'];
var hasIllegalCharacters = function hasIllegalCharacters(inputText) {
  return illegalFieldInputCharacters.some(function (_char) {
    return inputText.indexOf(_char) > -1;
  });
};

var en_US = {
  code: 'en_US',
  name: 'English (US)',
  nativeName: 'English (US)'
};
var de_DE = {
  code: 'de_DE',
  name: 'Deutsch',
  nativeName: 'German'
};
var en_GB = {
  code: 'en_GB',
  name: 'English (International)',
  nativeName: 'English (International)'
};
var es_ES = {
  code: 'es_ES',
  name: 'Spanish',
  nativeName: 'Español'
};
var fr_FR = {
  code: 'fr_FR',
  name: 'French',
  nativeName: 'Français'
};
var it_IT = {
  code: 'it_IT',
  name: 'Italian',
  nativeName: 'Italiano'
};
var zh_CN = {
  code: 'zh_CN',
  name: 'Simplified Chinese',
  nativeName: '简体中文'
};
var ja_JP = {
  code: 'ja_JP',
  name: 'Japanese',
  nativeName: '日本語'
};
var ko_KR = {
  code: 'ko_KR',
  name: 'Korean',
  nativeName: '한국어'
};
var pt_BR = {
  code: 'pt_BR',
  name: 'Brazilian Portuguese',
  nativeName: 'Português do Brasil'
};
var LANGS = [en_US, de_DE, en_GB, es_ES, fr_FR, it_IT, zh_CN, ja_JP, ko_KR, pt_BR];
var LANGS_MAP = LANGS.reduce(function (acc, lang) {
  return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, lang.code, lang));
}, {});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var checkTemplateEmailAccess = function checkTemplateEmailAccess(licenses) {
  return !!(licenses && licenses.results && licenses.results.filter(function (licence) {
    return licence.type === 'paid' || licence.type === 'generic';
  }).length);
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var checkLicensesHasExtension = function checkLicensesHasExtension(selectedLicenseKeys, licenses) {
  return !!(licenses && licenses.results && licenses.results.filter(function (license) {
    return selectedLicenseKeys.includes(license.key);
  }).some(function (license) {
    return JIVE_PRODUCT_ABRS.some(function (product) {
      return license && license.products && license.products.includes(product);
    });
  }));
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var checkLicensesHasAssist = function checkLicensesHasAssist(licenses) {
  return !!(licenses && licenses.results && licenses.results.some(function (license) {
    return ASSIST_PRODUCT_ABRS.some(function (product) {
      return license && license.products && license.products.includes(product);
    });
  }));
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var isChannelBoss = function isChannelBoss(licenses) {
  return !!(licenses && licenses.results && licenses.results.find(function (license) {
    return license.channel === 'boss';
  }));
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var isUserProductJive = function isUserProductJive(licenseState, userDetails) {
  if (licenseState) {
    var allGotoconnectLicenses = licenseState && licenseState.results && licenseState.results.filter(function (license) {
      return JIVE_PRODUCT_ABRS.some(function (product) {
        return license && license.products && license.products.includes(product);
      });
    });
    var allLicenseUserKeysFlattened = allGotoconnectLicenses && allGotoconnectLicenses.map(function (license) {
      return license.userKeys;
    }).flat();
    return allLicenseUserKeysFlattened && allLicenseUserKeysFlattened.find(function (userKey) {
      return userKey === (userDetails && userDetails.key);
    }) ? true : false;
  } else {
    return false;
  }
};
// add invited users on top of the user count
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var computeLicenseUserCount = function computeLicenseUserCount(license) {
  return (license.userCount || 0) + (license.invitedUserKeys && license.invitedUserKeys.length || 0) + (license.deviceKeys && license.deviceKeys.length || 0);
};
var computeNewUserCount = function computeNewUserCount(currentCount, status) {
  switch (status) {
    case 'added':
      return currentCount + 1;
    case 'removed':
      return currentCount - 1;
    default:
      return currentCount;
  }
};
var switchLicenseStatus = function switchLicenseStatus(status) {
  switch (status) {
    case 'off':
      return 'added';
    case 'on':
      return 'removed';
    case 'added':
      return 'off';
    case 'removed':
      return 'on';
  }
};

// Makes sure the user can only type in numbers, /, :, and .
var onlyIpAddressDigits = function onlyIpAddressDigits(e) {
  // We don't want to supress form submission
  if (e.key !== 'Enter') {
    !e.key.match(/[\d./:]+/g) && e.preventDefault();
  }
};

var removeAllSpaces = function removeAllSpaces(str) {
  return str.replace(/\s/gm, '');
};

var DOMPurify = require('dompurify');
var secureHtml = function secureHtml(html) {
  if (html === null || html === undefined) {
    return '';
  }
  if (typeof html !== 'string') {
    return html;
  }
  return DOMPurify.sanitize(html);
};

var PHI = 1.618033988749895;
// Converts any string to a corresponding color based on a random seed
// Mainly used in Avatar component
var stringToColor = function stringToColor(str) {
  return "hsl(".concat(Math.floor((seedrandom(str)() + 1 / PHI) % 1 * 360), ", 75%, 55%)");
};

/* istanbul ignore file */
// KEYS
var MIXPANEL_API_KEY = 'c5934d98a88971c01e14163bfa6b1ee2';
// HOSTNAMES
var VALID_HOSTNAMES = ['feature.admin.dev.gtc.goto.com', 'admin.dev.gtc.goto.com', 'admin.goto.com', 'admin.staging.gtc.goto.com', 'localhost', 'my.dev.jive.com', 'my.jive.com', 'my.staging.jive.com'];

export { ACTIVITY_ROUTE, ADD_FILTER_BUTTON_ID, ADD_ONS_ROUTE, ALL_PRIVILEGES, APP_PREFIX, AT_LEAST_4_DIGITS_REGEXP, AddressBox$1 as AddressBox, Analytics, AutoComplete, AutocompleteTextField$1 as AutocompleteTextField, BANNER_HEIGHT, BILLING_GROUPS_ROUTE, BILLING_ROUTE, BULK_DELETE_USERS_LIMIT, BUSINESS_CONTINUITY_ROUTE, BillingRoles, BreadcrumbLink$1 as BreadcrumbLink, BreadcrumbLoader$1 as BreadcrumbLoader, CALL_QUEUES_ROUTE, CANADIAN_POSTAL_CODE_REGEX, ChipTabs, ConferenceBridgesEditorDialog$1 as ConferenceBridgesEditorDialog, ConfirmDeleteDialog, CopyToClipboard$1 as CopyToClipboard, DASHBOARD_ROUTE, DATATABLE_PAGE_SIZES, DATE_FORMAT_1, DATE_FORMAT_2, DATE_FORMAT_3, DATE_FORMAT_4, DATE_FORMAT_5, DATE_RANGE_FILTER_TRIGGERID, DEFAULT_PAGE_SIZE, DEVICES_ROUTE, DIAL_PLANS_ROUTE, DIGITAL_WORKFORCE_ROUTE, DRAWER_WIDTH, DataTable$1 as DataTable, DataTableFilters, DataTableHighlights$1 as DataTableHighlights, DataTableNoResults$1 as DataTableNoResults, DataTablePagination, DataTableRowActions, DataTableSkeleton$1 as DataTableSkeleton, DataTableToolbar, DefaultEmergencyAcknowledgeDialog, DelayRender, DetailsLayout, DialByNameDirectoryDialog, Dialog, DialogActions, DialogContentWrapper, DialogMode, Divider$1 as Divider, Drawer$1 as Drawer, Dropzone, EMAIL_REGEX, EMPTY_SYMBOL, EN_US_LOCALE, ErrorFallback, FILTER_POPOVER_TRIGGER_ID, FIRST_NAME_AND_LAST_NAME_REGEXP, FileExtensionChip$1 as FileExtensionChip, FileUpload, FormField, FormSubtitle$1 as FormSubtitle, FormTitle$1 as FormTitle, FormikCheckbox, FormikDatePickerField, FormikNumberField, FormikPhoneNumber, FormikRadioGroup, FormikSelect, FormikSwitch, FormikTextArea, FormikTextField, GTC_BILLING_ROUTE, GlobalSecurityContext, GlobalStyle, H5AudioPlayer, H5AudioPlayerLight, HOUR_FORMAT_1, HelperText, HolidayEditorDialog, INTEGRATIONS_ROUTE, IP_ADDRESS_PORT_REGEXP, IP_ADDRESS_REGEXP, JIVE_PRODUCT_ABRS, JrnParser, LANGS, LANGS_MAP, LinearProgress, LocalizedNumber$1 as LocalizedNumber, MAC_ADDRESS_REGEXP, MAX_FILTERS, MIXPANEL_API_KEY, MenuLabel$1 as MenuLabel, ModifyDataTableColumns, MuiThemeProvider, NETWORK_IPV4_IPV6_REGEX, NETWORK_IPV4_REGEXP, NETWORK_REGEXP, NETWORK_ROUTE, NUMBERS_ROUTE, NumberCell$1 as NumberCell, ONLY_NUMBERS_OR_ASTERISK_REGEXP, ONLY_NUMBERS_REGEXP, ORDERS_ROUTE, OVERVIEW_ROUTE, PEOPLE_ROUTE, PHONES_ROUTE, PHONE_NUMBER_REGEXP, PLACES_ROUTE, PRODUCTS_ROUTE, PageActions$1 as PageActions, PageLayout$1 as PageLayout, PageTabLayout$1 as PageTabLayout, PatchedCheckbox$1 as PatchedCheckbox, PlanLimitMessage, PrevNextChevronNavigator$1 as PrevNextChevronNavigator, PreventNavigationPrompt$1 as PreventNavigationPrompt, PrivilegedContent, ProductIcons$1 as ProductIcons, ProductLogo$1 as ProductLogo, REPORTS_ROUTE, ReadOnlyTextField$1 as ReadOnlyTextField, RecurrenceModal as ReccurenceModal, Roles, SETTINGS_ROUTE, SMS_CAMPAIGN_ROUTE, ScheduleHolidays, ScheduleListView, Scheduler, ScrollSpy, ScrollSpySkeleton$1 as ScrollSpySkeleton, SearchBar, SectionDivider$1 as SectionDivider, SimpleConfirmDialog$1 as SimpleConfirmDialog, TABLE_HEIGHT, TABLE_HEIGHT_NO_TABS, TABLE_HEIGHT_ONLY, TABLE_HEIGHT_WITH_CHIPS, TABLE_HEIGHT_WITH_SEARCHBAR, TABLE_HEIGHT_WITH_SEARCHBAR_AND_TABS, TABLE_PREFERENCES_KEY, TABLE_SUB_ROW_INDENT_WIDTH, TENANTS_ROUTE, TOP_BAR_HEIGHT, TabPanelWrapper$1 as TabPanelWrapper, TablePageEmptyState$1 as TablePageEmptyState, Tabs$1 as Tabs, TextCell$1 as TextCell, US_ZIP_CODE_REGEX, UserAvatar$1 as UserAvatar, VALID_HOSTNAMES, VirtualFaxEditorDialog$1 as VirtualFaxEditorDialog, VisibleOnDevOnly, backendSchedulerTimeRange, buildRolesBasedSecurityContext, buildSecurityContext, calculateNextExtension, callFilterNumberValidation, checkLicensesHasAssist, checkLicensesHasExtension, checkTemplateEmailAccess, computeLicenseUserCount, computeNewUserCount, constSuToFormattedRole, constantToText, convertFileToXml, convertHoursStringToMoment, de_DE, disableSecurityContext, downloadFile, downloadFileFromUrl, en_GB, en_US, enableSecurityContext, es_ES, escapeHtml, extractFirstAndLastName, formatBytes, formatPhoneNumber, fr_FR, fromHex, getChildProductDescription, getChildProductName, getProductDescription, getProductLogo, getProductName, getProductTitle, hasIllegalCharacters, isChannelBoss, isPrivilegeGranted, isUserProductJive, it_IT, ja_JP, ko_KR, localizeNumber, onlyIpAddressDigits, pt_BR, removeAllSpaces, secureHtml as sanitizeHtml, stringToColor, switchLicenseStatus, toHex, trimAvatarString, useAppHeights, useDelayedRender, useDialogVisibility, usePageHeader, usePageHeaderContext, usePerformanceMeasure, usePrivilege, useQueryParamReplace, useRenderTabs, useReportTranslations, useTranslateRegion, useWaitForElement, zh_CN };
